const stores_json= {
    "150056": {
        "Stato": "IT",
        "CAP": "87029",
        "Localit\u00e0": "TERRACINA",
        "Indirizzo": "VIA ROMA, 68",
        "N.ri Tel.": "0985 272515",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC11440-007111,25SBBKC01452-007111,25SBLGC01441-007111,25SBLKX02418-005958,25SBLKC11440-007111,25SBLKX02418-005958,25SBBKC01452-007111"
    },
    "003575": {
        "Stato": "DE",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ESCHENBRUENNLESTRASSE 11",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,24WBLDC05357-005831,24WBLDC02251-006631"
    },
    "003863": {
        "Stato": "AT",
        "CAP": "3400",
        "Localit\u00e0": "KLOSTERNEUBURG - WIEN",
        "Indirizzo": "INKUSTRASSE 13",
        "N.ri Tel.": "0043 2243 228990",
        "Insegna": "NEUMANN",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03040-006950,24WBLDK03040-006950,24WBLDK03040-006950,24WBLDK03040-006950,24WBLDK03346-006047,24WBLDK03346-006047,24WBLDK03346-006047,24WBLDK03346-006047,24WBLUK03216-006966"
    },
    "004215": {
        "Stato": "DE",
        "CAP": "59755",
        "Localit\u00e0": "ARNSBERG",
        "Indirizzo": "APOTHEKERSTRASSE 32",
        "N.ri Tel.": "0049293228881",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDH02433-006971"
    },
    "004272": {
        "Stato": "DE",
        "CAP": "95028",
        "Localit\u00e0": "HOF",
        "Indirizzo": "Ludwigstrasse 77",
        "N.ri Tel.": "+49.9281.143930",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "004330": {
        "Stato": "DE",
        "CAP": "47441",
        "Localit\u00e0": " MOERS",
        "Indirizzo": "HAAGSTR. 40",
        "N.ri Tel.": "0049.2841.1050",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03315-006640"
    },
    "004372": {
        "Stato": "DE",
        "CAP": "40211",
        "Localit\u00e0": "D\u00fcsseldorf",
        "Indirizzo": "KLOSTERSTR.18",
        "N.ri Tel.": "0049-211-36150",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "004761": {
        "Stato": "ES",
        "CAP": "39003",
        "Localit\u00e0": "Santander",
        "Indirizzo": "Plaza Principe, 3",
        "N.ri Tel.": "942312975",
        "Insegna": "GOLF",
        "CODICE PRODOTTO KOOOMO": "25SBLUB04360-006788,25SBLUC04163-006788,25WBLUK11140-007286"
    },
    "004783": {
        "Stato": "ES",
        "CAP": "27850",
        "Localit\u00e0": "Viveiro ESPANA",
        "Indirizzo": "Calle Margarita Pardo de Cela, 8",
        "N.ri Tel.": "982550341",
        "Insegna": "MONICA ALBO PEREZ",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC02352-006977,24WBLDC03298-006992,24WBLDK03040-006950,24WBLDK03052-006047,24WBLDK03293-005553,24WBLDK03315-006950,24WBLDK03346-006047"
    },
    "004791": {
        "Stato": "AD",
        "CAP": "500",
        "Localit\u00e0": "ANDORRA LA VELLA - PRINCIPAT D'ANDORRA",
        "Indirizzo": "C/ de l'Aigueta 14",
        "N.ri Tel.": "0037 376803140",
        "Insegna": "POLLYANNA",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDC01221-007108,25SBLUT02346-007132,25WBLDC03097-006047,25WBLKC03400-007308,24WBLDK03052-006047,24WBLDC03047-006047,25SBLGC01441-007111,25WBLUC03233-007308,25SBLKC06443-007101,25SBLUC03011-006719,24WBLDK02556-006646,24WBLDB03558-006950,25SBLGC02426-006648,24WBLDC02251-006631,24WBLDC02290-006646,25SBLUC01211-007101,25WBLDC03096-006047,25SBLDC03007-006950,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDK02363-005831,24WBLDC02250-007008,25SBLDC02330-007119,25SBLUC03012-006719,24WBLDL01416-006669,24WBLDK03122-006955,25SBLUC03013-006719,25WBLUC06082-005480,25SBLDC03006-006950,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDK03098-006047,25SBLGC02429-006648,25SBLDC01279-007111"
    },
    "004797": {
        "Stato": "ES",
        "CAP": "27001",
        "Localit\u00e0": "LUGO",
        "Indirizzo": "calle Juan Montes, 5",
        "N.ri Tel.": "982227916",
        "Insegna": "GARYSOM",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDK03037-006950,25WBLUC03090-006719,25WBLUK03142-005480,24WBLDK03052-006047,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUC01211-007101,24WBLDA05469-007037,25WBLDK11162-007110,25SBLDC03007-006950,24WBLDK02363-005831,25WBLUC03086-006047,24WBLDK03120-006951,24WBLDA05465-006127,25SBLUC01034-007111,25WBLDA05335-007349,25WBLDK03098-006047,25WBLUA05297-006127,24WBLDK03346-006047"
    },
    "004798": {
        "Stato": "ES",
        "CAP": "08221",
        "Localit\u00e0": "Terrassa",
        "Indirizzo": "calle Gavatxons, 5",
        "N.ri Tel.": "0093 783 7744",
        "Insegna": "BASIC CONCEPT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25SBLUA04528-007183,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25WBLUA05299-006127,25WBLDC03097-006047,25SBLUT02346-007132,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUH02195-004547,25SBLUT02316-007116,25SBLUF03186-006804,25SBLUH02348-007132,25SBLUT02110-006526,25SBLUH02192-004547,25SBLUC01121-007105,25SBLUL02403-006543,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUF01055-007092,25WBLDC03092-006719,25SBLUF02188-006804,25WBLUA05301-006434,25WBLDK03102-006047,25SBLUT02315-007117,25WBLDK03098-006047,25SBLUA04525-007182"
    },
    "004800": {
        "Stato": "ES",
        "CAP": "08401",
        "Localit\u00e0": "GRANOLLERS-BARCELONA",
        "Indirizzo": "CALLE SANTA ANA NUM 15",
        "N.ri Tel.": "0034 938708353",
        "Insegna": "AFRICA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLDT02125-006526,25SBLDP02143-007109,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDX03318-006992,25WBLDC03095-006047,25SBLUC01209-007101,25SBLDP05141-007109,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDK03102-006047,24WBLDC03048-006047,25SBLDC04066-007109,25SBLUT02315-007117,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03346-006047"
    },
    "004803": {
        "Stato": "ES",
        "CAP": "33003",
        "Localit\u00e0": "OVIEDO",
        "Indirizzo": "CALLE URIA, 3",
        "N.ri Tel.": "985242150",
        "Insegna": "BRIOS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC03084-006976,24WBLDC02049-006636,25WBLDK03101-006047,25SBLUL02402-007153,24WBLDC03036-006950,25SBLDB04068-007109,24WBLDK11337-006007,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLDF03076-007092,24WBLDK03039-006950,24WBLDB02092-006976,25SBLUC04206-006535,25WBLDC02170-006648,24WBLDK02363-005831,24WBLDB03294-005553,24WBLDK03122-006955,25WBLDC03099-006047,25SBLDC04066-007109,25WBLDK03098-006047,25SBLUC01210-007101,25SBLDC01279-007111,25WBLUK11140-007286,24WBLDK03346-006047"
    },
    "004804": {
        "Stato": "ES",
        "CAP": "33002",
        "Localit\u00e0": "OVIEDO",
        "Indirizzo": "CALLE PALACIO VALDES, 9 4 K",
        "N.ri Tel.": "985207544",
        "Insegna": "KOPA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC03084-006976,24WBLDC02049-006636,25WBLDK03101-006047,25WBLDK03161-006719,25WBLUC08078-006355,25WBLDC02178-006646,25SBLUL02402-007153,25SBLDC01222-007108,25SBLUT02346-007132,25SBLDB04068-007109,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDK03293-005553,25SBLDF03076-007092,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDB02092-006976,25SBLUC04206-006535,24WBLDK02363-005831,24WBLDB03294-005553,25SBLDF08078-007092,25WBLUC06082-005480,25WBLDC03099-006047,25SBLDC04066-007109,25WBLDK03098-006047,25SBLUC01210-007101,25SBLDC01279-007111,25WBLUK11140-007286"
    },
    "004808": {
        "Stato": "ES",
        "CAP": "48011",
        "Localit\u00e0": "Bilbao Vizcaya",
        "Indirizzo": "C. Gran Via Don Diego Lopez de Haro, 61",
        "N.ri Tel.": "0034 944418743",
        "Insegna": "DOCK",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUB01216-007111,25SBLUC04176-006854,25SBLUF03186-006804,25SBLUC02228-007104,25SBLUC01121-007105,25SBLUC04206-006535,25SBLUK11239-007110,25SBLUC11214-007111,25SBLUC04168-006788,25WBLUK11140-007286"
    },
    "004816": {
        "Stato": "ES",
        "CAP": "08241",
        "Localit\u00e0": "MANRESA",
        "Indirizzo": "CALLE ANGEL GUIMERA, 36",
        "N.ri Tel.": "938738817",
        "Insegna": "COKKO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25SBLDH02372-005707,25WBLUC08078-006355,25WBLDC02178-006646,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02377-007147,25SBLUT02346-007132,24WBLDC03036-006950,25SBLDH03371-005707,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUT02312-006803,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,25SBLDF03257-007113,24WBLDC03051-006047,25SBLUC01209-007101,25WBLDC02170-006648,25WBLUC03086-006047,25SBLDH02375-006842,25SBLDC01328-007131,25WBLDK03102-006047,25WBLDK03098-006047,25WBLDC03097-006047,25SBLUF03185-006804"
    },
    "004820": {
        "Stato": "ES",
        "CAP": "17800",
        "Localit\u00e0": "OLOT",
        "Indirizzo": "C/ RECTOR FERRER, 11",
        "N.ri Tel.": "0034 972453416",
        "Insegna": "ANA AULY SUNYEV",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,25WBLDK01376-007378,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDM10408-007022,25SBLUT02317-007116,24WBLDK03039-006950,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01209-007101,25SBLUC11214-007111,24WBLDC02352-006977,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUC11083-007110,24WBLDC03084-006976,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUF01055-007092,25WBLDC03092-006719,24WBLDL01416-006669,25SBLUP02063-007092,25SBLUC01210-007101,24WBLDK03037-006950,25SBLDM08474-007166,25WBLUC03090-006719,25WBLDC02178-006646,25SBLUA04527-007182,25SBLUF01184-006804,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDF08400-006987,25WBLDC03095-006047,25SBLDC04333-007109,25SBLDM01473-007166,25WBLDK03103-006047,24WBLDA05465-006127,24WBLDF03399-006987,25SBLUC01281-007105,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUC03074-006355,24WBLDM09261-006645,25SBLUH02150-007100,25SBLUC11207-006787,24WBLDC02342-006631,25SBLUF01568-007121,25SBLUB01216-007111,24WBLDA05469-007037,25WBLDK11162-007110,25SBLDC01159-007105,25SBLDF03257-007113,25WBLDC02170-006648,24WBLDK02363-005831,24WBLDM10259-006645,25SBLDC04066-007109"
    },
    "004835": {
        "Stato": "ES",
        "CAP": "09200",
        "Localit\u00e0": "MIRANDA DE EBRO",
        "Indirizzo": "CALLE ANTONIO MACHADO, 5/7",
        "N.ri Tel.": "0034 947322862",
        "Insegna": "L\u00faa Miranda de Ebro",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,24WBLDK03037-006950,25SBLDC04070-007109,25WBLDK03101-006047,25SBLDP01140-007109,25SBLDH02375-006842,25WBLDK03102-006047,25SBLDK01249-007111,25SBLDC04066-007109,24WBLDK03040-006950,25SBLDF03076-007092,25SBLDC01279-007111,25SBLDC04333-007109,24WBLDK03039-006950"
    },
    "004840": {
        "Stato": "ES",
        "CAP": "08021",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "CALLE MUNTANER 339 - TIENDA",
        "N.ri Tel.": "0034 93 5907342",
        "Insegna": "NINO ALVAREZ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUH02348-007132,25SBLUH02192-004547,25SBLUT02312-006803,25SBLUC04206-006535,25SBLUC01209-007101,25WBLUC03086-006047,25SBLUC04168-006788,25WBLUC06082-005480,25WBLUC02080-005958"
    },
    "004844": {
        "Stato": "ES",
        "CAP": "15705",
        "Localit\u00e0": "SANTIAGO DE COMPOSTELA",
        "Indirizzo": "C/ RUA DEL VILLAR, 11",
        "N.ri Tel.": "0034 98 1582331",
        "Insegna": "GARYSOM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03074-006355,25SBLUC02280-005958,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUH02195-004547,25SBLUB01216-007111,25SBLUS01341-007136,25SBLUS01337-007137,25WBLUC06082-005480"
    },
    "004855": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "CALLE SANT AUGUSTIN 1",
        "N.ri Tel.": "0034 987 273398",
        "Insegna": "LEIKO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDK03052-006047,25SBLUC01119-007105,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUH02195-004547,24WBLDK03293-005553,25SBLUH02242-007100,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02276-005695,25SBLUC01121-007105,25SBLUL02403-006543,25SBLUC11083-007106,25SBLUT02310-006817,24WBLDC03051-006047,25WBLUC02153-007300,24WBLDB03294-005553,25WBLUC03086-006047,25SBLUC03013-006719,24WBLDK03040-006950,24WBLDK03346-006047"
    },
    "004859": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "GRAN VIA S. MARCOS,13",
        "N.ri Tel.": "0034 987 237203",
        "Insegna": "DIEGUEZ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02289-007119,25WBLDK03161-006719,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,25SBLDV02296-007143,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDH02377-007147,24WBLDK03052-006047,25SBLUC01119-007105,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUH02195-004547,25SBLUT02316-007116,24WBLDK03293-005553,25SBLDH02387-007144,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02313-006818,25WBLDC03096-006047,25SBLUC01121-007105,25SBLUL02403-006543,25SBLUC11083-007106,25SBLUT02310-006817,25SBLDF03257-007113,24WBLDC03051-006047,25SBLUH02241-007100,25SBLUT02306-006801,25SBLDP01140-007109,25SBLUL02409-006547,25WBLUC03086-006047,25SBLDF08078-007092,25SBLDH02373-005707,25SBLDC04066-007109,24WBLDK03040-006950,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDC01279-007111,25WBLUK11140-007286,25SBLDV01146-007107,24WBLDK03346-006047"
    },
    "004864": {
        "Stato": "ES",
        "CAP": "33450",
        "Localit\u00e0": "Piedras Blancas, Asturias",
        "Indirizzo": "Av. Eysines, 20",
        "N.ri Tel.": "0034 985533577",
        "Insegna": "ARNALDO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC03084-006976,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUT02308-006801,24WBLDC02314-006631,25WBLDC03097-006047,24WBLDX02113-006631,24WBLDK03052-006047,25SBLUC01119-007105,25SBLUC01115-007105,25SBLUS01341-007136,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDK03103-006047,24WBLDC02352-006977,25WBLDC03099-006047,25WBLDK03098-006047,25WBLUK11140-007286,24WBLDK03346-006047"
    },
    "004872": {
        "Stato": "ES",
        "CAP": "33202",
        "Localit\u00e0": "GIJON",
        "Indirizzo": "CALLE SAN AGUSTIN ,5 BAJO",
        "N.ri Tel.": "+34 985342933",
        "Insegna": "MARIA JOSE FERNANDEZ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK11337-006007,24WBLDC05357-005831,24WBLDC03084-006976,25WBLDK02192-006648,24WBLDC03298-006992,25WBLDK11162-007110,24WBLDK03297-006992,25WBLDK02073-006648,24WBLDK03346-006047,24WBLDK02363-005831"
    },
    "004883": {
        "Stato": "ES",
        "CAP": "08037",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "CALLE PAU CLARIS, 159",
        "N.ri Tel.": "0034 934 876084",
        "Insegna": "NOTENOM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC03074-006355,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDC03298-006992,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDX03318-006992,24WBLDK03297-006992,25WBLDC03095-006047,25WBLUC03086-006047,25WBLDK02192-006648,25WBLDK03102-006047"
    },
    "004888": {
        "Stato": "ES",
        "CAP": "08242",
        "Localit\u00e0": "MANRESA (BARCELONA)",
        "Indirizzo": "CALLE CARRIO 37",
        "N.ri Tel.": "93 742 21 98",
        "Insegna": "SEVEN PAM I PIPA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUA05299-006127,24WBLDC03047-006047,24WBLDH01432-006971,25SBLUF01184-006804,25SBLUH02108-006864,25SBLDT02125-006526,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUA04524-007182,25SBLUT02110-006526,25SBLDH02389-007144,25SBLDC11237-007110,24WBLDF08400-006987,25SBLDC01159-007105,25SBLUN02513-007179,25SBLUT02309-007125,25SBLDF03257-007113,25WBLDK03103-006047,25SBLDF08078-007092,24WBLDC02352-006977,24WBLDX03280-006719,25SBLUH01149-007100,25WBLDF08236-007301,25SBLUC01281-007105"
    },
    "004900": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "C/DE LA GUARDIA CIVIL, 1",
        "N.ri Tel.": "0034 987407736",
        "Insegna": "SIROCO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDC03051-006047,24WBLDC03084-006976,24WBLDK03039-006950,24WBLDK03040-006950,24WBLDK03052-006047,24WBLDK03086-006976,24WBLDK03122-006955,25SBLUC01115-007105,25SBLUC01119-007105,25SBLUH02150-007100,25SBLUH02194-004547,25SBLUT02316-007116,25SBLUT02317-007116"
    },
    "004907": {
        "Stato": "ES",
        "CAP": "24400",
        "Localit\u00e0": "PONFERRADA",
        "Indirizzo": "C.C. \"EL ROSAL\" AV. CONSTITUCION 2",
        "N.ri Tel.": "0034 987407736",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02042-006648"
    },
    "004925": {
        "Stato": "ES",
        "CAP": "08500",
        "Localit\u00e0": "VIC",
        "Indirizzo": "PLAZA MAYOR, 14",
        "N.ri Tel.": "+34938867183",
        "Insegna": "INSIGNIA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUS01339-007137,25WBLUC08078-006355,24WBLDX02113-006631,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUT02310-006817,25SBLUC01209-007101,25SBLDH02386-007144,25WBLUC03086-006047,25SBLDF08078-007092,24WBLDC03048-006047,25SBLUH02030-006846,25WBLDA05337-006127,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUA05300-006434,25SBLUH02195-004547,25SBLUF03186-006804,25SBLUA04524-007182,24WBLDK02043-006648,24WBLDM04562-007021,24WBLDK03297-006992,24WBLDL01416-006669,25SBLDH02375-006842,25WBLDC03099-006047,25WBLDF08236-007301,25SBLUF08504-007173,25SBLUF03185-006804,24WBLDK03037-006950,25WBLDK03161-006719,25SBLDM08474-007166,25WBLDC02178-006646,24WBLDC03038-006950,24WBLDC03298-006992,25SBLUF01184-006804,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDC03007-006950,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,25SBLDC04333-007109,24WBLDB03294-005553,25SBLDM01473-007166,25WBLDK03103-006047,24WBLDA05465-006127,24WBLDF01398-006987,25SBLUF02188-006804,25WBLDK03102-006047,25WBLDA05335-007349,24WBLDF03399-006987,25SBLUC01281-007105,25WBLDK03101-006047,25SBLDP01300-007140,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25SBLDF03076-007092,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDH02377-007144,24WBLDM04428-005794,25SBLDF03257-007113,25SBLUT02306-006801,25WBLDC02170-006648,25SBLDC01328-007131,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "004952": {
        "Stato": "ES",
        "CAP": "27400",
        "Localit\u00e0": "MONFORTE DE LEMUS",
        "Indirizzo": "CARDENAL, 28",
        "N.ri Tel.": "+34982405341",
        "Insegna": "AVRIL 28",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDK02045-006648,25WBLDK03161-006719,25WBLDK02192-006648,25WBLDK01376-007378,24WBLDK03346-006047,24WBLDC02314-006631,24WBLDC02112-006631,24WBLDK02363-005831"
    },
    "004968": {
        "Stato": "ES",
        "CAP": "08650",
        "Localit\u00e0": "SALLENT",
        "Indirizzo": "CALLE COS NUM. 16",
        "N.ri Tel.": "0034 687779071",
        "Insegna": "JORDI PADROS",
        "CODICE PRODOTTO KOOOMO": "25SBLDM08474-007166,25SBLDH02372-005707,25SBLDS01292-007141,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDP01300-007140,25SBLDC01222-007108,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUT02346-007132,24WBLDX02113-006631,25SBLDH02381-007114,24WBLDK11337-006007,24WBLDC03047-006047,25SBLDF03201-006804,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC03007-006950,25SBLDK01249-007111,25WBLDC03095-006047,25SBLUS01337-007137,25SBLUC01209-007101,24WBLDK02363-005831,25SBLDM01473-007166,24WBLDL01416-006669,25SBLUF02188-006804,25SBLUC04168-006788,25WBLUC06082-005480,25SBLDC01328-007131,24WBLDC03048-006047,25SBLUH02394-007114,25SBLDP05301-007140"
    },
    "004977": {
        "Stato": "ES",
        "CAP": "17002",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "CALLE DE LA CREU 35",
        "N.ri Tel.": "0034972218804",
        "Insegna": "ELENA ROSSINI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,25WBLDK03103-006047,25SBLDC01260-007108,25WBLUC03086-006047,24WBLDC03038-006950,25WBLDC03096-006047,25WBLDC02178-006646,24WBLDC03048-006047,25SBLDC04066-007109,24WBLDK03297-006992,25SBLDC01222-007108,25WBLDC03099-006047,25SBLDC04331-006788,24WBLDK03039-006950"
    },
    "006429": {
        "Stato": "DE",
        "CAP": "33332",
        "Localit\u00e0": "GUETERSLOH",
        "Indirizzo": "NEUENKIRCHENER STRASSE 60",
        "N.ri Tel.": "+49 5241-5291",
        "Insegna": "EUSTERHUS",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01219-007108,25SBLUC11207-006787,25WBLUC02151-007287,25SBLUB04167-006854,25WBLUC06082-005480,25WBLUK03142-005480,25SBLUC02153-007124,25SBLUC01217-007108"
    },
    "007356": {
        "Stato": "ES",
        "CAP": "08026",
        "Localit\u00e0": "BARCELONA",
        "Indirizzo": "C/ PUJADES 77-79, 1 2",
        "N.ri Tel.": "932657599",
        "Insegna": "PILAR Y ANDREA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUC03233-007308,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC03097-006047"
    },
    "007975": {
        "Stato": "ES",
        "CAP": "43870",
        "Localit\u00e0": "AMPOSTA / TARRAGONA",
        "Indirizzo": "AVENIDA SANTA BARBARA, 3",
        "N.ri Tel.": "977701622",
        "Insegna": "TRIBECA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDK11337-006007,24WBLDK02556-006646,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC02352-006977,24WBLDC03048-006047"
    },
    "008134": {
        "Stato": "DE",
        "CAP": "25980",
        "Localit\u00e0": "SYLT OF WESTERLAND",
        "Indirizzo": "ELISABETHSTR.4",
        "N.ri Tel.": "04651967700",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01159-007105"
    },
    "008381": {
        "Stato": "ES",
        "CAP": "08221",
        "Localit\u00e0": "TARRASA - BARCELONA",
        "Indirizzo": "C/FONT VELLA 54",
        "N.ri Tel.": "937830462",
        "Insegna": "NURIA PENINA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25WBLUA05301-006434"
    },
    "008965": {
        "Stato": "DE",
        "CAP": "85748",
        "Localit\u00e0": "GARCHING",
        "Indirizzo": "GUTENBERGSTR. 3A",
        "N.ri Tel.": "0049 89 5527860",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012009": {
        "Stato": "ES",
        "CAP": "15701",
        "Localit\u00e0": "SANTIAGO DE COMPOSTELA",
        "Indirizzo": "GENERAL PARDI\u00d1AS 40 BJ",
        "N.ri Tel.": "981593886",
        "Insegna": "FRISEE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25WBLDC02072-006648,24WBLDK03037-006950,25WBLDK03161-006719,25WBLDK03101-006047,24WBLDC02044-006648,24WBLDC02314-006631,25SBLDC03003-006950,24WBLDK03052-006047,25SBLDC11335-007110,24WBLDK11337-006007,25WBLDK11162-007110,25SBLDC01159-007105,25SBLDK01249-007111,24WBLDK03297-006992,25SBLDC04331-006788,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDF01398-006987,25WBLDK03102-006047,25SBLDC04066-007109,24WBLDF03399-006987"
    },
    "012029": {
        "Stato": "ES",
        "CAP": "17230",
        "Localit\u00e0": "PALAMO, GIRONA",
        "Indirizzo": "PLAZA DE LOS ARBOLES 4,6",
        "N.ri Tel.": "972317128",
        "Insegna": "D'AVUI PALAMOS 4-6",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,24WBLDK03037-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25WBLDC03096-006047,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355"
    },
    "012067": {
        "Stato": "ES",
        "CAP": "25600",
        "Localit\u00e0": "BALAGUER",
        "Indirizzo": "POLIGONO INDUSTRIAL CAMP LLONG CALLE XALOC, 5",
        "N.ri Tel.": "973450212",
        "Insegna": "CIA CANOA QUEBRADA, S.L",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC02314-006631,25SBLDP01300-007140,25SBLDC01222-007108,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUP01189-006804,25SBLDP01079-007092,25SBLDF03201-006804,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDC03298-006992,25SBLDT02125-006526,25SBLUH02191-004547,24WBLDC02290-006646,25SBLDH02389-007144,25SBLUT02312-006803,25SBLDH02377-007144,25WBLDK11162-007110,24WBLDF08400-006987,25SBLUC04206-006535,25SBLUP04322-007129,24WBLDC03051-006047,25SBLDT02138-006526,25SBLUC01209-007101,25SBLUC11214-007111,24WBLDK02363-005831,25SBLUF01055-007092,25SBLDM01473-007166,25WBLDA05337-006127,24WBLDF16106-006960,25SBLDF08078-007092,25SBLUF02188-006804,25SBLUF03185-006804,25SBLUH02275-007100,25WBLUC03086-006047,25SBLDC01328-007131,25WBLUA05298-006127,25SBLDP05080-007092,25SBLUT02315-007117,25WBLDK03098-006047,24WBLDF03399-006987,25WBLDF08236-007301,25WBLDC03097-006047,24WBLDF02101-006960,25SBLDP05301-007140"
    },
    "012095": {
        "Stato": "ES",
        "CAP": "15003",
        "Localit\u00e0": "LA CORUNA",
        "Indirizzo": "CALLE JUANA DE VEGA, 8",
        "N.ri Tel.": "667122676",
        "Insegna": "2 R STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDK11337-006007,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUT02317-007116,25WBLDC03100-006047,25WBLDK02073-006648,24WBLDK03039-006950,25SBLUH02348-007132,25SBLUT02110-006526,25SBLUC01209-007101,25SBLDC02330-007119,25SBLUC03012-006719,25WBLUC03086-006047,25SBLUM01486-007172,25WBLUC05125-007283,24WBLDC03048-006047,24WBLDC03084-006976,25WBLUK03142-005480,25SBLUT02308-006801,25SBLUX02147-007103,25SBLUH02195-004547,25SBLUA04524-007182,25SBLDK01249-007111,24WBLDM04562-007021,24WBLDK03297-006992,24WBLDF16106-006960,25WBLDC03099-006047,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25SBLUA04527-007182,25SBLUF01184-006804,25WBLDC03096-006047,25WBLDC03095-006047,25SBLDC04331-006788,24WBLDC03051-006047,25SBLUS01337-007137,25SBLDC04333-007109,25SBLDM01473-007166,24WBLDK03086-006976,25SBLDC03006-006950,25WBLDK03102-006047,24WBLDM10555-007022,25SBLUC01281-007105,25SBLDC02233-007104,25WBLDK03101-006047,25SBLDP01300-007140,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUT02316-007116,25SBLUB01216-007111,24WBLDA05469-007037,25WBLDK11162-007110,25SBLDF03257-007113,25WBLDC02170-006648,25SBLDC01328-007131,25WBLDK03098-006047,24WBLDF02101-006960"
    },
    "012422": {
        "Stato": "UA",
        "CAP": "-",
        "Localit\u00e0": "KRIVOY ROG",
        "Indirizzo": "PROSPEKT GAGARINA 15",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012730": {
        "Stato": "CZ",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "BLAUER - SOUDNI 10/13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25WBLDK03161-006719,24WBLDA05465-006127,25WBLDK03101-006047,25SBLDH02373-005707,24WBLDK02362-005831,25WBLDK03098-006047,25WBLDK05019-007298,25SBLUF03185-006804,24WBLDK03039-006950"
    },
    "012907": {
        "Stato": "CZ",
        "CAP": "110 00",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDM08474-007166,24WBLDC02044-006648,25SBLDP01300-007140,24WBLDM09261-006645,24WBLDX02113-006631,25SBLDH02381-007114,24WBLDM13260-006645,24WBLDC03298-006992,24WBLDB03558-006950,25SBLDV03365-007143,25SBLUP05530-007173,25WBLDM01463-007330,25SBLUP05355-007139,24WBLDF08400-006987,24WBLDM04428-005794,24WBLDK02362-005831,25SBLDV04293-007143,24WBLDM10259-006645,25SBLDP05080-007092,25WBLDX03181-006985,25SBLUP02352-006855,25WBLDK03182-006985,25SBLUF08504-007173,24WBLDK03346-006047"
    },
    "012931": {
        "Stato": "ES",
        "CAP": "17220",
        "Localit\u00e0": "SANT FELIU DE GUIXOLS",
        "Indirizzo": "CALLE MAYOR 9",
        "N.ri Tel.": "+34972821112",
        "Insegna": "CLOVER",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC03084-006976,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDX02113-006631,24WBLDC03036-006950,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUF01184-006804,25SBLUH02195-004547,25SBLUH02108-006864,25SBLDT02125-006526,25SBLDF03076-007092,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUT02312-006803,24WBLDK02043-006648,25SBLUC01121-007105,25SBLUT02309-007125,24WBLDX03318-006992,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,25SBLDF08078-007092,25SBLUF02188-006804,24WBLDC02352-006977,25SBLDH02375-006842,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUT02315-007117,25SBLUC01210-007101,25SBLDC01279-007111"
    },
    "013285": {
        "Stato": "ES",
        "CAP": "09004",
        "Localit\u00e0": "BURGOS",
        "Indirizzo": "CALLE VICTORIA 13",
        "N.ri Tel.": "620994026",
        "Insegna": "BURWEAR",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC08078-006355,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03295-006857,25SBLUT02346-007132,25SBLUC02280-005958,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02195-004547,25SBLUH02242-007100,25WBLDB03191-007294,25SBLUS01341-007136,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLUF02118-007121,25SBLUS01338-007137,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02241-007100,25WBLUC02153-007300,24WBLDB03294-005553,25WBLDK03103-006047,25SBLUC03013-006719,25WBLUA05298-006127,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047,25SBLUC01210-007101,25WBLUK11140-007286,25SBLUF03185-006804,24WBLDK03346-006047"
    },
    "013392": {
        "Stato": "ES",
        "CAP": "17002",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "JOAN MARAGALL 15",
        "N.ri Tel.": "+34 620022344",
        "Insegna": "WHITE ICE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDC11335-007110,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUC01119-007105,24WBLDC03038-006950,25SBLUC11207-006787,25WBLUA05300-006434,25WBLUC03233-007308,25SBLUH02195-004547,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC01209-007101,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25SBLDC01328-007131,25WBLDK03102-006047,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047"
    },
    "013441": {
        "Stato": "ES",
        "CAP": "33201",
        "Localit\u00e0": "GIJON",
        "Indirizzo": "CALLE SAN BERNARDO 39",
        "N.ri Tel.": "0034985359245",
        "Insegna": "TRAPPER SHOP",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLDC01222-007108,25SBLUT02346-007132,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDK11337-006007,25SBLUC02151-007124,25SBLUC02229-005958,25WBLUC03233-007308,25SBLUC03011-006719,25SBLUC02254-007101,24WBLDK03039-006950,25SBLDC01159-007105,25SBLDC03007-006950,25SBLDK01249-007111,25SBLUC11214-007111,25WBLUC03086-006047,25SBLUB04167-006854,25WBLUC06082-005480,24WBLDL01420-007016,25WBLUC02080-005958,25SBLUC01034-007111,25SBLDC01279-007111,25WBLUK11140-007286,25SBLUC01281-007105"
    },
    "013487": {
        "Stato": "CZ",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "RYTIRSKA 534/13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03040-006950"
    },
    "014129": {
        "Stato": "ES",
        "CAP": "17002",
        "Localit\u00e0": "GIRONA",
        "Indirizzo": "C/GRAN VIA JAUME I, N\u00b061",
        "N.ri Tel.": "972 29 71 50",
        "Insegna": "ONIX",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUF01184-006804,25SBLDT02125-006526,25SBLUC04176-006854,25SBLUT02110-006526,25SBLUH02276-005695,25SBLUM01480-007168,25SBLDC04333-007109,25SBLDM01473-007166,25SBLUC04168-006788,25SBLUC04163-006788,25WBLDL01346-007354"
    },
    "014446": {
        "Stato": "DE",
        "CAP": "63741",
        "Localit\u00e0": "ASCHAFFENBURG",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "00493041706555",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01358-007101,25WBLDK03101-006047"
    },
    "014726": {
        "Stato": "DE",
        "CAP": "49835",
        "Localit\u00e0": "Wietmarschen",
        "Indirizzo": "Meitnerstrasse 17",
        "N.ri Tel.": "0049 59154950",
        "Insegna": "L\u00f6ning",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDC01222-007108,25SBLDC01221-007108,24WBLDC02342-006631,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK02043-006648,25WBLDK11162-007110,25SBLDC03007-006950,25SBLDC02128-007103,25WBLDK02192-006648,25WBLDK03102-006047,25SBLDC04066-007109,24WBLDK03040-006950,24WBLDK03346-006047"
    },
    "014728": {
        "Stato": "DE",
        "CAP": "30823",
        "Localit\u00e0": "GARBSEN",
        "Indirizzo": "HAVELSER STR. 1",
        "N.ri Tel.": "0049 5131 1619",
        "Insegna": "BROOXX",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC03119-006951,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25WBLDK01376-007378,25WBLUC02079-005958,25WBLUL01314-007012,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUC11207-006787,25SBLUC01119-007105,24WBLDC03047-006047,24WBLDC02342-006631,25WBLUC03233-007308,24WBLDK02353-006985,25WBLDC03100-006047,24WBLDC02290-006646,24WBLDK02043-006648,25SBLUL02403-006543,25SBLUC04206-006535,25WBLDC02170-006648,24WBLDK02363-005831,25SBLUC03012-006719,25SBLDC02236-006648,25WBLDK02192-006648,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUC01217-007108"
    },
    "014751": {
        "Stato": "ES",
        "CAP": "08720",
        "Localit\u00e0": "VILAFRANCA DE PENEDES",
        "Indirizzo": "CALLE PARELLADA 22",
        "N.ri Tel.": "349212127",
        "Insegna": "JUST",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDK03037-006950,25WBLUC08078-006355,25WBLDA05336-007349,25WBLDC02178-006646,25WBLDK01376-007378,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01222-007108,25SBLUT02346-007132,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDH02389-007144,25SBLUH02192-004547,25SBLUT02312-006803,25WBLDK11162-007110,25WBLUA05297-006127,25SBLDC03007-006950,25SBLDK01249-007111,25WBLDC03095-006047,25SBLDF03257-007113,25SBLUC01209-007101,25SBLDP05141-007109,25WBLDK03103-006047,24WBLDL01416-006669,24WBLDC05357-005831,24WBLDA05465-006127,24WBLDF01398-006987,25SBLDF08078-007092,25SBLUH02275-007100,25SBLDH02375-006842,25WBLDK03102-006047,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03099-006047,24WBLDF03399-006987,25SBLDC01279-007111,25WBLDA05337-006127"
    },
    "014753": {
        "Stato": "ES",
        "CAP": "40001",
        "Localit\u00e0": "SEGOVIA",
        "Indirizzo": "C/ JUAN BRAVO 36",
        "N.ri Tel.": "921462738",
        "Insegna": "GERMAN ELIAS IGLESIAS",
        "CODICE PRODOTTO KOOOMO": "24WBLDF03399-006987"
    },
    "014780": {
        "Stato": "ES",
        "CAP": "25230",
        "Localit\u00e0": "MOLLERUSSA",
        "Indirizzo": "PLAZA PLA DE URGELL 1",
        "N.ri Tel.": "0034 973603401",
        "Insegna": "ESSER ROBA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDC01222-007108,24WBLDX02113-006631,25SBLDC11335-007110,25SBLUC11207-006787,24WBLDK11337-006007,25SBLDF03201-006804,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUM06481-007168,25SBLDP05205-006804,25SBLDT02125-006526,25SBLDF03076-007092,25SBLUF03186-006804,25SBLDS01291-007141,25SBLUH02348-007132,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUC01211-007101,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUT02310-006817,25SBLDC04331-006788,25SBLDF03257-007113,25SBLUC01209-007101,25SBLDP05141-007109,24WBLDB03294-005553,25SBLDM01473-007166,25SBLUP02352-006855,24WBLDC05357-005831,24WBLDF01398-006987,25SBLDF08078-007092,24WBLDC02352-006977,25SBLUT02315-007117,24WBLDF03399-006987"
    },
    "014781": {
        "Stato": "RU",
        "CAP": "-",
        "Localit\u00e0": "TULA",
        "Indirizzo": "UL. DEMONSTRATSII 9",
        "N.ri Tel.": "02/8321103",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014875": {
        "Stato": "ES",
        "CAP": "17820",
        "Localit\u00e0": "BA\u00d1OAS",
        "Indirizzo": "CALLE MERCADAL 9",
        "N.ri Tel.": "972574856",
        "Insegna": "COMALAT DONA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLDC02178-006646,25SBLDH02374-006842,24WBLDC03036-006950,24WBLDK11337-006007,24WBLDC03038-006950,25SBLDT02125-006526,25SBLDF03076-007092,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLDH02377-007144,25WBLDC03096-006047,25SBLDK01249-007111,25SBLDC04333-007109,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "015198": {
        "Stato": "DE",
        "CAP": "52146",
        "Localit\u00e0": "Wuerselen",
        "Indirizzo": "Kaiserstrasse 72",
        "N.ri Tel.": "+49 240591770",
        "Insegna": "ROBOMO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02352-006977,24WBLDX03318-006992,24WBLDC03252-007008,24WBLDK03297-006992,25WBLDK03182-006985,24WBLDK03346-006047"
    },
    "015240": {
        "Stato": "ES",
        "CAP": "17210",
        "Localit\u00e0": "CALELLA DE PALAFRUGELL",
        "Indirizzo": "CALLE BOFILL Y CODINA 23",
        "N.ri Tel.": "0034 972615357",
        "Insegna": "ALFER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25SBLUH02194-004547,25SBLKH02555-007188,25WBLDC03100-006047,25SBLUT02110-006526,25SBLUT02312-006803,25SBLKP05558-007187,25SBLKF02553-007187,25SBLUC01209-007101,25SBLGF03548-007187,24WBLDC03048-006047,24WBLDC03084-006976,24WBLDC02314-006631,25SBLDH02377-007147,25SBLGP05549-007187,25SBLDK01249-007111,25SBLUF01055-007092,25SBLUH02275-007100,25WBLDC03099-006047,25WBLDF08236-007301,24WBLDC02112-006631,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLKF03551-007187,25SBLGF02547-007187,25SBLDV03365-007143,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUS01337-007137,25SBLDM01473-007166,24WBLDK03086-006976,25WBLUC06082-005480,25WBLDK03102-006047,25SBLGH02550-007188,25SBLUC01281-007105,24WBLDK03346-006047,25SBLDH02372-005707,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLGC01441-007111,25SBLKC06443-007101,25SBLUB01216-007111,25SBLUN02513-007179,25SBLDF03257-007113,25WBLDC02170-006648,25SBLDC01328-007131"
    },
    "015283": {
        "Stato": "DE",
        "CAP": "77933",
        "Localit\u00e0": "LAHR",
        "Indirizzo": "VORDERE MAUERGASSE 7",
        "N.ri Tel.": "0049 784121474",
        "Insegna": "Feldm\u00fcller - Fank",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDK03037-006950,25WBLUC03090-006719,25WBLUC02079-005958,24WBLDC02342-006631,24WBLDC03298-006992,25WBLDC03100-006047,24WBLDC02352-006977,25WBLDK03102-006047,24WBLDK03040-006950,24WBLDK03346-006047"
    },
    "015309": {
        "Stato": "ES",
        "CAP": "08620",
        "Localit\u00e0": "SANT VICENT DELS HORTS",
        "Indirizzo": "LA POBLA 41",
        "N.ri Tel.": "0034936724792",
        "Insegna": "MUNNE 1941",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDC03084-006976,25WBLDK03161-006719,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC02314-006631,25SBLDC01221-007108,24WBLDC03047-006047,24WBLDC02251-006631,24WBLDC02290-006646,25WBLDK11162-007110,25SBLDC01159-007105,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDK03120-006951,24WBLDC02352-006977,25SBLDC01279-007111"
    },
    "015311": {
        "Stato": "CZ",
        "CAP": "549 00",
        "Localit\u00e0": "Nachod",
        "Indirizzo": "Okruzni 334",
        "N.ri Tel.": "420606606700",
        "Insegna": "Fashion store",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,24WBLDX02113-006631,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDC02251-006631,25SBLUT02317-007116,24WBLDK03039-006950,25SBLDC02330-007119,25WBLUC03086-006047,24WBLDK03120-006951,24WBLDK03122-006955,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUC01217-007108,25SBLUP05190-006804,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDL01417-006668,25SBLDP01079-007092,25SBLDH03369-006845,25SBLDP05205-006804,25SBLDK01249-007111,24WBLDM04562-007021,25SBLUS01338-007137,25WBLUA05298-006127,25WBLUK11140-007286,25SBLDP05301-007140,25WBLDK03161-006719,25SBLDC03003-006950,25SBLDF03201-006804,25SBLDC01358-007101,24WBLDC03038-006950,24WBLDC03298-006992,25SBLUF01184-006804,25SBLDS01291-007141,25WBLDC03096-006047,24WBLDX03318-006992,25SBLDC03007-006950,25SBLDP05141-007109,24WBLDA05465-006127,25WBLDA05335-007349,24WBLDM01437-007021,25SBLDH02372-005707,25WBLDK03101-006047,25SBLDV02296-007143,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUC11207-006787,25SBLDH02387-007144,25SBLDF03076-007092,24WBLDK02362-005831,25SBLDH02370-006845,25WBLDC02170-006648,24WBLDL01420-007016,24WBLDM10259-006645,25WBLDF08248-006948,25WBLUA05301-006434,25WBLDK03098-006047"
    },
    "015387": {
        "Stato": "ES",
        "CAP": "32005",
        "Localit\u00e0": "OURENSE",
        "Indirizzo": "AV PONTEVEDRA, 2",
        "N.ri Tel.": "0034 988245736",
        "Insegna": "FRANK STORE",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01209-007101,25SBLUC04168-006788,25SBLUC11207-006787,25SBLUH02192-004547,25SBLUT02312-006803"
    },
    "015685": {
        "Stato": "DE",
        "CAP": "44532",
        "Localit\u00e0": "LUENEN",
        "Indirizzo": "MARKSTRASSE 2C",
        "N.ri Tel.": "+49 2306 9280756",
        "Insegna": "TIEMANN'S",
        "CODICE PRODOTTO KOOOMO": "25SBLDB04068-007109,24WBLDC03119-006951,24WBLDC02342-006631,25WBLDK11162-007110,25SBLDC01159-007105,25SBLDK01249-007111,25SBLDC04066-007109,24WBLDK03315-006640,25SBLDC01221-007108,25WBLDC11163-007110,24WBLDC03036-006950,25SBLDC02330-007119"
    },
    "015729": {
        "Stato": "RU",
        "CAP": "-",
        "Localit\u00e0": "YAROSLAV",
        "Indirizzo": "RESPUBLICANSKAYA, 84",
        "Insegna": "OOO UNIQUE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02049-006636,24WBLDC03298-006992,24WBLDH02433-006971,24WBLDK02311-006648,24WBLDK03297-006992,25SBLUC01210-007101,25SBLUC02151-007124,25SBLUC02227-007104,25SBLUF01184-006804,25SBLUF02188-006804,25SBLUH02030-006846,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUH02194-004547,25SBLUM01476-006233,25SBLUM01479-007167,25SBLUP01189-006804,25SBLUP01350-006855,25SBLUP02352-006855,25SBLUP03535-006873,25SBLUP04043-007130,25SBLUP04353-007129,25SBLUP04354-007129,25SBLUP05033-007094,25SBLUP05190-006804,25SBLUT02308-006801,25SBLUT02309-007125"
    },
    "015745": {
        "Stato": "ES",
        "CAP": "20302",
        "Localit\u00e0": "IRUN, GUIPUZCOA",
        "Indirizzo": "CALLE ALMIRANTE ARIZMENDI 9",
        "N.ri Tel.": "0034 943639946",
        "Insegna": "SAERR",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015807": {
        "Stato": "AT",
        "CAP": "6561",
        "Localit\u00e0": "ISCHGL",
        "Indirizzo": "DORFSTRASSE 79",
        "N.ri Tel.": "+43 (0)5444 59 90",
        "Insegna": "ELISABETH HANGL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,24WBLDK03040-006950,24WBLDK03346-006047"
    },
    "015829": {
        "Stato": "DE",
        "CAP": "72119",
        "Localit\u00e0": "Ammerbuch",
        "Indirizzo": "C/O Logistik & Service, Hagenring 23",
        "N.ri Tel.": "004970711520",
        "Insegna": "MODEHAUS ZINSER GMBH & CO. KG",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25SBLDC01260-007108,24WBLDK03037-006950,24WBLDC03119-006951,25SBLDC02264-006648,24WBLDC03084-006976,25WBLDK02069-006648,25WBLDK03101-006047,24WBLDK02042-006648,25WBLDC02178-006646,25SBLDC03007-006950,24WBLDK03040-006950,25SBLDC01222-007108,25WBLDC03100-006047,25WBLDC02170-006648"
    },
    "015890": {
        "Stato": "ES",
        "CAP": "26002",
        "Localit\u00e0": "LOGRONO (LA RIOJA)",
        "Indirizzo": "VARA DEL REY 12",
        "Insegna": "LDM",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,25WBLUC03090-006719,25SBLDH02372-005707,25WBLDK03101-006047,25SBLUH02150-007100,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDC03007-006950,24WBLDK03297-006992,24WBLDC03051-006047,25SBLUC01209-007101,24WBLDC02250-007008,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,25SBLDH02373-005707,24WBLDC03252-007008,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDK03098-006047,25WBLDC03097-006047,24WBLDK03346-006047"
    },
    "016123": {
        "Stato": "DE",
        "CAP": "45131",
        "Localit\u00e0": "ESSEN",
        "Indirizzo": "RUETTENSCHEIDER STR. 261",
        "N.ri Tel.": "0049 1725306001",
        "Insegna": "Pfeffers",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLDC01221-007108,25SBLUC01217-007108,25SBLUC04163-006788"
    },
    "016127": {
        "Stato": "ES",
        "CAP": "43840",
        "Localit\u00e0": "SALOU, TARRAGONA",
        "Indirizzo": "PASEO JAIME 1, 10",
        "N.ri Tel.": "0034 977350723",
        "Insegna": "CACHE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03051-006047,24WBLDC05357-005831,24WBLDK03039-006950,24WBLDK03040-006950,24WBLDK03293-005553,25SBLDC01222-007108,25SBLDC03007-006950,25SBLDX03008-006950"
    },
    "016315": {
        "Stato": "DE",
        "CAP": "69117",
        "Localit\u00e0": "HEIDELBERG",
        "Indirizzo": "UNTERE NECKARSTRASSE 2",
        "N.ri Tel.": "+49 (0) 6221 - 9116-0",
        "Insegna": "KRAUS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC02079-005958,25SBLUC04206-006535,24WBLUK03216-006966"
    },
    "016353": {
        "Stato": "DE",
        "CAP": "67655",
        "Localit\u00e0": "Kaiserslautern",
        "Indirizzo": "Marktstrasse 40",
        "N.ri Tel.": "063163900",
        "Insegna": "HOSENSTUDIO WOLF GMBH",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUC11207-006787,25SBLUC01119-007105,25WBLUK11140-007286,25SBLUC04206-006535,25SBLUC04082-007159,25SBLUC01210-007101,25SBLUC01217-007108,25SBLUC01281-007105"
    },
    "016384": {
        "Stato": "DE",
        "CAP": "54516",
        "Localit\u00e0": "Wittlich",
        "Indirizzo": "Friedrichstrasse 59",
        "N.ri Tel.": "+49 6571 696440",
        "Insegna": "BUNGERT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02289-007119,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC02079-005958,25SBLDC01221-007108,25WBLDC03100-006047,25WBLUC02151-007287,25SBLDC02264-006648,24WBLUK03216-006966,25SBLDC03007-006950,25WBLDK03102-006047"
    },
    "016404": {
        "Stato": "DE",
        "CAP": "44787",
        "Localit\u00e0": "BOCHUM",
        "Indirizzo": "HELLWEG 13",
        "N.ri Tel.": "00492345889944",
        "Insegna": "RUSCH MEN'S SHOES & MORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25SBLUP05190-006804,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUC11541-007110,25SBLUC01047-007120,25WBLUC02151-007287,25SBLUC04206-006535,25WBLUC02153-007300,25SBLUF02188-006804,25SBLUC01217-007108"
    },
    "016409": {
        "Stato": "DE",
        "CAP": "78532",
        "Localit\u00e0": "TUTTLINGEN",
        "Indirizzo": "KOENIGSTRASSE 16",
        "N.ri Tel.": "0049 7461 9102938",
        "Insegna": "EXTRAVAGANT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02064-006100,24WBLDK02043-006648,24WBLDK02043-006648"
    },
    "016448": {
        "Stato": "ES",
        "CAP": "22002",
        "Localit\u00e0": "HUESCA",
        "Indirizzo": "PLAZA NAVARRA 7",
        "N.ri Tel.": "+34 974210707",
        "Insegna": "MIRATE",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02308-006801,25WBLUC03074-006355,25SBLDC11335-007110,24WBLDC03047-006047,24WBLDC02342-006631,25SBLUF01184-006804,25SBLUH02195-004547,25SBLUH02242-007100,24WBLDC02251-006631,25SBLDP02143-007109,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUH02192-004547,25WBLDC03096-006047,25SBLUT02310-006817,25SBLDC02251-006648,25SBLUC11214-007111,25SBLDC04070-007109,25SBLUC04168-006788,25SBLUH02199-004547,25WBLUK11140-007286,25SBLDV01146-007107"
    },
    "016457": {
        "Stato": "UA",
        "CAP": "-",
        "Localit\u00e0": "UZHGOROD",
        "Indirizzo": "ULICA PEREMOGI 5-3",
        "N.ri Tel.": "02/8321103",
        "Insegna": "PUNTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25WBLUC03090-006719,25WBLUC02079-005958,24WBLDC03295-006857,24WBLDX02113-006631,24WBLDC03298-006992,24WBLDK02556-006646,24WBLDB03558-006950,24WBLDK03315-006950,24WBLDC02290-006646,24WBLDK03297-006992,24WBLDC02112-006631,24WBLDL01416-006669,25WBLDK02192-006648,25WBLUC06082-005480,25WBLDX03181-006985,25WBLUL01316-007012,25WBLDK03182-006985,24WBLDK03346-006047"
    },
    "016461": {
        "Stato": "ES",
        "CAP": "50008",
        "Localit\u00e0": "ZARAGOZA",
        "Indirizzo": "CALLE MADRE VEDRUNA,8",
        "N.ri Tel.": "876535315",
        "Insegna": "SIBIRANA RESTANO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02251-006631,24WBLDC02290-006646,24WBLDC03298-006992,24WBLDK03040-006950,25SBLDC01279-007111,25SBLDC04333-007109,25SBLDL02396-007152,25SBLDM01473-007166,25SBLDS01291-007141,25SBLDV01146-007107,25SBLUA04527-007182,25SBLUC01121-007105,25SBLUC04082-007159,25SBLUC11083-007106,25SBLUH02150-007100,25SBLUH02194-004547,25SBLUM01486-007172,25SBLUP04043-007130,25SBLUT02313-006818"
    },
    "016470": {
        "Stato": "DE",
        "CAP": "45472",
        "Localit\u00e0": "Muelheim an der Ruhr",
        "Indirizzo": "Wackelsbeck 57-59",
        "N.ri Tel.": "0049 208780340",
        "Insegna": "PRUEMER'S HAUS DER DAME",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02049-006636,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03119-006951,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02043-006648,24WBLDK02043-006648,24WBLDK02045-006648,24WBLDK03040-006950,24WBLDK03346-006047,24WBLDM01437-007021,24WBLDM04562-007021"
    },
    "016476": {
        "Stato": "DE",
        "CAP": "73525",
        "Localit\u00e0": "DE SCHWAEBISCH GMUEND",
        "Indirizzo": "KALTER MARKT 27",
        "N.ri Tel.": "00497171925920",
        "Insegna": "ROETTELE MAENNERMODE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUK11140-007286"
    },
    "016511": {
        "Stato": "ES",
        "CAP": "25300",
        "Localit\u00e0": "TARREGA",
        "Indirizzo": "PLAZA DEL CARMEN,15",
        "N.ri Tel.": "+34973310556",
        "Insegna": "MODA DAIC",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,25WBLDC02178-006646,25SBLDC02234-006648,24WBLDC02314-006631,25SBLDC03003-006950,25SBLDC01222-007108,24WBLDM09261-006645,25SBLDC01221-007108,25SBLDH02374-006842,25SBLDP01300-007140,25SBLDH03371-005707,24WBLDL01417-006668,24WBLDK03052-006047,25SBLDF03201-006804,25SBLUH02194-004547,25SBLDP05205-006804,25SBLDT02125-006526,25WBLDC03100-006047,24WBLDC02290-006646,25SBLUH02348-007132,25SBLUN02516-007177,25SBLDH02377-007144,25SBLDP01326-007143,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDC02232-007104,24WBLDK03297-006992,25WBLDC03095-006047,25SBLDF03257-007113,24WBLDC03051-006047,24WBLDK02363-005831,25SBLDF08078-007092,25SBLDC01328-007131,25SBLDH02373-005707,24WBLDC03048-006047,24WBLDF03399-006987,25WBLDF08236-007301"
    },
    "016517": {
        "Stato": "DE",
        "CAP": "44225",
        "Localit\u00e0": "DORTMUND",
        "Indirizzo": "HARKORTSTRASSE 25-27",
        "N.ri Tel.": "02317101142",
        "Insegna": "DUSTMANN. ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC01222-007108,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC02342-006631,24WBLDK03346-006047,25WBLDC03100-006047,25WBLUC02151-007287,25SBLDC03007-006950,25SBLDC02330-007119,25SBLUL02409-006547,25SBLDC02236-006648,25SBLUB04167-006854,25WBLDK03102-006047,24WBLDK03040-006950,25SBLUC01210-007101,25SBLUC01217-007108,25SBLUC01281-007105"
    },
    "016520": {
        "Stato": "ES",
        "CAP": "20600",
        "Localit\u00e0": "EIBAR",
        "Indirizzo": "ZULOAGA 9",
        "N.ri Tel.": "943202833",
        "Insegna": "GUBY HOMBRE",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUT02110-006526,25SBLUC01211-007101,25SBLUC04206-006535,25SBLUF03187-006804,25SBLUC04168-006788,25WBLUC06082-005480,25SBLUC04163-006788"
    },
    "016528": {
        "Stato": "DE",
        "CAP": "51429",
        "Localit\u00e0": "Bensberg",
        "Indirizzo": "Schlossstrasse 43",
        "N.ri Tel.": "0049 1775673548",
        "Insegna": "WERNER STUEMPER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287,25WBLUC03233-007308"
    },
    "016594": {
        "Stato": "ES",
        "CAP": "09003",
        "Localit\u00e0": "BURGOS",
        "Indirizzo": "PLAZA ALONSO MARTINEZ N. 7",
        "N.ri Tel.": "0034 947209358",
        "Insegna": "BOUTIQUE GISELA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,24WBLDC02314-006631,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02342-006631,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDK03293-005553,25WBLGC02391-006648,25WBLDB03191-007294,25WBLDK02073-006648,25WBLKC02427-005958,24WBLDK03039-006950,24WBLDK02043-006648,25WBLDC03096-006047,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDK02192-006648,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25WBLKC02429-005958,24WBLDK03346-006047"
    },
    "016836": {
        "Stato": "DE",
        "CAP": "32052",
        "Localit\u00e0": "Herford",
        "Indirizzo": "Gehrenberg 11",
        "Insegna": "Klingenthal (Herford)",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLDC02264-006648,25SBLDC02236-006648,24WBLDC02342-006631,24WBLDK02311-006648,24WBLDK02043-006648,25WBLDK02192-006648,25WBLDC02178-006646,24WBLDK03346-006047,25SBLDC03007-006950,24WBLDK03040-006950,25SBLDC01222-007108,25SBLDC01221-007108,24WBLDC02112-006631,24WBLDC02250-007008"
    },
    "016842": {
        "Stato": "DE",
        "CAP": "33330",
        "Localit\u00e0": "Paderborn",
        "Indirizzo": "Westernstrasse 22-24",
        "N.ri Tel.": "+4952512860",
        "Insegna": "Klingenthal (Guetersloh)",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLDC02178-006646,25SBLDC01222-007108,25SBLDC01221-007108,24WBLDC02342-006631,24WBLDK02311-006648,25WBLDK02073-006648,25SBLDC02264-006648,24WBLDK02043-006648,25SBLDC03007-006950,24WBLDC02112-006631,24WBLDC02250-007008,25SBLDC02236-006648,25WBLDK02192-006648,24WBLDC03252-007008,25SBLDC04066-007109,24WBLDK03040-006950,24WBLDK03346-006047"
    },
    "016919": {
        "Stato": "ES",
        "CAP": "37002",
        "Localit\u00e0": "SALAMANCA",
        "Indirizzo": "ANAMONT C / ZAMORA 84-86",
        "N.ri Tel.": "0034 923267680",
        "Insegna": "ANAMONT",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25SBLUA04528-007183,24WBLDK11337-006007,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK03293-005553,25WBLDB03191-007294,25SBLUT02317-007116,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUC11083-007106,25SBLUP04353-007129,25SBLUM01486-007172,25SBLDF08078-007092,24WBLDC02352-006977,25SBLDC02357-007124,25SBLDV01146-007107,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDK02556-006646,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUH02276-005695,24WBLDL01416-006669,24WBLDF16106-006960,24WBLDC02112-006631,25WBLUC03090-006719,25WBLDC02178-006646,25SBLUC01115-007105,24WBLDC03038-006950,25SBLUP04043-007130,24WBLDC02290-006646,25WBLDC03096-006047,25SBLDC04331-006788,25SBLUS01337-007137,25SBLDC04333-007109,25SBLDP01140-007109,25SBLUP01324-007130,25WBLDK03103-006047,24WBLDC05357-005831,25WBLDK03102-006047,25SBLUA04525-007182,25WBLDK03101-006047,25SBLDV02296-007143,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC11335-007110,25SBLUC11207-006787,25SBLDF03076-007092,25SBLUB01216-007111,24WBLDB02092-006976,25SBLUT02313-006818,25WBLDK11162-007110,25SBLDC01159-007105,25SBLUK11239-007110,24WBLDK02363-005831,25SBLUC04082-007159,25SBLUH05028-006846,25SBLDC04066-007109,24WBLDF02101-006960"
    },
    "017147": {
        "Stato": "CZ",
        "CAP": "73951",
        "Localit\u00e0": "Praha 1",
        "Indirizzo": "Rytirsjka 13/534",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03038-006950"
    },
    "017215": {
        "Stato": "ES",
        "CAP": "08401",
        "Localit\u00e0": "GRANOLLERS-BARCELONA",
        "Indirizzo": "CALLE ANSELM CLAVE 16",
        "N.ri Tel.": "0034 938 790 529",
        "Insegna": "EXIT BCN",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDX02113-006631,25SBLDH03371-005707,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDC02251-006631,25WBLDC03100-006047,25SBLUH02348-007132,25SBLUT02312-006803,25SBLDS01366-007141,25SBLKF02553-007187,25SBLUC01209-007101,25SBLUC03012-006719,25WBLUC03086-006047,25SBLUC03013-006719,24WBLDC02352-006977,25SBLUX02230-005958,25WBLDA05337-006127,25SBLUP05190-006804,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDH02377-007147,25SBLDX02235-006648,25SBLUH02196-004547,25SBLUC02229-005958,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUH02242-007100,25SBLUF03186-006804,25SBLUA04524-007182,25SBLUH02276-005695,25SBLUP04322-007129,25SBLKP01554-007187,25SBLUF01055-007092,25WBLDC03092-006719,25SBLUH02275-007100,25SBLUH01149-007100,25WBLDC03099-006047,25WBLDF08236-007301,25SBLDC01279-007111,25SBLDP05301-007140,25WBLDC02178-006646,25SBLUA04527-007182,25SBLUP01189-006804,25SBLKF03551-007187,25SBLGF02547-007187,24WBLDC03038-006950,25SBLUF01184-006804,25SBLDV03365-007143,25SBLDH02389-007144,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDM01473-007166,25WBLDK03103-006047,25SBLDC03006-006950,25WBLDC03097-006047,25SBLUC01281-007105,24WBLDK03346-006047,25SBLUM01476-006233,25SBLUM03490-007170,25SBLUC11569-006787,25SBLDP01300-007140,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDK03052-006047,25SBLDC11335-007110,25SBLUC11207-006787,25SBLUH02192-004547,25SBLDV05299-007138,25WBLDK11162-007110,25SBLUN02513-007179,25SBLGH02495-007144,25SBLDF03257-007113,24WBLDK02363-005831,25SBLDC04066-007109,25SBLUT02315-007117"
    },
    "017225": {
        "Stato": "RU",
        "CAP": "119334",
        "Localit\u00e0": "MOSCA",
        "Indirizzo": "LENINSKIY avenue 41/2",
        "N.ri Tel.": "02/8321103",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017376": {
        "Stato": "ES",
        "CAP": "17250",
        "Localit\u00e0": "PLATJA D'ARO",
        "Indirizzo": "AV. STRASBOURG, 1",
        "N.ri Tel.": "972 81 84 12",
        "Insegna": "MARC FRANC",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUP05033-007094,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDV02296-007143,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUP01189-006804,24WBLDK03052-006047,25SBLDC11335-007110,24WBLDC03047-006047,25WBLUC03233-007308,25SBLDP05205-006804,25SBLDT02125-006526,25SBLDV03365-007143,25SBLUC04176-006854,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUH02348-007132,25SBLUT02312-006803,25WBLDC03096-006047,25SBLDC01159-007105,25SBLUL02403-006543,25SBLUF03031-007094,25WBLDC03095-006047,25SBLDC04331-006788,24WBLDC03051-006047,25SBLDX02290-007119,25SBLUH02030-006846,25SBLDF08078-007092,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDK03098-006047"
    },
    "017643": {
        "Stato": "DE",
        "CAP": "06116",
        "Localit\u00e0": "HALLE (SAALE)",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "0049 30 814 59040",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02311-006648,24WBLDC02250-007008"
    },
    "017850": {
        "Stato": "CZ",
        "CAP": "779 00",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "TYNECKA 714/6",
        "N.ri Tel.": "00420777934924",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP05530-007173,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "018122": {
        "Stato": "SM",
        "CAP": "47891",
        "Localit\u00e0": "FALCIANO SAN MARINO",
        "Indirizzo": "STRADA DEL BARGELLO, 80",
        "N.ri Tel.": "334 2267373",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018124": {
        "Stato": "ES",
        "CAP": "48993",
        "Localit\u00e0": "GETXO",
        "Indirizzo": "C/ LAS MERCEDES ( BAJO AREETA) , 20",
        "N.ri Tel.": "946640379",
        "Insegna": "ZABALA JOVEN",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02346-007132,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUB01216-007111,24WBLDK07405-005480,25SBLUC11214-007111,25SBLUC04163-006788,25WBLUK11140-007286"
    },
    "018380": {
        "Stato": "DE",
        "CAP": "68163",
        "Localit\u00e0": "MANNHEIM",
        "Indirizzo": "FABRIKSTATIONSTR. 40",
        "N.ri Tel.": " 00496211670100",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018451": {
        "Stato": "ES",
        "CAP": "31001",
        "Localit\u00e0": "PAMPLONA",
        "Indirizzo": "MAYOR, 5",
        "N.ri Tel.": "948222845",
        "Insegna": "ARTAZCOZ PROFESIONAL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUB01216-007111,25SBLUF03186-006804,25SBLUT02110-006526,25SBLUC01211-007101,25SBLUC04206-006535,25SBLUC04163-006788,25WBLUK11140-007286"
    },
    "018485": {
        "Stato": "SK",
        "CAP": "76001",
        "Localit\u00e0": "Zilina",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03040-006950,25SBLDF03201-006804,25SBLDM08474-007166,25SBLDP05301-007140,25SBLDX02290-007119"
    },
    "018549": {
        "Stato": "ES",
        "CAP": "08700",
        "Localit\u00e0": "IGUALADA",
        "Indirizzo": "RAMBLA GENERAL VIVES, 19",
        "N.ri Tel.": "938032867",
        "Insegna": "Llucia Moda",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDV02296-007143,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDP01300-007140,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,25SBLUT02346-007132,24WBLDK03052-006047,25SBLDH02381-007114,24WBLDC03047-006047,25SBLUC11207-006787,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUF01568-007121,24WBLDK02042-006648,25SBLUF01184-006804,25SBLUH02195-004547,25SBLDV03365-007143,25SBLDT02125-006526,25SBLDF03076-007092,25SBLUT02317-007116,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDS01291-007141,25SBLUC01211-007101,25SBLDH02377-007144,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDC03095-006047,25SBLDF03257-007113,25SBLDP05141-007109,25SBLDM01473-007166,25WBLDK03103-006047,25WBLUC06082-005480,25WBLDF08248-006948,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDF08236-007301,25SBLUC01217-007108"
    },
    "018648": {
        "Stato": "RU",
        "CAP": "443041",
        "Localit\u00e0": "SAMARA",
        "Indirizzo": "MOSCOW HIGHWAY 81B",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03558-006950,25SBLUP04353-007139"
    },
    "018649": {
        "Stato": "ES",
        "CAP": "08530",
        "Localit\u00e0": "LA GARRIGA",
        "Indirizzo": "LLTUS BEE FREE, C/CENTRE 13",
        "N.ri Tel.": "617158382",
        "Insegna": "CARLOS ORIOL ARGIMON",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC08078-006355,24WBLDC03114-006719,25SBLUT02308-006801,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUF01184-006804,24WBLDK03039-006950,25WBLDC03095-006047,25WBLUC03086-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUF03185-006804"
    },
    "018915": {
        "Stato": "ES",
        "CAP": "48970",
        "Localit\u00e0": "Basauri",
        "Indirizzo": "Berriochoa, 1",
        "N.ri Tel.": "+34688696406",
        "Insegna": "Modas Pascual",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDC02072-006648,25WBLUC08078-006355,24WBLDC02314-006631,25SBLUT02346-007132,24WBLDX02113-006631,25SBLDC11335-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUC04206-006535,25SBLDC03007-006950,25SBLUT02306-006801,25SBLUC11214-007111,24WBLDK02363-005831,25WBLDC02170-006648,24WBLDC05357-005831,25SBLDF08078-007092,24WBLDC02352-006977,25SBLDC01328-007131,25SBLUC01034-007111,25WBLDC03099-006047,25SBLDC04066-007109,25SBLDC01279-007111,25SBLUF03185-006804"
    },
    "018938": {
        "Stato": "ES",
        "CAP": "08192",
        "Localit\u00e0": "SAN QUIRZE DEL VALLES",
        "Indirizzo": "RAMBLA LLUIS COMPANY, 18B",
        "N.ri Tel.": "638011639",
        "Insegna": "EVA SEVILLA FASION STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03084-006976,25SBLDC01221-007108,24WBLDK11337-006007,25SBLUH02194-004547,25SBLDT02125-006526,25SBLDF03076-007092,25SBLUA04524-007182,25SBLUP04062-007092,25WBLDK11162-007110,25SBLDC01159-007105,25SBLUL02403-006543,24WBLDX03318-006992,25SBLUN02513-007179,25SBLDC03007-006950,25WBLDC03095-006047,25SBLUP02038-007096,25SBLDC04333-007109,25SBLDP05141-007109,25SBLUM01486-007172,25SBLUP04354-007129,25WBLDK02192-006648,24WBLDC02352-006977,25SBLUH05028-006846,25WBLDC03099-006047,25SBLUP02063-007092,24WBLDK03346-006047"
    },
    "018994": {
        "Stato": "ES",
        "CAP": "48005",
        "Localit\u00e0": "BILBAO",
        "Indirizzo": "VICTOR 1, ESQ BIDEBARRIETA, P 1",
        "N.ri Tel.": "944158520",
        "Insegna": "VESMAN",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019109": {
        "Stato": "ES",
        "CAP": "49600",
        "Localit\u00e0": "ZAMORA",
        "Indirizzo": "CALLE RUA, 26",
        "N.ri Tel.": "980632076",
        "Insegna": "JAPPA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLDC02233-007104,24WBLDC02049-006636,25WBLDC02178-006646,24WBLDC03295-006857,25SBLDC11335-007110,25SBLDH02376-006842,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDK02042-006648,24WBLDK02353-006985,25SBLDT02125-006526,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC03007-006950,25SBLDK01249-007111,25SBLDC04331-006788,24WBLDC05357-005831,24WBLDC02352-006977,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDK03098-006047,24WBLDK03040-006950,25SBLDC01279-007111"
    },
    "019117": {
        "Stato": "ES",
        "CAP": "09200",
        "Localit\u00e0": "MIRANDA DE EBRO, BURGOS",
        "Indirizzo": "AVINGUDA COMUNEROS DE CASTILLA, 8",
        "N.ri Tel.": "947330936",
        "Insegna": "GLOBAL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02346-007132,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUF03186-006804,25WBLUC03086-006047,25SBLUC01034-007111,25SBLUC01210-007101,25WBLUK11140-007286,25SBLUC01281-007105"
    },
    "019125": {
        "Stato": "ES",
        "CAP": "01005",
        "Localit\u00e0": "VITORIA GASTEIZ, ALAVA",
        "Indirizzo": "PLAZA GENERAL LOMA, 4",
        "N.ri Tel.": "9452333617",
        "Insegna": "EMILIO RUIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25SBLUH02109-006526,25SBLUT02346-007132,25SBLUF01184-006804,25SBLUF03186-006804,25SBLUT02110-006526,25SBLUC04206-006535,25SBLUK11239-007110,25SBLUC01034-007111,25SBLUC04163-006788,25WBLUK11140-007286"
    },
    "019254": {
        "Stato": "ES",
        "CAP": "39300",
        "Localit\u00e0": "TORRELAVEGA - CANTABRIA",
        "Indirizzo": "CALLE JOSE FELIPE QUIJANO (ANCHA) 2",
        "N.ri Tel.": "942880840",
        "Insegna": "ADRIANA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC03084-006976,24WBLDC02049-006636,25WBLDK03101-006047,24WBLDK03052-006047,25SBLDC11335-007110,25WBLDC03100-006047,25SBLDC01159-007105,24WBLDX03318-006992,25SBLDC04331-006788,24WBLDC03051-006047,24WBLDK03086-006976,24WBLDK03122-006955,24WBLDC02352-006977,25SBLDC04066-007109,24WBLDK03040-006950,25SBLDC01329-007131"
    },
    "019285": {
        "Stato": "ES",
        "CAP": "31500",
        "Localit\u00e0": "TUDELA, NAVARRA",
        "Indirizzo": "AV. ZARAGOZA 14",
        "N.ri Tel.": "948820061",
        "Insegna": "AQUERRETA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUX02081-005958,25WBLUC03086-006047"
    },
    "019310": {
        "Stato": "ES",
        "CAP": "08398",
        "Localit\u00e0": "SANTA SUSANNA",
        "Indirizzo": "PLAZA DE LA TORRE S/N",
        "N.ri Tel.": "626049999",
        "Insegna": "SANTA SUSANA ORIGINAL STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03084-006976,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDC03100-006047,24WBLDC02290-006646,24WBLDC03051-006047,25WBLUC03086-006047,25WBLDK03102-006047,25WBLDK03098-006047,24WBLDK03040-006950,25WBLDC03097-006047"
    },
    "019316": {
        "Stato": "ES",
        "CAP": "39700",
        "Localit\u00e0": "CASTRO URDIALES, CANTABRIA",
        "Indirizzo": "JUAN DE LA COSA, 10",
        "N.ri Tel.": "637773089",
        "Insegna": "EL BORNE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC03084-006976,24WBLDC02044-006648,25WBLDC03173-007307,24WBLDC02314-006631,25SBLDC01222-007108,24WBLDC03295-006857,24WBLDX02113-006631,24WBLDK11337-006007,25SBLDC01358-007101,24WBLDC02342-006631,24WBLDC03298-006992,25SBLDF03076-007092,24WBLDK03039-006950,25WBLDK11162-007110,25SBLDK01249-007111,25SBLDP01140-007109,25WBLDC02170-006648,25WBLDL01340-007355,24WBLDB03294-005553,25WBLDK02192-006648,24WBLDL01420-007016,24WBLDC02352-006977,25WBLDA05335-007349,25WBLDC03099-006047,25SBLDC04066-007109,25SBLDC01279-007111,24WBLDC02112-006631"
    },
    "019335": {
        "Stato": "DE",
        "CAP": "85586",
        "Localit\u00e0": "WITTEN",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK07405-005480"
    },
    "019423": {
        "Stato": "ES",
        "CAP": "36211",
        "Localit\u00e0": "VIGO, PONTEVEDRA",
        "Indirizzo": "AVDA. CAMELIAS, 130-BAJO",
        "N.ri Tel.": "0034 986235163",
        "Insegna": "BOXER",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25WBLUC03090-006719,25SBLUA04527-007182,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUH02195-004547,25SBLUA04524-007182,24WBLDC02290-006646,25SBLUC01211-007101,25SBLUC11214-007111,25SBLUF01055-007092,25WBLUC06082-005480,25SBLUH02199-004547"
    },
    "019469": {
        "Stato": "ES",
        "CAP": "24402",
        "Localit\u00e0": "PONFERRADA (LEON)",
        "Indirizzo": "C/ DOCTOR FLEMING 2",
        "N.ri Tel.": "0034 987405187",
        "Insegna": "CHERIE 1961",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,25WBLDK03101-006047,25WBLUC08078-006355,25WBLUK03142-005480,24WBLDX02113-006631,24WBLDK03052-006047,25SBLDC11335-007110,24WBLDC02342-006631,25SBLUH02194-004547,24WBLDK03039-006950,25SBLUT02312-006803,25SBLUC01211-007101,25SBLDC01159-007105,25SBLDC03007-006950,25SBLUC11083-007106,25WBLDK03103-006047,24WBLDF01398-006987,25SBLUH02274-007100,25WBLDC03099-006047,25WBLDK03098-006047,24WBLDK03040-006950,24WBLDF03399-006987,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "019516": {
        "Stato": "ZA",
        "CAP": "-",
        "Localit\u00e0": "Cape Town",
        "Indirizzo": "Shop 7237, V&A Waterfront",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019599": {
        "Stato": "CZ",
        "CAP": "602 00",
        "Localit\u00e0": "Brno",
        "Indirizzo": "PLAZA FASHION store, HERSPCKA 1009/11c",
        "N.ri Tel.": "+ 42 0774555888",
        "Insegna": "Plaza Fashion store",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC03233-007308,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUC01211-007101,25SBLUC02227-007104,25SBLDC02232-007104,25SBLDS01366-007141,25SBLDC02330-007119,24WBLDK03120-006951,25SBLDF08078-007092,24WBLDK03122-006955,25SBLDH02373-005707,24WBLDK03040-006950,25WBLDA05337-006127,25SBLUP05033-007094,25SBLDC02289-007119,25SBLDH02374-006842,25SBLDH02377-007147,25SBLDL02396-007156,25SBLDT02125-006526,25SBLUH02276-005695,24WBLDK02043-006648,25SBLUP04322-007129,25SBLUS01338-007137,25SBLUH02275-007100,25SBLDP05080-007092,25WBLUK11140-007286,24WBLDC02112-006631,25WBLDK03161-006719,25WBLDC02178-006646,24WBLDA05467-006434,25SBLDC01358-007101,25SBLUH02197-004547,24WBLDX03318-006992,25SBLDC03007-006950,25SBLDC02128-007103,24WBLDC03051-006047,25SBLDP05141-007109,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDA05465-006127,25WBLDA05335-007349,25SBLUH02394-007114,25WBLDC03097-006047,24WBLDK03346-006047,25SBLUH02193-004547,25WBLDK03101-006047,25SBLDV02296-007143,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02387-007144,25SBLUN02513-007179,25SBLDT02138-006526,25WBLDC02170-006648,25WBLUA05301-006434,25WBLDK03098-006047,25WBLUA05297-006127"
    },
    "019622": {
        "Stato": "ES",
        "CAP": "43201",
        "Localit\u00e0": "REUS",
        "Indirizzo": "C/VIDRE 28",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02314-006631,25SBLDH02387-007144,25SBLUC01210-007101"
    },
    "019663": {
        "Stato": "ES",
        "CAP": "34002",
        "Localit\u00e0": "PALENCIA",
        "Indirizzo": "CALLE MUNTANER 83 B, LOCAL 1",
        "N.ri Tel.": "619768266",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03038-006950,25SBLUT02317-007116,25SBLUH02275-007100"
    },
    "019862": {
        "Stato": "PL",
        "CAP": "43-300",
        "Localit\u00e0": "Bielsko Biala",
        "Indirizzo": "Barlickiego 4",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02244-007100"
    },
    "019884": {
        "Stato": "ES",
        "CAP": "43001",
        "Localit\u00e0": "TARRAGONA",
        "Indirizzo": "CARRER UNIO 12",
        "N.ri Tel.": "977214201",
        "Insegna": "TACCO DISTANTE",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,25WBLDC02178-006646,24WBLDC03114-006719,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDX02113-006631,25SBLDC11335-007110,24WBLDK11337-006007,24WBLDC03298-006992,25SBLDH03369-006845,25SBLDP05205-006804,25SBLDV03365-007143,25SBLDP02143-007109,25SBLDF03076-007092,25SBLDC01359-007101,25SBLDC11237-007110,25WBLDK11162-007110,24WBLDX03318-006992,25SBLDH02370-006845,25WBLDC03095-006047,25SBLDC04333-007109,25SBLDP01140-007109,25SBLDM01473-007166,25WBLDK02192-006648,24WBLDC02352-006977,25SBLDH02375-006842,25SBLUC01034-007111,25SBLDP05080-007092,25WBLDC03099-006047,24WBLDK03040-006950,24WBLDC02112-006631"
    },
    "019890": {
        "Stato": "DE",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ESCHENBRUENNLESTRASSE 11",
        "N.ri Tel.": "0049 711 2110",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,24WBLDC03036-006950,24WBLDC02044-006648"
    },
    "019924": {
        "Stato": "DE",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ESCHENBRUENNLESTRASSE 11",
        "N.ri Tel.": "070316160",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019948": {
        "Stato": "PL",
        "CAP": "370 01",
        "Localit\u00e0": "Legionowo, PL",
        "Indirizzo": "Namesti Otakara Premysla II 36",
        "N.ri Tel.": "572 383 562",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03038-006950,24WBLDK03039-006950,24WBLDC03048-006047,25SBLUX03226-006719"
    },
    "019976": {
        "Stato": "ES",
        "CAP": "20004",
        "Localit\u00e0": "SAN SEBASTIAN",
        "Indirizzo": "CHURRUCA, 3",
        "N.ri Tel.": "943441689",
        "Insegna": "NOA & JUDY",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,24WBLDK03037-006950,25WBLDK03101-006047,24WBLDC02044-006648,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDK03293-005553,24WBLDK02353-006985,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDK02043-006648,25WBLDK03103-006047,25WBLDC03099-006047,25WBLDK03098-006047,24WBLDK03040-006950,24WBLDK03346-006047"
    },
    "019988": {
        "Stato": "ES",
        "CAP": "20008",
        "Localit\u00e0": "SAN SEBASTIAN, GUIPUZCOA",
        "Indirizzo": "ONDARBIDE, 3",
        "N.ri Tel.": "943212109",
        "Insegna": "TOME",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLUC02079-005958,24WBLDC03114-006719,25WBLUC03074-006355,25SBLDH02374-006842,25SBLDC11335-007110,24WBLDK11337-006007,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUC04176-006854,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUT02312-006803,25SBLUC01211-007101,24WBLDK02043-006648,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDK01249-007111,25SBLUH02241-007100,25SBLDM01473-007166,25WBLUC03086-006047,25SBLUC04168-006788,25SBLDC01328-007131,25SBLUC01034-007111,25WBLDK03102-006047,25SBLDC04066-007109,25SBLUT02315-007117,25SBLDC01279-007111"
    },
    "020333": {
        "Stato": "ES",
        "CAP": "35109",
        "Localit\u00e0": "MADRID",
        "Indirizzo": "CR. ANDALUCIA KM 22.800, VALDEMORO",
        "N.ri Tel.": "928 72 12 55",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF01055-007092"
    },
    "020342": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+49(0)40 638569-427",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLDC02236-006648,25SBLUC02227-007104,24WBLDK02043-006648,25WBLDK02069-006648,24WBLDC02044-006648,25WBLDK02192-006648,24WBLDC02041-006648,24WBLDC03114-006719,25SBLUX02230-005958,25SBLDC02232-007104,25WBLDC02170-006648,25WBLDK02073-006648"
    },
    "020760": {
        "Stato": "ES",
        "CAP": "39003",
        "Localit\u00e0": "Santander",
        "Indirizzo": "Plaza Pombo 3",
        "Insegna": "GOLF",
        "CODICE PRODOTTO KOOOMO": "24WBLDL01417-006668,24WBLDK11337-006007,25WBLDK11162-007110,24WBLDL01420-007016,24WBLDC02352-006977,25WBLDC03173-007307,24WBLDC02314-006631,25WBLDL01346-007354"
    },
    "020854": {
        "Stato": "DE",
        "CAP": "73951",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03346-006047,24WBLDK02045-006648,24WBLDC02041-006648,25SBLDC02236-006648,25SBLDC03006-006950,25SBLDC02128-007103"
    },
    "020859": {
        "Stato": "RU",
        "CAP": "644123",
        "Localit\u00e0": "OMSK",
        "Indirizzo": "70 LET OKTYABRYA, 22/1 APT. 56",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02276-005695,25SBLUL02412-007155"
    },
    "020927": {
        "Stato": "UA",
        "CAP": "85748",
        "Localit\u00e0": "GARCHING",
        "Indirizzo": "PR. POBEDI 90",
        "N.ri Tel.": "0049 89 5527860",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03182-006985"
    },
    "020957": {
        "Stato": "CZ",
        "CAP": "360 01",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "Vridelni 33",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03039-006950,25SBLUC02228-007104"
    },
    "021101": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "VALLADOLID",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "983313162",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03051-006047,24WBLDC03051-006047"
    },
    "021122": {
        "Stato": "AT",
        "CAP": "1140",
        "Localit\u00e0": "Wien",
        "Indirizzo": "Hutteldorferstr.163-165",
        "N.ri Tel.": "0043 198231740",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950"
    },
    "021457": {
        "Stato": "ES",
        "CAP": "43850",
        "Localit\u00e0": "Manlleu",
        "Indirizzo": "Carrer de la Font numero 1",
        "N.ri Tel.": "660988497",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDF01398-006987,24WBLDF08400-006987,24WBLDF03399-006987,24WBLDC03252-007008,24WBLDC03048-006047,25SBLDC11335-007110,25SBLUC01209-007101,25SBLUF03186-006804,25SBLUH02150-007100,25SBLDH02373-005707,25SBLUH02195-004547,25SBLDC04331-006788,25SBLDH02386-007144,25SBLDX02235-006648,25SBLDC03006-006950,25SBLDH02377-007144,25SBLUH02199-004547,25SBLUC11541-007110,25SBLUH02192-004547"
    },
    "021674": {
        "Stato": "DE",
        "CAP": "82031",
        "Localit\u00e0": "GRUNWALD, VACIJA",
        "Indirizzo": "NORDLICHE MUNCHNER STRASSE 47",
        "N.ri Tel.": "+49 30 300131800",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUA04528-007183,25SBLUP05190-006804,24WBLDA05467-006434,25SBLUN02510-007177,24WBLDC03295-006857,25SBLDX02235-006648,25SBLUC11215-007110,25SBLUP01189-006804,25SBLDL02396-007156,24WBLDK03315-006950,25SBLUF03186-006804,25SBLUH02197-004547,25SBLUF02188-006804,25SBLDF08078-007092,25SBLDL02399-007155,25SBLUH02199-004547,25SBLUL02583-007370,25SBLUP02352-006855"
    },
    "021678": {
        "Stato": "RU",
        "CAP": "97-306",
        "Localit\u00e0": "Tallinn",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "02/8321103",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355"
    },
    "021971": {
        "Stato": "DE",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ESCHENBRUENNLESTRASSE 11",
        "N.ri Tel.": "070316160",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,25SBLDC02357-007124,24WBLDK07405-005480,24WBLDK03346-006047"
    },
    "022054": {
        "Stato": "PL",
        "CAP": "12915",
        "Localit\u00e0": "TALLIN MOW",
        "Indirizzo": "HARJU MAAKOND, MUSTAMAE LINNAOSA, LAKI TN 25, OFFICE 301",
        "Insegna": "OSCAR (ULAN UDE)",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "022064": {
        "Stato": "PL",
        "CAP": "12915",
        "Localit\u00e0": "TALLIN MOW",
        "Indirizzo": "HARJU MAAKOND, MUSTAMAE LINNAOSA, LAKI TN 25, OFFICE 301",
        "Insegna": "TRADING CENTER \"KNYAZHY DVOR\"",
        "CODICE PRODOTTO KOOOMO": "25SBLUA04524-007182,25SBLUF01184-006804,25SBLUF03037-007096,25SBLUH02103-007149,25SBLUP01189-006804,25SBLUP02038-007096,25SBLUP04353-007139,25SBLUX02230-005958"
    },
    "022077": {
        "Stato": "RU",
        "CAP": "95463",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "988 60 25 20",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUL02409-006547"
    },
    "022078": {
        "Stato": "PL",
        "CAP": "72-500",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "795 137 494",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02043-006648,25SBLDK01249-007111,25WBLDK02073-006648"
    },
    "022091": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": ". +34 650958601",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUN02516-007177,25SBLUM01486-007172,25WBLUC03233-007308,25SBLUH02108-006864,25SBLUP04322-007129,25SBLUS01337-007137,25SBLUH02241-007100"
    },
    "022157": {
        "Stato": "GB",
        "CAP": "YO21 3BS",
        "Localit\u00e0": "WHITBY",
        "Indirizzo": "GOLDEN LION STREET 4/4A",
        "N.ri Tel.": "+44 7818424432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDK02556-006646,25SBLUF03037-007096"
    },
    "022206": {
        "Stato": "UA",
        "CAP": "49000",
        "Localit\u00e0": "HALLE (SAALE)",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "02/8321103",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,24WBLDC02049-006636,25SBLUP05190-006804,25SBLDH02374-006842,25SBLUP01189-006804,25SBLUC01046-007120,25SBLUC11207-006787,24WBLDK02311-006648,24WBLDB03558-006950,25SBLUM06481-007168,24WBLDC02251-006631,25SBLUP04043-007130,25SBLUH02379-007147,25SBLUM01480-007168,25SBLDS01366-007141,25SBLDC02128-007103,25SBLUS01337-007137,25SBLUP01324-007130,25SBLUC11214-007111,24WBLDK03120-006951,25SBLUF02188-006804,25SBLUP04354-007129,25SBLUP03535-006873,25SBLDP05080-007092,25SBLUP03534-006873"
    },
    "022239": {
        "Stato": "ES",
        "CAP": "34002",
        "Localit\u00e0": "SANTIAGO DE COMPOSTELA",
        "Indirizzo": "CALLE TORRENT, 45",
        "N.ri Tel.": "699913377",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02363-005831,24WBLDC03298-006992,24WBLDK03297-006992,25SBLDP02345-006855,25SBLDC11237-007110,25SBLDM01473-007166,25SBLDP01344-006855,25SBLDT02125-006526,25SBLDV05299-007138,25SBLDH03369-006845"
    },
    "022240": {
        "Stato": "GB",
        "CAP": "WA10 1RY",
        "Localit\u00e0": "St Helens",
        "Indirizzo": "44 Barrow Street",
        "N.ri Tel.": "+441744730985",
        "Insegna": "Store name - OD's",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC02250-007008,24WBLDC02290-006646,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDK02045-006648,24WBLDK02556-006646,24WBLDK03122-006955"
    },
    "000001": {
        "Stato": "IT",
        "CAP": "35131",
        "Localit\u00e0": "PADOVA",
        "Indirizzo": "VICOLO BELLINI, 12",
        "N.ri Tel.": "0444 635146",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000048": {
        "Stato": "IT",
        "CAP": "66023",
        "Localit\u00e0": "FRANCAVILLA AL MARE",
        "Indirizzo": "VIALE NETTUNO, 155",
        "N.ri Tel.": "085 4910656",
        "Insegna": "DEL RE",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLDK03101-006047,25SBLUP05190-006804,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUT02313-006818,25SBLUS01338-007137,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC02080-005958,25WBLDC03097-006047"
    },
    "000089": {
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA S. TOMMASO D'AQUINO",
        "N.ri Tel.": "081 407010",
        "Insegna": "ANTONIO BARBARO",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000123": {
        "Stato": "IT",
        "CAP": "36075",
        "Localit\u00e0": "ALTE DI MONTECCHIO MAGGIORE",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25SBLDX03008-006950,24WBLDK03037-006950,24WBLDC03114-006719,25SBLDC02234-006648,25WBLDC03357-007294,25SBLDC01222-007108,25WBLUA05299-006127,25SBLDC01221-007108,25WBLDC03097-006047,25WBLUL01316-007012,24WBLDX02113-006631,24WBLDK11337-006007,24WBLDC02342-006631,25SBLKC06443-007101,25SBLKC02430-007104,25WBLDC03100-006047,25SBLGC02432-007104,24WBLDK02043-006648,25WBLDK11162-007110,25WBLUA05297-006127,25SBLDC02128-007103,25WBLDK05019-007298,24WBLDB03294-005553,25SBLDM01473-007166,25SBBKC01452-007111,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDK03098-006047,25SBLDP05301-007140"
    },
    "000126": {
        "Stato": "IT",
        "CAP": "00040",
        "Localit\u00e0": "MARINO",
        "Indirizzo": "VIA APPIA NUOVA KM 19,4",
        "N.ri Tel.": "06 93548512",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,24WBLDK03086-006976,25SBLGC01441-007111,25SBLKC06443-007101,25SBLDC01279-007111"
    },
    "000127": {
        "Stato": "IT",
        "CAP": "36075",
        "Localit\u00e0": "GADESCO PIEVE DELMONA",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000128": {
        "Stato": "IT",
        "CAP": "27050",
        "Localit\u00e0": "CODEVILLA",
        "Indirizzo": "VIA RIVO BRIGNOLO, 2/6",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02250-007008,25SBLGF03548-007187,25SBLGP05549-007187,25SBLKC01445-007101,25SBLKP05558-007187"
    },
    "000139": {
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "CORSO MAZZINI, 199/201",
        "N.ri Tel.": "0968 29281",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000140": {
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA XX SETTEMBRE, 62",
        "N.ri Tel.": "0968 29281",
        "Insegna": "MARVIN",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01211-007101,25SBLUC01219-007108,25SBLUC11207-006787,25SBLUH02194-004547,25SBLUT02309-007125,25SBLUX02230-005958"
    },
    "000145": {
        "Stato": "IT",
        "CAP": "00157",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA CURIONI, 37",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,25WBLDC02178-006646,24WBLDC03048-006047"
    },
    "000177": {
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "VIA TIBERIO SOLIS, 98",
        "N.ri Tel.": "0882 222487",
        "Insegna": "CRISTALLI UOMO",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000181": {
        "Stato": "IT",
        "CAP": "56025",
        "Localit\u00e0": "PONTEDERA",
        "Indirizzo": "CORSO MATTEOTTI, 8",
        "N.ri Tel.": "0587 52735",
        "Insegna": "CARNABY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUH02196-004547,25SBLUT02346-007132,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUH02241-007100,25SBLUC11214-007111,25WBLDK03103-006047,25SBLUF02188-006804,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUH02274-007100,24WBLDC03048-006047,25SBLUL02583-007370,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "000186": {
        "Stato": "IT",
        "CAP": "93100",
        "Localit\u00e0": "CALTANISSETTA",
        "Indirizzo": "VIA ROSSO DI SAN SECONDO, 87",
        "N.ri Tel.": "0934 599289",
        "Insegna": "CIP SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25WBLDC03097-006047,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDA05465-006127,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,25WBLDK03102-006047,25WBLUA05301-006434,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUP02352-006855,25WBLDA05337-006127"
    },
    "000207": {
        "Stato": "IT",
        "CAP": "45044",
        "Localit\u00e0": "COLLECCHIO",
        "Indirizzo": "VIA PERTINI, 1",
        "N.ri Tel.": "0521 806868",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648"
    },
    "000214": {
        "Stato": "IT",
        "CAP": "70032",
        "Localit\u00e0": "BITONTO",
        "Indirizzo": "VIA REP. ITALIANA, 50",
        "N.ri Tel.": "080 3756075",
        "Insegna": "GIALLO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC03047-006047,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03095-006047,25WBLUC02080-005958,25WBLDK03102-006047"
    },
    "000224": {
        "Stato": "IT",
        "CAP": "06023",
        "Localit\u00e0": "GUALDOTADINO",
        "Indirizzo": "VIA FRANCO STORELLI, 96",
        "N.ri Tel.": "075 912244",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000229": {
        "Stato": "IT",
        "CAP": "20162",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA VALFURVA, 3",
        "N.ri Tel.": "02 6437773",
        "Insegna": "GRIP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC03119-006951,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,25SBLDP01079-007092,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK02042-006648,25SBLDF03076-007092,25SBLUB01216-007111,25SBLUP04062-007092,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,25SBLDT02138-006526,25SBLDC04333-007109,25SBLDP05141-007109,25SBLUF01055-007092,25SBLDM01473-007166,25WBLDK03103-006047,24WBLDK03122-006955,25SBLDH02375-006842,25SBLDC01328-007131,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUP02063-007092,24WBLDC02112-006631"
    },
    "000236": {
        "Stato": "IT",
        "CAP": "22079",
        "Localit\u00e0": "VILLAGUARDIA",
        "Indirizzo": "VIA VARESINA 15/17",
        "N.ri Tel.": "031/481494",
        "Insegna": "ADEMARK",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDX02113-006631,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUB01216-007111,24WBLDK03039-006950,25SBLUH02192-004547,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25SBLUX02230-005958,25WBLUC02132-007284,25WBLDC03099-006047,24WBLDK03040-006950,25SBLDC01279-007111,25SBLUF08504-007173,25SBLUF03185-006804"
    },
    "000243": {
        "Stato": "IT",
        "CAP": "70056",
        "Localit\u00e0": "MOLFETTA",
        "Indirizzo": "VIA TENENTE FIORINO, 72/74",
        "N.ri Tel.": "080 3345701",
        "Insegna": "NOLUMA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03114-006719,25WBLUC03074-006355,24WBLDC03038-006950,25WBLUC03233-007308,24WBLDK03039-006950,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "000244": {
        "Stato": "IT",
        "CAP": "52013",
        "Localit\u00e0": "PONTE A POPPI",
        "Indirizzo": "VIA ROMA, 83/85",
        "N.ri Tel.": "0575 529704",
        "Insegna": "BAZAAR",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25WBLUC03074-006355,24WBLDC02041-006648,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDC02250-007008,24WBLDK02363-005831,25WBLDK03103-006047,25WBLDK03102-006047,25WBLUC02079-A05958,24WBLDK03040-006950,25WBLUA05297-006127"
    },
    "000257": {
        "Stato": "IT",
        "CAP": "70121",
        "Localit\u00e0": "BARI",
        "Indirizzo": "VIA BEATILLO, 13-15",
        "N.ri Tel.": "080 5214022",
        "Insegna": "1513",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUC11569-006787,25SBLUH02193-004547,25SBLUS01339-007137,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02346-007132,25SBLUC11207-006787,25SBLUT02312-006803,25SBLUT02309-007125,25SBLUS01338-007137,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUM01479-007167"
    },
    "000271": {
        "Stato": "IT",
        "CAP": "60035",
        "Localit\u00e0": "JESI",
        "Indirizzo": "CORSO MATTEOTTI, 44",
        "N.ri Tel.": "0731 215417",
        "Insegna": "LUCA' S",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUS01339-007137,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUP01189-006804,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUM12488-007170,25SBLUB01216-007111,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUC02228-007104,24WBLDM04562-007021,24WBLDK03297-006992,25SBLUS01338-007137,24WBLDC03051-006047,25SBLUB04360-006788,25SBLUP01324-007130,25SBLUT02306-006801,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC02080-005958"
    },
    "000280": {
        "Stato": "IT",
        "CAP": "33019",
        "Localit\u00e0": "REANA DEL ROJALE",
        "Indirizzo": "VIA NAZIONALE, 9",
        "N.ri Tel.": "0432 880154 UD",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLKC11416-007110,24WBLDC02314-006631,25SBLDC01222-007108,25SBLUH02196-004547,24WBLDC03047-006047,24WBLDK03293-005553,25SBLUX03226-006719,25WBLGC02391-006648,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUS02336-007137,25SBLDK01249-007111,25WBLDC03095-006047,24WBLDC03051-006047,25WBLUA05298-006127,24WBLDC03252-007008,25WBLDK03098-006047,25WBLDC03097-006047,25WBLKC02429-005958"
    },
    "000320": {
        "Stato": "IT",
        "CAP": "21058",
        "Localit\u00e0": "SOLBIATE OLONA",
        "Indirizzo": "VIA PER FAGNANO OLONA, 11",
        "N.ri Tel.": "0331 608362",
        "Insegna": "FACIBA PLANET",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,24WBLDC03084-006976,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,25SBLDC01329-007131,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLDH03369-006845,25SBLUF01184-006804,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUT02312-006803,25SBLUC01211-007101,25SBLDP01326-007143,25WBLDC03096-006047,25SBLDH02370-006845,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDK02363-005831,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,25SBLDC01328-007131,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111,25SBLUF03185-006804,24WBLDC02112-006631"
    },
    "000328": {
        "Stato": "IT",
        "CAP": "10036",
        "Localit\u00e0": "SETTIMO TORINESE",
        "Indirizzo": "VIA ASTEGIANO, 8",
        "N.ri Tel.": "011 8971766",
        "Insegna": "ULTIMO IMPERO",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,25SBLUS01341-007136,25WBLUK03142-005480,25SBLUC04206-006535,25WBLDB03191-007294,25SBLUS01340-007138,25SBLUM01476-006233"
    },
    "000329": {
        "Stato": "IT",
        "CAP": "10036",
        "Localit\u00e0": "SETTIMO TORINESE",
        "Indirizzo": "VIA TORINO, 24/B",
        "N.ri Tel.": "011 8971766",
        "Insegna": "ULTIMO IMPERO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUK03142-005480,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUF01184-006804,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02276-005695,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03495-006047,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "000344": {
        "Stato": "IT",
        "CAP": "13866",
        "Localit\u00e0": "MASSERANO",
        "Indirizzo": "VIA REPUBBLICA, 26 FRAZ. S.GIACOMO",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03038-006950,24WBLDK02042-006648,25WBLDK03102-006047,25WBLDC03099-006047,25WBLGC02391-006648"
    },
    "000345": {
        "Stato": "IT",
        "CAP": "13866",
        "Localit\u00e0": "MASSERANO",
        "Indirizzo": "VIA STRUSIGLIA, 22",
        "N.ri Tel.": "06 93548512",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01340-007138,25SBLDC03007-006950,25SBLDX03008-006950,25SBLUT02346-007132,25SBLUX02147-007103"
    },
    "000346": {
        "Stato": "IT",
        "CAP": "37053",
        "Localit\u00e0": "CEREA",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC11335-007110,25SBLUC03012-006719,25WBLDC02072-006648,24WBLDC02044-006648,25SBLDC03006-006950,25SBLDC03007-006950"
    },
    "000347": {
        "Stato": "IT",
        "CAP": "34077",
        "Localit\u00e0": "RONCHI DEI LEGIONARI",
        "Indirizzo": "VIA PIETRO MICCA SNC",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDK03037-006950,24WBLDC02314-006631,25SBLUC11215-007110,24WBLDC03036-006950,25WBLDK02069-006648,25WBLGC02391-006648,25WBLKC02427-005958,25SBLUC01219-007108,24WBLDC03211-006990,25SBLUC04206-006535,25WBLDC02170-006648,25SBLUB04167-006854,25WBLUC06082-005480,25WBLDK03098-006047,25WBLDC11163-007110"
    },
    "000351": {
        "Stato": "IT",
        "CAP": "36075",
        "Localit\u00e0": "GALLARATE",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01217-007108,24WBLDK03122-006955,25SBLUS01340-007138"
    },
    "000352": {
        "Stato": "IT",
        "CAP": "20030",
        "Localit\u00e0": "BOVISIO MASCIAGO",
        "Indirizzo": "VIA SALVEMINI, 1/5/7",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC03211-006990,24WBLDK02042-006648,24WBLDC02041-006648,25WBLUX02081-005958,24WBLDC03048-006047"
    },
    "000353": {
        "Stato": "IT",
        "CAP": "20094",
        "Localit\u00e0": "CORSICO",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 2",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDB03191-007294,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC03048-006047,25WBLUA05297-006127,25WBLDA05337-006127,25WBLKC02429-005958"
    },
    "000354": {
        "Stato": "IT",
        "CAP": "29010",
        "Localit\u00e0": "CASTELVETRO PIACENTINO",
        "Indirizzo": "STRADA STATALE, 10",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02192-004547,25WBLDC02072-006648,25SBLUS02336-007138,25SBLUB04167-006854,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDK02069-006648,25SBLUT02316-007116,24WBLDC02041-006648,25SBLUC04206-006535,25SBLUM12488-007170,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25SBLUH02191-004547,25SBLUH02150-007100,25SBLUC04176-006854,25SBLUM01476-006233"
    },
    "000355": {
        "Stato": "IT",
        "CAP": "43056",
        "Localit\u00e0": "SAN POLO DI TORRILE",
        "Indirizzo": "VIA DEL LAVORO, 3",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648"
    },
    "000365": {
        "Stato": "IT",
        "CAP": "20020",
        "Localit\u00e0": "ARESE",
        "Indirizzo": "VIALE MONTE RESEGONE, 1 ANGOLO VIA GIACOMO MATTEOTTI, 18",
        "N.ri Tel.": "02 9380109",
        "Insegna": "CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUP03539-006873,25SBLUS01339-007137,25WBLUC03090-006719,25SBLUP05190-006804,25WBLDA05336-007349,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDM09261-006645,25SBLUC11207-006787,24WBLDM13260-006645,24WBLDC03047-006047,25SBLUP01350-006855,25WBLDK02069-006648,24WBLDK02042-006648,25SBLDT02125-006526,25SBLUH02191-004547,25SBLUM12488-007170,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDP01344-006855,25SBLUT02110-006526,25WBLDM01463-007330,25SBLUT02312-006803,24WBLDM04428-005794,25SBLDP02345-006855,25SBLUP04322-007129,25WBLDC03095-006047,25SBLDM01473-007166,25WBLDK03103-006047,25WBLUA05298-006127,24WBLDM01427-005794,24WBLDC03048-006047,25SBLUL02583-007370,25WBLDC03099-006047,25SBLUM01476-006233"
    },
    "000366": {
        "Stato": "IT",
        "CAP": "39042",
        "Localit\u00e0": "BRESSANONE",
        "Indirizzo": "VIA VITTORIO VENETO 67",
        "N.ri Tel.": "0472 802372",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000377": {
        "Stato": "IT",
        "CAP": "15067",
        "Localit\u00e0": "NOVI LIGURE",
        "Indirizzo": "PIAZZA DELLE PIANE, 4",
        "N.ri Tel.": "0143 75492",
        "Insegna": "L'EQUATORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC03084-006976,25WBLUC03074-006355,24WBLDM09261-006645,25SBLUH02150-007100,25SBLUC11215-007110,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUF01184-006804,24WBLDK02353-006985,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02197-004547,24WBLDC02018-006648,25SBLUH02244-007100,25SBLUP04062-007092,25SBLDC11237-007110,25WBLDC03096-006047,25SBLDK01249-007111,25WBLDC03095-006047,25SBLUF03187-006804,25SBLUH02241-007100,25SBLUF01055-007092,25WBLDK03103-006047,24WBLDC02016-006940,25WBLUC03086-006047,25SBLUF02188-006804,25WBLDK03495-006047,25WBLUC05125-007283,24WBLDM10259-006645,25SBLDC01328-007131,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25SBLUF03185-006804"
    },
    "000379": {
        "Stato": "IT",
        "CAP": "92024",
        "Localit\u00e0": "CANICATTI'",
        "Indirizzo": "VIALE REGINA MARGHERITA, 175/C",
        "N.ri Tel.": "0922 854113",
        "Insegna": "CALABRO' TREND",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUC01119-007105,24WBLDC03047-006047,25SBLDC01358-007101,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02195-004547,25SBLUT02316-007116,24WBLDC02251-006631,25SBLUF03186-006804,25WBLKC02427-005958,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDK03103-006047,24WBLDC02064-006100,25WBLDK02192-006648,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111,25SBLUF03185-006804,25SBLUC01281-007105"
    },
    "000389": {
        "Stato": "IT",
        "CAP": "84018",
        "Localit\u00e0": "SCAFATI",
        "Indirizzo": "VIA GEREMIA CAVALLARO, 87",
        "N.ri Tel.": "081 8505936",
        "Insegna": "TUFANO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC01209-007101,25WBLDK03103-006047,24WBLDA05465-006127,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "000400": {
        "Stato": "IT",
        "CAP": "70029",
        "Localit\u00e0": "SANTERAMO",
        "Indirizzo": "PIAZZA DI VAGNO, 27",
        "N.ri Tel.": "080 3036585",
        "Insegna": "BOUTIQUE LA SALA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,25SBLDS01292-007141,25WBLDC03173-007307,24WBLDA05467-006434,25WBLUC03074-006355,25SBLUH02109-006526,25WBLDC03097-006047,24WBLDK03052-006047,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUH02108-006864,25SBLDC01359-007101,25SBLUC02227-007104,25SBLDC02232-007104,25SBLDP02345-006855,25SBLUP04322-007129,24WBLDC03051-006047,24WBLDK03120-006951,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDK03098-006047,25SBLUP02063-007092,25SBLUP02352-006855"
    },
    "000417": {
        "Stato": "IT",
        "CAP": "22071",
        "Localit\u00e0": "CADORAGO",
        "Indirizzo": "VIA MAMELI, 16",
        "N.ri Tel.": "031 904542",
        "Insegna": "MAGDA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDC02072-006648,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDV02296-007143,25WBLUC03074-006355,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLDV03365-007143,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUC01211-007101,25WBLDC03096-006047,25SBLDP02345-006855,25SBLUT02310-006817,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDK02363-005831,25WBLDK03103-006047,25SBLDH02375-006842,25SBLUX02230-005958,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02112-006631"
    },
    "000425": {
        "Stato": "IT",
        "CAP": "10141",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO RACCONIGI, 159/D",
        "N.ri Tel.": "011 331867",
        "Insegna": "UP COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUA05300-006434,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,25SBLDT02125-006526,25SBLUH02191-004547,24WBLDC02018-006648,24WBLDK03212-006990,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUH02241-007100,25SBLDM01473-007166,25WBLDK03495-006047,25SBLDH02375-006842,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111,25WBLDC11163-007110,25SBLUC01281-007105"
    },
    "000432": {
        "Stato": "IT",
        "CAP": "09028",
        "Localit\u00e0": "SESTU",
        "Indirizzo": "EX STRADA STATALE 131 KM 11,100",
        "N.ri Tel.": "070 22056",
        "Insegna": "ANTUOFERMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLUC03090-006719,25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02108-006864,25SBLDT02125-006526,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25WBLDC03096-006047,25SBLDT02138-006526,25SBLUC01209-007101,25SBLDC04333-007109,25SBLUT02306-006801,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUT02315-007117"
    },
    "000442": {
        "Stato": "IT",
        "CAP": "91100",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA DAL MAZIO BIRAGO, 11",
        "N.ri Tel.": "091 6176500",
        "Insegna": "NEW FORM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLKH02555-007188,25SBLDC11237-007110,25SBLUC02227-007104,25SBLKC01445-007101,25SBLDC02232-007104,25WBLDK02192-006648,24WBLDC02352-006977,25WBLUC02080-005958,25WBLUC11083-007110,25WBLUK03142-005480,25SBLUC02229-005958,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBBXC02454-007110,25WBLKC02427-005958,25SBLGC02432-007104,25WBLDC02177-007284,25SBLGC02429-006648,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUC11215-007110,25SBLKF03551-007187,25SBLUC01119-007105,25SBLKP05564-007187,25SBLKC02430-007104,24WBLDC02290-006646,25SBLKC11440-007111,25WBLDC03096-006047,25WBLDC03095-006047,25SBBKC01452-007111,25WBLUC02132-007284,25SBLDC03006-006950,24WBLDC03252-007008,25WBLDK03102-006047,25WBLDC11163-007110,25WBLDC02072-006648,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLGC01441-007111,25WBLGC02391-006648,25SBLUC02228-007104,25SBLGH02495-007144,25WBLDC02170-006648,25SBLUH02199-004547"
    },
    "000444": {
        "Stato": "IT",
        "CAP": "16162",
        "Localit\u00e0": "GENOVA BOLZANETO",
        "Indirizzo": "VIA PASTORINO, 35 R",
        "N.ri Tel.": "010 7455284",
        "Insegna": "LULLI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUA04527-007182,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC01119-007105,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUA04524-007182,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUF02188-006804,25SBLUX02230-005958,25WBLUA05301-006434,25WBLDK03102-006047,24WBLDC03048-006047"
    },
    "000453": {
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA RUGGERO SETTIMO, 64",
        "N.ri Tel.": "091 326284",
        "Insegna": "UOMO CLUB",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDL01421-007016,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUL02318-007340,24WBLDC02064-006100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "000491": {
        "Stato": "IT",
        "CAP": "62100",
        "Localit\u00e0": "MACERATA",
        "Indirizzo": "VIA TOMMASO LAURI, 30",
        "N.ri Tel.": "0733 235908",
        "Insegna": "CHIARAMONI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUF03186-006804,25SBLUT02313-006818,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC02232-007104,25WBLDC03095-006047,25SBLUH02275-007100,25SBLDC04070-007109,24WBLDM10259-006645,24WBLDC02352-006977,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02080-005958,25SBLDC04066-007109,25WBLUC02079-A05958"
    },
    "000506": {
        "Stato": "IT",
        "CAP": "87064",
        "Localit\u00e0": "CORIGLIANO CALABRO",
        "Indirizzo": "VIA NAZIONALE, 42",
        "N.ri Tel.": "0983 886956",
        "Insegna": "PAPILLON",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03047-006047,24WBLDK03039-006950,25SBLUT02313-006818,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25SBLDC03006-006950,24WBLDC03048-006047,25SBLUP02352-006855"
    },
    "000516": {
        "Stato": "IT",
        "CAP": "37016",
        "Localit\u00e0": "GARDA",
        "Indirizzo": "VIA LUNGOLAGO REGINA ADELAIDE, 36",
        "N.ri Tel.": "045 7256884",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC11335-007110,25SBLDK01249-007111"
    },
    "000528": {
        "Stato": "IT",
        "CAP": "80010",
        "Localit\u00e0": "QUARTO",
        "Indirizzo": "CORSO ITALIA, 86/88",
        "N.ri Tel.": "081 8762784",
        "Insegna": "VISCONTI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC02080-005958,25SBLDC01328-007131,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "000531": {
        "Stato": "IT",
        "CAP": "09042",
        "Localit\u00e0": "MONSERRATO",
        "Indirizzo": "VIA GIULIO CESARE, 152",
        "N.ri Tel.": "070 572478",
        "Insegna": "PUSHAK",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUC01119-007105,25SBLUC01115-007105,25SBLUH02348-007132,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDK11162-007110,25WBLDK03103-006047,25WBLDC03099-006047"
    },
    "000539": {
        "Stato": "IT",
        "CAP": "23023",
        "Localit\u00e0": "CHIESA IN VALMALENCO",
        "Indirizzo": "VIA ROMA, 150",
        "Insegna": "PIRCHER SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDC03084-006976,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25SBLUH02196-004547,25SBLDX02235-006648,24WBLDX02113-006631,25SBLUC11207-006787,25SBLUC11541-007110,24WBLDC03038-006950,24WBLDC02342-006631,25WBLUC03233-007308,25SBLUC03011-006719,25SBLUF01184-006804,25SBLUX03226-006719,25WBLDB03191-007294,25WBLGC02391-006648,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC02290-006646,25WBLKC02427-005958,25SBLDC11237-007110,25WBLDC03096-006047,25SBLDC02232-007104,25SBLDP02345-006855,25SBLUT02310-006817,24WBLDK02363-005831,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03102-006047,25WBLDC03099-006047,24WBLDK03040-006950,25SBLDC01329-007131"
    },
    "000547": {
        "Stato": "IT",
        "CAP": "89018",
        "Localit\u00e0": "VILLA S. GIOVANNI",
        "Indirizzo": "VIALE ITALIA, 10/12",
        "N.ri Tel.": "0965 795060",
        "Insegna": "GIALLO OCRA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDX02235-006648,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUX03226-006719,25WBLDK03527-006047,25SBLDF03076-007092,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDK03039-006950,25SBLDC02264-006648,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDT02138-006526,25WBLDC02170-006648,25SBLUF01055-007092,25SBLUC03012-006719,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC02080-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUP02063-007092,25WBLKC03400-007308"
    },
    "000548": {
        "Stato": "IT",
        "CAP": "06012",
        "Localit\u00e0": "CITTA' DI CASTELLO",
        "Indirizzo": "PIAZZA FANTI, 2",
        "N.ri Tel.": "075 8553046",
        "Insegna": "ALUIGI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUB01216-007111,25SBLUC04206-006535,25WBLDC03095-006047,25WBLUC03086-006047,24WBLDC02352-006977,25WBLDK03098-006047,25WBLUC02079-A05958"
    },
    "000551": {
        "Stato": "IT",
        "CAP": "07029",
        "Localit\u00e0": "TEMPIO PAUSANIA",
        "Indirizzo": "VIA POERIO, 1",
        "N.ri Tel.": "079 631433",
        "Insegna": "GIUA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDK03037-006950,25SBLDC02233-007104,25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02374-006842,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03038-006950,25SBLDF03076-007092,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25SBLDC03007-006950,25SBLDC02232-007104,25WBLDC03095-006047,25SBLDT02138-006526,25SBLDP05141-007109,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUL01316-007012"
    },
    "000552": {
        "Stato": "IT",
        "CAP": "39038",
        "Localit\u00e0": "SAN CANDIDO",
        "Indirizzo": "VIA P.P. RAINER, 13/A",
        "N.ri Tel.": "0474 913030",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02251-006631,24WBLDK02556-006646,24WBLDK02556-006646"
    },
    "000557": {
        "Stato": "IT",
        "CAP": "20038",
        "Localit\u00e0": "SEREGNO",
        "Indirizzo": "LARGO SAN VITTORE, 27 Ang Via Cavour",
        "N.ri Tel.": "0362 220788",
        "Insegna": "CLAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUF01184-006804,25SBLUM01478-007167,25SBLUB01216-007111,25SBLUX02230-005958,25SBLUC04163-006788"
    },
    "000571": {
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "ERBUSCO",
        "Indirizzo": "VIA PER ROVATO, 44",
        "N.ri Tel.": "030 7704917",
        "Insegna": "BAGLIONI JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUC01115-007105,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUB01216-007111,25SBLUF03186-006804,25SBLUH02192-004547,25SBLUC01211-007101,25SBLUC01121-007105,25SBLDC01159-007105,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03122-006955,25SBLUH01149-007100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDK03040-006950,25SBLDC01279-007111"
    },
    "000573": {
        "Stato": "IT",
        "CAP": "84100",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA DEI MERCANTI, 55",
        "N.ri Tel.": "089 220855",
        "Insegna": "FERLAZZO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUH02108-006864,25SBLUT02313-006818,25SBLUC01211-007101,25SBLUT02310-006817,25SBLUC01209-007101,25SBLUC11214-007111,25WBLUC02080-005958,25WBLUC02079-A05958,25SBLUC01281-007105"
    },
    "000578": {
        "Stato": "IT",
        "CAP": "35028",
        "Localit\u00e0": "PIOVE DI SACCO",
        "Indirizzo": "VIA ROMA, 55",
        "N.ri Tel.": "049 9705844",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02049-006636,25SBLDK01249-007111"
    },
    "000586": {
        "Stato": "IT",
        "CAP": "80021",
        "Localit\u00e0": "AFRAGOLA",
        "Indirizzo": "VIA OBERDAN, 28",
        "N.ri Tel.": "081 8691221",
        "Insegna": "MOCERINO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC02290-006646,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC11209-006007,24WBLDF08400-006987,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03040-006950,24WBLDK03122-006955"
    },
    "000598": {
        "Stato": "IT",
        "CAP": "16035",
        "Localit\u00e0": "RAPALLO",
        "Indirizzo": "PIAZZA CAVOUR, 11",
        "N.ri Tel.": "0185 51218",
        "Insegna": "EQUIPE 84",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC03086-006047"
    },
    "000604": {
        "Stato": "IT",
        "CAP": "37045",
        "Localit\u00e0": "LEGNAGO Loc. SAN PIETRO",
        "Indirizzo": "VIALE EUROPA, 38",
        "N.ri Tel.": "0442 629079",
        "Insegna": "PUNTO BLU ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDA05336-007349,25WBLUC02079-005958,24WBLDK11337-006007,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC03012-006719,24WBLDK03120-006951,24WBLDK03122-006955,25SBLUP05190-006804,25WBLUK03142-005480,25SBLDC01222-007108,25SBLUC03011-006719,24WBLDK02042-006648,24WBLDC02041-006648,25WBLKC02427-005958,25SBLDK01249-007111,24WBLDC03119-006951,24WBLDK03037-006950,25WBLDK03161-006719,25WBLUC03090-006719,25WBLDC02178-006646,25SBLDC01358-007101,25SBLUF01184-006804,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUF02188-006804,25WBLDK03102-006047,25WBLDC11163-007110,24WBLDC11209-006007,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25WBLGC02391-006648,25SBLUH02192-004547,25WBLDK11162-007110,25SBLUT02306-006801,25WBLUC02079-A05958,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "000637": {
        "Stato": "IT",
        "CAP": "38068",
        "Localit\u00e0": "ROVERETO",
        "Indirizzo": "VIA MAIOLICHE, 53",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC08078-006355,25SBLDC01222-007108,25SBLUC11215-007110,24WBLDC03036-006950,25WBLDC03100-006047,25SBLUH02197-004547,25SBLUC01211-007101,25SBLDK01249-007111,25WBLUC06082-005480"
    },
    "000638": {
        "Stato": "IT",
        "CAP": "31050",
        "Localit\u00e0": "CASTRETTE DI VILLORBA",
        "Indirizzo": "VIA ROMA, 182/D",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLDK03101-006047,25SBLKF08561-007187,25WBLDC03097-006047,24WBLDC03036-006950,25SBLGF02547-007187,25WBLUC03233-007308,25SBLUF03037-007096,25SBLKH02555-007188,25SBLDL02396-007152,25SBLGP05549-007187,25WBLGC02391-006648,25WBLDC03100-006047,25SBLUC04176-006854,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKF02553-007187,25SBLKP01554-007187,25SBLUP02038-007096,25WBLUC03086-006047,25SBLGF03548-007187,25SBLDC01328-007131,24WBLDC03252-007008,25WBLDK03102-006047,25WBLDC03099-006047,25SBLDC04066-007109,25SBLGH02550-007188,25SBLUC04163-006788"
    },
    "000639": {
        "Stato": "IT",
        "CAP": "50124",
        "Localit\u00e0": "FIRENZE Loc. GALUZZO",
        "Indirizzo": "VIA SENESE, 136/R",
        "N.ri Tel.": "055 2048704",
        "Insegna": "FALCIANI",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC02290-006646"
    },
    "000676": {
        "Stato": "IT",
        "CAP": "61033",
        "Localit\u00e0": "FERMIGNANO",
        "Indirizzo": "VIALE KENNEDY, 44",
        "N.ri Tel.": "0722 331403",
        "Insegna": "ZAGARI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03039-006950"
    },
    "000679": {
        "Stato": "IT",
        "CAP": "30027",
        "Localit\u00e0": "SAN DONA' DI PIAVE",
        "Indirizzo": "VIA VANONI, 8",
        "N.ri Tel.": "0421 221515",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUX02081-005958,24WBLDC02314-006631,24WBLDK03052-006047,24WBLDC03047-006047,25WBLKC02427-005958,25SBLUF03186-006804,25SBLUC04176-006854,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02276-005695,25SBLUC01211-007101,25WBLDK11162-007110,25SBLUC04206-006535,25SBLUT02310-006817,24WBLDC03051-006047,25SBLUT02306-006801,24WBLDB03294-005553,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUC04163-006788,25WBLDC11163-007110"
    },
    "000686": {
        "Stato": "IT",
        "CAP": "10126",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA NIZZA, 104",
        "N.ri Tel.": "011 6964101",
        "Insegna": "ERZEGOVAZ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDC03047-006047,24WBLDK03039-006950,25SBLDL02397-007156,25SBLUF01055-007092,25SBLUH02109-006526,25SBLUH02192-004547,25SBLUL02403-006543,25SBLUP02063-007092,25SBLUS01341-007136,25SBLUS02336-007137,25SBLUS02336-007138,25SBLUT02308-006801,25SBLUT02315-007117"
    },
    "000735": {
        "Stato": "IT",
        "CAP": "20092",
        "Localit\u00e0": "CINISELLO BALSAMO",
        "Indirizzo": "VIA GIOSUE' CARDUCCI, 11",
        "N.ri Tel.": "02 36585337",
        "Insegna": "DEVIS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLDK03101-006047,25WBLUC03090-006719,25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC08078-006355,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDA05467-006434,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUX03226-006719,25WBLDK03527-006047,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDA05469-007037,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDB03294-005553,25SBLUC03012-006719,25WBLDK03103-006047,25SBLUX02230-005958,25WBLUA05298-006127,25WBLDA05335-007349,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDC11163-007110"
    },
    "000746": {
        "Stato": "IT",
        "CAP": "80046",
        "Localit\u00e0": "S. GIORGIO A CREMANO",
        "Indirizzo": "VIA DE LAUZIERES, 16/18",
        "N.ri Tel.": "081 479666",
        "Insegna": "GUARRACINO",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02109-006526,25SBLDH02374-006842,25WBBXC02456-005958,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUH02194-004547,24WBLDK02556-006646,25WBLGC02391-006648,25WBLKC02427-005958,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC11237-007110,24WBLDC03051-006047,25SBLUT02306-006801,25SBLUC11214-007111,25SBLUH02275-007100,24WBLDC03048-006047,25WBLKC02429-005958"
    },
    "000754": {
        "Stato": "IT",
        "CAP": "70010",
        "Localit\u00e0": "CASAMASSIMA",
        "Indirizzo": "SS100 KM 18 C/O IL BARICENTRO LOTTO 20/B MOD. 4-5-6",
        "N.ri Tel.": "080 6970050",
        "Insegna": "TOP SPORT SRL - DEST. CASAMASSIMA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03233-007308,25WBLDC03100-006047,25SBLUP04062-007092,25SBLDS01366-007141,25SBLUH02241-007100,25SBLDH02386-007144,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUH02030-006846,25WBLKC02429-005958,25WBLUC11083-007110,25SBLDH02374-006842,25WBLUC02077-006943,25SBLUH02242-007100,25WBLKC02427-005958,25SBLUH02276-005695,25WBLDC03099-006047,25SBLUF03185-006804,25SBLDX03008-006950,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25WBBXC02456-005958,25SBLDC01358-007101,25SBLDV03365-007143,24WBLDC02290-006646,25SBLUH02244-007100,25WBLDC03096-006047,25WBLDC03095-006047,25SBLDC04331-006788,24WBLDC03051-006047,25SBLUS01342-007136,25WBLDK03103-006047,25SBLDV04293-007143,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUH02193-004547,24WBLDC03114-006719,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25WBLGC02391-006648,25SBLUH02191-004547,25WBLDK11162-007110,25SBLUK11239-007110,25WBLDC02170-006648,24WBLDK02363-005831,25WBLDF08248-006948"
    },
    "000756": {
        "Stato": "IT",
        "CAP": "70122",
        "Localit\u00e0": "BARI",
        "Indirizzo": "VIA CALEFATI, 75/79",
        "N.ri Tel.": "080 6970050",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDX03280-006719"
    },
    "000777": {
        "Stato": "IT",
        "CAP": "51016",
        "Localit\u00e0": "MONTECATINI TERME",
        "Indirizzo": "VIA ANTONIETTA, 3",
        "N.ri Tel.": "0572 79341",
        "Insegna": "BONVICINI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03122-006955,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDA05337-006127,25SBLUP05190-006804,25SBLDB04068-007109,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC02177-007284,25SBLDC02236-006648,25SBLUH02275-007100,25WBLDC03099-006047,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUP01189-006804,25SBLDC01358-007101,25SBLUF01184-006804,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,24WBLDC02064-006100,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDA05335-007349,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25WBLDC02170-006648,25WBLDF08248-006948,25WBLUC02079-A05958,25WBLDK03098-006047,25WBLDL01346-007354"
    },
    "000791": {
        "Stato": "IT",
        "CAP": "62029",
        "Localit\u00e0": "TOLENTINO",
        "Indirizzo": "VIA C. COLOMBO, 108",
        "N.ri Tel.": "0733 966356",
        "Insegna": "BARNY'S",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25WBLDC03096-006047,25WBLDC02170-006648,25WBLUC03086-006047"
    },
    "000798": {
        "Stato": "IT",
        "CAP": "10122",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GARIBALDI, 5/D",
        "N.ri Tel.": "011 4361543",
        "Insegna": "BLOB",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDK03037-006950,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03038-006950,25WBLDK03527-006047,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLDK03495-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "000811": {
        "Stato": "IT",
        "CAP": "71029",
        "Localit\u00e0": "TROIA",
        "Indirizzo": "VIA REGINA MARGHERITA, 160",
        "N.ri Tel.": "0881 970039",
        "Insegna": "CARMELINO BUONO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC02044-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC02077-006943,24WBLDC03036-006950,25SBLUC11541-007110,25WBLUC03233-007308,25SBLDL02396-007156,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDP04142-007109,24WBLDC02018-006648,25SBLDC11237-007110,24WBLDC03211-006990,25SBLDC02232-007104,25WBLDC03095-006047,25SBLDC04331-006788,24WBLDC03051-006047,25SBLDC04333-007109,25WBLDC02170-006648,25SBLUC03012-006719,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDC11163-007110"
    },
    "000826": {
        "Stato": "IT",
        "CAP": "24069",
        "Localit\u00e0": "TRESCORE BALNEARIO",
        "Indirizzo": "VIA RESISTENZA, 5/A",
        "N.ri Tel.": "035 940089",
        "Insegna": "PARIMBELLI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLDK03101-006047,24WBLDC02044-006648,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDM09261-006645,24WBLDM13260-006645,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDC03252-007008"
    },
    "000830": {
        "Stato": "IT",
        "CAP": "74023",
        "Localit\u00e0": "GROTTAGLIE",
        "Indirizzo": "VIA MARCONI, 13",
        "N.ri Tel.": "099 5666931",
        "Insegna": "NEW ATLETIC",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25SBLUH02193-004547,24WBLDC02049-006636,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUH02196-004547,25WBLUC02077-006943,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUH02191-004547,25WBLDC03100-006047,25SBLDC01359-007101,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02309-007125,25SBLDK01249-007111,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDT02138-006526,25WBLDC02170-006648,25WBLUL02318-007340,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDC03097-006047,24WBLDC02112-006631"
    },
    "000832": {
        "Stato": "IT",
        "CAP": "66100",
        "Localit\u00e0": "CHIETI",
        "Indirizzo": "CORSO MARRUCCINO, 95",
        "N.ri Tel.": "0871 330204",
        "Insegna": "CAPITANIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03122-006955"
    },
    "000837": {
        "Stato": "IT",
        "CAP": "22066",
        "Localit\u00e0": "MARIANO COMENSE",
        "Indirizzo": "VIA VOLTA, 26",
        "N.ri Tel.": "031 746224",
        "Insegna": "SORELLE MOTTA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,24WBLDC03119-006951,25SBLUA04528-007183,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDM09261-006645,25WBLUA05299-006127,24WBLDC03036-006950,24WBLDM13260-006645,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUF03037-007096,25SBLUF01184-006804,25SBLUM06481-007168,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUA04524-007182,24WBLDC02290-006646,25SBLUP05530-007173,25SBLUC02227-007104,25SBLUM01480-007168,25SBLUC04206-006535,25SBLUF03187-006804,25SBLUT02306-006801,24WBLDK02363-005831,25WBLUC06082-005480,25WBLDK03102-006047,25SBLUT02315-007117,25SBLUF08504-007173,25SBLUC01281-007105"
    },
    "000845": {
        "Stato": "IT",
        "CAP": "80059",
        "Localit\u00e0": "TORRE DEL GRECO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 160 (EX 264)",
        "N.ri Tel.": "081 8812587",
        "Insegna": "PROCIDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUT02110-006526,25SBLUC01211-007101,25SBLUC02227-007104,25SBLUT02309-007125,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUT02306-006801,25SBLUC11214-007111,25SBLUF01055-007092,25WBLUC02080-005958,25WBLUC02132-007284"
    },
    "000847": {
        "Stato": "IT",
        "CAP": "80045",
        "Localit\u00e0": "POMPEI",
        "Indirizzo": "VIA PLINIO, 25",
        "N.ri Tel.": "081 8506056",
        "Insegna": "PIPOL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLDC02178-006646,25SBLUH02109-006526,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25WBLDK03527-006047,24WBLDC02290-006646,25SBLUT02110-006526,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUH02199-004547,24WBLDC03048-006047,25SBLUP02063-007092,25SBLUC01210-007101,25WBLDC03099-006047"
    },
    "000848": {
        "Stato": "IT",
        "CAP": "61100",
        "Localit\u00e0": "PESARO",
        "Indirizzo": "VIA TRA I DUE PORTI, 2",
        "N.ri Tel.": "0721 25679",
        "Insegna": "NAUTIC STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,25SBLUS01340-007138,25SBLUT02312-006803,25SBLUC02227-007104,25SBLDS01366-007141,25WBLUC03086-006047,25SBLDF08078-007092,25SBLUX02230-005958,24WBLDK03040-006950,25SBLDC02289-007119,25SBLUN01521-006581,25WBLUK03142-005480,25SBLUT02308-006801,25SBLDC01222-007108,25SBLDP01079-007092,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDK02353-006985,25SBLUF03186-006804,25SBLUC04206-006535,25WBLUC03090-006719,24WBLDP01448-006420,25SBLUC11215-007110,25SBLUP01189-006804,25SBLUF01184-006804,24WBLDC02290-006646,25SBLDS01291-007141,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03102-006047,24WBLDM10555-007022,25SBLDC02233-007104,25WBLDC02072-006648,25WBLUC03074-006355,24WBLDM09261-006645,24WBLDC03036-006950,25SBLUH02191-004547,25SBLUM12488-007170,25SBLUT02313-006818,25SBLUC02228-007104,25WBLDK11162-007110,25SBLUK11239-007110,25SBLDH02370-006845,24WBLDM10259-006645"
    },
    "000857": {
        "Stato": "IT",
        "CAP": "87021",
        "Localit\u00e0": "BELVEDERE MARITTIMO",
        "Indirizzo": "VIA GIUSTINO FORTUNATO, 50",
        "N.ri Tel.": "0985 84522",
        "Insegna": "FANTASIA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUC11214-007111,25WBLUC03086-006047,24WBLDC02352-006977,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUL02583-007370,25WBLUC11083-007110,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDK01249-007111,25SBLUF01055-007092,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUP02063-007092,25SBLDX03008-006950,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUH02108-006864,25SBLDC02264-006648,25WBLDC03096-006047,24WBLDX03318-006992,25WBLDK03103-006047,25WBLDK03102-006047,25WBLDC02072-006648,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC02228-007104,25WBLDK11162-007110,25WBLDC02170-006648"
    },
    "000858": {
        "Stato": "IT",
        "CAP": "10142",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO PESCHIERA, 291",
        "N.ri Tel.": "011 727449",
        "Insegna": "FORNASIERI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03084-006976,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUH02276-005695,25SBLUT02312-006803,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDK11162-007110,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDC02250-007008,25SBLUF01055-007092,25SBLUL02409-006547,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC03086-006047,25SBLUF02188-006804,25WBLDK03495-006047,25WBLUC06082-005480,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUC01210-007101,25SBLUC01281-007105"
    },
    "000862": {
        "Stato": "IT",
        "CAP": "87022",
        "Localit\u00e0": "CETRARO MARINA",
        "Indirizzo": "VIA AMALFI, 32 34 36",
        "N.ri Tel.": "0982 999226",
        "Insegna": "PAGINE DI MODA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUP05033-007094,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDC03038-006950,25SBLUM06481-007168,24WBLDC02251-006631,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUA04524-007182,25SBLUC01219-007108,25SBLUT02110-006526,25SBLUC02227-007104,25SBLUM01480-007168,25SBLDC03007-006950,25SBLDC02232-007104,25SBLDK01249-007111,25SBLUS01338-007137,25SBLUS01337-007137,25WBLDC02170-006648,24WBLDC02112-006631,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUL02583-007370,25SBLDC01279-007111"
    },
    "000877": {
        "Stato": "IT",
        "CAP": "80127",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA LUCA GIORDANO, 39",
        "N.ri Tel.": "081 0502087",
        "Insegna": "REVELATION",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,24WBLDC02044-006648,25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,25WBLUC03233-007308,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDA05465-006127,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDA05337-006127"
    },
    "000902": {
        "Stato": "IT",
        "CAP": "86170",
        "Localit\u00e0": "ISERNIA",
        "Indirizzo": "VIA UMBRIA C/O CENTRO COMMERCIALE",
        "N.ri Tel.": "0865 451806",
        "Insegna": "SPORT CLUB",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLUS01339-007137,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUP01350-006855,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,25SBLUF03186-006804,25SBLDP01344-006855,24WBLDC02290-006646,25SBLUP04043-007130,25SBLUT02110-006526,25SBLUT02313-006818,25SBLDC02264-006648,25SBLUC01211-007101,25SBLUC02148-007103,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDK01249-007111,25SBLUS01338-007137,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUM01486-007172,25SBLDC03006-006950,25WBLDC03099-006047"
    },
    "000907": {
        "Stato": "IT",
        "CAP": "07041",
        "Localit\u00e0": "ALGHERO",
        "Indirizzo": "VIA CARLO ALBERTO, 57",
        "N.ri Tel.": "333 2591865 Luisella",
        "Insegna": "GILBERT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLDH02372-005707,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUF01184-006804,25SBLDP02143-007109,25SBLDF03076-007092,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,25SBLDT02138-006526,25SBLUT02306-006801,25SBLDC04333-007109,25SBLDP01140-007109,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02132-007284,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03099-006047,25WBLDC03097-006047"
    },
    "000912": {
        "Stato": "IT",
        "CAP": "74100",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA F. DI PALMA, 107",
        "N.ri Tel.": "099 4590127",
        "Insegna": "ANDRIANI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDA05467-006434,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUC11207-006787,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,25SBLUC02228-007104,25SBLUC01211-007101,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC02170-006648,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "000914": {
        "Stato": "IT",
        "CAP": "19126",
        "Localit\u00e0": "LA SPEZIA",
        "Indirizzo": "VIA DEL CANALETTO, 254",
        "N.ri Tel.": "0187 513847",
        "Insegna": "GODANI",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,24WBLDK03037-006950,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25SBLDX02235-006648,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUC11541-007110,25SBLUC03011-006719,25SBLUX03226-006719,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC03012-006719,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03495-006047,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "000921": {
        "Stato": "IT",
        "CAP": "73012",
        "Localit\u00e0": "CAMPI SALENTINA",
        "Indirizzo": "VIA PACINOTTI 19 - CAMPICENTRO",
        "N.ri Tel.": "0832 792966",
        "Insegna": "VERSIENTI VOGUER",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDK03037-006950,24WBLDC03119-006951,25SBLDS01292-007141,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC01222-007108,25SBLUH02109-006526,25SBLDH02374-006842,25WBLUC02077-006943,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02108-006864,25SBLUH02191-004547,25SBLUM01478-007167,25WBLDC03100-006047,25SBLDS01291-007141,25SBLUC01219-007108,25SBLUT02313-006818,25WBLDC03095-006047,25SBLUT02306-006801,25SBLDH02386-007144,25SBLDM01473-007166,25SBLUH02275-007100,25SBLDC04070-007109,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUM01479-007167"
    },
    "000922": {
        "Stato": "IT",
        "CAP": "87055",
        "Localit\u00e0": "SAN GIOVANNI IN FIORE",
        "Indirizzo": "VIALE DELLA REPUBBLICA, 313-321",
        "N.ri Tel.": "0984 992945",
        "Insegna": "MYJ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUH02109-006526,25SBLUC11207-006787,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,25SBLUC04176-006854,24WBLDK03039-006950,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUT02306-006801,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC06082-005480,25WBLDC03099-006047"
    },
    "000934": {
        "Stato": "IT",
        "CAP": "98055",
        "Localit\u00e0": "LIPARI",
        "Indirizzo": "VIA VITTORIO EMANUELE, 55",
        "N.ri Tel.": "090 9817020",
        "Insegna": "IL BOTTEGHINO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,25WBLDK02069-006648,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047"
    },
    "000963": {
        "Stato": "IT",
        "CAP": "89015",
        "Localit\u00e0": "PALMI",
        "Indirizzo": "VIA CONCORDATO, 9",
        "N.ri Tel.": "0966 21170",
        "Insegna": "PRESTIGE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01211-007101,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLUK03142-005480,25WBLUL01314-007012,24WBLDC02314-006631,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUX03226-006719,25WBLUA05298-006127,25WBLDC03099-006047,25WBLUL01316-007012,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUL02412-007155,24WBLDC03038-006950,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC02132-007284,25WBLDC02072-006648,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25SBLUH02192-004547,25WBLDC02170-006648,25SBLUH02199-004547,25WBLUC02079-A05958"
    },
    "000971": {
        "Stato": "IT",
        "CAP": "36050",
        "Localit\u00e0": "BOLZANO VICENTINO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "0444 356044",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC01445-007101,24WBLDC03252-007008,25SBLDV03365-007143,25SBLUP02352-006855"
    },
    "000983": {
        "Stato": "IT",
        "CAP": "58100",
        "Localit\u00e0": "GROSSETO",
        "Indirizzo": "VIALE SONNINO, 5",
        "N.ri Tel.": "0564 29525",
        "Insegna": "PARRONCHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25SBLDC01221-007108,25SBLUT02346-007132,25SBLUC01046-007120,24WBLDC03047-006047,24WBLDK02042-006648,25SBLUC01047-007120,25SBLUH02108-006864,25SBLUS01341-007136,24WBLDC02290-006646,25SBLUT02110-006526,25SBLUH02244-007100,25SBLUT02312-006803,25SBLUC01211-007101,25SBLDK01249-007111,25SBLUH02241-007100,25SBLUT02306-006801,25WBLDK03103-006047,24WBLDC02064-006100,24WBLDL01420-007016,25SBLUH02030-006846,25WBLUK11140-007286"
    },
    "000994": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA APPIA NUOVA, 90",
        "N.ri Tel.": "06 7003609",
        "Insegna": "LIZ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,25WBLDK03103-006047,24WBLDC02018-006648,24WBLDK03052-006047,24WBLDC03119-006951,24WBLDC03047-006047,24WBLDK03086-006976,24WBLDK03120-006951,25WBLDC03096-006047,25WBLDK05019-007298,24WBLDK02556-006646,25WBLDK11162-007110,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03095-006047,25WBLDK03527-006047,24WBLDC03051-006047"
    },
    "000995": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA APPIA NUOVA, 86",
        "N.ri Tel.": "06 7003609",
        "Insegna": "LIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355"
    },
    "001001": {
        "Stato": "IT",
        "CAP": "90146",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA PIETRO NENNI, 30/32 C/o CANALE E SERVIZI",
        "N.ri Tel.": "091 6800911",
        "Insegna": "LA MALFA 14",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLKH02555-007188,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC02227-007104,25SBLKP05558-007187,25SBBGC02453-005958,25SBLKF02553-007187,25SBLUC01209-007101,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUM01479-007167,25SBLUP02352-006855,25WBLKC02429-005958,25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25WBLKC11416-007110,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLGP05549-007187,25WBLKC02427-005958,25SBLUF03186-006804,25SBLGC02432-007104,25SBLKP01554-007187,25WBLDC03099-006047,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUC11215-007110,25SBLKF03551-007187,25SBLGF02547-007187,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUH02108-006864,25SBLKC11440-007111,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25SBLUS01337-007137,25SBLUF02188-006804,25SBBKC01452-007111,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDK03102-006047,25SBLGH02550-007188,25WBLDC03097-006047,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUX02081-005958,25SBLKF08561-007187,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUC11207-006787,25SBLGC01441-007111,25SBLKC01444-007101,25SBLKC06443-007101,25WBLGC02391-006648,25SBLUH02191-004547,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUC02231-005958,25WBLDC02170-006648,25SBLDC01328-007131,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "001002": {
        "Stato": "IT",
        "CAP": "62024",
        "Localit\u00e0": "MATELICA",
        "Indirizzo": "VIA CESARE BATTISTI, 8",
        "N.ri Tel.": "0737 85770",
        "Insegna": "SPORT LINE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLDC02072-006648,25WBLDK03101-006047,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,25WBLUC03233-007308,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUT02312-006803,25SBLUC04206-006535,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDC02170-006648,25WBLUC03086-006047,25WBLUC02080-005958,25WBLDK03102-006047,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "001007": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "CORSO MAZZINI, 220/222",
        "N.ri Tel.": "0984 25843",
        "Insegna": "NEW LINE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDK03037-006950,24WBLDC03084-006976,25SBLDH02372-005707,25WBLDK03101-006047,25WBLDC02178-006646,25WBLDC03173-007307,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDL01417-006668,24WBLDK03052-006047,25SBLDP01079-007092,24WBLDC03047-006047,25SBLDC01358-007101,24WBLDC03038-006950,25WBLDK02069-006648,25SBLDL02396-007156,24WBLDK03293-005553,25SBLDV03365-007143,24WBLDC02251-006631,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC03086-006047,24WBLDK03120-006951,25SBLDF08078-007092,25WBLDK03495-006047,24WBLDX03280-006719,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25SBLDC01279-007111,25WBLDA05337-006127"
    },
    "001008": {
        "Stato": "IT",
        "CAP": "20065",
        "Localit\u00e0": "INZAGO",
        "Indirizzo": "VIA MARCHESI, 34",
        "N.ri Tel.": "02 9549315",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001034": {
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA XX SETTEMBRE, 48",
        "Insegna": "IL PUNTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC02044-006648,25SBLUP05190-006804,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUH02194-004547,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUC01211-007101,25SBLUC02227-007104,24WBLDC03211-006990,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02064-006100,25WBLUC05125-007283,25WBLUC06082-005480,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "001055": {
        "Stato": "IT",
        "CAP": "20015",
        "Localit\u00e0": "PARABIAGO",
        "Indirizzo": "VIA S. GIUSEPPE, 25",
        "N.ri Tel.": "0331 557055",
        "Insegna": "IMMAGINE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC03047-006047,24WBLDC03119-006951,24WBLDC03119-006951,24WBLDK02363-005831,24WBLDK03037-006950"
    },
    "001057": {
        "Stato": "IT",
        "CAP": "70038",
        "Localit\u00e0": "TERLIZZI",
        "Indirizzo": "VIALE ROMA, 37",
        "N.ri Tel.": "080 3511091",
        "Insegna": "JUST COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUC11569-006787,25WBLUC03090-006719,25WBLUK03142-005480,25SBLDC01222-007108,25SBLUC11207-006787,25SBLDC01358-007101,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUA04524-007182,25SBLUH02197-004547,25SBLUT02110-006526,25SBLUP04062-007092,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUS01338-007137,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958"
    },
    "001061": {
        "Stato": "IT",
        "CAP": "71100",
        "Localit\u00e0": "FOGGIA",
        "Indirizzo": "PIAZZA CAVOUR, 9",
        "N.ri Tel.": "0881-587803",
        "Insegna": "SIMONE COLLECTION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,24WBLDA05467-006434,25WBLUC03074-006355,25WBLUC03233-007308,25SBLUX02255-007101,25SBLUH02195-004547,25SBLUH02244-007100,25WBLUC03086-006047,25WBLUC05125-007283,25WBLUC06082-005480,25SBLUX02230-005958,25WBLUA05298-006127"
    },
    "001068": {
        "Stato": "IT",
        "CAP": "70018",
        "Localit\u00e0": "RUTIGLIANO",
        "Indirizzo": "VIA S. FRANCESCO D'ASSISI, 9",
        "N.ri Tel.": "080 4769091",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP04043-007130"
    },
    "001069": {
        "Stato": "IT",
        "CAP": "87012",
        "Localit\u00e0": "CASTROVILLARI",
        "Indirizzo": "VIA ROMA, 79/81",
        "N.ri Tel.": "0981 21721",
        "Insegna": "LA MAMMINA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDC03003-006950,25SBLDC01222-007108,25WBLUC03074-006355,25WBLUL01316-007012,25SBLDX02235-006648,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDB04068-007109,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUX03226-006719,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUC04176-006854,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUT02313-006818,25SBLUC02228-007104,25WBLDK11162-007110,24WBLDC03051-006047,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUB04167-006854,25WBLUC06082-005480,24WBLDC02352-006977,25SBLUH02199-004547,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "001074": {
        "Stato": "IT",
        "CAP": "20137",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIALE CORSICA, 33",
        "N.ri Tel.": "02 715006",
        "Insegna": "V&V",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUH02196-004547,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUF03186-006804,24WBLDC02290-006646,25WBLUC02151-007287,25SBLUH02192-004547,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUC01281-007105,25SBLUT02310-006817,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03102-006047,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,24WBLDC02112-006631"
    },
    "001077": {
        "Stato": "IT",
        "CAP": "05022",
        "Localit\u00e0": "AMELIA",
        "Indirizzo": "PIAZZA XXI SETTEMBRE, 6/7",
        "N.ri Tel.": "0744 982217",
        "Insegna": "CONTI STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUF01184-006804,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02352-006977,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "001103": {
        "Stato": "IT",
        "CAP": "85043",
        "Localit\u00e0": "FRANCAVILLA SUL SINNI",
        "Indirizzo": "VIA LUIGI CIMINELLI, 23",
        "N.ri Tel.": "0973 574212",
        "Insegna": "MELE FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC01260-007108,24WBLDK03037-006950,25SBLUC11569-006787,25WBLDC02072-006648,24WBLDC02044-006648,25SBLDS01292-007141,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDV02296-007143,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01222-007108,25WBLDC03097-006047,25WBLUC02077-006943,24WBLDC03036-006950,25SBLUC01046-007120,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02376-006842,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUM01478-007167,25SBLUB01216-007111,24WBLDC02290-006646,25SBLDP04142-007109,25SBLUC02228-007104,25SBLUC04206-006535,25SBLUC11083-007106,25SBLUS01338-007137,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLDC04070-007109,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC01329-007131"
    },
    "001126": {
        "Stato": "IT",
        "CAP": "87027",
        "Localit\u00e0": "PAOLA",
        "Indirizzo": "VIA NAZIONALE, 124",
        "N.ri Tel.": "0982 587450",
        "Insegna": "SAX MODA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25SBLDH02372-005707,25WBLDC02178-006646,24WBLDC02314-006631,24WBLDC03036-006950,25SBLDP01079-007092,25SBLDB04068-007109,24WBLDK11337-006007,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02251-006631,25SBLDF03076-007092,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC02264-006648,25WBLDC03096-006047,25SBLDK01249-007111,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDT02138-006526,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDK03120-006951,24WBLDC02352-006977,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01329-007131"
    },
    "001133": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "TITO",
        "Indirizzo": "VIA SANDRO PERTINI, 36",
        "N.ri Tel.": "0971 485309",
        "Insegna": "TROTTA MARCO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25WBLUK03142-005480,25WBLDC03173-007307,25WBLUC03074-006355,25SBLDC01222-007108,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDB04068-007109,25WBLUC03233-007308,25SBLUH02108-006864,25WBLDC03100-006047,25WBLDC03096-006047,25SBLUS02336-007137,25SBLUC11083-007106,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,25SBLDC04333-007109,24WBLDB03294-005553,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25SBLUM01476-006233"
    },
    "001134": {
        "Stato": "IT",
        "CAP": "36025",
        "Localit\u00e0": "NOVENTA VICENTINA",
        "Indirizzo": "CORSO G. MATTEOTTI, 109",
        "N.ri Tel.": "0444 887860",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001135": {
        "Stato": "IT",
        "CAP": "61037",
        "Localit\u00e0": "MAROTTA DI MONDOLFO",
        "Indirizzo": "VIA MOLISE, 29",
        "N.ri Tel.": "0721 967081",
        "Insegna": "NETTUNO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02049-006636,24WBLDC02044-006648,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,25SBLUP01189-006804,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUB01216-007111,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03099-006047,25SBLUC01217-007108"
    },
    "001152": {
        "Stato": "IT",
        "CAP": "98044",
        "Localit\u00e0": "SAN FILIPPO DEL MELA",
        "Indirizzo": "CONTRADA MASSERIA CORRIOLO",
        "N.ri Tel.": "090 931525",
        "Insegna": "CALCAGNO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDH02374-006842,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC02231-005958,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,25SBLUT02306-006801,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25SBLDF08078-007092,24WBLDC02064-006100,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUH02199-004547,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUP02352-006855,25SBLDC01279-007111"
    },
    "001157": {
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "TORRICELLA",
        "Indirizzo": "VIA ROSARIO, 38",
        "N.ri Tel.": "099 9573024",
        "Insegna": "CAPUTO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDH02374-006842,25SBLUP01189-006804,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUL02412-007155,25WBLDK02069-006648,25WBLUC03233-007308,25SBLUF02101-007121,25SBLUH02108-006864,25SBLUH02191-004547,25SBLUM01478-007167,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUT02312-006803,25WBLDC03096-006047,25SBLUP01183-007121,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUP04322-007129,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,25SBLUT02306-006801,25SBLDP01140-007109,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDK03120-006951,25SBLDC04070-007109,25SBLUH02275-007100,25WBLUC02080-005958,25WBLDC03099-006047,25WBLDK03098-006047,25SBLUM01479-007167,25WBLDC03097-006047"
    },
    "001164": {
        "Stato": "IT",
        "CAP": "80017",
        "Localit\u00e0": "MELITO",
        "Indirizzo": "CORSO EUROPA, 212",
        "N.ri Tel.": "081 7110086",
        "Insegna": "CEAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC02079-005958,25WBLUC03074-006355,25SBLGC01441-007111,25SBLUC11541-007110,25SBLUH02194-004547,25SBLKC06443-007101,25WBLKC02427-005958,25SBLKC11440-007111,25SBLUC11214-007111,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02079-A05958,25SBLUC01210-007101,25WBLKC02429-005958"
    },
    "001165": {
        "Stato": "IT",
        "CAP": "80017",
        "Localit\u00e0": "MELITO",
        "Indirizzo": "CORSO EUROPA , 139-141-143",
        "N.ri Tel.": "081 7117671",
        "Insegna": "ANITA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,24WBLDK03037-006950,25WBLDK03101-006047,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,24WBLDK02556-006646,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02112-006631"
    },
    "001201": {
        "Stato": "IT",
        "CAP": "81025",
        "Localit\u00e0": "AURNO MARCIANISE",
        "Indirizzo": "CENTRO COMMERCIALE CAMPANIA LOC.",
        "N.ri Tel.": "081 8694791",
        "Insegna": "GRILLO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC01121-007105,25SBLUC11214-007111,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDK02556-006646,25WBLDK03527-006047,25SBLDH02375-006842,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03038-006950,24WBLDC02290-006646,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUC01281-007105,25SBLUH02193-004547,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25SBLUC11207-006787,25SBLUT02313-006818,25WBLDK11162-007110,25SBLUT02306-006801,25WBLDC02170-006648,25SBLDC01328-007131,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "001226": {
        "Stato": "IT",
        "CAP": "50136",
        "Localit\u00e0": "FIRENZE",
        "Indirizzo": "VIA F. DE SANCTIS, 24R",
        "N.ri Tel.": "055 660712",
        "Insegna": "MARCO OLIVA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUK03142-005480,25SBLUH02109-006526,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUM01478-007167,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUT02110-006526,25SBLUC04206-006535,24WBLDK02363-005831,25SBLUF01055-007092,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25WBLDK03102-006047,25WBLDC03099-006047"
    },
    "001231": {
        "Stato": "IT",
        "CAP": "81037",
        "Localit\u00e0": "SESSA AURUNCA",
        "Indirizzo": "VIA XXI LUGLIO, 91",
        "N.ri Tel.": "0823 936825",
        "Insegna": "KUBA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02196-004547,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,24WBLDC02342-006631,25SBLUH02194-004547,24WBLDC02041-006648,25SBLUH02242-007100,25SBLUH02191-004547,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25SBLUT02110-006526,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUH02241-007100,25SBLUC11214-007111,25WBLDC02170-006648,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,25WBLDK03102-006047,24WBLDC03048-006047,25SBLDC01279-007111"
    },
    "001232": {
        "Stato": "IT",
        "CAP": "16132",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA BORGORATTI, 8R",
        "N.ri Tel.": "010 381779",
        "Insegna": "OLMEDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUP03539-006873,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDK02042-006648,25SBLUF01184-006804,25WBLDK03527-006047,24WBLDK03039-006950,25SBLUH02192-004547,25WBLDC03096-006047,25SBLDP03537-006873,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047,25WBLDC03097-006047,25SBLDC01279-007111,25SBLUF03185-006804"
    },
    "001235": {
        "Stato": "IT",
        "CAP": "88070",
        "Localit\u00e0": "BOTRICELLO",
        "Indirizzo": "VIA NAZIONALE, 463",
        "N.ri Tel.": "0961 963327",
        "Insegna": "STORIE DI MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLUC03090-006719,25SBLDH02372-005707,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,24WBLDC03114-006719,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUS02336-007138,25SBLUH02108-006864,25WBLDC03100-006047,25SBLUT02110-006526,25SBLUH02192-004547,25WBLDC03096-006047,24WBLDC03051-006047,25SBLDT02138-006526,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03495-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03097-006047"
    },
    "001248": {
        "Stato": "IT",
        "CAP": "12011",
        "Localit\u00e0": "BORGO SAN DALMAZZO",
        "Indirizzo": "PIAZZA MARTIRI, 14",
        "N.ri Tel.": "0171 266362",
        "Insegna": "MICLO'",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUP01189-006804,24WBLDK03052-006047,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDK02042-006648,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUT02312-006803,25WBLDC03096-006047,25WBLDK11162-007110,24WBLDC03211-006990,25WBLDC03095-006047,25SBLUF03187-006804,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDC05357-005831,25SBLUH02275-007100,25WBLDK03495-006047,25SBLUX02230-005958,25WBLDC03099-006047,25WBLDC11163-007110"
    },
    "001259": {
        "Stato": "IT",
        "CAP": "58043",
        "Localit\u00e0": "CASTIGLIONE DELLA PESCAIA",
        "Indirizzo": "VIA PONTE GIORGINI, 43",
        "N.ri Tel.": "0564 934217",
        "Insegna": "NAUTALA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLDX03008-006950,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUX02147-007103,24WBLDC03047-006047,25SBLDC01358-007101,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,25SBLKH02555-007188,24WBLDK02042-006648,24WBLDC02041-006648,25WBLGC02391-006648,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUC02228-007104,25SBLDC02264-006648,25SBLKX02418-005958,25SBLUC02227-007104,25SBLKP05558-007187,25WBLDC03096-006047,25SBLUC04206-006535,25SBLDC02232-007104,25SBLDK01249-007111,25SBLKF02553-007187,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111,25WBLUK11140-007286"
    },
    "001260": {
        "Stato": "IT",
        "CAP": "80135",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "PIAZZA DANTE, 10-11",
        "N.ri Tel.": "081-5642377",
        "Insegna": "POLVERE DI STELLE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02064-006100,24WBLDC02290-006646,24WBLDC03084-006976,24WBLDC03084-006976,24WBLDC11209-006007,24WBLDF01398-006987,24WBLDK03086-006976,24WBLDK03120-006951,24WBLDK03122-006955,24WBLDL01420-007016"
    },
    "001267": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "CERCOLA",
        "Indirizzo": "CORSO RICCARDI, 341",
        "N.ri Tel.": "081 5550561",
        "Insegna": "AMMENDOLA",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC02290-006646,24WBLDC03038-006950,24WBLDK03039-006950,25SBLDC01279-007111,25SBLDC04066-007109,25SBLDH02374-006842,25SBLDH02375-006842,25SBLUC01121-007105,25SBLUC04206-006535,25SBLUC11207-006787,25SBLUC11214-007111,25SBLUF01055-007092,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02274-007100,25SBLUP02063-007092,25SBLUS02336-007138,25SBLUT02110-006526,25SBLUT02306-006801,25SBLUT02346-007132"
    },
    "001367": {
        "Stato": "IT",
        "CAP": "60033",
        "Localit\u00e0": "CHIARAVALLE",
        "Indirizzo": "VIA D'ANTONA, 1",
        "N.ri Tel.": "071 948950",
        "Insegna": "GIGOLE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUF01184-006804,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUS01338-007137,25WBLDC03095-006047,25SBLUB04360-006788,25WBLDC02170-006648,25SBLUM01486-007172,25SBLUB04167-006854,24WBLDC02352-006977,25SBLDC03006-006950,25WBLDK03102-006047"
    },
    "001388": {
        "Stato": "IT",
        "CAP": "90026",
        "Localit\u00e0": "PETRALIA SOPRANA",
        "Indirizzo": "VIA Io MAGGIO, 78",
        "N.ri Tel.": "0921 680208",
        "Insegna": "PAGANO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLGC02391-006648,25WBLDB03191-007294,25WBLKC02427-005958,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUA05301-006434,25WBLUC02132-007284,25WBLDC03099-006047,25WBLKC02429-005958"
    },
    "001394": {
        "Stato": "IT",
        "CAP": "04019",
        "Localit\u00e0": "TERRACINA",
        "Indirizzo": "VIA ROMA, 134/136",
        "N.ri Tel.": "0773 705057",
        "Insegna": "CARMEN",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25SBLDX03008-006950,24WBLDC02044-006648,25WBLDA05336-007349,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC01115-007105,25SBLDL02396-007156,25WBLDC03100-006047,25WBLDK02073-006648,25SBLUC04176-006854,25SBLUH02379-007147,25WBLDC03096-006047,25SBLDC01159-007105,24WBLDC03051-006047,25SBLUH02241-007100,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDA05465-006127,25SBLUX02230-005958,25WBLDA05335-007349,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUH02394-007114,25SBLUC01217-007108,25WBLDA05337-006127"
    },
    "001428": {
        "Stato": "IT",
        "CAP": "17027",
        "Localit\u00e0": "PIETRA LIGURE",
        "Indirizzo": "VIA VINZONE, 4",
        "N.ri Tel.": "019 625454",
        "Insegna": "PEPE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC03074-006355,25SBLDX02235-006648,24WBLDC03047-006047,24WBLDC02342-006631,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDB03294-005553,25SBLUF02188-006804,25WBLDK03495-006047,25SBLUX02230-005958,24WBLDC03252-007008,25WBLDK03102-006047,25SBLUT02315-007117,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "001443": {
        "Stato": "IT",
        "CAP": "80027",
        "Localit\u00e0": "FRATTAMAGGIORE",
        "Indirizzo": "CORSO DURANTE, 70",
        "N.ri Tel.": "081 8328882",
        "Insegna": "LORDLY",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001444": {
        "Stato": "IT",
        "CAP": "23816",
        "Localit\u00e0": "BARZIO",
        "Indirizzo": "PIAZZA GARIBALDI, 3/4",
        "N.ri Tel.": "0341 996191",
        "Insegna": "MAROCCO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03095-006047,24WBLDK02363-005831,25WBLUC03086-006047,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDC11163-007110,24WBLDC02112-006631"
    },
    "001486": {
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA COSENZA, 21",
        "N.ri Tel.": "081 5265608",
        "Insegna": "POZZUOLI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUA04524-007182,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC01209-007101,25SBLUC11214-007111,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC03086-006047,24WBLDA05465-006127,24WBLDC02064-006100,25SBLDC01328-007131,25WBLUA05298-006127,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111,25WBLDA05337-006127,25SBLUC01281-007105"
    },
    "001493": {
        "Stato": "IT",
        "CAP": "36027",
        "Localit\u00e0": "ROSA'",
        "Indirizzo": "VIA NAZIONALE, 9",
        "N.ri Tel.": "0432 880154 UD",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02049-006636,24WBLDC02342-006631,24WBLDC03211-006990,24WBLDK03212-006990,25WBLDC02178-006646"
    },
    "001498": {
        "Stato": "IT",
        "CAP": "08015",
        "Localit\u00e0": "MACOMER",
        "Indirizzo": "CORSO UMBERTO, 109",
        "N.ri Tel.": "0785 70612",
        "Insegna": "VERDEMELA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUH02193-004547,25SBLDH02372-005707,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUC11207-006787,24WBLDK02042-006648,25SBLUF01184-006804,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02310-006817,25SBLUT02306-006801,25SBLDC04333-007109,25SBLUB04167-006854,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUF03185-006804"
    },
    "001529": {
        "Stato": "IT",
        "CAP": "86045",
        "Localit\u00e0": "PORTOCANNONE",
        "Indirizzo": "VIA GARIBALDI, 15A",
        "N.ri Tel.": "0875 599247",
        "Insegna": "SIMONA FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,24WBLDK03039-006950,25SBLUC01211-007101,25SBLDC02232-007104,25SBLDP02345-006855,25SBLUP04353-007129,25SBLDH02386-007144,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03122-006955,25SBLUC03013-006719,24WBLDC02352-006977,25WBLUC02080-005958,25SBLDC02234-006648,24WBLDC02314-006631,25SBLDC01222-007108,25SBLDX02235-006648,25SBLUC03011-006719,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUF03186-006804,25SBLUC04206-006535,25SBLDC04070-007109,25WBLDC03099-006047,25WBLDF08236-007301,25SBLDC01279-007111,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC03003-006950,25SBLUH02109-006526,25SBLUL02412-007155,25SBLUX02255-007101,25SBLUM06481-007168,25SBLUH02108-006864,24WBLDC02290-006646,25WBLDC03096-006047,25SBLDC02128-007103,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,25SBLDP01140-007109,25SBLDP05141-007109,25WBLDK03103-006047,24WBLDC02064-006100,25SBLDC03006-006950,25SBLUL02402-007153,25SBLUM01476-006233,25WBLDC03357-007294,25WBLUC03074-006355,25WBLDP04294-007324,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUT02313-006818,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDC02016-006940,24WBLDM10259-006645,25WBLDK03098-006047,25WBLDK01375-007378"
    },
    "001549": {
        "Stato": "IT",
        "CAP": "70033",
        "Localit\u00e0": "CORATO",
        "Indirizzo": "VIA RUVO, 29",
        "N.ri Tel.": "080 8981812",
        "Insegna": "GRAFFITI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUC11569-006787,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02109-006526,25WBLUC02077-006943,25SBLDX02235-006648,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUC11541-007110,25SBLKH02555-007188,25SBLKP05564-007187,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC01211-007101,25SBLKP05558-007187,25SBLKX02418-005958,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUT02309-007125,25SBLKC01445-007101,25SBLDC03007-006950,25SBLDK01249-007111,25SBLUT02310-006817,24WBLDC03051-006047,25WBLDC02170-006648,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLUC02079-A05958"
    },
    "001562": {
        "Stato": "IT",
        "CAP": "00019",
        "Localit\u00e0": "TIVOLI",
        "Indirizzo": "VIA PACIFICI, 15",
        "N.ri Tel.": "0774 314387",
        "Insegna": "PLANET FASHION",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK03039-006950,25SBLUT02110-006526,25SBLDC11237-007110,25WBLUL02318-007340,25SBLUX02230-005958,25SBLDH02373-005707,24WBLDC03048-006047,25SBLUP02352-006855,25SBLUH02030-006846,25WBLUK03142-005480,25SBLDH02374-006842,25SBLUS02336-007138,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUC04206-006535,25SBLUF01055-007092,25WBLDC03099-006047,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUF01184-006804,24WBLDC02290-006646,25SBLDS01291-007141,25WBLDC03096-006047,25SBLUS02336-007137,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUP01324-007130,24WBLDK03086-006976,24WBLDC05357-005831,24WBLDA05465-006127,25WBLDC03097-006047,25SBLUH02193-004547,25WBLDK03101-006047,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDK03052-006047,25SBLUH02191-004547,25WBLDK11162-007110,25SBLDH02370-006845,25SBLUT02306-006801,25WBLDC02170-006648,25SBLDC01328-007131,25WBLDK03098-006047"
    },
    "001578": {
        "Stato": "IT",
        "CAP": "06034",
        "Localit\u00e0": "FOLIGNO",
        "Indirizzo": "VIA G. DA FOLIGNO, 22-26",
        "N.ri Tel.": "075 8942732",
        "Insegna": "FIRENZE MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,25WBLUC11083-007110,24WBLDK03037-006950,25WBLUC03086-006047,25WBLUC08078-006355,25SBLDC03006-006950,25WBLDK03102-006047,24WBLDC03036-006950,24WBLDK03039-006950"
    },
    "001579": {
        "Stato": "IT",
        "CAP": "06059",
        "Localit\u00e0": "TODI",
        "Indirizzo": "VIA G. DA FOLIGNO, 22-26",
        "N.ri Tel.": "075 8942732",
        "Insegna": "FIRENZE MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK11162-007110,25SBLUC01209-007101"
    },
    "001599": {
        "Stato": "IT",
        "CAP": "06083",
        "Localit\u00e0": "FOLIGNO",
        "Indirizzo": "VIA VIVALDI, 71",
        "N.ri Tel.": "075 8942732",
        "Insegna": "FIRENZE MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC02290-006646,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUC03012-006719,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUC02132-007284"
    },
    "001618": {
        "Stato": "IT",
        "CAP": "80126",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO DUCA D'AOSTA, 27",
        "N.ri Tel.": "081 7267187",
        "Insegna": "MELE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02064-006100,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDK03037-006950,24WBLDK03040-006950,24WBLDL01417-006668,25SBLDC01279-007111,25SBLUC04176-006854,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUH02196-004547,25SBLUT02346-007132"
    },
    "001630": {
        "Stato": "IT",
        "CAP": "80053",
        "Localit\u00e0": "CASTELLAMARE DI STABIA",
        "Indirizzo": "VIA ALFREDO COTTRAU, 24",
        "N.ri Tel.": "081 8703474",
        "Insegna": "PAVIDAS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC11214-007111,25WBLUL02318-007340,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUC11083-007110,24WBLDC02314-006631,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC02177-007284,25SBLUH02275-007100,25WBLUA05298-006127,25WBLDC03099-006047,25SBLUP02063-007092,25SBLUC01210-007101,25SBLDC01279-007111,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03038-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDA05335-007349,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDK03212-006990,25WBLDC02170-006648,25SBLDC01328-007131,25WBLDK01375-007378"
    },
    "001652": {
        "Stato": "IT",
        "CAP": "17047",
        "Localit\u00e0": "VADO LIGURE",
        "Indirizzo": "VIA ITALIA, 2",
        "N.ri Tel.": "019 215801",
        "Insegna": "EGO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25SBLDC03003-006950,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUC03011-006719,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUC03012-006719,25WBLUC06082-005480,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "001689": {
        "Stato": "IT",
        "CAP": "70014",
        "Localit\u00e0": "CONVERSANO",
        "Indirizzo": "VIA BOLOGNINI, 34",
        "N.ri Tel.": "080 4111452",
        "Insegna": "MAX 1980",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK02556-006646,24WBLDK03039-006950,24WBLDK03293-005553,24WBLDK11337-006007"
    },
    "001701": {
        "Stato": "IT",
        "CAP": "70031",
        "Localit\u00e0": "ANDRIA",
        "Indirizzo": "VIA REGINA MARGHERITA, 93 C-D",
        "N.ri Tel.": "0883 597570",
        "Insegna": "D'AVANZO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUM01478-007167,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUC01211-007101,25SBLUC02227-007104,24WBLDC03211-006990,25SBLUK11239-007110,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUC02079-A05958"
    },
    "001717": {
        "Stato": "IT",
        "CAP": "16146",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA PAOLO BOSELLI, 6R",
        "N.ri Tel.": "010 3626227",
        "Insegna": "POSH",
        "CODICE PRODOTTO KOOOMO": "24WBLDM01437-007021,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDM04562-007021,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDA05465-006127,25WBLUC06082-005480,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "001781": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIA LUIGI EINAUDI, 56",
        "N.ri Tel.": "081 7741809",
        "Insegna": "JOICE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25SBLDH03371-005707,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC01121-007105,25SBLUT02310-006817,25SBLUC11214-007111,25WBLUC03086-006047,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUP05190-006804,25WBLUK03142-005480,24WBLDC02314-006631,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUP02063-007092,25SBLDC01279-007111,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02109-006526,24WBLDC03038-006950,25SBLUH02197-004547,24WBLDC02290-006646,25WBLUC02151-007287,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC02132-007284,25WBLDC03097-006047,25WBLDC02072-006648,25SBLUH02193-004547,25WBLDK03101-006047,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25WBLDC02170-006648,25SBLUH02199-004547,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "001793": {
        "Stato": "IT",
        "CAP": "87041",
        "Localit\u00e0": "ACRI",
        "Indirizzo": "VIA DELLA RESISTENZA SNC",
        "N.ri Tel.": "0984 953558",
        "Insegna": "IL QUADRIFOGLIO BY PINO RITACCO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC11214-007111,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUL02583-007370,25WBLUC11083-007110,24WBLDC03084-006976,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDT02125-006526,25WBLDK03527-006047,24WBLDC02018-006648,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDK03495-006047,25WBLDC03099-006047,25WBLUL01316-007012,25SBLDC01279-007111,24WBLDK03037-006950,25WBLDK03161-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUH02108-006864,24WBLDC02290-006646,25SBLDC02264-006648,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25WBLGC02391-006648,24WBLDB02092-006976,25SBLUT02313-006818,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03098-006047,25WBLDL01346-007354"
    },
    "001879": {
        "Stato": "IT",
        "CAP": "80019",
        "Localit\u00e0": "QUALIANO",
        "Indirizzo": "VIA CAMPANA, 224",
        "N.ri Tel.": "081 8189187 Luciano",
        "Insegna": "I GABBIANI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUT02310-006817,25SBLUC11214-007111,25SBLUC03012-006719,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUK03142-005480,25WBLKC11416-007110,25SBLDH02374-006842,25SBLUX02147-007103,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLKC02427-005958,25WBLDC02177-007284,25SBLUH02275-007100,25SBLDH02375-006842,25SBLDC01279-007111,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03038-006950,24WBLDC02290-006646,25WBLUC02151-007287,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDC03097-006047,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25SBLUC11207-006787,25WBLDC02170-006648,25WBLDK03098-006047"
    },
    "001891": {
        "Stato": "IT",
        "CAP": "00155",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DI TOR SAPIENZA, 35 B/C/D",
        "N.ri Tel.": "06 2284544",
        "Insegna": "WALCOR",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDK02073-006648,24WBLDK03039-006950,25SBLUP04062-007092,25SBLUC01121-007105,25SBLUH02241-007100,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUC01217-007108,25WBLDA05337-006127,25WBLKC02429-005958,25WBLKC11416-007110,25SBLDL02396-007156,25SBLDL02396-007152,25WBLDK03527-006047,24WBLDC02018-006648,25SBLUC04206-006535,25WBLUA05298-006127,25WBLDC03099-006047,25SBLUP02063-007092,25SBLUC01210-007101,25SBLDC01279-007111,25WBLUB05126-007283,25SBLDX03008-006950,25WBLUC03090-006719,25WBLDC02178-006646,25WBBXC02456-005958,25SBLUC01115-007105,24WBLDC03038-006950,25SBLUX02255-007101,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUS02336-007137,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDK03086-006976,25SBLDC03006-006950,25WBLDC03097-006047,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDK03052-006047,25SBLDC01159-007105,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDC02016-006940,25SBLUC04082-007159,25SBLDC04066-007109,25WBLDK03098-006047,25WBLDL01346-007354"
    },
    "001926": {
        "Stato": "IT",
        "CAP": "87027",
        "Localit\u00e0": "PAOLA",
        "Indirizzo": "CORSO ROMA, 37",
        "N.ri Tel.": "0982 587057",
        "Insegna": "FOREVER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02197-004547,25SBLUC01219-007108,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUC04206-006535,25SBLUS01338-007137,25SBLUF01055-007092,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958"
    },
    "001936": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "LECCE",
        "Indirizzo": "VIA ZANARDELLI, 28",
        "N.ri Tel.": "0832 458566",
        "Insegna": "CRAZY SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLUC02079-005958,25WBLUC03233-007308,24WBLDM10408-007022,25SBLUT02110-006526,25SBLDP01326-007143,25WBLDP01295-007323,24WBLDK03122-006955,24WBLDC02352-006977,25WBLUC02080-005958,25WBLDA05337-006127,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDC01359-007101,25SBLDK01249-007111,25WBLUA05298-006127,25WBLDC03099-006047,25WBLUK11140-007286,24WBLDC03119-006951,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02108-006864,25SBLDP02143-007109,25SBLUH02197-004547,24WBLDC02290-006646,25SBLDP04142-007109,25SBLUT02309-007125,25WBLDC03095-006047,25SBLDC04333-007109,25WBLDK03103-006047,24WBLDP03447-007029,25SBLDV04293-007143,25WBLUC06082-005480,24WBLDM01427-005794,25WBLDA05335-007349,24WBLDF03399-006987,24WBLDM01437-007021,25SBLUH02193-004547,24WBLDM09261-006645,25SBLUT02346-007132,25SBLUC11207-006787,25SBLDH02376-006842,25WBLDM01463-007330,25WBLDK11162-007110,25SBLUK11239-007110,25SBLDH02370-006845,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDF08248-006948,25WBLUC02079-A05958,25WBLUA05297-006127"
    },
    "001957": {
        "Stato": "IT",
        "CAP": "31057",
        "Localit\u00e0": "LANZAGO DI SILEA",
        "Indirizzo": "VIA FRIULI, 2",
        "N.ri Tel.": "0422 361266",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001974": {
        "Stato": "IT",
        "CAP": "42019",
        "Localit\u00e0": "SCANDIANO",
        "Indirizzo": "VIA TRIESTE, 1/E",
        "N.ri Tel.": "0522 857173",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001994": {
        "Stato": "IT",
        "CAP": "80038",
        "Localit\u00e0": "POMIGLIANO D'ARCO",
        "Indirizzo": "VIA E. CANTONE, 48",
        "Insegna": "OVER THE TOP",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDK03101-006047,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDC03038-006950,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDK03102-006047,25WBLDC03099-006047"
    },
    "002077": {
        "Stato": "IT",
        "CAP": "28041",
        "Localit\u00e0": "ARONA",
        "Indirizzo": "VIA CAVOUR, 92",
        "N.ri Tel.": "0323 405789",
        "Insegna": "REPTILE'S HOUSE",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03084-006976,24WBLDK03037-006950,24WBLDK03040-006950,25SBLUP02352-006855,25SBLUP04322-007129,25SBLUP04353-007129,25SBLUP05355-007139,25SBLUX02230-005958"
    },
    "002079": {
        "Stato": "IT",
        "CAP": "64025",
        "Localit\u00e0": "PINETO",
        "Indirizzo": "VIA G. D'ANNUNZIO, 71",
        "N.ri Tel.": "085 9492781",
        "Insegna": "ATELIER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDK03037-006950,25SBLUN01521-006581,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUP01189-006804,25SBLUL02412-007155,24WBLDC03047-006047,25WBLDC03100-006047,25SBLUC04176-006854,25SBLUA04524-007182,24WBLDC02290-006646,24WBLDK03039-006950,25SBLUP04043-007130,25SBLUH02276-005695,25SBLUT02312-006803,25SBLUT02313-006818,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDC03007-006950,24WBLDC03051-006047,25WBLDC02170-006648,25SBLUF02188-006804,25SBLUM01486-007172,25SBLUP04354-007129,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUL02583-007370,25SBLUH02394-007114,25SBLUH02030-006846,25SBLUC01217-007108"
    },
    "002293": {
        "Stato": "IT",
        "CAP": "57125",
        "Localit\u00e0": "LIVORNO",
        "Indirizzo": "VIA RICASOLI, 127",
        "N.ri Tel.": "0586 899779",
        "Insegna": "BERTOLINI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUA05297-006127"
    },
    "002301": {
        "Stato": "IT",
        "CAP": "81031",
        "Localit\u00e0": "AVERSA",
        "Indirizzo": "VIA ROMA, 161",
        "N.ri Tel.": "081 8111689",
        "Insegna": "ARIANO BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDK11337-006007,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDK02556-006646,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,24WBLDK03212-006990,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03086-006976,25WBLDK03495-006047,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "002332": {
        "Stato": "IT",
        "CAP": "63100",
        "Localit\u00e0": "ASCOLI PICENO",
        "Indirizzo": "VIA ERASMO MARI, 10",
        "N.ri Tel.": "0736 43448",
        "Insegna": "MAX",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDC02049-006636,25SBLUP05190-006804,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25SBLUH02109-006526,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUF01184-006804,25SBLUF03186-006804,24WBLDC02290-006646,25WBLUC02151-007287,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDK03103-006047,25SBLUC03012-006719,25SBLDC02236-006648,25SBLUM01486-007172,25SBLUT02315-007117,25SBLUC01210-007101,25WBLUA05297-006127"
    },
    "002374": {
        "Stato": "IT",
        "CAP": "80056",
        "Localit\u00e0": "ERCOLANO",
        "Indirizzo": "CORSO RESINA, 316",
        "N.ri Tel.": "081 7390809",
        "Insegna": "ELEGANZA",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDK02556-006646,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUC11214-007111,25WBLDK03102-006047,24WBLDC03048-006047"
    },
    "002376": {
        "Stato": "IT",
        "CAP": "74122",
        "Localit\u00e0": "TALSANO",
        "Indirizzo": "CORSO VITTORIO EMANUELE II, 184/A",
        "N.ri Tel.": "099 7310544",
        "Insegna": "LINEA SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,25SBLKH02555-007188,25SBLUC01211-007101,25SBLKF02553-007187,25SBLUH02241-007100,25SBLDH02386-007144,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLKC02429-005958,25SBLDC01222-007108,25WBLUC02077-006943,25SBLUC02229-005958,24WBLDK02042-006648,25SBLUH02195-004547,25WBLKC02427-005958,25SBLUS01338-007137,25SBLDC04070-007109,25WBLDC03099-006047,25WBLDF08236-007301,25SBLUF03185-006804,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUF01184-006804,25SBLKP05564-007187,24WBLDC02290-006646,25SBLKX02418-005958,25WBLDC03096-006047,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLDC03097-006047,25WBLDC02072-006648,25WBLKA05458-006127,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLGC01441-007111,25SBLKC06443-007101,25SBLDF03076-007092,25SBLUC02228-007104,25SBLDF03257-007113,25SBLDC01328-007131,25WBLDK03098-006047"
    },
    "002392": {
        "Stato": "IT",
        "CAP": "20019",
        "Localit\u00e0": "SETTIMO MILANESE",
        "Indirizzo": "VIA D'ADDA, 20",
        "N.ri Tel.": "02 33500036",
        "Insegna": "PROGETTO MODA",
        "CODICE PRODOTTO KOOOMO": "25SBLUP03539-006873,25WBLDA05336-007349,25WBLDC03173-007307,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDM10408-007022,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02310-006817,25SBLUH02241-007100,25SBLUX02230-005958,24WBLDC03048-006047,25SBLDV01146-007107,25WBLDA05337-006127,24WBLDC02314-006631,25SBLDP01079-007092,24WBLDC02041-006648,25SBLUP04322-007129,25SBLUF01055-007092,25SBLUH01149-007100,25WBLUA05298-006127,25SBLUP02063-007092,25WBLDC02178-006646,25SBLUA04527-007182,24WBLDA05467-006434,24WBLDC03038-006950,25SBLUF01184-006804,24WBLDC02290-006646,25SBLUH02244-007100,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03102-006047,24WBLDM10555-007022,25SBLUH02150-007100,25SBLDC01221-007108,25SBLUC11207-006787,25SBLDF03076-007092,25SBLUX01218-007108,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "002449": {
        "Stato": "IT",
        "CAP": "98061",
        "Localit\u00e0": "BROLO",
        "Indirizzo": "VIA UGO FOSCOLO S/N",
        "N.ri Tel.": "0941 561547",
        "Insegna": "LS CITY",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUK03142-005480,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLKH02555-007188,25SBLUH02108-006864,25SBLUX03226-006719,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUC01211-007101,25SBLKP05558-007187,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLUT02310-006817,25SBLKF02553-007187,25SBLKT02464-006818,25WBLDC03095-006047,25SBLKP01554-007187,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02132-007284,25WBLUA05301-006434,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047"
    },
    "002454": {
        "Stato": "IT",
        "CAP": "80053",
        "Localit\u00e0": "CASTELLAMARE DI STABIA",
        "Indirizzo": "PIAZZA PRINCIPE UMBERTO, 11",
        "N.ri Tel.": "081 8716248",
        "Insegna": "ANTONELLA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDK01376-007378,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC02251-006631,25WBLDB03191-007294,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC11214-007111,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUP02352-006855,24WBLDC02314-006631,25SBLDC01222-007108,25SBLUH02196-004547,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUP04322-007129,25SBLUF01055-007092,25SBLUC01034-007111,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUC11215-007110,24WBLDC03038-006950,25SBLUH02108-006864,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDC03095-006047,24WBLDC03051-006047,25WBLUC06082-005480,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDC03097-006047,25SBLUC11569-006787,25WBLDC02072-006648,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUT02313-006818,25SBLUT02306-006801,25WBLDC02170-006648,25WBLUC02079-A05958,25WBLDK03098-006047,25WBLDK01375-007378"
    },
    "002461": {
        "Stato": "IT",
        "CAP": "20158",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "PIAZZALE LUGANO, 9",
        "N.ri Tel.": "02 66983261",
        "Insegna": "DONATO RICCI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDK03037-006950,24WBLDK03040-006950,24WBLDK03040-006950,24WBLDK03052-006047,24WBLDK03122-006955"
    },
    "002848": {
        "Stato": "IT",
        "CAP": "76125",
        "Localit\u00e0": "TRANI",
        "Indirizzo": "PIAZZA DELLA REPUBBLICA,60",
        "N.ri Tel.": "0883 506090",
        "Insegna": "NEW MULTIBRAND FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLDS01292-007141,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDV02296-007143,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUT02346-007132,25SBLDC01358-007101,25WBLUA05300-006434,25SBLDV03365-007143,25SBLDP02143-007109,25SBLUK04174-006854,25SBLUM01478-007167,25SBLUC04176-006854,25SBLUF03186-006804,25SBLUK11239-007110,25SBLDS01366-007141,25SBLDC02128-007103,25SBLDC04331-006788,25SBLUF03187-006804,25SBLUS01338-007137,25SBLDC04333-007109,25SBLDM01473-007166,25SBLUX02230-005958,25WBLUC02079-A05958,25SBLDC04066-007109,25SBLUM01479-007167,25SBLUH02394-007114,25WBLUA05297-006127,25SBLDV01146-007107"
    },
    "002900": {
        "Stato": "IT",
        "CAP": "00010",
        "Localit\u00e0": "FONTE NUOVA",
        "Indirizzo": "VIA NOMENTANA, 623",
        "N.ri Tel.": "348-8416514",
        "Insegna": "MARCO MASI FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,24WBLDC03047-006047,25WBLDB03191-007294,25SBLUP04062-007092,25SBLUC01121-007105,25SBLDP02345-006855,24WBLDC03048-006047,25SBLUL02583-007370,24WBLDC03084-006976,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDH02374-006842,25SBLDL02396-007156,25SBLDT02125-006526,24WBLDC02018-006648,25SBLUC04206-006535,25SBLUP04322-007129,25SBLDH02375-006842,25WBLDC03099-006047,25SBLDC01279-007111,25SBLDX03008-006950,25WBLDC02178-006646,24WBLDA05467-006434,25SBLUP01189-006804,25SBLUF01184-006804,25SBLUC04176-006854,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDA05465-006127,24WBLDC03252-007008,25WBLDA05335-007349,25WBLDC03097-006047,25SBLUM01476-006233,25SBLUH02193-004547,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUH02192-004547,25SBLDC01159-007105,25SBLDT02138-006526,25WBLDC02170-006648,25SBLDC01328-007131,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "002908": {
        "Stato": "IT",
        "CAP": "09125",
        "Localit\u00e0": "CAGLIARI",
        "Indirizzo": "VIA STAZIONE VECCHIA, 7",
        "N.ri Tel.": "070 666106",
        "Insegna": "SURF SPOT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02064-006100,24WBLDC03038-006950,24WBLDK03037-006950"
    },
    "002918": {
        "Stato": "IT",
        "CAP": "25087",
        "Localit\u00e0": "SALO'",
        "Indirizzo": "PIAZZA ZANELLI, 16",
        "N.ri Tel.": "0365 43735",
        "Insegna": "DAY AFTER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDC03119-006951,24WBLDK03037-006950,25WBLUC03090-006719,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUX03226-006719,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUH02348-007132,25WBLUC02151-007287,24WBLDC03211-006990,25SBLDP02345-006855,24WBLDC03051-006047,25SBLUH02241-007100,24WBLDK02363-005831,25SBLDM01473-007166,24WBLDA05465-006127,25WBLUC06082-005480,25SBLUH01149-007100,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDC01329-007131,24WBLDC02112-006631"
    },
    "002941": {
        "Stato": "IT",
        "CAP": "70015",
        "Localit\u00e0": "NOCI",
        "Indirizzo": "VIA CAVOUR, 101",
        "N.ri Tel.": "080 4971994",
        "Insegna": "LUIGINA",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "002970": {
        "Stato": "IT",
        "CAP": "53100",
        "Localit\u00e0": "SIENA",
        "Indirizzo": "STRADA MASSETANA ROMANA, 54",
        "N.ri Tel.": "0577 283927",
        "Insegna": "GHN",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC02080-005958,25WBLDA05335-007349,24WBLDC03048-006047,25WBLDK03098-006047,25WBLUC02079-A05958,25WBLDC03097-006047,25WBLDA05337-006127"
    },
    "003003": {
        "Stato": "IT",
        "CAP": "22077",
        "Localit\u00e0": "OLGIATE COMASCO",
        "Indirizzo": "VIA SEGANTINI, 14",
        "N.ri Tel.": "031 945155",
        "Insegna": "CONFEZIONI GIEM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDX02113-006631,25WBLDP01291-007324,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25WBLDC03100-006047,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02310-006817,25SBLDF08078-007092,25WBLUC05125-007283,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLKC02429-005958,25WBLUC11083-007110,25WBLUK03142-005480,25WBLDC02196-007283,25SBLDP01079-007092,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUF03186-006804,25WBLDC03099-006047,25WBLDF08236-007301,25SBLDC01279-007111,25WBLUK11140-007286,24WBLDK03037-006950,25WBLUC03090-006719,25SBLUH02109-006526,25SBLUF01184-006804,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC06082-005480,25WBLDK03102-006047,25SBLDC02233-007104,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDF03076-007092,25WBLUC02079-A05958,25SBLDC04066-007109"
    },
    "003120": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "PRATO",
        "Indirizzo": "VIALE DELLA REPUBBLICA, 254",
        "N.ri Tel.": "0574 580367",
        "Insegna": "PEDINI",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02191-004547,24WBLDK03039-006950,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25SBLUH02275-007100,25SBLUX02230-005958,25WBLDF08248-006948,25WBLDC03099-006047,25WBLDC03097-006047"
    },
    "003148": {
        "Stato": "IT",
        "CAP": "200582",
        "Localit\u00e0": "VILLASANTA",
        "Indirizzo": "VIA CONFALONIERI FEDERICO CONTE, 29",
        "N.ri Tel.": "039 303989",
        "Insegna": "COLOMBO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDK03037-006950,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03090-006719,25SBLDH02372-005707,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUF01184-006804,24WBLDC02041-006648,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUP04322-007129,25SBLUT02310-006817,25WBLDC03095-006047,25SBLDC04333-007109,24WBLDK02363-005831,25SBLUC03012-006719,25SBLDF08078-007092,25SBLDH02375-006842,25WBLUA05301-006434,25WBLDK03102-006047,24WBLDC03048-006047,25SBLDC01329-007131,25SBLUM01476-006233"
    },
    "003214": {
        "Stato": "IT",
        "CAP": "80070",
        "Localit\u00e0": "ISCHIA ISOLA",
        "Indirizzo": "CORSO VITTORIO COLONNA, 160",
        "N.ri Tel.": "081 984032",
        "Insegna": "LAMBITELLI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02064-006100,24WBLDC02290-006646,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDK03037-006950,24WBLDK03037-006950"
    },
    "003298": {
        "Stato": "IT",
        "CAP": "80059",
        "Localit\u00e0": "TORRE DEL GRECO",
        "Indirizzo": "VIA SALVATOR NOTO, 41/43/45",
        "N.ri Tel.": "081 8828144",
        "Insegna": "NOVECENTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,25WBLDK03103-006047,24WBLDK03037-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDC03096-006047,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03527-006047,25WBLDC03095-006047,25WBLDC03100-006047,24WBLDC03036-006950,24WBLDK03039-006950"
    },
    "003370": {
        "Stato": "IT",
        "CAP": "73057",
        "Localit\u00e0": "TAVIANO",
        "Indirizzo": "CORSO VITTORIO EMANUELE II, 2",
        "N.ri Tel.": "0833 914180",
        "Insegna": "BOVE ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDC02044-006648,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01222-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDC01358-007101,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUH02108-006864,25SBLUT02313-006818,25SBLDC11237-007110,25SBLUS02336-007137,25SBLDC02232-007104,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02079-A05958,25WBLDK03098-006047,25SBLUM01479-007167,25WBLDC03097-006047"
    },
    "003379": {
        "Stato": "IT",
        "CAP": "41124",
        "Localit\u00e0": "MODENA",
        "Indirizzo": "VIA PIETRO GIARDINI 264",
        "N.ri Tel.": "059 341955",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "003502": {
        "Stato": "IT",
        "CAP": "81038",
        "Localit\u00e0": "TRENTOLA DUCENTA",
        "Indirizzo": "SP TRENTOLA PARETE C/O C.C. JAMBOL",
        "N.ri Tel.": "081 5017285",
        "Insegna": "MIKA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUC11215-007110,24WBLDC03036-006950,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25SBLGC01441-007111,24WBLDC03038-006950,25WBLDK02069-006648,25SBLKC06443-007101,25WBLDC03100-006047,25SBLKC11440-007111,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,25WBLDA05335-007349,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02112-006631"
    },
    "003513": {
        "Stato": "IT",
        "CAP": "00034",
        "Localit\u00e0": "COLLEFERRO",
        "Indirizzo": "VIA FONTANA DELL'OSTE , 88",
        "N.ri Tel.": "06 97303809",
        "Insegna": "GULLIVER ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLGC02426-006648,24WBLDC02251-006631,25WBLDB03191-007294,24WBLDK03039-006950,25SBLUC03012-006719,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLUK03142-005480,24WBLDC02314-006631,24WBLDL01417-006668,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDC02018-006648,25SBLUC04206-006535,25WBLDC02177-007284,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUC11215-007110,25WBBXC02456-005958,25SBLUC01115-007105,24WBLDC03038-006950,24WBLDC02290-006646,25SBLKX02418-005958,25WBLDC03096-006047,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDC02072-006648,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDK03052-006047,25SBLGC01441-007111,25SBLKC06443-007101,25WBLGC02391-006648,25WBLDC02170-006648,25SBLDC01328-007131,25WBLDK03098-006047"
    },
    "003762": {
        "Stato": "IT",
        "CAP": "84022",
        "Localit\u00e0": "CAMPAGNA",
        "Indirizzo": "VIA PROVINCIALE PER CAMPAGNA, QUADRIVIO",
        "N.ri Tel.": "333 1792210",
        "Insegna": "ANGEL'S",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLKH02555-007188,24WBLDK03293-005553,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC02227-007104,25SBLKP05558-007187,25SBLDC02232-007104,25SBLUC11083-007106,25SBLUT02310-006817,25SBLUF03187-006804,25SBLKF02553-007187,25SBLUC01209-007101,25SBLUC11214-007111,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03122-006955,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLKC03400-007308,25WBLKC02429-005958,25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25SBLDC02234-006648,25SBLUX02147-007103,25SBLUC01046-007120,25SBLUC03011-006719,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLGP05549-007187,25WBLKC02427-005958,25SBLUC04206-006535,25SBLKP01554-007187,25SBLUF01055-007092,25SBLUH02275-007100,25SBLDH02375-006842,25WBLDC03099-006047,25SBLUP02063-007092,25SBLDC01279-007111,24WBLDC02112-006631,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC03003-006950,25WBBXC02456-005958,25SBLUP01189-006804,25SBLKF03551-007187,25SBLGF02547-007187,25SBLDC01358-007101,24WBLDC03038-006950,25SBLKC02430-007104,25SBLUC04176-006854,24WBLDC02290-006646,25SBLKX02418-005958,25WBLDC03096-006047,24WBLDF08400-006987,25SBLUT02309-007125,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25SBLUS01342-007136,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02132-007284,25SBLDC03006-006950,25SBLGH02550-007188,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUM01476-006233,25SBLUC11569-006787,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDC11335-007110,25SBLDH02376-006842,25SBLUC11207-006787,25SBLGC01441-007111,25SBLKC01444-007101,25SBLKC06443-007101,25WBLGA05461-007349,25WBLGC02391-006648,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUB04167-006854,25SBLDC01328-007131,25SBLUH02199-004547,25WBLUC02079-A05958,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "004495": {
        "Stato": "IT",
        "CAP": "10129",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA PIGAFETTA, 49/I",
        "N.ri Tel.": "011 591304",
        "Insegna": "BAUDINO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLDK03101-006047,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUL02318-007340,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "004520": {
        "Stato": "IT",
        "CAP": "46041",
        "Localit\u00e0": "ASOLA",
        "Indirizzo": "VIA CREMONA, 62",
        "N.ri Tel.": "0376 712027",
        "Insegna": "RIZZI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUF01184-006804,25SBLUF03186-006804,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDC02112-006631"
    },
    "004555": {
        "Stato": "IT",
        "CAP": "54037",
        "Localit\u00e0": "MARINA DI MASSA",
        "Indirizzo": "VIA C. COLOMBO, 15",
        "N.ri Tel.": "0585-243882",
        "Insegna": "ETE'",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308,25WBLDC03096-006047,25WBLUC08078-006355,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC03074-006355"
    },
    "004572": {
        "Stato": "IT",
        "CAP": "21016",
        "Localit\u00e0": "LUINO",
        "Indirizzo": "VIA XV AGOSTO, 20/22",
        "N.ri Tel.": "0332 537689",
        "Insegna": "CRESPI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUK03142-005480,24WBLDC03036-006950,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDC03211-006990,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC06082-005480,25WBLDC03099-006047"
    },
    "004573": {
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "MACLODIO",
        "Indirizzo": "PIAZZALE EUROPA, 1",
        "N.ri Tel.": "030 3737192",
        "Insegna": "PIER MODE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUM01478-007167,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUM01480-007168,25WBLDC03095-006047,25SBLUC03012-006719,25WBLDC03092-006719,25WBLUC03086-006047,25WBLUC02080-005958,25SBLDC03006-006950,24WBLDC03048-006047,24WBLDK03040-006950"
    },
    "005189": {
        "Stato": "IT",
        "CAP": "95031",
        "Localit\u00e0": "ADRANO",
        "Indirizzo": "VIA CASALE DEI GRECI, 2",
        "N.ri Tel.": "095 7699130",
        "Insegna": "TREND ADRANO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUA04524-007182,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,25WBLDC03099-006047,25SBLUC01210-007101,25SBLDC01279-007111,25WBLDC11163-007110"
    },
    "005699": {
        "Stato": "IT",
        "CAP": "36075",
        "Localit\u00e0": "URGNANO",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUH02193-004547,25WBLUC03090-006719,25SBLUP05190-006804,25SBLUC11541-007110,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUP05530-007173,24WBLDK02363-005831,25SBLDC01328-007131,25SBLUC01217-007108,25SBLUF08504-007173,25WBLKC02429-005958"
    },
    "005942": {
        "Stato": "IT",
        "CAP": "62010",
        "Localit\u00e0": "PASSO DI TREIA",
        "Indirizzo": "CORSO GARIBALDI, 263/C",
        "N.ri Tel.": "0733 541525",
        "Insegna": "JOLLY PIU'",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25SBLUP05190-006804,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11541-007110,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUP04043-007130,25SBLUT02313-006818,25SBLUC02228-007104,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,25SBLUB04360-006788,25WBLDC02170-006648,25SBLUM01486-007172,25WBLUC02080-005958,25SBLUT02315-007117,25WBLDK03098-006047,25SBLUH02030-006846,25SBLUF03185-006804,25SBLUM01476-006233"
    },
    "006075": {
        "Stato": "IT",
        "CAP": "71019",
        "Localit\u00e0": "VIESTE",
        "Indirizzo": "VIA MADONNA DELLA LIBERA, 32-34",
        "N.ri Tel.": "0884 708992",
        "Insegna": "JOHANAN ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDK03037-006950,25SBLDX03008-006950,25WBLUK03142-005480,25WBLDC02178-006646,25WBLDC03173-007307,25SBLUA04527-007182,25SBLDC02234-006648,24WBLDA05467-006434,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02195-004547,25SBLUM12488-007170,25SBLUF03186-006804,25SBLUA04524-007182,25SBLUH02276-005695,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUC02227-007104,25WBLDK11162-007110,25SBLUC01281-007105,25SBLDC03007-006950,25SBLUP04322-007129,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDH02386-007144,25WBLDK03103-006047,25SBLUM01486-007172,24WBLDC02064-006100,25WBLUC06082-005480,25SBLUH02199-004547,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUP02352-006855,25SBLUA04525-007182,25SBLUM01476-006233"
    },
    "006140": {
        "Stato": "IT",
        "CAP": "38068",
        "Localit\u00e0": "UGGIATE TREVANO",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 2",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUP04322-007129,25SBLUC03012-006719,25SBLUX02230-005958,25WBLUC02079-A05958,24WBLDK03040-006950"
    },
    "006199": {
        "Stato": "IT",
        "CAP": "20121",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "P.ZZA XXV APRILE, 1",
        "N.ri Tel.": "02 63471267",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP05033-007094,25SBLUN01521-006581,25WBLDB03191-007294,25SBLUM01478-007167,25SBLUN02516-007177,25WBLUC03086-006047,25WBLDP01295-007323,24WBLDC02064-006100,24WBLDF03399-006987,25SBLUL02402-007153"
    },
    "006216": {
        "Stato": "IT",
        "CAP": "10136",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA TRIPOLI, 68",
        "N.ri Tel.": "011 3292512",
        "Insegna": "NEW SALOON JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958"
    },
    "006217": {
        "Stato": "IT",
        "CAP": "10136",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA VITTORIO EMANUELE, 76",
        "N.ri Tel.": "011 3292512",
        "Insegna": "NEW SALOON JEANS",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDK03527-006047,25WBLDB03191-007294,25SBLUF03186-006804,25SBLUH02197-004547,24WBLDB02092-006976,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDB03294-005553,24WBLDK03086-006976,25WBLDK03495-006047,24WBLDC03048-006047,25SBLDC01279-007111"
    },
    "006253": {
        "Stato": "IT",
        "CAP": "00044",
        "Localit\u00e0": "FRASCATI",
        "Indirizzo": "VIA C. BATTISTI, 6",
        "N.ri Tel.": "329 9391946",
        "Insegna": "PIGNATELLI",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUN01521-006581,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUC11207-006787,25SBLUC01119-007105,24WBLDK11337-006007,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUA04524-007182,25SBLUP04062-007092,25SBLUC01121-007105,25SBLUN02513-007179,25SBLDK01249-007111,25SBLUT02306-006801,25SBLUF01055-007092,24WBLDK03120-006951,25WBLUL02318-007340,25WBLDA05335-007349,25SBLUT02315-007117,25WBLDK03102-006047,25WBLUB05126-007283,25SBLUM01476-006233"
    },
    "006324": {
        "Stato": "IT",
        "CAP": "89013",
        "Localit\u00e0": "GIOIA TAURO",
        "Indirizzo": "VIA ROMA, 19/23",
        "N.ri Tel.": "0966 55767",
        "Insegna": "MARCHESE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDB02092-006976,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC02231-005958,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "006344": {
        "Stato": "IT",
        "CAP": "73050",
        "Localit\u00e0": "SALVE",
        "Indirizzo": "VIA ROMA SNC",
        "N.ri Tel.": "0833 741042",
        "Insegna": "PUNTO SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02049-006636,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDK02042-006648,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUH02030-006846,25SBLUH02191-004547,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUH02196-004547,25SBLUH02197-004547,25SBLUT02306-006801,25SBLUT02310-006817,25SBLUT02313-006818"
    },
    "006372": {
        "Stato": "IT",
        "CAP": "84100",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA WENNER, 28/A",
        "N.ri Tel.": "089 302883",
        "Insegna": "MARINO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC02080-005958,25SBLDC03006-006950,25WBLDA05335-007349,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDC04066-007109,25WBLDC03099-006047,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "006374": {
        "Stato": "IT",
        "CAP": "83054",
        "Localit\u00e0": "SANT 'ANGELO DEI LOMBARDI",
        "Indirizzo": "PIAZZA F. DE SANCTIS, 22",
        "N.ri Tel.": "0827 24488",
        "Insegna": "FUSCHETTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC02290-006646,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDK03039-006950,25SBLUA04524-007182,25SBLUA04528-007183,25SBLUC01210-007101,25SBLUC01281-007105,25SBLUC04206-006535,25SBLUC11541-007110,25SBLUF01055-007092,25SBLUF01184-006804,25SBLUF02188-006804,25SBLUH02194-004547,25SBLUH02197-004547,25SBLUT02306-006801,25SBLUT02310-006817,25SBLUT02313-006818"
    },
    "006463": {
        "Stato": "IT",
        "CAP": "72018",
        "Localit\u00e0": "SAN MICHELE SALENTINO",
        "Indirizzo": "VIA G. PASCOLI, 19",
        "N.ri Tel.": "0831 964771",
        "Insegna": "LINEA SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25SBLUM03490-007170,25WBLUC11083-007110,24WBLDC02044-006648,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDK11337-006007,25SBLUP01350-006855,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUH02191-004547,25SBLUM01478-007167,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDB02092-006976,25SBLUT02313-006818,25WBLDK11162-007110,25SBLUT02310-006817,25SBLUP04353-007129,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03122-006955,24WBLDC03048-006047,25WBLUC02079-A05958,25SBLUC04163-006788,25WBLDC11163-007110"
    },
    "007030": {
        "Stato": "IT",
        "CAP": "74017",
        "Localit\u00e0": "MOTTOLA",
        "Indirizzo": "VIA RISORGIMENTO, 8-10",
        "N.ri Tel.": "0998 863767",
        "Insegna": "VERTICE UOMO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUT02346-007132,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUT02110-006526,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUH02199-004547"
    },
    "007038": {
        "Stato": "IT",
        "CAP": "76123",
        "Localit\u00e0": "ANDRIA",
        "Indirizzo": "VIALE ROMA, 5",
        "N.ri Tel.": "0883 556095",
        "Insegna": "CARDINALE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25SBLDS01292-007141,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUS02336-007138,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDH02389-007144,25SBLDH02377-007144,25WBLDK11162-007110,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDK03103-006047,25SBLDF08078-007092,24WBLDM10259-006645,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDC11163-007110"
    },
    "007078": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA CALOPRESE, 47-49",
        "N.ri Tel.": "0984 390262",
        "Insegna": "VIP",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDK03037-006950,25SBLDH02372-005707,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,25WBLDC02196-007283,25WBLDP01291-007324,25SBLUC11207-006787,25SBLDB04068-007109,25SBLUL02412-007155,25WBLUC03233-007308,25SBLUC03011-006719,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC02227-007104,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC02232-007104,25SBLDK01249-007111,25SBLDC02128-007103,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC02080-005958,25WBLDF08236-007301,25WBLUC02132-007284,25WBLDK03102-006047,24WBLDC03048-006047,25SBLUL02402-007153,25WBLUL01316-007012"
    },
    "007159": {
        "Stato": "IT",
        "CAP": "71036",
        "Localit\u00e0": "LUCERA",
        "Indirizzo": "VIA ZUPPETTA, 48-50",
        "N.ri Tel.": "0881 530513",
        "Insegna": "REBECCA FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDX03008-006950,25SBLUS01339-007137,25SBLUP05190-006804,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11207-006787,25SBLDC01358-007101,25SBLUC11541-007110,25SBLUC03011-006719,25SBLUX03226-006719,25SBLUF03186-006804,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUC01211-007101,25SBLDC03007-006950,25SBLDC04333-007109,25SBLDP01140-007109,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUP02063-007092"
    },
    "007265": {
        "Stato": "IT",
        "CAP": "18038",
        "Localit\u00e0": "SANREMO",
        "Indirizzo": "VIA MATTEOTTI, 184",
        "N.ri Tel.": "0184 591273",
        "Insegna": "PLAY FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUF01184-006804,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02192-004547,25SBLUH02276-005695,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "007294": {
        "Stato": "IT",
        "CAP": "10059",
        "Localit\u00e0": "SUSA",
        "Indirizzo": "VIA ROMA, 15",
        "N.ri Tel.": "0122 622818",
        "Insegna": "DA CASTAGNA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,25SBLUH02150-007100,25SBLUH02196-004547,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUH02348-007132,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUT02312-006803,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDK02363-005831,25WBLDL01340-007355,25WBLDK03103-006047,25SBLUF02188-006804,25WBLDK03495-006047,25WBLUC06082-005480,24WBLDC03048-006047,25WBLUC02079-A05958"
    },
    "007331": {
        "Stato": "IT",
        "CAP": "00175",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DELL'AEROPORTO, 45-47",
        "N.ri Tel.": "06 76902690 amm.",
        "Insegna": "FRANCAVILLA MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLDC03100-006047,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUC03012-006719,24WBLDK03122-006955,24WBLDC02352-006977,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDA05337-006127,25SBLDH02374-006842,25SBLDX02235-006648,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDC02018-006648,25SBLUH02275-007100,25WBLUA05298-006127,25SBLDC01279-007111,24WBLDC02112-006631,24WBLDK03037-006950,25WBLDC02178-006646,24WBLDA05467-006434,25SBLUC01119-007105,25SBLUH02197-004547,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25WBLDK03103-006047,25SBLDC03006-006950,25SBLDC02233-007104,25WBLDC02072-006648,24WBLDC02049-006636,25SBLDH02372-005707,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDK03052-006047,25SBLUC02228-007104,25SBLDC01159-007105,25WBLDC02170-006648,25SBLUC04082-007159,25WBLUC02079-A05958,25SBLUT02315-007117"
    },
    "007364": {
        "Stato": "IT",
        "CAP": "71043",
        "Localit\u00e0": "MANFREDONIA",
        "Indirizzo": "CORSO MANFREDI, 202",
        "N.ri Tel.": "0884 534712",
        "Insegna": "PROPOSTA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,25SBLUC01219-007108,25SBLUN02516-007177,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUT02310-006817,25WBLUC03086-006047,25SBLDF08078-007092,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUP02352-006855,25WBLUC11083-007110,24WBLDC02314-006631,25SBLUS02336-007138,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUM01478-007167,25SBLUA04524-007182,25SBLUP04322-007129,25SBLUH02275-007100,25SBLDH02375-006842,25WBLDC03099-006047,25SBLUP02063-007092,25WBLDF08236-007301,24WBLDC02112-006631,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUF01184-006804,25SBLUC04176-006854,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDF08400-006987,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25SBLDP05141-007109,25WBLDK03103-006047,24WBLDA05465-006127,24WBLDC02064-006100,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC11163-007110,24WBLDC11209-006007,25SBLDC02233-007104,25SBLUC11569-006787,25WBLDC02072-006648,25SBLDH02372-005707,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02376-006842,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDK02363-005831,24WBLDM10259-006645,25SBLUH02199-004547,25WBLDK03098-006047"
    },
    "007396": {
        "Stato": "IT",
        "CAP": "65122",
        "Localit\u00e0": "PESCARA",
        "Indirizzo": "VIA ROMA, 57",
        "N.ri Tel.": "085 4216341",
        "Insegna": "MONDOVELA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25SBLDP03540-006873,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25SBLKH02555-007188,25WBLUC03233-007308,24WBLDK03293-005553,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC02227-007104,25SBLKP05558-007187,25SBLKC01445-007101,25SBLDC02232-007104,25SBLDS01366-007141,25SBLKF02553-007187,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03120-006951,24WBLDK03122-006955,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUH02030-006846,25WBLUC11083-007110,25SBLDC02289-007119,25SBLUN01521-006581,25SBLUP05190-006804,25WBLUK03142-005480,25WBLKC11416-007110,25SBLDC02234-006648,25SBLUH02196-004547,25SBLDL02396-007156,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,25WBLKC02427-005958,25SBLUF03186-006804,25SBLUC04206-006535,25SBLDK01249-007111,25SBLUL02409-006547,25SBLUH01149-007100,25WBLDC03099-006047,25SBLDC01279-007111,25SBLDX03008-006950,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC03003-006950,25SBLUH02109-006526,24WBLDL01421-007016,25SBLUP01189-006804,25SBLUL02412-007155,25SBLUC01115-007105,24WBLDC03038-006950,25SBLUF01184-006804,25SBLKX02418-005958,25WBLDC03096-006047,24WBLDF08400-006987,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDP05141-007109,25WBLDK03103-006047,25SBLUF02188-006804,25SBLDC03006-006950,25SBLUL02402-007153,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUM01476-006233,25SBLDC02233-007104,25WBLDC02072-006648,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLGC01441-007111,25SBLKC06443-007101,25WBLGC02391-006648,25SBLUT02313-006818,25SBLUC02228-007104,25WBLDK11162-007110,25WBLDK05019-007298,25WBLDC02170-006648,25WBLDK03098-006047"
    },
    "007403": {
        "Stato": "IT",
        "CAP": "81055",
        "Localit\u00e0": "SANTA MARIA CAPUA VETERE",
        "Indirizzo": "CORSO ALDO MORO, 91",
        "N.ri Tel.": "0823 840550",
        "Insegna": "DEL RE WOMAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02197-004547,25SBLUC01211-007101,25SBLUT02310-006817,25SBLUC01209-007101,25SBLUT02306-006801,25WBLUC02080-005958,25WBLUC02132-007284,25SBLUH02199-004547,25WBLUC02079-A05958"
    },
    "007462": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "GROTTE",
        "Indirizzo": "VIA DON LUIGI STURZO, 11",
        "N.ri Tel.": "0922 945637",
        "Insegna": "PILATO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDK01376-007378,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDK03039-006950,25SBLUC01211-007101,25SBLUC01121-007105,25SBLUH02241-007100,25SBLUC01209-007101,25SBLUC11214-007111,25WBLUL02318-007340,25SBLUX02230-005958,24WBLDC03048-006047,25WBLUC11083-007110,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDC01222-007108,24WBLDK02556-006646,24WBLDC02041-006648,24WBLDC02018-006648,25WBLDC02177-007284,25WBLDC03099-006047,25WBLUL01316-007012,25SBLDC01279-007111,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUC01119-007105,25SBLUL02412-007155,25SBLUC01115-007105,24WBLDC03038-006950,25SBLUH02108-006864,25SBLUP04043-007130,24WBLDC02290-006646,25WBLDC03096-006047,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02132-007284,24WBLDC03252-007008,25SBLUC01281-007105,25SBLDC02233-007104,25WBLDC02072-006648,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC11335-007110,25SBLUC11207-006787,25WBLDK11162-007110,25SBLDC01159-007105"
    },
    "007572": {
        "Stato": "IT",
        "CAP": "27100",
        "Localit\u00e0": "PAVIA",
        "Indirizzo": "CORSO STRADA NUOVA, 48",
        "N.ri Tel.": "0382 23254",
        "Insegna": "STILMODE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC03048-006047"
    },
    "007636": {
        "Stato": "IT",
        "CAP": "28015",
        "Localit\u00e0": "MOMO",
        "Indirizzo": "VIA BONIPERTI, 71",
        "N.ri Tel.": "0321 990073",
        "Insegna": "NEW BOX",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,24WBLDK03040-006950,25WBLDC03097-006047"
    },
    "007655": {
        "Stato": "IT",
        "CAP": "20129",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "CORSO VENTIDUE MARZO, 39",
        "N.ri Tel.": "02 717259",
        "Insegna": "ROBERTO LEON",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDM09261-006645,25SBLDC01221-007108,24WBLDX02113-006631,25SBLDC01329-007131,24WBLDK03052-006047,24WBLDM13260-006645,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUS02336-007138,25WBLUC03233-007308,24WBLDM10408-007022,25WBLDB03191-007294,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDK11162-007110,25SBLUS02336-007137,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLUC02153-007300,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC05125-007283,25WBLUC06082-005480,24WBLDM10259-006645,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDC02112-006631"
    },
    "007667": {
        "Stato": "IT",
        "CAP": "88068",
        "Localit\u00e0": "SOVERATO",
        "Indirizzo": "VIA SANTA MARIA, 15",
        "N.ri Tel.": "0967 23325",
        "Insegna": "ALESSIO MELINO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUT02110-006526,25SBLUC02227-007104,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUC11214-007111,25WBLUC03086-006047,24WBLDK03120-006951,25SBLUP04354-007129,25WBLUC05125-007283,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUP02352-006855,24WBLDC03084-006976,25SBLUP05190-006804,25WBLUK03142-005480,25SBLDC01222-007108,25WBLUC02077-006943,25SBLUC03011-006719,24WBLDK02042-006648,25SBLDL02396-007152,25SBLUX03226-006719,25WBLDK03527-006047,25SBLUC04206-006535,25SBLUF01055-007092,25WBLDK03495-006047,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUB05126-007283,24WBLDC03119-006951,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUP01189-006804,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUC04176-006854,24WBLDC02290-006646,25SBLDC02264-006648,25SBLUH02379-007147,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUB04360-006788,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,24WBLDC02064-006100,25WBLDC03097-006047,25WBLDC02072-006648,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUC02254-007101,25SBLUT02315-007117,25WBLDK03098-006047"
    },
    "007711": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA APPIA NUOVA, 109/B",
        "N.ri Tel.": "06 77205372",
        "Insegna": "CLADI'",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUL02412-007155,25SBLUC04206-006535,24WBLDK02362-005831,25SBLUP02352-006855,24WBLDC05357-005831,25SBLUB04167-006854,25WBLUA05297-006127"
    },
    "007729": {
        "Stato": "IT",
        "CAP": "91011",
        "Localit\u00e0": "ALCAMO",
        "Indirizzo": "CORSO DEI MILLE, 42",
        "N.ri Tel.": "0924 23784",
        "Insegna": "PLAYGROUND",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02177-007284,24WBLDC02064-006100,25WBLUC06082-005480,25SBLUX02230-005958,25SBLUH02199-004547,25WBLDC03099-006047,25SBLUP02352-006855"
    },
    "007764": {
        "Stato": "IT",
        "CAP": "71014",
        "Localit\u00e0": "SAN MARCO IN LAMIS",
        "Indirizzo": "CORSO G.MATTEOTTI, 115",
        "N.ri Tel.": "0882 816258",
        "Insegna": "TRASPARENZE ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUH02348-007132,25SBLUT02110-006526,25SBLUP04062-007092,25SBLUT02310-006817,24WBLDK03120-006951,24WBLDK03122-006955,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDV01146-007107,25WBLUC11083-007110,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDC01222-007108,25SBLDH02374-006842,25WBLUC02077-006943,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUH02242-007100,25SBLUF03186-006804,24WBLDC02018-006648,25SBLUF01055-007092,25SBLUH02275-007100,25SBLUP02063-007092,24WBLDC02112-006631,24WBLDC03119-006951,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUL02412-007155,25SBLDC01358-007101,25SBLDV03365-007143,25SBLUH02108-006864,24WBLDC03211-006990,25SBLUT02309-007125,24WBLDC03051-006047,25SBLDC04333-007109,25WBLUC06082-005480,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUC11569-006787,25WBLUX02081-005958,25SBLDV02296-007143,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDK03052-006047,25SBLUT02313-006818,25WBLDK11162-007110,25WBLDC02170-006648,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "007772": {
        "Stato": "IT",
        "CAP": "80028",
        "Localit\u00e0": "GRUMO NEVANO",
        "Indirizzo": "VIA DUCA D'AOSTA, 9",
        "N.ri Tel.": "081 8332480",
        "Insegna": "ANTEPRIMA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25SBLUH02194-004547,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02310-006817,25SBLUC11214-007111,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUS02336-007138,24WBLDK02556-006646,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUF01055-007092,25WBLDC03099-006047,25SBLUP02063-007092,25SBLUC01210-007101,25SBLDC01279-007111,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02197-004547,24WBLDC02290-006646,25WBLUC02151-007287,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25SBLUC01281-007105,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25WBLDK11162-007110,25WBLDC02170-006648,25WBLUC02079-A05958,25WBLDK01375-007378"
    },
    "007893": {
        "Stato": "IT",
        "CAP": "23891",
        "Localit\u00e0": "SIRTORI Loc. BEVERA",
        "Indirizzo": "VIA DELLE INDUSTRIE, 17/A",
        "N.ri Tel.": "039 9211189",
        "Insegna": "BLU FRIDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355"
    },
    "007912": {
        "Stato": "IT",
        "CAP": "16012",
        "Localit\u00e0": "BUSALLA",
        "Indirizzo": "PIAZZA E.MACCIO', 17",
        "N.ri Tel.": "010 9643812",
        "Insegna": "PASTORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLUC03090-006719,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC02342-006631,25WBLDK03527-006047,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUA05298-006127,25WBLDK03102-006047"
    },
    "007936": {
        "Stato": "IT",
        "CAP": "89046",
        "Localit\u00e0": "MARINA DI GIOIOSA IONICA",
        "Indirizzo": "PIAZZA ZALEUCO, 19",
        "N.ri Tel.": "0964 416439",
        "Insegna": "BELCASTRO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC03074-006355"
    },
    "007938": {
        "Stato": "IT",
        "CAP": "70051",
        "Localit\u00e0": "BARLETTA",
        "Indirizzo": "VIA FERDINANDO I D'ARAGONA, 94",
        "N.ri Tel.": "0883 532086",
        "Insegna": "CARDINALE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02112-006631,24WBLDC03036-006950,24WBLDC03051-006047,24WBLDK03037-006950,24WBLDK03052-006047,24WBLDC03038-006950,24WBLDC11209-006007,24WBLDF08400-006987,24WBLDK02042-006648,24WBLDK03039-006950,24WBLDK03122-006955,25SBLDC01221-007108,25SBLDC01222-007108,25SBLDC01359-007101,25SBLDC02233-007104,25SBLDC11237-007110,25SBLDP01344-006855,25SBLDP02345-006855,25SBLDT02138-006526,25SBLDV02296-007143,25SBLDV03365-007143,25SBLDC01358-007101,25SBLDH02374-006842,25SBLDS01291-007141,25SBLDS01292-007141"
    },
    "007952": {
        "Stato": "IT",
        "CAP": "48022",
        "Localit\u00e0": "LUGO",
        "Indirizzo": "VIA FORO BOARIO, 79/81",
        "N.ri Tel.": "0545 282231",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02306-006801,25SBLUC03012-006719"
    },
    "008003": {
        "Stato": "IT",
        "CAP": "55032",
        "Localit\u00e0": "CASTELNUOVO DI GARFAGNANA",
        "Indirizzo": "VIALE GARIBALDI, 12",
        "N.ri Tel.": "0187 622967",
        "Insegna": "GODANI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC03086-006047,25WBLDK03495-006047,25WBLUC05125-007283,24WBLDC03048-006047"
    },
    "008025": {
        "Stato": "IT",
        "CAP": "42037",
        "Localit\u00e0": "CERRETO LAGHI",
        "Indirizzo": "PIAZZALE DEL LAGO, 1",
        "N.ri Tel.": "0522 898158",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "008051": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "LECCE",
        "Indirizzo": "VIA BRACCIO MARTELLO, 35",
        "N.ri Tel.": "0832 315715",
        "Insegna": "MAGRITTE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,24WBLDC03119-006951,25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDK03120-006951,25WBLUA05298-006127,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDC03097-006047,25WBLDA05337-006127"
    },
    "008186": {
        "Stato": "IT",
        "CAP": "20091",
        "Localit\u00e0": "BRESSO",
        "Indirizzo": "VIA VITTORIO VENETO, 59",
        "N.ri Tel.": "02 6106123",
        "Insegna": "CLAN INTERNATIONAL",
        "CODICE PRODOTTO KOOOMO": "25SBLUB01216-007111,25SBLUC01281-007105,25SBLUC04176-006854,25SBLUC04206-006535,25SBLUF01184-006804,25SBLUF03031-007094,25SBLUM01480-007168,25SBLUM06481-007168,25SBLUM12488-007170,25SBLUP02352-006855,25SBLUT02310-006817,25SBLUX02147-007103"
    },
    "008187": {
        "Stato": "IT",
        "CAP": "00054",
        "Localit\u00e0": "FIUMICINO",
        "Indirizzo": "VIA G.MONTANARI SN",
        "N.ri Tel.": "0665489651",
        "Insegna": "AMORE E SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUT02317-007116,25SBLUS01340-007138,25WBLDC03100-006047,25SBLUT02110-006526,25SBLUC01121-007105,25SBLUH02241-007100,25SBLDF08078-007092,25WBLUL02318-007340,25WBLUC05125-007283,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUP02352-006855,25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUH02196-004547,25SBLDP01079-007092,25SBLUS02336-007138,24WBLDK02042-006648,25SBLDT02125-006526,25SBLDP01344-006855,25SBLUC04206-006535,25SBLUP04322-007129,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUL01316-007012,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUC11215-007110,24WBLDL01421-007016,25SBLUF01184-006804,25SBLUH02197-004547,24WBLDC02290-006646,25SBLDH02389-007144,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25WBLUC02132-007284,25WBLDK03102-006047,25WBLDC03097-006047,25SBLDC01329-007131,25WBLDC11163-007110,24WBLDC11209-006007,25SBLUM01476-006233,25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,25SBLUC11207-006787,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUH02192-004547,25SBLDH02377-007144,25SBLUT02306-006801,25SBLDC01328-007131"
    },
    "008206": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "PALMA DI MONTECHIARO",
        "Indirizzo": "CSO G.B.ODIERNA, 635",
        "N.ri Tel.": "0922 968598",
        "Insegna": "GULINO MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03090-006719,25SBLDH02372-005707,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC03114-006719,25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUH02196-004547,25SBLUC02229-005958,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUC03011-006719,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUH02191-004547,24WBLDK03039-006950,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDK03103-006047,25WBLDC03092-006719,24WBLDC02064-006100,25WBLUC06082-005480,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUP02352-006855"
    },
    "008209": {
        "Stato": "IT",
        "CAP": "51017",
        "Localit\u00e0": "UZZANO",
        "Indirizzo": "VIA PROVINCIALE LUCCHESE, 314/318",
        "N.ri Tel.": "0572 451098",
        "Insegna": "MALTAGLIATI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11215-007110,24WBLDX02113-006631,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDK03527-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02110-006526,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC02232-007104,25SBLDK01249-007111,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC02132-007284,25WBLUA05298-006127,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "008232": {
        "Stato": "IT",
        "CAP": "84036",
        "Localit\u00e0": "SALA CONSILINA",
        "Indirizzo": "VIA TRINITA' 67",
        "N.ri Tel.": "0975 45815",
        "Insegna": "CARBONE1950",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUX03226-006719,25WBLDK03527-006047,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDC02018-006648,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUC11214-007111,25SBLUF01055-007092,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "008241": {
        "Stato": "IT",
        "CAP": "24121",
        "Localit\u00e0": "BERGAMO",
        "Indirizzo": "VIALE PAPA GIOVANNI XXIII, 88",
        "N.ri Tel.": "035 244504",
        "Insegna": "TIFFANY CLUB 88",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUH02194-004547,25WBLDK03527-006047,25WBLDC03100-006047,25WBLDC03096-006047,25SBLDC03007-006950,25WBLDC03095-006047,25WBLDK03103-006047,25SBLUC03012-006719,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDK03102-006047,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047,25WBLUC02132-007284"
    },
    "008308": {
        "Stato": "IT",
        "CAP": "11100",
        "Localit\u00e0": "AOSTA",
        "Indirizzo": "VIA DE TILLIER, 51",
        "N.ri Tel.": "0165 363544",
        "Insegna": "NEAPOLIS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDX03008-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC01211-007101,25SBLDC02232-007104,25SBLUC11214-007111,25SBLUC03012-006719,25WBLUC06082-005480,25SBLUX02230-005958,25SBLDC03006-006950,25SBLUC01210-007101"
    },
    "008311": {
        "Stato": "IT",
        "CAP": "00100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DI TORREVECCHIA 84",
        "N.ri Tel.": "06 3012785",
        "Insegna": "WEST END ROMA",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,25WBLDC02072-006648,25SBLUH02193-004547,25SBLUS01339-007137,25WBLDA05336-007349,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUT02346-007132,25SBLDF03201-006804,24WBLDC03047-006047,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDK03527-006047,25SBLUH02191-004547,25SBLUM01478-007167,25WBLDB03191-007294,25WBLDK02073-006648,25SBLUC04176-006854,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25SBLUT02110-006526,25WBLDC03096-006047,25SBLUP04322-007129,25SBLUS01338-007137,25SBLUS01337-007137,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUS01342-007136,25SBLUF01055-007092,25SBLUP02352-006855,25WBLDK03103-006047,25SBLUB04167-006854,24WBLDC02352-006977,25WBLUA05301-006434,25SBLUH05028-006846,25SBLUT02315-007117,25SBLUH02030-006846,25SBLDC01279-007111,25SBLUM01476-006233"
    },
    "008319": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "SAN SEBASTIANO AL VESUVIO",
        "Indirizzo": "VIA PLINIO IL VECCHIO, 2",
        "N.ri Tel.": "081-5745499",
        "Insegna": "2EFFE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02191-004547,25SBLUH02197-004547,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC02231-005958,25SBLDC02232-007104,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUC01281-007105"
    },
    "008321": {
        "Stato": "IT",
        "CAP": "24050",
        "Localit\u00e0": "ORIO AL SERIO",
        "Indirizzo": "VIA PORTICO",
        "Insegna": "OREGON",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,24WBLDC03051-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDK03098-006047,25WBLUC02079-A05958"
    },
    "008344": {
        "Stato": "IT",
        "CAP": "66100",
        "Localit\u00e0": "ROMA LUNGHEZZA",
        "Indirizzo": "VIA TIRINO - LOC. S. FILOMENA C/o C.C. MEGALO'",
        "N.ri Tel.": "0871 540245",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLKC11440-007111,25SBLKF02553-007187,25SBLKF03551-007187,25SBLKF08561-007187,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKX02418-005958"
    },
    "008356": {
        "Stato": "IT",
        "CAP": "20813",
        "Localit\u00e0": "LIMBIATE",
        "Indirizzo": "CORSO COMO, 13",
        "N.ri Tel.": "0362 594987",
        "Insegna": "MARCONI 22",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDA05467-006434,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUP01189-006804,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLDK03495-006047,25SBLUX02230-005958,25WBLUA05301-006434,25WBLUC02132-007284,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDA05337-006127"
    },
    "008414": {
        "Stato": "IT",
        "CAP": "75024",
        "Localit\u00e0": "MONTESCAGLIOSO",
        "Indirizzo": "CORSO REPUBBLICA 39",
        "N.ri Tel.": "0835 207526",
        "Insegna": "TOP TEN",
        "CODICE PRODOTTO KOOOMO": "25SBLDS01292-007141,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDK03052-006047,25WBLUC03233-007308,25SBLUH02191-004547,24WBLDC02290-006646,25SBLDH02377-007144,24WBLDC03211-006990,25SBLUT02309-007125,25SBLUC04206-006535,24WBLDC03051-006047,24WBLDK02363-005831,24WBLDK03120-006951,25WBLDK02192-006648,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "008424": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "RACALMUTO",
        "Indirizzo": "VIA ALDO MORO, 26",
        "N.ri Tel.": "338 3234106",
        "Insegna": "PALUMBO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDK01376-007378,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDK03103-006047,24WBLDL01420-007016,25WBLUA05298-006127,25WBLUA05301-006434,25WBLDC03099-006047,25WBLUL01316-007012"
    },
    "008470": {
        "Stato": "IT",
        "CAP": "51100",
        "Localit\u00e0": "PISTOIA",
        "Indirizzo": "VIA DEGLI ORAFI, 7/9",
        "N.ri Tel.": "0573 368932",
        "Insegna": "STREET 67",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDC02251-006631,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03495-006047,25WBLDF08248-006948,25WBLUA05298-006127,25WBLDK03102-006047,25WBLUK11140-007286,25WBLDA05337-006127"
    },
    "008534": {
        "Stato": "IT",
        "CAP": "88049",
        "Localit\u00e0": "SOVERIA MANNELLI",
        "Indirizzo": "CORSO G.GARIBALDI, 214",
        "N.ri Tel.": "0968 662530",
        "Insegna": "SOTTOSOPRA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLDM08474-007166,25SBLDH02372-005707,25SBLDC03003-006950,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC02342-006631,25SBLUH02194-004547,25SBLUP01350-006855,24WBLDK02042-006648,24WBLDK03293-005553,25WBLDB03191-007294,24WBLDK03039-006950,25SBLUA04524-007182,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUC02228-007104,25SBLDC02264-006648,25SBLDH02377-007144,25SBLDC02128-007103,25SBLUS01338-007137,25SBLDT02138-006526,25SBLUT02306-006801,25SBLUF01055-007092,25WBLDK03103-006047,24WBLDK03120-006951,25WBLDK03495-006047,25SBLUX02230-005958,25SBLUH02199-004547,25SBLUC01281-007105"
    },
    "008560": {
        "Stato": "IT",
        "CAP": "23100",
        "Localit\u00e0": "SONDRIO",
        "Indirizzo": "VIA CESURA, 15",
        "N.ri Tel.": "0342 517756",
        "Insegna": "PAOLO CURTI",
        "CODICE PRODOTTO KOOOMO": "25SBLUP03539-006873,25WBLUC02079-005958,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDM10408-007022,24WBLDK03039-006950,25SBLUP04062-007092,25SBLUC01211-007101,25WBLDA05337-006127,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDC02314-006631,25SBLDH02374-006842,25SBLDP01079-007092,25SBLUP01350-006855,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUP04322-007129,25SBLUF01055-007092,25WBLDK03495-006047,25SBLDH02375-006842,24WBLDC02112-006631,25SBLUL02412-007155,24WBLDC03038-006950,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDA05465-006127,25WBLUC06082-005480,25WBLDA05335-007349,24WBLDM10555-007022,25SBLDC02233-007104,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC02342-006631,25SBLDF03076-007092,25SBLUB01216-007111,24WBLDM04428-005794,25SBLDF03257-007113,25WBLUC02079-A05958,25WBLDK03098-006047,25WBLUA05297-006127"
    },
    "008577": {
        "Stato": "IT",
        "CAP": "30015",
        "Localit\u00e0": "CHIOGGIA",
        "Indirizzo": "CORSO DEL POPOLO, 1315",
        "N.ri Tel.": "041 405526",
        "Insegna": "NUVOL AIR",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUN02510-007177,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUT02110-006526,25SBLUN02516-007177,25SBLUT02310-006817,25SBLUC01209-007101,25SBLUC03012-006719,25WBLUL02318-007340,25SBLUX02230-005958,25SBLUP02352-006855,25WBLUC11083-007110,25SBLUN01521-006581,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUT02308-006801,25WBLUA05299-006127,25SBLUH02196-004547,25SBLUC03011-006719,25SBLUF03186-006804,25SBLUL02409-006547,25WBLUA05298-006127,25WBLUL01316-007012,25WBLUC03090-006719,25SBLUP01189-006804,25SBLUF01184-006804,25SBLUH02108-006864,25SBLUH02197-004547,25WBLUC02151-007287,25SBLUT02309-007125,25SBLUS02336-007137,25SBLUS01337-007137,25SBLUS01342-007136,25SBLUM01476-006233,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUM12488-007170,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUL02403-006543,25SBLUH02199-004547,25WBLUC02079-A05958,25WBLUA05297-006127"
    },
    "008587": {
        "Stato": "IT",
        "CAP": "36047",
        "Localit\u00e0": "MONTEGALDA",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "0444 635146",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,25SBLKH02555-007188,25SBLUS01340-007138,25SBLUP04062-007092,25SBLKF02553-007187,25SBLUF03187-006804,25SBLUC03012-006719,25SBLUH02196-004547,25SBLDL02396-007156,25SBLUH02195-004547,25SBLUF03186-006804,25WBLDC02177-007284,25SBLUF08504-007173,25SBLUP01189-006804,25SBLKF03551-007187,25SBLUF01184-006804,25SBLUH02197-004547,24WBLDK03052-006047,25SBLUP05530-007173,25SBLDF03257-007113,25SBLUH02199-004547"
    },
    "008605": {
        "Stato": "IT",
        "CAP": "00028",
        "Localit\u00e0": "SUBIACO",
        "Indirizzo": "PIAZZA U. PELLICCIA, 5",
        "N.ri Tel.": "0774 85677",
        "Insegna": "LIVETTIHECCHI29",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02289-007119,25SBLDH02372-005707,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUC11215-007110,25SBLDP01079-007092,25SBLUC11541-007110,24WBLDH01432-006971,24WBLDC03038-006950,25SBLUP01350-006855,25SBLUH02194-004547,24WBLDC02041-006648,25SBLDF03076-007092,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,24WBLDF08400-006987,25SBLUS01338-007137,25WBLDC03095-006047,25SBLDX02290-007119,25SBLUC11214-007111,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUX02230-005958,25WBLUA05301-006434,25WBLDA05335-007349,24WBLDC03048-006047,25SBLUH05028-006846,25SBLUP02063-007092,25SBLUT02315-007117,25SBLUP02352-006855,25SBLUF03185-006804"
    },
    "008619": {
        "Stato": "IT",
        "CAP": "70042",
        "Localit\u00e0": "MOLA DI BARI",
        "Indirizzo": "VIA C. BATTISTI, 115",
        "N.ri Tel.": "080 4744144",
        "Insegna": "PIETANZA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308,25WBLUK03142-005480,25WBLUC02080-005958,25WBLUC02079-005958"
    },
    "008659": {
        "Stato": "IT",
        "CAP": "74017",
        "Localit\u00e0": "MOTTOLA",
        "Indirizzo": "VIA RISORGIMENTO, 1",
        "N.ri Tel.": "099 8861621",
        "Insegna": "VERTICE DONNA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC03119-006951,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC01222-007108,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDK03052-006047,25SBLDB04068-007109,24WBLDK02042-006648,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,24WBLDC03211-006990,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25SBLDP01140-007109,25WBLDC02170-006648,24WBLDK03120-006951,25SBLDF08078-007092,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDV01146-007107,24WBLDC02112-006631"
    },
    "008793": {
        "Stato": "IT",
        "CAP": "18012",
        "Localit\u00e0": "BORDIGHERA",
        "Indirizzo": "CORSO ITALIA, 42",
        "N.ri Tel.": "0184 262174",
        "Insegna": "TINTA TIENDA",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUC01047-007120,25WBLDK03527-006047,24WBLDK03039-006950,25WBLDC03096-006047,25SBLDC02232-007104,24WBLDB03294-005553,25SBLUC04168-006788,25WBLUC06082-005480,24WBLDL01420-007016,25SBLUX02230-005958,25SBLDC01279-007111"
    },
    "008799": {
        "Stato": "IT",
        "CAP": "74100",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "PIAZZA MARIA IMMACOLATA, 7/9",
        "N.ri Tel.": "099 4528083",
        "Insegna": "NITOR",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02195-004547,24WBLDC02290-006646,25SBLUT02313-006818,25WBLDC03096-006047,25WBLUF02118-007121,24WBLDC03211-006990,25SBLUT02306-006801,25WBLUL02318-007340,25WBLUC06082-005480,25WBLUC02080-005958,25WBLUA05298-006127,25SBLUH02199-004547,25WBLDC03099-006047,25SBLUH02394-007114"
    },
    "008806": {
        "Stato": "IT",
        "CAP": "16121",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA ROMA, 34/R",
        "Insegna": "BLAUER STORE GENOVA",
        "CODICE PRODOTTO KOOOMO": "25SBLUP03539-006873,24WBLDC03047-006047,25SBLUT02317-007116,25SBLUC01219-007108,25SBLUN02516-007177,25SBLUM01486-007172,25SBLUP02352-006855,25SBLUP05033-007094,24WBLDC03084-006976,25SBLDC02234-006648,25SBLUC01046-007120,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDP01344-006855,25SBLUA04524-007182,25SBLUH02276-005695,25SBLUC04206-006535,25SBLUF01055-007092,25SBLUL02409-006547,25SBLUC01034-007111,25SBLUF08504-007173,24WBLDK03037-006950,25SBLUF01184-006804,25SBLUM06481-007168,25SBLDV03365-007143,25WBLDC03095-006047,24WBLDA05465-006127,24WBLDF01398-006987,25SBLDC03006-006950,25WBLDA05335-007349,24WBLDM10555-007022,25SBLDC02233-007104,24WBLUK02171-006995,25SBLUP05530-007173,25SBLUX01218-007108,25SBLUL02403-006543,25SBLDT02138-006526,25SBLUC04082-007159,24WBLDL01420-007016,25SBLUP04353-007139,25SBLDC04066-007109,25WBLDK03098-006047,24WBLDF02101-006960,25WBLDA05336-007349,25SBLUN02510-007177,24WBLDK03039-006950,25SBLUC11083-007106,25SBLDF08078-007092,25WBLUC11083-007110,25SBLUP05190-006804,25SBLDH02377-007147,25SBLUH02195-004547,25SBLDK01249-007111,24WBLDM04562-007021,24WBLDL01416-006669,25WBLDC03099-006047,25SBLDX03008-006950,25WBLUC03090-006719,24WBLDP01448-006420,24WBLDA05467-006434,24WBLDL01421-007016,25SBLUL02412-007155,25SBLUC01115-007105,24WBLDH01432-006971,25SBLDP02143-007109,25SBLDP04142-007109,24WBLDF08400-006987,25SBLUS02336-007137,25SBLDC03007-006950,24WBLDC03051-006047,25SBLDP05141-007109,25SBLDM01473-007166,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,24WBLDF03399-006987,25SBLUC01281-007105,25SBLUM01476-006233,24WBLDC11209-006007,25WBLDK03101-006047,24WBLDP03446-007029,25SBLUH02150-007100,25SBLUC11207-006787,25SBLUM12488-007170,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDH02370-006845,25WBLDC02170-006648,24WBLDC02016-006940,24WBLDM10259-006645,24WBLDM10408-007022,25SBLUC02227-007104,25SBLUT02310-006817,25SBLDS01366-007141,25WBLUC03086-006047,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDC01222-007108,25WBLUA05299-006127,25SBLDP01079-007092,25SBLUP01350-006855,25SBLUC03011-006719,25SBLDL02396-007152,25WBLDK03527-006047,24WBLDF16106-006960,25WBLUA05298-006127,24WBLDC02044-006648,25SBLDC03003-006950,25SBLUP01189-006804,25SBLUC01119-007105,24WBLDC03038-006950,25SBLDH02389-007144,25WBLDC03096-006047,25SBLUM01482-007168,24WBLDM01437-007021,25WBLUC03074-006355,24WBLDM09261-006645,24WBLDC03036-006950,25SBLUC02280-005958,24WBLDK03052-006047,25SBLUT02316-007116,25WBLDM01463-007330,25SBLDV05299-007138,25SBLDC01159-007105,25SBLUF03031-007094,24WBLDK02362-005831,25SBLDF03257-007113,25WBLDL01340-007355,25SBLUT02315-007117,25WBLUA05297-006127,25SBLDP03540-006873,25SBLUC11541-007110,25WBLDB03191-007294,25WBLDC03100-006047,25SBLDC11237-007110,25SBLDP02345-006855,25SBLUP04353-007129,25SBLUC03012-006719,25SBLDH02373-005707,25WBLDA05337-006127,25SBLUN01521-006581,25WBLUK03142-005480,25SBLDH03369-006845,25SBLUP04322-007129,25WBLDK03495-006047,25SBLDC01279-007111,25SBLUF03185-006804,25WBLDC02178-006646,25SBLUA04527-007182,25SBLDS01291-007141,25SBLDC02264-006648,25SBLUT02309-007125,25SBLUS01337-007137,25SBLDP01140-007109,24WBLDC05357-005831,25SBLUP03535-006873,25WBLDK03102-006047,25SBLUH02394-007114,25SBLUL02402-007153,25WBLDC03097-006047,25SBLUA04525-007182,25SBLUM03490-007170,25SBLDP01300-007140,25SBLUT02346-007132,25SBLUH02191-004547,24WBLDB02092-006976,25SBLUT02313-006818,24WBLDH02433-006971,25SBLUT02306-006801,25SBLDL02399-007155"
    },
    "008849": {
        "Stato": "IT",
        "CAP": "16100",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "PZA DELLA VITTORIA 86/R",
        "N.ri Tel.": "010 580054",
        "Insegna": "BOX 86",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLDL02396-007156,25WBLDK03527-006047,25WBLDC03100-006047,25SBLUC04176-006854,24WBLDK03039-006950,25WBLDC03096-006047,24WBLDK03212-006990,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25SBLUM01482-007168,25WBLDK03103-006047,25WBLUC06082-005480,25WBLUC02132-007284,24WBLDC03252-007008,25WBLDK03102-006047,24WBLDC03048-006047,25SBLUL02408-007151,25WBLDC03099-006047,25SBLDC01279-007111,25WBLDL01346-007354"
    },
    "008912": {
        "Stato": "IT",
        "CAP": "75100",
        "Localit\u00e0": "MATERA",
        "Indirizzo": "VIA ROMA, 64",
        "N.ri Tel.": "0835 330483",
        "Insegna": "KEN PARKER",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC02077-006943,25SBLUP01189-006804,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUT02316-007116,25SBLUH02108-006864,25SBLUH02191-004547,25SBLUS01340-007138,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUC01219-007108,24WBLDC02018-006648,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUC01121-007105,24WBLDC03211-006990,24WBLDF08400-006987,25SBLUT02309-007125,25SBLUH02275-007100,24WBLDC02352-006977,25WBLUC02080-005958"
    },
    "008915": {
        "Stato": "IT",
        "CAP": "80128",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA M. KERBAKER, 13",
        "N.ri Tel.": "081 2298348",
        "Insegna": "FREE MAN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUT02313-006818,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUT02306-006801,25SBLUC11214-007111,25WBLUC02132-007284,25SBLUC01281-007105"
    },
    "008928": {
        "Stato": "IT",
        "CAP": "53036",
        "Localit\u00e0": "POGGIBONSI",
        "Indirizzo": "LOC. DROVE, 2/G",
        "N.ri Tel.": "0577 937870",
        "Insegna": "CASA DELLO SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLUP03539-006873,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUL02407-007151,25WBLDP01291-007324,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,25SBLUF02101-007121,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUC02227-007104,25SBLUP01183-007121,25SBLDC02232-007104,25SBLUC11083-007106,25SBLUT02310-006817,25SBLUF03187-006804,25SBLUC03012-006719,25WBLUL02318-007340,24WBLDK03122-006955,25WBLUC05125-007283,24WBLDX03280-006719,25SBLUX02230-005958,25SBLDH02373-005707,24WBLDC03048-006047,25SBLUL02583-007370,25SBLUP03534-006873,25SBLUC01217-007108,25WBLDA05337-006127,25SBLUP05190-006804,25WBLUK03142-005480,24WBLDC02314-006631,25SBLUH02196-004547,25WBLDC02196-007283,25SBLUP01350-006855,25SBLUS02336-007138,25SBLUC03011-006719,24WBLDK02042-006648,25SBLDL02396-007152,24WBLDC02041-006648,25WBLDK03527-006047,25SBLDP01344-006855,25SBLDK01249-007111,25SBLUP04322-007129,25SBLUF01055-007092,25SBLDC02236-006648,25SBLUH02275-007100,25WBLDK03495-006047,25SBLDH02375-006842,25WBLDC03099-006047,25SBLUP02063-007092,25WBLDF08236-007301,25SBLDC01279-007111,24WBLDC02112-006631,25SBLDX03008-006950,25SBLDM08474-007166,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUC11215-007110,25SBLUP01189-006804,25SBLDH02381-007114,25SBLUF01184-006804,25SBLUH02108-006864,24WBLDC02290-006646,25SBLDS01291-007141,25SBLUP04043-007130,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUS01337-007137,25SBLDC04333-007109,25WBLDK03103-006047,25SBLUP03535-006873,25SBLDV04293-007143,25WBLUC02132-007284,25SBLUM01476-006233,25SBLDC02233-007104,25WBLDC02072-006648,25SBLUH02193-004547,24WBLDC03114-006719,25WBLUX02081-005958,25SBLDP01300-007140,25WBLUC03074-006355,25SBLDC01221-007108,25SBLDC11335-007110,25SBLUH02191-004547,25SBLUC02228-007104,25SBLUL02403-006543,25SBLDF03257-007113,25SBLDT02138-006526,25WBLDC02170-006648,25WBLDL01340-007355,24WBLDL01420-007016,25SBLUH05028-006846,25WBLUC02079-A05958,25SBLUC04163-006788"
    },
    "008929": {
        "Stato": "IT",
        "CAP": "00139",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ALBERTO LIONELLO, 201 INT. 125 C/o C.C. PORTE DI ROMA (BUFALOTTA)",
        "N.ri Tel.": "06 87074325",
        "Insegna": "NEGOZI PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25SBLKF08561-007187,24WBLDC02314-006631,25WBLUC03074-006355,25SBLKF03551-007187,25SBLKH02555-007188,25WBLGC02391-006648,24WBLDC02290-006646,25SBLKC11440-007111,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKF02553-007187,25SBLKP01554-007187,25WBLDC02170-006648,25SBLUX02230-005958"
    },
    "008937": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA ISONZO, 20",
        "N.ri Tel.": "0984 26196",
        "Insegna": "GIGLIO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC03173-007307,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01219-007108,25WBLUC03086-006047,25SBLUP04354-007129,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUP02352-006855,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDX02235-006648,25SBLUS02336-007138,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUP04322-007129,25WBLDC02177-007284,25WBLDC03099-006047,25WBLUL01316-007012,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUL02412-007155,24WBLDC03038-006950,25SBLDC02264-006648,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUS02336-007137,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUH02191-004547,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC02228-007104,25SBLUT02306-006801,25WBLDC02170-006648,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "008957": {
        "Stato": "IT",
        "CAP": "86100",
        "Localit\u00e0": "CAMPOBASSO",
        "Indirizzo": "VIA VITTORIO VENETO, 76",
        "N.ri Tel.": "0874.65273",
        "Insegna": "IAVERONE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDC02234-006648,24WBLDC02314-006631,25WBLDC03357-007294,25SBLDC01222-007108,25SBLUH02109-006526,25SBLDC01221-007108,25SBLUH02196-004547,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUP01189-006804,25WBLDC02196-007283,25WBLDP01291-007324,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUP01350-006855,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUT02110-006526,25SBLUT02313-006818,25SBLDC02264-006648,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,24WBLDC03051-006047,25WBLDC02170-006648,25WBLUC03086-006047,25WBLUC05125-007283,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDA05335-007349,25WBLDK03098-006047,25WBLDF08236-007301,25WBLDC03097-006047,25SBLDC01279-007111,25WBLDA05337-006127"
    },
    "008962": {
        "Stato": "IT",
        "CAP": "86039",
        "Localit\u00e0": "TERMOLI",
        "Indirizzo": "C.SO F.LLI BRIGIDA",
        "N.ri Tel.": "0874.65273",
        "Insegna": "MONDOVELA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLDC03357-007294,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,24WBLDC03051-006047,25WBLUC03086-006047,25WBLDK03102-006047,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "009008": {
        "Stato": "IT",
        "CAP": "80010",
        "Localit\u00e0": "QUARTO",
        "Indirizzo": "VIA MASULLO, 37",
        "N.ri Tel.": "081 8762000",
        "Insegna": "GALLERY 66",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,24WBLDC02044-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25WBLDC03097-006047,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02348-007132,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDK03103-006047,25SBLDC01328-007131,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03099-006047,25SBLUC04163-006788,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "009015": {
        "Stato": "IT",
        "CAP": "16011",
        "Localit\u00e0": "ARENZANO",
        "Indirizzo": "CORSO GIACOMO MATTEOTTI, 114",
        "N.ri Tel.": "010 9127605",
        "Insegna": "OLIVETTE 2",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC02079-005958,25WBLUC03074-006355"
    },
    "009017": {
        "Stato": "IT",
        "CAP": "20871",
        "Localit\u00e0": "VIMERCATE",
        "Indirizzo": "VIA CAVOUR, 15",
        "N.ri Tel.": "039 6082211",
        "Insegna": "TRUE TYPE",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC02151-007287"
    },
    "009093": {
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CESSALTO Loc. S.MARIA DI CAMPAGNA",
        "Indirizzo": "VIA MAGGIORE, 193",
        "N.ri Tel.": "0968 29281",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "009104": {
        "Stato": "IT",
        "CAP": "80016",
        "Localit\u00e0": "MARANO DI NAPOLI",
        "Indirizzo": "CORSO EUROPA, 190/192",
        "N.ri Tel.": "081 5865395",
        "Insegna": "IDEASPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03495-006047,25WBLUC02132-007284,25SBLDC01279-007111"
    },
    "009128": {
        "Stato": "IT",
        "CAP": "82018",
        "Localit\u00e0": "SAN GIORGIO DEL SANNIO",
        "Indirizzo": "VIALE SPINELLI, 116",
        "N.ri Tel.": "0824 58992",
        "Insegna": "VANITY",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02374-006842,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUL02412-007155,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDK03527-006047,25WBLDC03100-006047,25SBLUH02197-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUF02188-006804,24WBLDC02064-006100,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02079-A05958"
    },
    "009229": {
        "Stato": "IT",
        "CAP": "10095",
        "Localit\u00e0": "GRUGLIASCO",
        "Indirizzo": "VIA CREA. 10 C/o C.C. LE GRU",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI STORE",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "009245": {
        "Stato": "IT",
        "CAP": "75100",
        "Localit\u00e0": "MATERA",
        "Indirizzo": "VIA LUCANA, 112",
        "N.ri Tel.": "3385693071",
        "Insegna": "SCANDIFFIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDM01437-007021,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDK03052-006047,25WBLUC03233-007308,24WBLDK02556-006646,25WBLDC03100-006047,24WBLDC02290-006646,24WBLDP03447-007025,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDM04562-007021,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03120-006951,25WBLUC06082-005480,25WBLUC02080-005958,25WBLDC03099-006047,25WBLDK03098-006047,24WBLDF03399-006987,25WBLDC03097-006047,25WBLUK11140-007286,25WBLDA05337-006127"
    },
    "009327": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "TERZIGNO",
        "Indirizzo": "CORSO LEONARDO DA VINCI, 219",
        "N.ri Tel.": "081 8271487",
        "Insegna": "STUDIO'S",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUP01189-006804,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUH02108-006864,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02244-007100,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03096-006047,24WBLDF08400-006987,25SBLUC04206-006535,25SBLUT02306-006801,25SBLUF01055-007092,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,25SBLUP02063-007092"
    },
    "009334": {
        "Stato": "IT",
        "CAP": "41027",
        "Localit\u00e0": "PIEVEPELAGO",
        "Indirizzo": "VIA ROMA, 55",
        "N.ri Tel.": "0536 71507",
        "Insegna": "MORDINI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDK02042-006648"
    },
    "009442": {
        "Stato": "IT",
        "CAP": "81056",
        "Localit\u00e0": "SPARANISE",
        "Indirizzo": "VIA CONTE ALDEMARIO, 25",
        "N.ri Tel.": "0823-881174",
        "Insegna": "PIRMEMPS",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03036-006950,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUC01211-007101,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUT02309-007125,25WBLDK11162-007110,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC06082-005480,25SBLDC01328-007131,25SBLUH02199-004547,25WBLDK01375-007378,25WBLDC03099-006047,25WBLDK03102-006047,25SBLDC01279-007111,25WBLDC11163-007110"
    },
    "009493": {
        "Stato": "IT",
        "CAP": "37032",
        "Localit\u00e0": "MONTEFORTE D'ALPONE",
        "Indirizzo": "VIA ALPONE, 3/A",
        "N.ri Tel.": "045 6101850",
        "Insegna": "POLI MODE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,24WBLDC03114-006719,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUP01350-006855,25SBLUC03011-006719,24WBLDK02042-006648,25SBLUF01184-006804,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC02112-006631,24WBLDK02363-005831,25SBLUC03012-006719,25WBLUC03086-006047,25SBLDC03006-006950,24WBLDC03252-007008,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUP02352-006855,25WBLDC11163-007110,24WBLDK03346-006047,25SBLUM01476-006233"
    },
    "009497": {
        "Stato": "IT",
        "CAP": "81025",
        "Localit\u00e0": "MARCIANISE",
        "Indirizzo": "VIA S.S. SANNITICA, 87 KM 19",
        "N.ri Tel.": "379 1827111 amm.",
        "Insegna": "O1 COSCIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC02044-006648,25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25SBLKC06443-007101,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLGC02391-006648,25SBLUH02191-004547,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDK03039-006950,24WBLDC02290-006646,25SBLKC11440-007111,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02309-007125,25SBLKC01445-007101,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25SBLUC01210-007101,25WBLDC03097-006047,25WBLUC02079-A05958"
    },
    "009502": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "PRATO",
        "Indirizzo": "VIA B. RICASOLI, 10",
        "N.ri Tel.": "0574 607070",
        "Insegna": "CARILLON",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC03047-006047,24WBLDK03120-006951,25WBLDC03096-006047,25WBLDK11162-007110,24WBLDK02042-006648,25WBLDC02178-006646,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03095-006047,25WBLUA05297-006127,25WBLDA05337-006127"
    },
    "009567": {
        "Stato": "IT",
        "CAP": "40053",
        "Localit\u00e0": "BAZZANO",
        "Indirizzo": "VIA G. MATTEOTTI, 23",
        "N.ri Tel.": "051 830638",
        "Insegna": "LORENZO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11207-006787,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,24WBLDK03039-006950,25WBLUC02151-007287,25SBLUH02276-005695,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDK03103-006047,25SBLUF02188-006804,25WBLUC02080-005958,25WBLDC03099-006047"
    },
    "009576": {
        "Stato": "IT",
        "CAP": "41124",
        "Localit\u00e0": "MODENA",
        "Indirizzo": "VIA SASSI, 1",
        "N.ri Tel.": "059 443156",
        "Insegna": "EXTREME",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDK11337-006007,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25SBLDC02232-007104,25SBLDK01249-007111,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLUC03086-006047,25SBLUB04167-006854,25SBLUX02230-005958,25WBLDC03099-006047"
    },
    "009612": {
        "Stato": "IT",
        "CAP": "80018",
        "Localit\u00e0": "MUGNANO DI NAPOLI",
        "Indirizzo": "VIA NAPOLI, 255/A/B/C/D",
        "N.ri Tel.": "081 5862862",
        "Insegna": "VOGUE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK03527-006047,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUA05298-006127,24WBLDC03048-006047,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "009616": {
        "Stato": "IT",
        "CAP": "30126",
        "Localit\u00e0": "VENEZIA Loc. LIDO",
        "Indirizzo": "GRANVIALE S.M. ELISABETTA, 2",
        "N.ri Tel.": "041 5265030",
        "Insegna": "ARBOR STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDX02235-006648,25SBLUP01189-006804,25SBLUC11207-006787,25SBLUF01184-006804,25SBLUX03226-006719,25SBLUF03186-006804,25SBLUP05530-007173,25SBLUC04206-006535,25SBLDK01249-007111,25WBLUA05298-006127,25WBLUC02079-A05958,25SBLUF08504-007173"
    },
    "009632": {
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "VIA E. BUCCARELLI, 8/10",
        "N.ri Tel.": "0961 721657",
        "Insegna": "NOI DUE & CO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDK03101-006047,24WBLDC02044-006648,25SBLDC02234-006648,24WBLDC02314-006631,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDK11337-006007,25SBLDF03076-007092,25WBLDC03100-006047,25SBLDC03007-006950,25SBLDC02128-007103,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDK03120-006951,24WBLDC02352-006977,25SBLDC01328-007131,25WBLDK03102-006047,24WBLDC03048-006047,24WBLDC02112-006631"
    },
    "009659": {
        "Stato": "IT",
        "CAP": "65100",
        "Localit\u00e0": "PESCARA",
        "Indirizzo": "CORSO UMBERTO I, 121",
        "N.ri Tel.": "085 9431373",
        "Insegna": "CLINIKA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDK03037-006950,25SBLDC03007-006950,25SBLUC03013-006719,25SBLUS02336-007137"
    },
    "009669": {
        "Stato": "IT",
        "CAP": "66013",
        "Localit\u00e0": "CHIETI SCALO",
        "Indirizzo": "CONTRADA S. FILOMENA C/o C.C. MEGALO'",
        "N.ri Tel.": "085 9431373",
        "Insegna": "CLINIKA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUP05190-006804,25WBLDC02178-006646,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUX02255-007101,24WBLDK02556-006646,25SBLUK04174-006854,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUT02312-006803,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUC04206-006535,24WBLDC03051-006047,25SBLUB04360-006788,24WBLDC02250-007008,25SBLUH02030-006846,25SBLUC03012-006719,25WBLDK03103-006047,25SBLUF02188-006804,25SBLUC03013-006719,25SBLUP04353-007139,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUM01476-006233"
    },
    "009672": {
        "Stato": "IT",
        "CAP": "80124",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE CAMPI FLEGREI, 7/F-9",
        "N.ri Tel.": "081 5704153",
        "Insegna": "MAGLIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,25WBLUC11083-007110,25WBLDC02178-006646,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDK11337-006007,24WBLDC03047-006047,25SBLDH02376-006842,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02556-006646,25WBLDB03191-007294,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC01121-007105,24WBLDF08400-006987,25SBLUT02309-007125,25WBLDK11162-007110,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLDH02375-006842,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111,25WBLDC11163-007110,25WBLDA05337-006127"
    },
    "009696": {
        "Stato": "IT",
        "CAP": "91026",
        "Localit\u00e0": "MAZARA DEL VALLO",
        "Indirizzo": "CORSO V. VENETO, 70",
        "N.ri Tel.": "0923 906453",
        "Insegna": "FUORI STRADA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02196-004547,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02108-006864,25SBLUT02110-006526,25SBLUH02192-004547,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC02132-007284,25WBLUA05298-006127,25WBLUL01316-007012"
    },
    "009701": {
        "Stato": "IT",
        "CAP": "80029",
        "Localit\u00e0": "SANT 'ANTIMO",
        "Indirizzo": "VIA TRIESTE E TRENTO, 59",
        "N.ri Tel.": "081 5050735",
        "Insegna": "ER NONNO DUE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02018-006648,24WBLDC02018-006648,24WBLDC02064-006100,24WBLDC02064-006100,24WBLDC02064-006100,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDK03037-006950,24WBLDK03037-006950"
    },
    "009703": {
        "Stato": "IT",
        "CAP": "70024",
        "Localit\u00e0": "GRAVINA IN PUGLIA",
        "Indirizzo": "VIA RIMINI,1/3",
        "N.ri Tel.": "080-3258300",
        "Insegna": "MARTONE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,25WBLDA05336-007349,25SBLUN02510-007177,25SBLUH02194-004547,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUP04062-007092,25SBLUC02227-007104,25SBLUC11083-007106,25SBLUT02310-006817,25WBLUC03086-006047,25SBLUP04354-007129,24WBLDK03122-006955,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUM01479-007167,25SBLUH02030-006846,25WBLUC11083-007110,25SBLUP05033-007094,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDC01222-007108,25WBLUC02077-006943,25SBLUX02147-007103,25SBLUC01046-007120,25SBLDB04068-007109,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUM01478-007167,25SBLUP04322-007129,24WBLDC02112-006631,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC01358-007101,25SBLUH02197-004547,24WBLDC02290-006646,25SBLDP04142-007109,25SBLDS01291-007141,25SBLUT02309-007125,25SBLDC02128-007103,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,25SBLUP01324-007130,25WBLDK03103-006047,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03097-006047,25SBLDC01329-007131,25SBLUC11569-006787,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03036-006950,25SBLUC11207-006787,25SBLDH02376-006842,25SBLUB01216-007111,24WBLDB02092-006976,25SBLUC02228-007104,25WBLDK11162-007110,25SBLUF03031-007094,25WBLDC02170-006648"
    },
    "009722": {
        "Stato": "IT",
        "CAP": "81100",
        "Localit\u00e0": "CASERTA",
        "Indirizzo": "VIA G.B. VICO, 10",
        "N.ri Tel.": "0823 443378",
        "Insegna": "CHARLIE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUT02346-007132,25SBLUP01189-006804,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUT02110-006526,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUT02306-006801,25SBLUC11214-007111,25SBLUF02188-006804,25WBLUC02080-005958,25SBLUM01479-007167,25SBLUC04163-006788"
    },
    "009732": {
        "Stato": "IT",
        "CAP": "12037",
        "Localit\u00e0": "SALUZZO",
        "Indirizzo": "CORSO ITALIA, 58",
        "N.ri Tel.": "0175 46089",
        "Insegna": "HIM",
        "CODICE PRODOTTO KOOOMO": "25SBLUC03013-006719"
    },
    "009733": {
        "Stato": "IT",
        "CAP": "84129",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA ROCCO COCCHIA 21/25",
        "N.ri Tel.": "089 721928",
        "Insegna": "GOA",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25WBLUC08078-006355,25WBLUC02079-005958,25SBLDH03371-005707,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02310-006817,25SBLUC11214-007111,25WBLUC03086-006047,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUC11083-007110,24WBLDC03084-006976,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUC04206-006535,25SBLUF01055-007092,25SBLUH02275-007100,25SBLDC04070-007109,25WBLDC03099-006047,25SBLUP02063-007092,25SBLUC01210-007101,25SBLDC01279-007111,24WBLDC02112-006631,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUC11215-007110,24WBLDC03038-006950,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUS02336-007137,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25SBLUS01342-007136,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUC11569-006787,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUB04167-006854,25SBLDC01328-007131,25WBLDF08248-006948,25SBLUH02199-004547,25WBLUC02079-A05958,25SBLDC04066-007109"
    },
    "009755": {
        "Stato": "IT",
        "CAP": "10100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO TRAIANO, 60",
        "N.ri Tel.": "011 616051",
        "Insegna": "GEORGE'S SHOP DAL 1976",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDA05467-006434,25SBLDH02374-006842,24WBLDC03036-006950,25SBLUH02194-004547,24WBLDK02042-006648,25WBLDC03100-006047,24WBLDC02290-006646,25SBLUP04062-007092,25SBLUC04206-006535,25SBLDS01366-007141,25SBLDT02138-006526,25SBLUT02306-006801,24WBLDK02363-005831,25SBLDH02386-007144,24WBLDK03086-006976,25SBLDF08078-007092,25WBLUC06082-005480,25WBLDK03102-006047,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUC02079-A05958"
    },
    "009760": {
        "Stato": "IT",
        "CAP": "09128",
        "Localit\u00e0": "CAGLIARI",
        "Indirizzo": "VIA G.B. PERGOLESI, 25",
        "N.ri Tel.": "070 497714",
        "Insegna": "IL CLUB SPORTIVO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC03074-006355,25WBLUL01316-007012"
    },
    "009771": {
        "Stato": "IT",
        "CAP": "80128",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA ADOLFO OMODEO, 50",
        "N.ri Tel.": "081 5790589",
        "Insegna": "BRANCACCIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC08078-006355,25WBLDC02178-006646,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02242-007100,25WBLDK03527-006047,25SBLUH02191-004547,25SBLUT02317-007116,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02241-007100,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02199-004547,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111,25SBLUF03185-006804"
    },
    "009810": {
        "Stato": "IT",
        "CAP": "10057",
        "Localit\u00e0": "S. AMBROGIO DI TORINO",
        "Indirizzo": "VIA CADUTI PER LA PATRIA, 14",
        "N.ri Tel.": "011 939123",
        "Insegna": "BOETTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUT02313-006818,25SBLUH02192-004547,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLUC03086-006047,25WBLDC03099-006047"
    },
    "009823": {
        "Stato": "IT",
        "CAP": "10022",
        "Localit\u00e0": "CARMAGNOLA",
        "Indirizzo": "PIAZZA SANT 'AGOSTINO, 2",
        "N.ri Tel.": "011 9773350",
        "Insegna": "DOVER",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUK03142-005480,25SBLDC03003-006950,25WBLUC03074-006355,24WBLDC03036-006950,25SBLDP01079-007092,25SBLDH02381-007114,25SBLUC11207-006787,24WBLDK02042-006648,25SBLUF01184-006804,25WBLDK03527-006047,25SBLDF03076-007092,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02312-006803,25SBLUC02227-007104,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUC04206-006535,25SBLDC02232-007104,25SBLDK01249-007111,25WBLDK03103-006047,24WBLDC02016-006940,25WBLUC03086-006047,25SBLUF02188-006804,25WBLUC06082-005480,25SBLDH02375-006842,25SBLDC01328-007131,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUC01210-007101,25SBLUM01476-006233"
    },
    "009937": {
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "VIA M. IANNELLI, 3",
        "N.ri Tel.": "377 4164660",
        "Insegna": "FRANCESCO MELINO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUP01189-006804,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUC04176-006854,25SBLUT02110-006526,25SBLUC02227-007104,25SBLUH02379-007147,25SBLUT02309-007125,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUB04360-006788,25SBLUC11214-007111,25SBLUF01055-007092,25WBLUC03086-006047,25SBLUF02188-006804,25WBLUC06082-005480,25SBLUX02230-005958,25SBLUT02315-007117,25SBLUP02063-007092,25WBLUA05297-006127"
    },
    "010001": {
        "Stato": "IT",
        "CAP": "81031",
        "Localit\u00e0": "AVERSA",
        "Indirizzo": "VIA SAPORITO, 66",
        "N.ri Tel.": "081-5031244",
        "Insegna": "PORCARO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDC03100-006047,25SBLUA04524-007182,24WBLDC02290-006646,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUP04062-007092,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUP04322-007129,25SBLUS01338-007137,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,25SBLUT02306-006801,25SBLUC11214-007111,25SBLUF01055-007092,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,25SBLUC01034-007111,25WBLUC02132-007284,25WBLDA05335-007349,25WBLDC03099-006047"
    },
    "010006": {
        "Stato": "IT",
        "CAP": "20161",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA FONTANELLI, 2",
        "N.ri Tel.": "02/66220118",
        "Insegna": "ROBERTO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDA05336-007349,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03122-006955,24WBLDC03048-006047,25WBLDA05337-006127,25WBLUK03142-005480,25SBLUT02308-006801,25SBLUX03226-006719,25WBLDK03527-006047,25SBLUF03186-006804,25SBLUP04322-007129,25WBLDC03092-006719,25WBLUA05298-006127,25WBLDC03099-006047,25SBLDC01279-007111,25SBLDX03008-006950,24WBLDK03037-006950,25WBLUC03090-006719,25SBLUH02109-006526,25WBBXC02456-005958,25SBLUP01189-006804,24WBLDC03038-006950,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDA05465-006127,25WBLUC02132-007284,25WBLDK03102-006047,25SBLDC02233-007104,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUH02192-004547,25SBLDC04066-007109"
    },
    "010059": {
        "Stato": "IT",
        "CAP": "30126",
        "Localit\u00e0": "VENEZIA Loc. LIDO",
        "Indirizzo": "VIA LEPANTO, 8",
        "N.ri Tel.": "041 5265030",
        "Insegna": "ARBOR STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDK03161-006719,24WBLDC02049-006636,24WBLDC02314-006631,24WBLDK03052-006047,25WBLDB03191-007294,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03122-006955,24WBLDX03280-006719,25WBLDK03102-006047,25WBLDC03097-006047,24WBLDK03346-006047"
    },
    "010105": {
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA DELL'EPOMEO, 77/79",
        "N.ri Tel.": "0812413920",
        "Insegna": "GHIGGI",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUT02312-006803,25SBLUC01211-007101,25SBLUT02310-006817,25SBLUC11214-007111,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284"
    },
    "010124": {
        "Stato": "IT",
        "CAP": "10100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO G.FERRARIS 35",
        "N.ri Tel.": "3389823369",
        "Insegna": "GALFER 35",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDK03161-006719,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDX02235-006648,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDK02556-006646,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02306-006801,24WBLDK02363-005831,25SBLUF02188-006804,25SBLUC03013-006719,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDK03098-006047,25WBLDC03097-006047,25WBLUK11140-007286"
    },
    "010125": {
        "Stato": "IT",
        "CAP": "01100",
        "Localit\u00e0": "VITERBO",
        "Indirizzo": "VIA I.GARBINI 29 H/I/L",
        "N.ri Tel.": "0761 307107",
        "Insegna": "BRUBAKER STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDX03008-006950,25SBLUH02193-004547,25SBLDH02372-005707,24WBLDC02044-006648,25WBLDK03101-006047,25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDK03052-006047,24WBLDC03047-006047,25SBLDL02396-007156,24WBLDK02556-006646,25SBLUF01184-006804,25SBLDV03365-007143,25SBLUH02191-004547,25WBLDB03191-007294,24WBLDC02290-006646,25SBLDS01291-007141,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUS02336-007137,25SBLUC04206-006535,25SBLDS01366-007141,25SBLUS01337-007137,24WBLDC03051-006047,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDK05019-007298,25WBLDC02170-006648,25SBLDH02386-007144,24WBLDK03086-006976,24WBLDA05465-006127,25WBLUL02318-007340,25WBLUC05125-007283,25SBLUX02230-005958,25SBLDH02373-005707,25WBLUA05298-006127,25WBLUC02079-A05958,25SBLUL02583-007370,24WBLDK03040-006950,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDC01279-007111,25SBLUC01217-007108,25SBLUM01476-006233"
    },
    "010137": {
        "Stato": "IT",
        "CAP": "12037",
        "Localit\u00e0": "SALUZZO",
        "Indirizzo": "CORSO ITALIA 58",
        "N.ri Tel.": "0175 41319",
        "Insegna": "LEI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUC03074-006355,24WBLDC03038-006950,24WBLDC02041-006648,24WBLDK02353-006985,24WBLDK03039-006950,24WBLDC03211-006990,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDL01416-006669,25WBLUC06082-005480,25SBLUC03013-006719,25WBLDA05335-007349,25WBLDC03099-006047"
    },
    "010143": {
        "Stato": "IT",
        "CAP": "06049",
        "Localit\u00e0": "SPOLETO",
        "Indirizzo": "CORSO MAZZINI, 13",
        "N.ri Tel.": "0743 223331",
        "Insegna": "ZUCCHERO KANDISKY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUP01189-006804,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUP01350-006855,25SBLUH02194-004547,25SBLUS02336-007138,25SBLUF01184-006804,25SBLUP04043-007130,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,24WBLDK03297-006992,25SBLUF03187-006804,25WBLDK05019-007298,25SBLUP02352-006855,25SBLUC01217-007108"
    },
    "010145": {
        "Stato": "IT",
        "CAP": "32043",
        "Localit\u00e0": "CORTINA D'AMPEZZO",
        "Indirizzo": "PIAZZA V. ALFIERI, 47",
        "N.ri Tel.": "0436 860905",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02312-006803"
    },
    "010166": {
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA ASTALONGA, 98",
        "N.ri Tel.": "081 19977792",
        "Insegna": "CIVICO 36 OUTLET",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBBXC02456-005958,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25WBLGC02391-006648,25WBBXC02454-007110,25WBLKC02427-005958,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLKC03400-007308,25WBLDC11163-007110"
    },
    "010286": {
        "Stato": "IT",
        "CAP": "27026",
        "Localit\u00e0": "GARLASCO",
        "Indirizzo": "VIA LEONARDO DA VINCI 69/2",
        "N.ri Tel.": "0382-810380",
        "Insegna": "LAZZARONI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02112-006631,24WBLDC02290-006646,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDC03084-006976,24WBLDK02363-005831,24WBLDK03037-006950,24WBLDK03052-006047,24WBLDK03122-006955,24WBLDK03346-006047,25SBLDC01221-007108,25SBLDC02232-007104,25SBLDC02233-007104,25SBLUB01216-007111,25SBLUC02228-007104,25SBLUC04206-006535,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUF03185-006804,25SBLUH02192-004547,25SBLUH02196-004547,25SBLUP02352-006855,25SBLUT02310-006817,25SBLUX02230-005958"
    },
    "010373": {
        "Stato": "IT",
        "CAP": "00042",
        "Localit\u00e0": "ANZIO",
        "Indirizzo": "VIA B. BUOZZI, 13",
        "N.ri Tel.": "069844841",
        "Insegna": "NUOVA CENTOLIRE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUP03539-006873,25SBLUS01339-007137,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUT02110-006526,25SBLKP05558-007187,25SBLUC01121-007105,25WBLUL02318-007340,24WBLDK03122-006955,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUL02583-007370,25SBLUH02030-006846,25WBLUK03142-005480,25WBLUL01314-007012,25SBLUS02336-007138,25SBLDL02396-007156,24WBLDK02042-006648,25SBLDL02396-007152,25WBLDK03527-006047,25SBLUA04524-007182,24WBLDK03297-006992,24WBLDL01416-006669,25SBLDH02375-006842,25WBLDK03161-006719,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUH02109-006526,24WBLDL01421-007016,25SBLUP01189-006804,25SBLUL02412-007155,25SBLUF01184-006804,25SBLKP05564-007187,25SBLUC04176-006854,24WBLDC02290-006646,25SBLKX02418-005958,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,25WBLDC03097-006047,25SBLDH02372-005707,25WBLDK03101-006047,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02387-007144,24WBLDB02092-006976,25SBLUH02192-004547,25SBLUX01218-007108,25SBLDC01159-007105,25WBLDC02170-006648,25WBLDL01340-007355,24WBLDL01420-007016,25WBLUA05301-006434,25WBLDL01346-007354"
    },
    "010379": {
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA MADONNELLE, 33",
        "N.ri Tel.": "081 7748527",
        "Insegna": "ROCAMBOLE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC03038-006950,24WBLDC03048-006047,24WBLDK02042-006648,24WBLDK03039-006950,25SBLDC01279-007111,25SBLDC04066-007109,25SBLDH02375-006842,25SBLDH02376-006842,25SBLDH02389-007144,25SBLDP05205-006804,25SBLDT02125-006526,25SBLDV05299-007138,25SBLUH02195-004547,25SBLUH02199-004547,25SBLUN01521-006581,25SBLUN02516-007177,25SBLUP02063-007092,25SBLUT02313-006818"
    },
    "010401": {
        "Stato": "IT",
        "CAP": "07100",
        "Localit\u00e0": "SASSARI",
        "Indirizzo": "VIALE ITALIA, 18",
        "N.ri Tel.": "079 2019202 Ausilia",
        "Insegna": "DESOLE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUL01314-007012,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUM01478-007167,25SBLUC04176-006854,24WBLDK03039-006950,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25SBLUC01209-007101,25WBLDC02170-006648,25WBLUC03086-006047,25WBLUL02318-007340,25WBLUC05125-007283,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUL01316-007012"
    },
    "010427": {
        "Stato": "IT",
        "CAP": "10078",
        "Localit\u00e0": "VENARIA REALE",
        "Indirizzo": "VIA ANDREA MENSA,16/B",
        "N.ri Tel.": "011/4598972",
        "Insegna": "ROYAL",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02018-006648,24WBLDC02018-006648,24WBLDC02044-006648,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDK02556-006646,24WBLDK03052-006047,24WBLDK03052-006047,24WBLDL01417-006668"
    },
    "010443": {
        "Stato": "IT",
        "CAP": "71045",
        "Localit\u00e0": "ORTANOVA",
        "Indirizzo": "CORSO UMBERTO I 94",
        "N.ri Tel.": "0885 784315",
        "Insegna": "SCIKKERIE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC03074-006355,25WBLUC02077-006943,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDC03096-006047,24WBLDC03051-006047,25SBLUC03012-006719,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC03097-006047"
    },
    "010467": {
        "Stato": "IT",
        "CAP": "10024",
        "Localit\u00e0": "MONCALIERI",
        "Indirizzo": "CORSO SAVONA, N. 69",
        "N.ri Tel.": "011-8953288",
        "Insegna": "MOMI PLANET",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05465-006127,24WBLDA05465-006127"
    },
    "010507": {
        "Stato": "IT",
        "CAP": "80020",
        "Localit\u00e0": "FRATTAMINORE",
        "Indirizzo": "VIA ROMA 31,",
        "N.ri Tel.": "081-8305621",
        "Insegna": "SARONNI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01121-007105,25SBLUT02310-006817,25SBLUC11214-007111,25WBLUC03086-006047,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDK02556-006646,25SBLUH02195-004547,25WBLDK03527-006047,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUP02063-007092,25SBLUC01210-007101,25SBLDC01279-007111,25SBLUF03185-006804,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUP01189-006804,24WBLDC03038-006950,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC02132-007284,25WBLDC03097-006047,25WBLDC11163-007110,25SBLUH02193-004547,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25SBLUC11207-006787,25SBLUH02192-004547,25WBLDK11162-007110,25WBLDC02170-006648,25SBLUH02199-004547"
    },
    "010512": {
        "Stato": "IT",
        "CAP": "76123",
        "Localit\u00e0": "ANDRIA",
        "Indirizzo": "VIA REGINA MARGHERITA 47,",
        "N.ri Tel.": "0883/593579",
        "Insegna": "BRUNO 1924",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUT02346-007132,25SBLUC11207-006787,25SBLUH02191-004547,25SBLUS01340-007138,25SBLUB01216-007111,25SBLUC04176-006854,25SBLUS02336-007137,25SBLUK11239-007110,25WBLUC02080-005958,25WBLUA05297-006127,25WBLUK11140-007286"
    },
    "010556": {
        "Stato": "IT",
        "CAP": "70052",
        "Localit\u00e0": "BISCEGLIE",
        "Indirizzo": "PIAZZA VITT. EMANUELE, 62",
        "N.ri Tel.": "080/3957689",
        "Insegna": "LAMANUZZI",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUF03186-006804,25SBLUH02197-004547,25SBLUC02228-007104,25WBLUC02080-005958,25SBLUX02230-005958"
    },
    "010584": {
        "Stato": "IT",
        "CAP": "82020",
        "Localit\u00e0": "PIETRELCINA",
        "Indirizzo": "VIA NAZIONALE S.N.C, 1",
        "N.ri Tel.": "0824997395",
        "Insegna": "SOVISA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDC03038-006950,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDF08400-006987,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLDC03099-006047"
    },
    "010590": {
        "Stato": "IT",
        "CAP": "03100",
        "Localit\u00e0": "FROSINONE",
        "Indirizzo": "VIA VADO LA LENA, 15",
        "N.ri Tel.": "0775-290697",
        "Insegna": "BROGI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25WBLDC02178-006646,25SBLUT02308-006801,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUT02346-007132,25SBLUP01189-006804,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK02042-006648,25SBLUF01184-006804,25SBLDT02125-006526,25WBLDK03527-006047,25WBLDB03191-007294,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC03095-006047,25SBLUT02306-006801,25SBLDC04333-007109,25SBLDH02386-007144,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02064-006100,25WBLUC06082-005480,25SBLDH02375-006842,25SBLDC01328-007131,24WBLDC03048-006047,25SBLDC04066-007109,25SBLDC01279-007111"
    },
    "010591": {
        "Stato": "IT",
        "CAP": "10142",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA MONGINEVRO, 187/D",
        "N.ri Tel.": "011-7701493",
        "Insegna": "ZAGHI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25WBLUK03142-005480,25WBLDC02178-006646,25SBLDC02234-006648,25SBLDC03003-006950,25WBLDC03097-006047,25SBLUH02196-004547,25SBLUT02346-007132,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDK03052-006047,25SBLUC02229-005958,24WBLDC03047-006047,25SBLUH02194-004547,25WBLDK03527-006047,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUP04062-007092,25SBLDC11237-007110,25SBLUC02227-007104,25WBLDC03096-006047,24WBLDC03211-006990,25SBLDC03007-006950,25SBLDC02232-007104,25SBLDK01249-007111,24WBLDC03051-006047,24WBLDK02363-005831,25SBLUF01055-007092,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC02016-006940,25WBLUC03086-006047,25SBLDF08078-007092,25SBLUB04167-006854,25WBLUC06082-005480,25SBLDC01328-007131,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,24WBLDK03040-006950,25SBLUP02063-007092,25SBLUC01210-007101,25SBLUC04163-006788"
    },
    "010662": {
        "Stato": "IT",
        "CAP": "50019",
        "Localit\u00e0": "SESTO FIORENTINO",
        "Indirizzo": "PIAZZA VITTORIO VENETO, 13",
        "N.ri Tel.": "0554489997",
        "Insegna": "CHIOSTRI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,24WBLDC03047-006047,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUM01478-007167,24WBLDC02290-006646,25SBLUT02309-007125,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDK03103-006047,25WBLDK03102-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUM01476-006233"
    },
    "010697": {
        "Stato": "IT",
        "CAP": "80050",
        "Localit\u00e0": "PIMONTE",
        "Indirizzo": "VIA CASA CUOMO PIAZZA, 8 14",
        "N.ri Tel.": "081-8749071",
        "Insegna": "SHOPPING CUOMO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25SBLUC11569-006787,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLDH02374-006842,24WBLDK03052-006047,24WBLDK11337-006007,24WBLDC03047-006047,25SBLDH02376-006842,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUT02310-006817,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,25SBLDC01328-007131,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "010699": {
        "Stato": "IT",
        "CAP": "71011",
        "Localit\u00e0": "APRICENA",
        "Indirizzo": "CORSO ROMA, 97",
        "Insegna": "FASHION STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC03119-006951,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDV02296-007143,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUT02346-007132,24WBLDK03052-006047,25SBLUC11541-007110,25SBLUN02514-007179,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUH02195-004547,24WBLDC02041-006648,25SBLDV03365-007143,25SBLUH02108-006864,25WBLDB03191-007294,25SBLUC04176-006854,25SBLUH02197-004547,25SBLUH02348-007132,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUP04062-007092,25SBLUC01211-007101,25SBLDP01326-007143,24WBLDC03211-006990,25WBLDK11162-007110,25SBLDC03007-006950,25SBLDS01366-007141,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUF01055-007092,24WBLDK03120-006951,25SBLUH02275-007100,24WBLDK03122-006955,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUH02199-004547,25WBLDK03098-006047,25SBLUP02063-007092,25WBLUC02079-A05958,25WBLDC03097-006047,24WBLDC02112-006631"
    },
    "010718": {
        "Stato": "IT",
        "CAP": "56028",
        "Localit\u00e0": "PONTE A EGOLA - SAN MINIATO",
        "Indirizzo": "VIA ANTONIO GRAMSCI 8 10 12,",
        "N.ri Tel.": "0571 497870",
        "Insegna": "BONNIE & CLYDE",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUA04527-007182,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUH02194-004547,24WBLDK02042-006648,25WBLDK03527-006047,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC02232-007104,25SBLDK01249-007111,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDK03040-006950"
    },
    "010724": {
        "Stato": "IT",
        "CAP": "80143",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA GENOVA 90,",
        "N.ri Tel.": "081-5539446",
        "Insegna": "SORECA",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25SBLKF03551-007187,25SBLGF02547-007187,25SBLGC01441-007111,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUH02194-004547,25SBLKH02555-007188,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLGP05549-007187,25SBLUH02191-004547,25WBLKC02427-005958,24WBLDK03039-006950,25SBLKC11440-007111,25SBLUH02192-004547,25SBLDC11237-007110,25SBLKP05558-007187,25SBLUT02310-006817,25SBLKF02553-007187,25SBLKP01554-007187,25SBLGH02550-007188,25SBLDC01279-007111,25WBLKC02429-005958"
    },
    "010812": {
        "Stato": "IT",
        "CAP": "27015",
        "Localit\u00e0": "LANDRIANO",
        "Indirizzo": "PIAZZALE AMBROSOLI SNC MAGAZZINO LOTTO 5",
        "N.ri Tel.": "039 9908685",
        "Insegna": "MAXI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUL01314-007012,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUC11215-007110,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUC02228-007104,25SBLUH02192-004547,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25SBLDC04333-007109,25WBLUC03086-006047,25SBLDC04070-007109,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02112-006631"
    },
    "010914": {
        "Stato": "IT",
        "CAP": "16043",
        "Localit\u00e0": "CHIAVARI",
        "Indirizzo": "PIAZZA ROMA, 2",
        "N.ri Tel.": "0185 598043",
        "Insegna": "BLAUER STORE CHIAVARI",
        "CODICE PRODOTTO KOOOMO": "25SBLUP03539-006873,24WBLDC03047-006047,25SBLGC02426-006648,25SBLUT02317-007116,25SBLUC01219-007108,25SBLUN02516-007177,25SBLUM01486-007172,25SBLGF03548-007187,25SBLGH02492-007144,25WBLKC03400-007308,25SBLUP02352-006855,25WBLKC02429-005958,25SBLUP05033-007094,24WBLDC03084-006976,25WBLKC11416-007110,25SBLDC02234-006648,25SBLUC01046-007120,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDP01344-006855,25SBLUA04524-007182,25SBLUH02276-005695,25SBLGC02432-007104,25SBLUC04206-006535,25SBLUF01055-007092,25SBLUL02409-006547,25SBLUC01034-007111,25SBLGC02429-006648,25SBLUF08504-007173,24WBLDK03037-006950,25SBLUF01184-006804,25SBLUM06481-007168,25SBLDV03365-007143,25SBLKC11440-007111,25SBLKX02418-005958,25WBLDC03095-006047,25SBBKC01452-007111,24WBLDA05465-006127,24WBLDF01398-006987,25SBLDC03006-006950,25WBLDA05335-007349,24WBLDM10555-007022,25SBLDC02233-007104,25WBLKA05458-006127,25SBLKF08561-007187,24WBLUK02171-006995,25SBLUP05530-007173,25SBLUX01218-007108,25SBLUL02403-006543,25SBLDT02138-006526,25SBLUC04082-007159,24WBLDL01420-007016,25SBLUP04353-007139,25SBLDC04066-007109,25WBLDK03098-006047,24WBLDF02101-006960,25WBLDA05336-007349,25SBLUN02510-007177,25SBLKH02555-007188,24WBLDK03039-006950,25SBLUC11083-007106,25SBLDF08078-007092,25WBLUC11083-007110,25SBLUP05190-006804,25SBLDH02377-007147,25SBLUH02195-004547,25WBBXC02454-007110,25WBLKC02427-005958,25SBLDK01249-007111,24WBLDM04562-007021,25SBLKP01554-007187,24WBLDL01416-006669,25WBLDC03099-006047,25SBLDX03008-006950,25WBLUC03090-006719,24WBLDP01448-006420,24WBLDA05467-006434,25WBBXC02456-005958,24WBLDL01421-007016,25SBLKF03551-007187,25SBLUL02412-007155,25SBLUC01115-007105,24WBLDH01432-006971,25SBLKP05564-007187,25SBLDP02143-007109,25SBLKC01435-007108,25SBLDP04142-007109,24WBLDF08400-006987,25SBLUS02336-007137,25SBLDC03007-006950,24WBLDC03051-006047,25SBLDP05141-007109,25SBLDM01473-007166,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,24WBLDF03399-006987,25SBLUC01281-007105,25SBLUM01476-006233,24WBLDC11209-006007,25WBLDK03101-006047,24WBLDP03446-007029,25SBLUH02150-007100,25SBLUC11207-006787,25SBLGC01441-007111,25SBLUM12488-007170,25SBLUC02228-007104,25SBLDH02370-006845,25WBLDC02170-006648,24WBLDC02016-006940,24WBLDM10259-006645,25SBLKC02417-005958,24WBLDM10408-007022,25SBLUC02227-007104,25SBLKC01445-007101,25SBLUT02310-006817,25SBLDS01366-007141,25SBLKF02553-007187,25WBLUC03086-006047,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDC01222-007108,25WBLUA05299-006127,25SBLDP01079-007092,25SBLUP01350-006855,25SBLUC03011-006719,25SBLDL02396-007152,25WBLDK03527-006047,24WBLDF16106-006960,25WBLUA05298-006127,24WBLDC02044-006648,25SBLDC03003-006950,25SBLUP01189-006804,25SBLGF02547-007187,25SBLUC01119-007105,24WBLDC03038-006950,25SBLDH02389-007144,25WBLDC03096-006047,25SBLKT02464-006818,25SBLUM01482-007168,24WBLDM01437-007021,25WBLUC03074-006355,24WBLDM09261-006645,24WBLDC03036-006950,25SBLUC02280-005958,24WBLDK03052-006047,25SBLKC06443-007101,25SBLUT02316-007116,25WBLGC02391-006648,25WBLDM01463-007330,25SBLDV05299-007138,25SBLDC01159-007105,25SBLUF03031-007094,24WBLDK02362-005831,25SBLDF03257-007113,25WBLDL01340-007355,25SBLUT02315-007117,25WBLUA05297-006127,25SBLDP03540-006873,25SBLUC11541-007110,25WBLDB03191-007294,25WBLDC03100-006047,25SBLDC11237-007110,25SBLKP05558-007187,25SBLDP02345-006855,25SBBGC02453-005958,25SBLUP04353-007129,25SBLUC03012-006719,25SBLDH02373-005707,25WBLDA05337-006127,25SBLUN01521-006581,25WBLUK03142-005480,25SBLDH03369-006845,25SBLGP05549-007187,25SBLUP04322-007129,25WBLDK03495-006047,25SBLDC01279-007111,25SBLUF03185-006804,25WBLDC02178-006646,25SBLUA04527-007182,25SBLKC02430-007104,25SBLDS01291-007141,25SBLDC02264-006648,25SBLUT02309-007125,25SBLUS01337-007137,25SBLDP01140-007109,24WBLDC05357-005831,25SBLUP03535-006873,25WBLDK03102-006047,25SBLGH02550-007188,25SBLUH02394-007114,25SBLUL02402-007153,25WBLDC03097-006047,25SBLUA04525-007182,25SBLUM03490-007170,25SBLDP01300-007140,25SBLUT02346-007132,25WBLGA05461-007349,25SBLUH02191-004547,24WBLDB02092-006976,25SBLUT02313-006818,24WBLDH02433-006971,25SBLGH02495-007144,25SBLUT02306-006801,25SBLDL02399-007155"
    },
    "010918": {
        "Stato": "IT",
        "CAP": "33077",
        "Localit\u00e0": "SACILE",
        "Indirizzo": "VIALE TRENTO, 59",
        "N.ri Tel.": "0434/780696",
        "Insegna": "PIU' SPORT - amina sportiva",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25WBLUC11083-007110,24WBLDC02049-006636,25WBLDK03101-006047,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUC03011-006719,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUC03012-006719,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLUC02079-A05958,25SBLUC04163-006788,24WBLDK03346-006047"
    },
    "010962": {
        "Stato": "IT",
        "CAP": "97019",
        "Localit\u00e0": " VITTORIA -SCOGLITTI",
        "Indirizzo": "VIA ROMA 334",
        "N.ri Tel.": "0932 802490",
        "Insegna": "OTTONE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK03039-006950"
    },
    "010984": {
        "Stato": "IT",
        "CAP": "28100",
        "Localit\u00e0": "NOVARA - SAN MARTINO",
        "Indirizzo": "VIA UGO PORZIO GIOVANOLA, 7 - UNITA' 63",
        "Insegna": "NUVOLARI STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUT02346-007132,25SBLUH02242-007100,25WBLUC02080-005958,25SBLUX02230-005958"
    },
    "011060": {
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "FAVARA",
        "Indirizzo": "CORSO VITTORIO VENETO, 392",
        "N.ri Tel.": "0922 33216",
        "Insegna": "LIVRERI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "011069": {
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA ENRICO PARISI, 21",
        "N.ri Tel.": "091 322719",
        "Insegna": "UOMO STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25WBLDC03095-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUA05301-006434"
    },
    "011112": {
        "Stato": "IT",
        "CAP": "97100",
        "Localit\u00e0": "RAGUSA",
        "Indirizzo": "VIA MARIO RAPISARDI 146,",
        "N.ri Tel.": "0932655044",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "011139": {
        "Stato": "IT",
        "CAP": "00173",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA TUSCOLANA, 1243",
        "N.ri Tel.": "06-45509193",
        "Insegna": "BCL GROUP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,25WBLDK02073-006648,25SBLUH02241-007100,24WBLDK03122-006955,25WBLUC05125-007283,25WBLUC02080-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDC02314-006631,25SBLUH02196-004547,25SBLUS02336-007138,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDC02018-006648,25SBLUC04206-006535,25WBLDC02177-007284,25WBLDC03099-006047,24WBLDC03119-006951,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDC03097-006047,25WBLDC02072-006648,25SBLUH02193-004547,25WBLDK03101-006047,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDK03052-006047,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUT02306-006801,25WBLDC02170-006648,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "011216": {
        "Stato": "IT",
        "CAP": "88043",
        "Localit\u00e0": "FEROLETO ANTICO",
        "Indirizzo": "LOC. GARRUBBE SNC",
        "N.ri Tel.": "0968/750121",
        "Insegna": "THE GALLERY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUC01211-007101,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25SBLUX02230-005958,25WBLUC02132-007284,25WBLDC03099-006047"
    },
    "011236": {
        "Stato": "IT",
        "CAP": "20017",
        "Localit\u00e0": "RHO",
        "Indirizzo": "VIA MADONNA, 79/B",
        "N.ri Tel.": "373/8250889",
        "Insegna": "ASCOT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25WBLUC02079-005958,25SBLDP01300-007140,24WBLDM09261-006645,25SBLUH02150-007100,25SBLUH02196-004547,25SBLUC11207-006787,24WBLDM13260-006645,25SBLDF03201-006804,24WBLDC03047-006047,25SBLUC01115-007105,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUB01216-007111,25SBLUH02192-004547,24WBLDP03447-007025,25SBLUC02227-007104,25SBLUT02310-006817,25SBLUX02230-005958,25WBLUC02079-A05958,25SBLUF03185-006804"
    },
    "011243": {
        "Stato": "IT",
        "CAP": "80022",
        "Localit\u00e0": "ARZANO",
        "Indirizzo": "VIA VI ALFREDO PECCHIA 125-127,",
        "N.ri Tel.": "081 5732570",
        "Insegna": "IT GLAM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,24WBLDC02314-006631,25SBLUH02150-007100,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02191-004547,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02244-007100,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUT02310-006817,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDC03099-006047,24WBLDC02112-006631"
    },
    "011278": {
        "Stato": "IT",
        "CAP": "63082",
        "Localit\u00e0": "CASTEL DI LAMA",
        "Indirizzo": "VIA SALARIA 222,",
        "N.ri Tel.": "0736/814195",
        "Insegna": "AMADIO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUA05299-006127,25SBLDC01221-007108,25SBLUH02196-004547,24WBLDK11337-006007,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02192-004547,25WBLDC03096-006047,25WBLDK11162-007110,24WBLDX03318-006992,25SBLUC04206-006535,25SBLDK01249-007111,25SBLUP01324-007130,25WBLDC02170-006648,25SBLDC01328-007131,25SBLDC03006-006950,25SBLUH05028-006846,25WBLDC03099-006047,25WBLDK03098-006047,25SBLDC01279-007111"
    },
    "011296": {
        "Stato": "IT",
        "CAP": "80126",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA EPOMEO, 93",
        "N.ri Tel.": "081/7672262",
        "Insegna": "MAZZOLA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03211-006990,24WBLDK02042-006648,24WBLDK02363-005831,24WBLDK02556-006646,24WBLDK03040-006950,24WBLDK03212-006990,24WBLDL01416-006669"
    },
    "011352": {
        "Stato": "IT",
        "CAP": "80022",
        "Localit\u00e0": "ARZANO",
        "Indirizzo": "VIA ATELLANA, 46",
        "N.ri Tel.": "081/5730383",
        "Insegna": "MIDA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,25SBLKH02555-007188,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUC01211-007101,25SBLKP05558-007187,25SBLUC01121-007105,25SBLUT02310-006817,25SBLKF02553-007187,25WBLUC02080-005958,24WBLDC03048-006047,25WBLKC03400-007308,25WBLUK03142-005480,25SBLUP01350-006855,24WBLDK02042-006648,24WBLDC02041-006648,25WBLKC02427-005958,25SBLKP01554-007187,25SBLUF01055-007092,25SBLUH02275-007100,25WBLDC03099-006047,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUA04527-007182,25SBLUH02109-006526,25SBLKF03551-007187,25SBLKP05564-007187,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUS02336-007137,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC06082-005480,25SBLUH02394-007114,25WBLDC02072-006648,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUH02191-004547,25SBLUT02306-006801,25WBLDC02170-006648,25WBLUC02079-A05958"
    },
    "011355": {
        "Stato": "IT",
        "CAP": "10123",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA ROMA, 55",
        "N.ri Tel.": "011 3292512",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03527-006047,24WBLDC03084-006976"
    },
    "011366": {
        "Stato": "IT",
        "CAP": "84047",
        "Localit\u00e0": "CAPACCIO",
        "Indirizzo": "VIA ITALIA 61 168/N., CAPACCIO SCALO",
        "N.ri Tel.": "0828725516",
        "Insegna": "SORRENTINO S.RE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDH02374-006842,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,24WBLDK03039-006950,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02309-007125,25SBLDC02232-007104,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDK03103-006047,25SBLUH02275-007100,25SBLDH02375-006842,25WBLUC02132-007284,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "011369": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA ABATE MINICHINI,32",
        "N.ri Tel.": "3319667149",
        "Insegna": "MANU",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLKH02555-007188,25WBLDB03191-007294,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLKP05558-007187,25SBLKF02553-007187,25SBLUC11214-007111,25WBLUC02080-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLKC02429-005958,25WBLUK03142-005480,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLGP05549-007187,25WBLKC02427-005958,25SBLUC04206-006535,25SBLKP01554-007187,25SBLUH02275-007100,25SBLDC04070-007109,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02044-006648,25WBLDC02178-006646,25SBLKF03551-007187,25SBLDC01358-007101,24WBLDC03038-006950,24WBLDC02290-006646,25SBLKC11440-007111,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC06082-005480,25WBLUC02132-007284,25SBLGH02550-007188,25WBLDC03097-006047,25SBLUC11569-006787,25WBLDC02072-006648,25WBLDK03101-006047,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLGC01441-007111,25WBLGC02391-006648,25WBLDK11162-007110,25WBLDC02170-006648,25SBLDC01328-007131,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "011395": {
        "Stato": "RU",
        "CAP": "369000",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "UL SOVETSKAYA 60",
        "N.ri Tel.": "02 63471267",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP01324-007130"
    },
    "011458": {
        "Stato": "IT",
        "CAP": "85042",
        "Localit\u00e0": "LAGONEGRO",
        "Indirizzo": "VIALE ROMA, 36/25",
        "N.ri Tel.": "0973/22061",
        "Insegna": "MARY CHIC",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,25SBLUP04062-007092,25SBLDP01326-007143,25SBLDH02386-007144,25SBLUC03012-006719,25WBLUC03086-006047,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLDV01146-007107,24WBLDC02314-006631,25SBLDC01222-007108,25SBLDH02374-006842,25WBLUC02077-006943,25SBLDB04068-007109,24WBLDC02041-006648,25SBLUF03186-006804,25SBLDC01359-007101,25SBLUH02276-005695,25SBLUF01055-007092,25SBLDC04070-007109,25WBLDC03099-006047,25SBLUP02063-007092,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC01358-007101,24WBLDC03038-006950,25SBLUH02108-006864,24WBLDC02290-006646,25SBLDP04142-007109,25SBLDS01291-007141,25WBLDC03096-006047,25SBLDC02128-007103,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDP01140-007109,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLDC03097-006047,25SBLUM01476-006233,25SBLDC02233-007104,25WBLDC02072-006648,25SBLDS01292-007141,25SBLDV02296-007143,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,25SBLDH02376-006842,25SBLUT02313-006818,25SBLDH02377-007144,25SBLDT02138-006526,25WBLDC02170-006648,25WBLDK03098-006047"
    },
    "011464": {
        "Stato": "IT",
        "CAP": "87067",
        "Localit\u00e0": "ROSSANO",
        "Indirizzo": "VIA NAZIONALE, 85",
        "N.ri Tel.": "0983/290788",
        "Insegna": "IN STILE BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDK03037-006950,25SBLDC02233-007104,25WBLDC02072-006648,24WBLDC03084-006976,24WBLDC02044-006648,25WBLUL01314-007012,25SBLDC02234-006648,25SBLDC03003-006950,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDC02018-006648,25WBLDC03096-006047,25SBLDC01159-007105,25SBLDC03007-006950,25SBLDC02232-007104,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC05357-005831,24WBLDC02352-006977,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "011466": {
        "Stato": "IT",
        "CAP": "87067",
        "Localit\u00e0": "ROSSANO",
        "Indirizzo": "VIA NAZIONALE, 42/44",
        "Insegna": "PIERO & MIMMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUL02412-007155,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUC03011-006719,25SBLUH02195-004547,25SBLUH02191-004547,25WBLDB03191-007294,25SBLUT02313-006818,25SBLDC02264-006648,24WBLDC03211-006990,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03120-006951,25WBLUL02318-007340,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUA05298-006127,25WBLDC03099-006047,25WBLUL01316-007012,25WBLUB05126-007283"
    },
    "011486": {
        "Stato": "IT",
        "CAP": "20081",
        "Localit\u00e0": "ABBIATEGRASSO",
        "Indirizzo": "PIAZZA MARCONI, 11",
        "N.ri Tel.": "0381/90196",
        "Insegna": "BOSTON CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047,24WBLDK03039-006950"
    },
    "011652": {
        "Stato": "IT",
        "CAP": "20882",
        "Localit\u00e0": "BELLUSCO",
        "Indirizzo": "VIA ALESSANDRO MANZONI, 39",
        "N.ri Tel.": "039/623669",
        "Insegna": "PIROLA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUH02196-004547,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUF01184-006804,25SBLDF03076-007092,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUB01216-007111,25SBLDP04142-007109,25WBLDC03095-006047,25SBLUF03187-006804,25SBLDC04333-007109,25WBLDK03103-006047,24WBLDK03122-006955,25WBLUC06082-005480,25WBLDK03102-006047,25SBLUT02315-007117,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "012000": {
        "Stato": "IT",
        "CAP": "74011",
        "Localit\u00e0": "CASTELLANETA",
        "Indirizzo": "VIA R. MARGHERITA, 30",
        "N.ri Tel.": "099/ 8442321",
        "Insegna": "FUORI DAL COMUNE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02108-006864,25SBLUT02310-006817,25SBLUP04353-007129,25SBLUH02275-007100,25SBLUX02230-005958,25SBLUH02030-006846"
    },
    "012126": {
        "Stato": "IT",
        "CAP": "80014",
        "Localit\u00e0": "GIUGLIANO IN CAMPANIA",
        "Indirizzo": "VIA MADONNA DEL PANTANO LOC.LAGO PATRIA",
        "N.ri Tel.": "081-7213422",
        "Insegna": "MORALE ZONA NATO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUX02081-005958,24WBLDM09261-006645,25WBLDC03097-006047,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDM13260-006645,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,25WBLDC03100-006047,24WBLDC02290-006646,24WBLDC02018-006648,24WBLDC03211-006990,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,24WBLDB03294-005553,24WBLDK03086-006976,25WBLUL02318-007340,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDK03102-006047"
    },
    "012301": {
        "Stato": "IT",
        "CAP": "39030",
        "Localit\u00e0": "SAN LORENZO DI SEBATO",
        "Indirizzo": "VIA JOSEF RENZLER, 23",
        "N.ri Tel.": "0474-474460",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012304": {
        "Stato": "IT",
        "CAP": "71037",
        "Localit\u00e0": "MONTE SANT'ANGELO",
        "Indirizzo": "VIA GIUSEPPE GARIBALDI, 88",
        "N.ri Tel.": "0884/964562",
        "Insegna": "BOUTIQUE CAPRICCIO",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012315": {
        "Stato": "IT",
        "CAP": "10151",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "S.DA COMUNALE DI ALTESSANO 141",
        "N.ri Tel.": "011/2121148",
        "Insegna": "ONE'S EASE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01221-007108,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUX02255-007101,25SBLUT02316-007116,25SBLUC02254-007101,25SBLUS01341-007136,25SBLUH02197-004547,25SBLUH02348-007132,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC01121-007105,25SBLDC01159-007105,25SBLDC03007-006950,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUF01055-007092,25WBLDK03495-006047,25SBLUC01210-007101,25SBLDC01279-007111"
    },
    "012456": {
        "Stato": "IT",
        "CAP": "87032",
        "Localit\u00e0": "AMANTEA",
        "Indirizzo": "VIA REGINA MARGHERITA 12,",
        "N.ri Tel.": "0982426362",
        "Insegna": "IMMAGINE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02342-006631,25WBLDK02069-006648,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLDC03099-006047"
    },
    "012474": {
        "Stato": "IT",
        "CAP": "17024",
        "Localit\u00e0": "VARIGOTTI - FINALE LIGURE",
        "Indirizzo": "VIA DEL CAPO, 35",
        "N.ri Tel.": "019/698257",
        "Insegna": "BRUNA MODE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDK03037-006950,24WBLDK03037-006950"
    },
    "012481": {
        "Stato": "IT",
        "CAP": "58014",
        "Localit\u00e0": "MANCIANO",
        "Indirizzo": "VIA SS ANNUNZIATA, 3",
        "N.ri Tel.": "075 800 4272",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,25SBLUC01115-007105,25SBLUC02254-007101,25SBLUH02197-004547"
    },
    "012505": {
        "Stato": "IT",
        "CAP": "73029",
        "Localit\u00e0": "VERNOLE",
        "Indirizzo": "VIA MAZZINI, 40",
        "N.ri Tel.": "0832 892134",
        "Insegna": "KUBE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLDK02069-006648,24WBLDK02042-006648,25WBLDC03100-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC02079-A05958"
    },
    "012518": {
        "Stato": "IT",
        "CAP": "88043",
        "Localit\u00e0": "MAIDA",
        "Indirizzo": "LOCALITA' COMUNI CONDOMINI",
        "N.ri Tel.": "0968/750121",
        "Insegna": "AMERICAN JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,25WBLUC02077-006943,24WBLDK03052-006047,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUF03186-006804,25SBLUC01219-007108,25SBLUC01211-007101,25SBLUT02309-007125,24WBLDC03051-006047,25SBLUT02306-006801,25SBLUH02275-007100,24WBLDC02352-006977,25SBLUX02230-005958,25WBLDC03099-006047,25WBLDK03098-006047,25WBLUL01316-007012"
    },
    "012553": {
        "Stato": "IT",
        "CAP": "88900",
        "Localit\u00e0": "CROTONE",
        "Indirizzo": "VIA VITTORIO VENETO 30,",
        "N.ri Tel.": "096228488",
        "Insegna": "PUNTO GIOVANE EVELYN",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUP03539-006873,25SBLUS01339-007137,25SBLUA04528-007183,25WBLUC08078-006355,25WBLDK01376-007378,25WBLUC02079-005958,25SBLDP03540-006873,25SBLUN02510-007177,25WBLDP01291-007324,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUP04062-007092,25SBLUC01211-007101,25SBLUC02227-007104,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUC11214-007111,25SBLDC02330-007119,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03120-006951,25WBLUL02318-007340,25WBLDP01295-007323,25SBLUP04354-007129,25SBLUC03013-006719,24WBLDC02352-006977,25SBLUX02230-005958,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUL02583-007370,25WBLDA05337-006127,25WBLKC02429-005958,25WBLUC11083-007110,25SBLUP05033-007094,24WBLDC03084-006976,25SBLUP05190-006804,25WBLUK03142-005480,25WBLKC11416-007110,25SBLUT02308-006801,24WBLDC02314-006631,25SBLUH02196-004547,25SBLDB04068-007109,25SBLUC02229-005958,25SBLUP01350-006855,25SBLUC03011-006719,24WBLDK02042-006648,25SBLDL02396-007152,25SBLUH02195-004547,24WBLDC02041-006648,25SBLDT02125-006526,25SBLUX03226-006719,25SBLUM01478-007167,25SBLUF03186-006804,25SBLDP01344-006855,25SBLUA04524-007182,25SBLUC04206-006535,25SBLDK01249-007111,25SBLUP04322-007129,25SBLUF01055-007092,25SBLDC02236-006648,25SBLDC04070-007109,25SBLDH02375-006842,25SBLUC01034-007111,25WBLUA05298-006127,25WBLDC03099-006047,25SBLUP02063-007092,25SBLDC01279-007111,25WBLUL01316-007012,24WBLDC02112-006631,25SBLDX03008-006950,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,24WBLDP01448-006420,25WBLDC02178-006646,24WBLDA05467-006434,25SBLDC03003-006950,25SBLUH02109-006526,24WBLDL01421-007016,25SBLUP01189-006804,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUX02255-007101,25SBLUF01184-006804,25SBLDV03365-007143,25SBLUC04176-006854,24WBLDC02290-006646,25SBLDC02264-006648,25SBLUP05355-007139,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDP03537-006873,25SBLUT02309-007125,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDA05465-006127,24WBLDF01398-006987,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02132-007284,25SBLDC03006-006950,24WBLDF03399-006987,25WBLDC03097-006047,25SBLUM01476-006233,25SBLUC11569-006787,25WBLDC02072-006648,25SBLUH02193-004547,25SBLDS01292-007141,25SBLUL02582-007370,25WBLUX02081-005958,25SBLDV02296-007143,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUC02254-007101,25SBLDF03076-007092,25WBLGC02391-006648,25SBLUT02313-006818,25SBLUC02228-007104,25SBLDC01159-007105,25SBLUC02231-005958,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDL01340-007355,25SBLUB04167-006854,24WBLDL01420-007016,25SBLDL02399-007155,25WBLDF08248-006948,25SBLUH02199-004547,25WBLUC02079-A05958,25SBLUT02315-007117,25WBLDK01375-007378"
    },
    "012558": {
        "Stato": "IT",
        "CAP": "00054",
        "Localit\u00e0": "FIUMICINO",
        "Indirizzo": "VIA DELLA TORRE CLEMENTINA 158,",
        "N.ri Tel.": "06-6505059",
        "Insegna": "FRATELLI COTARDO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25WBLUL01316-007012,25SBLUH02196-004547,25SBLUC11207-006787,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUH02191-004547,25SBLUC04176-006854,25SBLUH02197-004547,25SBLUH02348-007132,25SBLUA04524-007182,25WBLUC02080-005958,25SBLUH05028-006846,25SBLUP02063-007092,25SBLUM01479-007167,25SBLUT02315-007117,25SBLUH02030-006846,25WBLUC02079-A05958"
    },
    "012564": {
        "Stato": "IT",
        "CAP": "81131",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE DEGLI ASTRONAUTI 13,",
        "N.ri Tel.": "081 7413586",
        "Insegna": "LX MODA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25WBLDK02069-006648,24WBLDK02042-006648,25WBLDK02073-006648,24WBLDK03039-006950,24WBLDC02290-006646,25WBLUC02151-007287,25WBLDC03096-006047,25WBLDC02170-006648,24WBLDC02064-006100,25WBLUC02080-005958,24WBLDC03048-006047,24WBLDK03040-006950"
    },
    "012578": {
        "Stato": "IT",
        "CAP": "03014",
        "Localit\u00e0": "FIUGGI",
        "Indirizzo": "CORSO NUOVA ITALIA N 42",
        "N.ri Tel.": "0775-506501",
        "Insegna": "REGINA BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDF08400-006987,24WBLDF08400-006987,24WBLDH01432-006971,24WBLDH01432-006971,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03052-006047,24WBLDK03086-006976"
    },
    "012584": {
        "Stato": "IT",
        "CAP": "62100",
        "Localit\u00e0": "MACERATA",
        "Indirizzo": "VIA TRENTO , 43/B",
        "N.ri Tel.": "0733 230180",
        "Insegna": "NAUTILUS",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLDC02178-006646,25SBLDC02234-006648,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDK03052-006047,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUC04176-006854,25SBLUP04043-007130,25SBLUT02313-006818,25SBLUT02312-006803,25SBLUC02227-007104,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC03095-006047,25SBLUM01482-007168,25SBLUH02030-006846,25WBLUC03086-006047,24WBLDC05357-005831,25SBLUB04167-006854,25SBLUM01486-007172,24WBLDC02352-006977,25WBLUC02080-005958,25WBLDK03102-006047,25SBLUH02394-007114,25SBLUC01217-007108,25WBLDC11163-007110,25WBLDA05337-006127,25SBLUM01476-006233"
    },
    "012611": {
        "Stato": "IT",
        "CAP": "67032",
        "Localit\u00e0": "PESCASSEROLI",
        "Indirizzo": "VIA PRINCIPE DI NAPOLI, 3",
        "N.ri Tel.": "0863/91881",
        "Insegna": "GALLINELLI MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDC03119-006951,25WBLDK03101-006047,24WBLDC02314-006631,25SBLDC01222-007108,25SBLDC01221-007108,25SBLUH02109-006526,25SBLDX02235-006648,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUX02255-007101,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUH02191-004547,24WBLDC02290-006646,25SBLUT02110-006526,24WBLDC02018-006648,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLDC02232-007104,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDK03120-006951,25SBLDC02236-006648,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK01375-007378,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDC01279-007111,25WBLDC11163-007110"
    },
    "012617": {
        "Stato": "IT",
        "CAP": "84013",
        "Localit\u00e0": "CAVA DE' TIRRENI",
        "Indirizzo": "VIA CASA GAGLIARDI, SNC - SANT'ARCANGELO",
        "N.ri Tel.": "089 441488",
        "Insegna": "DESY-D",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25SBLDK01249-007111,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDK03495-006047,24WBLDC02064-006100,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "012621": {
        "Stato": "IT",
        "CAP": "87026",
        "Localit\u00e0": "MORMANNO",
        "Indirizzo": "VIA SAN BIASE",
        "N.ri Tel.": "098180366",
        "Insegna": "MODA MANIA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03047-006047,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDB03294-005553,25WBLUL02318-007340,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUA05298-006127,25WBLDC03099-006047,25WBLDK03098-006047,25WBLUC02079-A05958,25WBLUL01316-007012,25WBLDA05337-006127"
    },
    "012678": {
        "Stato": "IT",
        "CAP": "00030",
        "Localit\u00e0": "SAN CESAREO",
        "Indirizzo": "VIA CASILINA, 82/B",
        "N.ri Tel.": "06 62284140",
        "Insegna": "ETAPE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01121-007105,25SBLUC03012-006719,25WBLUC05125-007283,25SBLUX02230-005958,25SBLDH02373-005707,25WBLDA05337-006127,25SBLUP05190-006804,25SBLUT02308-006801,25SBLDP01079-007092,25WBLUA05298-006127,25WBLDC03099-006047,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUP01189-006804,25SBLUF01184-006804,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25SBLUF02188-006804,25WBLUC06082-005480,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDA05335-007349,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUC11207-006787,25SBLDH02387-007144,25SBLDF03076-007092,25SBLUH02191-004547,25WBLGC02391-006648,25SBLUH02192-004547,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDK01375-007378"
    },
    "012703": {
        "Stato": "IT",
        "CAP": "90011",
        "Localit\u00e0": "BAGHERIA",
        "Indirizzo": "CORSO BUTERA, 412",
        "N.ri Tel.": "091/903627",
        "Insegna": "BERTINI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02041-006648,24WBLDK03039-006950,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284"
    },
    "012728": {
        "Stato": "IT",
        "CAP": "15100",
        "Localit\u00e0": "ALESSANDRIA",
        "Indirizzo": "PIAZZETTA DELLA LEGA LOMBARDA",
        "N.ri Tel.": "0131/40003",
        "Insegna": "FANDANGO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDK03101-006047,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK02311-006648,24WBLDK02556-006646,24WBLDC02251-006631,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03495-006047,24WBLDC02064-006100,25WBLDK02192-006648,25WBLUK11140-007286"
    },
    "012744": {
        "Stato": "IT",
        "CAP": "73052",
        "Localit\u00e0": "PARABITA",
        "Indirizzo": "VIA VITTORIO EMANUELE III , 28",
        "N.ri Tel.": "0833/593038",
        "Insegna": "MIRIZIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDC02049-006636,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUC03233-007308,24WBLDC02251-006631,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDC03092-006719,25WBLUC06082-005480"
    },
    "012769": {
        "Stato": "IT",
        "CAP": "30121",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "SESTIERE CANNAREGIO, 5733",
        "N.ri Tel.": "041/5222686",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDX02113-006631"
    },
    "012814": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "POGGIOMARINO",
        "Indirizzo": "VIA ROMA, 53",
        "N.ri Tel.": "081/5283168",
        "Insegna": "OFFICINA STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUH02108-006864,25WBLDK03527-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02110-006526,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC01209-007101,25WBLDC02170-006648,25WBLDL01340-007355,24WBLDC02064-006100,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUC01210-007101,25WBLDC03097-006047,25SBLDC01279-007111,25WBLDC11163-007110,24WBLDC02112-006631"
    },
    "012817": {
        "Stato": "IT",
        "CAP": "80035",
        "Localit\u00e0": "BOSCOFANGONE NOLA",
        "Indirizzo": "C. COMM.LE VULCANO - BUONO LOT.G 116",
        "N.ri Tel.": "0815035208",
        "Insegna": "SANTANGELO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,25SBLUH02193-004547,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02374-006842,24WBLDK11337-006007,24WBLDC03047-006047,25SBLDH02376-006842,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUH02191-004547,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02309-007125,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDC11163-007110,25SBLUB04167-006854,24WBLDC02064-006100,25SBLDH02375-006842,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDK03040-006950,25WBLUC02079-A05958"
    },
    "012827": {
        "Stato": "IT",
        "CAP": "10144",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA SAN DONATO, 48/F",
        "N.ri Tel.": "011-4377924",
        "Insegna": "D'ARE'",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02016-006940,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03084-006976,24WBLDK03039-006950,24WBLDK03040-006950"
    },
    "012851": {
        "Stato": "IT",
        "CAP": "88072",
        "Localit\u00e0": "CIRO' MARINA",
        "Indirizzo": "VIA ROMA,102/104",
        "N.ri Tel.": "096231166",
        "Insegna": "MERCURI",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012895": {
        "Stato": "IT",
        "CAP": "80132",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE CAMPI FLEGREI, 7F/9",
        "N.ri Tel.": "081/8412903",
        "Insegna": "MAGLIO",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012917": {
        "Stato": "IT",
        "CAP": "70023",
        "Localit\u00e0": "GIOIA DEL COLLE",
        "Indirizzo": "VIA ORSINI, 3",
        "N.ri Tel.": "080/3432573",
        "Insegna": "ALEX",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUC11569-006787,25SBLUS01339-007137,24WBLDC02044-006648,25WBLDC03173-007307,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDX02235-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUC01047-007120,24WBLDC02041-006648,25SBLDC02266-007124,25WBLDC03100-006047,25SBLUC04176-006854,25SBLDC01359-007101,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDP04142-007109,25SBLUC02148-007103,25WBLDC03096-006047,25SBLUC02231-005958,25SBLDC02128-007103,25WBLDC03095-006047,25SBLUS01337-007137,25SBLDP01140-007109,25WBLDC02170-006648,24WBLDK02363-005831,25SBLDC02236-006648,25SBLDC04070-007109,25WBLUC06082-005480,24WBLDC02352-006977,25SBLDC01328-007131,25SBLUX02230-005958,25WBLUC02080-005958,25WBLDK03098-006047,25WBLUC02079-A05958,25SBLUC01210-007101,25WBLUL01316-007012,25SBLDC01329-007131,24WBLDC02112-006631"
    },
    "012946": {
        "Stato": "IT",
        "CAP": "70124",
        "Localit\u00e0": "BARI",
        "Indirizzo": "V.LE DELLA REPUBBLICA, 42/44",
        "N.ri Tel.": "080/4769851",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "012950": {
        "Stato": "IT",
        "CAP": "80143",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA NAZIONALE,80",
        "N.ri Tel.": "081-260870",
        "Insegna": "IDEAL MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUH02194-004547,25SBLUH02108-006864,25WBLDK03527-006047,25WBLDC03100-006047,25SBLUC04176-006854,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02177-007284,25SBLDC04333-007109,25SBLUC11214-007111,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25SBLDC01328-007131,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "012953": {
        "Stato": "IT",
        "CAP": "80035",
        "Localit\u00e0": "CIS DI NOLA",
        "Indirizzo": "VIA ISOLA 1, 175",
        "N.ri Tel.": "081-289065",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "013135": {
        "Stato": "IT",
        "CAP": "18100",
        "Localit\u00e0": "IMPERIA",
        "Indirizzo": "VIA DELLA REPUBBLICA, 25",
        "N.ri Tel.": "0183-681239",
        "Insegna": "LEO JEANS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC01047-007120,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02192-004547,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC05357-005831,24WBLDA05465-006127,24WBLDL01420-007016,25SBLDH02373-005707,24WBLDC03252-007008,25WBLDK03102-006047,25SBLDC04066-007109,24WBLDK03040-006950,25SBLUT02315-007117,25WBLDC03099-006047,25WBLUA05298-006127,25SBLDC01279-007111,25WBLDA05337-006127"
    },
    "013232": {
        "Stato": "IT",
        "CAP": "06034",
        "Localit\u00e0": "FOLIGNO",
        "Indirizzo": "PIAZZA DELLA REPUBBLICA N 15-18",
        "N.ri Tel.": "0742/352239",
        "Insegna": "WONDERFUL",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02314-006631,24WBLDC03048-006047,25SBLDC01221-007108,25SBLDC01328-007131,25SBLDC01329-007131,25SBLDC02289-007119,25SBLDC11237-007110,25SBLDS01366-007141,25SBLUC04206-006535,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUH02193-004547,25SBLUH02275-007100,25SBLUS01340-007138,25SBLUT02306-006801,25SBLUT02312-006803"
    },
    "013234": {
        "Stato": "IT",
        "CAP": "06132",
        "Localit\u00e0": "SAN SISTO",
        "Indirizzo": "VIA PIEVAIOLA, 164 C.C. IL TRIANGOLO",
        "N.ri Tel.": "075-5287653",
        "Insegna": "WONDERFUL",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDK02069-006648,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDK03120-006951,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUC02079-A05958"
    },
    "013266": {
        "Stato": "IT",
        "CAP": "46100",
        "Localit\u00e0": "MANTOVA",
        "Indirizzo": "VIA VERDI, 18",
        "N.ri Tel.": "0376/362153",
        "Insegna": "TELAIO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDV02296-007143,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUF01184-006804,25SBLDV03365-007143,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUB01216-007111,25SBLUC04176-006854,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC04206-006535,25SBLDP02345-006855,25SBLDS01366-007141,25SBLUP04322-007129,25SBLDM01473-007166,25WBLDK03103-006047,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDC11163-007110"
    },
    "013310": {
        "Stato": "IT",
        "CAP": "80027",
        "Localit\u00e0": "FRATTAMAGGIORE",
        "Indirizzo": "CORSO FRANCESCO DURANTE, 49",
        "N.ri Tel.": "081/8314945",
        "Insegna": "LES AMIES",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDC03047-006047,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "013345": {
        "Stato": "IT",
        "CAP": "13894",
        "Localit\u00e0": "GAGLIANICO",
        "Indirizzo": "VIA CAMILLO CAVOUR 58,",
        "N.ri Tel.": "039/6957133",
        "Insegna": "BIELLA SCARPE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02018-006648,24WBLDC02290-006646,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDK03037-006950,24WBLDK03052-006047,25SBLUC01210-007101,25SBLUC01211-007101,25SBLUC04206-006535,25SBLUF02188-006804,25SBLUF03186-006804,25SBLUT02313-006818"
    },
    "013355": {
        "Stato": "IT",
        "CAP": "70122",
        "Localit\u00e0": "BARI",
        "Indirizzo": "PIAZZA ALDO MORO 53,",
        "N.ri Tel.": "080/5212290",
        "Insegna": "FERRANDES",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDC03119-006951,24WBLDK03037-006950,25SBLUH02193-004547,25WBLDC02072-006648,25SBLDS01292-007141,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC01222-007108,25SBLDH02374-006842,25SBLUT02346-007132,24WBLDC03036-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDC03100-006047,25SBLDC01359-007101,24WBLDC02290-006646,25SBLUT02110-006526,24WBLDC02018-006648,25SBLUT02313-006818,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUS02336-007137,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUP04322-007129,25WBLDC03095-006047,25SBLDC04331-006788,25SBLUS01337-007137,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUF01055-007092,25SBLUP02352-006855,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUM01479-007167"
    },
    "013361": {
        "Stato": "IT",
        "CAP": "43056",
        "Localit\u00e0": "SOLIERA",
        "Indirizzo": "VIA P. TOGLIATTI, 26/B",
        "N.ri Tel.": "052 2886171",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,25SBLUC11207-006787,24WBLDK03037-006950,25SBLUL02412-007155,25SBLUC02227-007104,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02080-005958,25WBLDC02178-006646,25WBLUC02079-A05958,24WBLDC03036-006950"
    },
    "013403": {
        "Stato": "IT",
        "CAP": "20020",
        "Localit\u00e0": "ARESE",
        "Indirizzo": "VIA GIUSEPPE EUGENIO LURAGHI, 11 UNITA' 160/161",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDK03037-006950,24WBLDC02049-006636,25WBLUK03142-005480,24WBLDC03114-006719,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLGC02391-006648,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDC02290-006646,25SBLUC01211-007101,24WBLDK02043-006648,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUC03012-006719,25WBLDC03092-006719,24WBLDK03120-006951,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDC03097-006047,25WBLKC02429-005958,24WBLDK03346-006047"
    },
    "013417": {
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "VIA TIBERIO SOLIS, 27",
        "N.ri Tel.": "0882/222446",
        "Insegna": "CRISTALLI DONNA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC02234-006648,24WBLDC02314-006631,25SBLDC03003-006950,25SBLDC01222-007108,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDH01432-006971,24WBLDC03038-006950,24WBLDK02556-006646,24WBLDM10408-007022,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDC03007-006950,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDC02064-006100,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,24WBLDF03399-006987,25WBLDC03097-006047"
    },
    "013474": {
        "Stato": "IT",
        "CAP": "47822",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIA TOLMEZZO,34",
        "N.ri Tel.": "06 9275397",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "013522": {
        "Stato": "IT",
        "CAP": "53100",
        "Localit\u00e0": "SIENA",
        "Indirizzo": "VIA DI CALZOLERIA, 1- 5",
        "N.ri Tel.": "0577/226045",
        "Insegna": "ACCORDI",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,24WBLDK03037-006950,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,25WBLUA05299-006127,25SBLUC11215-007110,25SBLUT02346-007132,25SBLUX02147-007103,24WBLDC03047-006047,25SBLDC01358-007101,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUB01216-007111,25SBLUF03186-006804,24WBLDC02290-006646,25WBLDC03096-006047,25SBLDC03007-006950,25SBLDK01249-007111,25WBLDC03095-006047,25SBLDM01473-007166,25WBLDK03102-006047,25WBLUC02079-A05958,25WBLDA05337-006127"
    },
    "013571": {
        "Stato": "IT",
        "CAP": "80074",
        "Localit\u00e0": "CASAMICCIOLA TERME",
        "Indirizzo": "CORSO LUIGI MANZI 61",
        "N.ri Tel.": "081/996880",
        "Insegna": "PISANI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDH02374-006842,25SBLDC01221-007108,25SBLUH02196-004547,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,24WBLDC02041-006648,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC06082-005480,25SBLDH02375-006842,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "013579": {
        "Stato": "IT",
        "CAP": "91100",
        "Localit\u00e0": "TRAPANI",
        "Indirizzo": "VIA G.B. FARDELLA 356",
        "N.ri Tel.": "0923873536",
        "Insegna": "SPADA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDM09261-006645,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUP01350-006855,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUH02195-004547,25SBLUH02108-006864,25SBLUH02242-007100,25WBLDC03100-006047,25WBLDK02073-006648,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUT02309-007125,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUP04354-007129,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03097-006047"
    },
    "013584": {
        "Stato": "IT",
        "CAP": "12042",
        "Localit\u00e0": "BRA",
        "Indirizzo": "VIA CAVOUR, 1",
        "N.ri Tel.": "0172/423059",
        "Insegna": "BARLEN",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDK03212-006990"
    },
    "013632": {
        "Stato": "IT",
        "CAP": "20063",
        "Localit\u00e0": "CERNUSCO SUL NAVIGLIO",
        "Indirizzo": "VIA GIOVANNI BOURDILLON, 43",
        "N.ri Tel.": "02/92111542",
        "Insegna": "BOLLINI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK02042-006648"
    },
    "013670": {
        "Stato": "IT",
        "CAP": "89041",
        "Localit\u00e0": "CAULONIA",
        "Indirizzo": "SAN NICOLA VIA EMILIA",
        "N.ri Tel.": "0964/863490",
        "Insegna": "DE.MO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC08078-006355,25WBLDC03173-007307,24WBLDC03114-006719,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25SBLUC02231-005958,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,24WBLDC02064-006100,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "013693": {
        "Stato": "IT",
        "CAP": "84085",
        "Localit\u00e0": "MERCATO SAN SEVERINO",
        "Indirizzo": "CORSO DIAZ 143",
        "N.ri Tel.": "089825519",
        "Insegna": "LA GIOVANE IDEA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUA04524-007182,25SBLUH02197-004547,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUP02063-007092,25WBLDC03099-006047,25SBLUC01210-007101,25WBLUC02079-A05958,25WBLDC11163-007110"
    },
    "013722": {
        "Stato": "IT",
        "CAP": "84070",
        "Localit\u00e0": "SAN GIOVANNI A PIRO",
        "Indirizzo": "VIA TORRETTA 8 -fraz BOSCO",
        "N.ri Tel.": "0974-980236",
        "Insegna": "IANNUZZI",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "013751": {
        "Stato": "IT",
        "CAP": "83012",
        "Localit\u00e0": "CERVINARA",
        "Indirizzo": "VIA ROMA 14",
        "N.ri Tel.": "0824 838042",
        "Insegna": "KALIMBUSA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25WBLDK02069-006648,25WBLDK03527-006047,24WBLDC02290-006646,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC02080-005958,25WBLDC03099-006047"
    },
    "013757": {
        "Stato": "IT",
        "CAP": "70038",
        "Localit\u00e0": "TERLIZZI",
        "Indirizzo": "VIA PIAVE N 20",
        "N.ri Tel.": "080 3511091",
        "Insegna": "JUST COLLECTION",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDC02251-006631,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDF01398-006987,25WBLDK03102-006047,25WBLDC03099-006047"
    },
    "013796": {
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIA MIRTO, 11",
        "N.ri Tel.": "349-6753489",
        "Insegna": "LE VETRINE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03047-006047,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUC04176-006854,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUS01338-007137,24WBLDC03051-006047,25SBLUC01209-007101,25SBLUH02275-007100,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUM01479-007167"
    },
    "013821": {
        "Stato": "IT",
        "CAP": "80133",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA GIACOMO LEOPARDI, 63",
        "N.ri Tel.": "081 627664",
        "Insegna": "FREE WAY",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03102-006047,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDC01279-007111"
    },
    "013860": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "VIA LORENZO IL MAGNIFICO, 22",
        "N.ri Tel.": "055 8798664",
        "Insegna": "RICICLO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDK03052-006047"
    },
    "013864": {
        "Stato": "IT",
        "CAP": "88018",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "CORSO UMBERTO I, 118",
        "N.ri Tel.": "0963 42301",
        "Insegna": "BONGIOVANNI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUS01339-007137,25WBLUC08078-006355,25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUM01476-006233,24WBLDM09261-006645,25SBLUH02109-006526,25WBLUC02077-006943,25SBLDX02235-006648,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDM13260-006645,24WBLDK11337-006007,25SBLDB04068-007109,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLDF03076-007092,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUT02110-006526,25SBLUH02192-004547,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDK01249-007111,25SBLUS01337-007137,24WBLDC03051-006047,24WBLDB03294-005553,25SBLUF01055-007092,25WBLDK03103-006047,25SBLDC04070-007109,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDF08248-006948,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047,25WBLUC02132-007284"
    },
    "013895": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "POGGIOMARINO",
        "Indirizzo": "VIA XXIV MAGGIO 429,",
        "N.ri Tel.": "0818652711",
        "Insegna": "TOMMASEO GROUP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLKH02555-007188,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,25SBLKP05558-007187,25SBLUT02310-006817,25SBLKF02553-007187,25SBLUC11214-007111,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUP02352-006855,25WBLUC11083-007110,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDK02042-006648,24WBLDC02041-006648,25SBLGP05549-007187,25WBLKC02427-005958,25SBLUF03186-006804,25SBLKP01554-007187,25WBLDC02177-007284,25SBLUH02275-007100,25SBLDH02375-006842,25WBLDC03099-006047,25SBLDC01279-007111,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03038-006950,25SBLUF01184-006804,25SBLUH02108-006864,24WBLDC02290-006646,25SBLKC11440-007111,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25SBBKC01452-007111,24WBLDC02064-006100,25WBLUC02132-007284,25SBLGH02550-007188,25WBLDC11163-007110,25SBLUH02193-004547,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUC11207-006787,25WBLGC02391-006648,25SBLUT02306-006801,25WBLDC02170-006648,25SBLDC01328-007131"
    },
    "013924": {
        "Stato": "IT",
        "CAP": "55011",
        "Localit\u00e0": "ALTOPASCIO",
        "Indirizzo": "VIA DELLE CERBAIE 24",
        "N.ri Tel.": "0583 269107",
        "Insegna": "CREATIVE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC08078-006355,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDK03039-006950,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDC03097-006047,25WBLUK11140-007286"
    },
    "013925": {
        "Stato": "IT",
        "CAP": "52025",
        "Localit\u00e0": "MONTEVARCHI",
        "Indirizzo": "VIA ROMA 149/151,",
        "N.ri Tel.": "055 980073",
        "Insegna": "BECATTINI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308,25WBLUC02080-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355"
    },
    "013926": {
        "Stato": "IT",
        "CAP": "55100",
        "Localit\u00e0": "PICCIORANA",
        "Indirizzo": "VIA PESCIATINA 1299,",
        "N.ri Tel.": "0583 996414",
        "Insegna": "OFFICINA UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUP01189-006804,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUM06481-007168,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUF02188-006804,25SBLUH02275-007100,25SBLUC04168-006788,25SBLUM01486-007172,25SBLUX02230-005958,25SBLUC01281-007105,25SBLUM01476-006233"
    },
    "013969": {
        "Stato": "IT",
        "CAP": "80039",
        "Localit\u00e0": "SAVIANO",
        "Indirizzo": "STRADA PROVINCIALE FRESSURIELLO 9,",
        "N.ri Tel.": "081-8203599",
        "Insegna": "LE FOLLIE DELLA MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLKH02555-007188,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02310-006817,25SBLKF02553-007187,25SBLUC11214-007111,25SBLGF03548-007187,25WBLUC02080-005958,25WBLKC02429-005958,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25SBLGP05549-007187,25WBLKC02427-005958,25SBLUC04206-006535,25SBLKP01554-007187,25SBLUH02275-007100,25SBLDH02375-006842,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02112-006631,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02109-006526,25SBLGF02547-007187,24WBLDM13260-006645,25SBLUF01184-006804,24WBLDC02290-006646,25SBLKC11440-007111,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDX02290-007119,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDK03086-006976,25WBLUC02132-007284,25SBLGH02550-007188,24WBLDC11209-006007,25WBLDC02072-006648,25WBLUC03074-006355,24WBLDK03052-006047,25SBLDH02376-006842,25SBLUC11207-006787,25WBLGC02391-006648,25SBLUH02191-004547,25SBLUT02306-006801,25SBLUB04167-006854,24WBLDM10259-006645"
    },
    "013976": {
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "RONCADELLE",
        "Indirizzo": "VIA PORTICO, 71",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUH02196-004547,25WBBXC02456-005958,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25WBLGC02391-006648,25SBLUH02191-004547,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUH02276-005695,25SBLUC01211-007101,25WBLDC03096-006047,24WBLDC03051-006047,25WBLDC03095-006047,25SBLUC03012-006719,25SBLUX02230-005958,25WBLDA05335-007349,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDC03097-006047,24WBLDK03346-006047"
    },
    "013986": {
        "Stato": "IT",
        "CAP": "25015",
        "Localit\u00e0": "DESENZANO DEL GARDA",
        "Indirizzo": "VIA CASTELLO 6",
        "N.ri Tel.": "030/9911998",
        "Insegna": "MAXIDI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDB03191-007294,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,24WBLDC02112-006631,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC02064-006100,24WBLDK03122-006955,25WBLUC02132-007284,25WBLDK03102-006047,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,24WBLDK03346-006047"
    },
    "013995": {
        "Stato": "IT",
        "CAP": "81030",
        "Localit\u00e0": "CANCELLO ED ARNONE",
        "Indirizzo": "STR. PROV X CAPPELLA REALE",
        "N.ri Tel.": "0823-859008",
        "Insegna": "STRADA FACENDO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUX02255-007101,25WBLUC03233-007308,25WBLDK03527-006047,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC04066-007109,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDC02112-006631"
    },
    "013996": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA NINO BIXIO 16,",
        "N.ri Tel.": " 081-1956779",
        "Insegna": "CIRDEC",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLKH02555-007188,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLKP05558-007187,25SBLUC01121-007105,25SBLUC11214-007111,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLKC02429-005958,25SBLUH02195-004547,25WBLDK03527-006047,25SBLGP05549-007187,25WBLKC02427-005958,25SBLKP01554-007187,25SBLUC01210-007101,25SBLDC01279-007111,24WBLDC02112-006631,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25WBBXC02456-005958,25SBLKF03551-007187,25SBLKC01435-007108,24WBLDC02290-006646,25SBLKC11440-007111,25WBLDC03096-006047,24WBLDC03211-006990,25SBLKT02464-006818,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDC02064-006100,24WBLDC03252-007008,25SBLGH02550-007188,25WBLDC03097-006047,25WBLDC02072-006648,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLGC01441-007111,25WBLGC02391-006648,25SBLGH02495-007144,25WBLDC02170-006648,25SBLUH02199-004547,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "014008": {
        "Stato": "IT",
        "CAP": "10147",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA CHIESA DELLA SALUTE 26/BIS,",
        "N.ri Tel.": "011/2217753",
        "Insegna": "PIAZZETTA 26",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25WBLDC02072-006648,25WBLUC03090-006719,25SBLUA04528-007183,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,25SBLUC11207-006787,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUA04524-007182,25SBLUT02313-006818,25SBLUP04062-007092,25SBLUC02231-005958,25SBLUT02306-006801,25SBLUC11214-007111,25SBLUF01055-007092,25SBLUH02275-007100,25SBLUB04167-006854,25WBLDC03099-006047,25SBLUC01210-007101,25SBLUM01476-006233"
    },
    "014021": {
        "Stato": "IT",
        "CAP": "09096",
        "Localit\u00e0": "SANTA GIUSTA",
        "Indirizzo": "STRADA PROVINCIALE PER ARBOREA KM. 0,400",
        "N.ri Tel.": "0783359046",
        "Insegna": "VESTIS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLDX03008-006950,25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03114-006719,25WBLUC02079-005958,25WBLUC03074-006355,25SBLKF03551-007187,25SBLUC11207-006787,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLKH02555-007188,24WBLDK02042-006648,25SBLUH02108-006864,25SBLDT02125-006526,25WBLGC02391-006648,25WBLDC03100-006047,25SBLUH02348-007132,25SBLUT02110-006526,25SBLUT02312-006803,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDK11162-007110,25SBLKC01445-007101,25SBLUT02310-006817,25SBLKF02553-007187,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDC03092-006719,25WBLDK03103-006047,24WBLDC02064-006100,25SBLUX02230-005958,25SBLDC04066-007109,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "014029": {
        "Stato": "IT",
        "CAP": "98051",
        "Localit\u00e0": "BARCELLONA POZZO DI GOTTO",
        "Indirizzo": "VIA ROMA ANG. VIA MOLETI SNC",
        "Insegna": "PUGLISI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,25SBLUC11541-007110,24WBLDC03038-006950,24WBLDC02041-006648,25WBLGC02391-006648,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDC02290-006646,24WBLDC02018-006648,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC03007-006950,25SBLUP04322-007129,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC01209-007101,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUC02132-007284,25WBLDK03102-006047,25WBLKC02429-005958,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUP02352-006855,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "014041": {
        "Stato": "IT",
        "CAP": "16011",
        "Localit\u00e0": "ARENZANO",
        "Indirizzo": "VIA OLIVETTE 18",
        "N.ri Tel.": "010 9127605",
        "Insegna": "OLIVETTE 2",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,24WBLDK03052-006047,24WBLDK03037-006950,25WBLDC02178-006646,24WBLDK03212-006990,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC03100-006047,24WBLDC03036-006950,25WBLDC02170-006648"
    },
    "014063": {
        "Stato": "IT",
        "CAP": "71017",
        "Localit\u00e0": "TORREMAGGIORE",
        "Indirizzo": "CORSO MATTEOTTI, 143",
        "N.ri Tel.": "0882 386268",
        "Insegna": "LONGO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,24WBLDK03052-006047,25SBLUH02195-004547,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUP04062-007092,25WBLDC03096-006047,24WBLDC03051-006047,25SBLUC11214-007111,25WBLDC02170-006648,25SBLUH02199-004547,25WBLDK03098-006047,25SBLUP02063-007092,25WBLDC03097-006047"
    },
    "014070": {
        "Stato": "IT",
        "CAP": "80014",
        "Localit\u00e0": "GIULIANO IN CAMPANIA",
        "Indirizzo": "VIA SAN FRANCESCO A PATRIA C/C GRANDE SUD",
        "N.ri Tel.": "081 8953793",
        "Insegna": "GALIANO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUH02191-004547,25SBLUC04176-006854,24WBLDC02290-006646,25SBLDC11237-007110,24WBLDC03051-006047,25SBLUC11214-007111,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUC01034-007111,24WBLDC03048-006047,25SBLUC01210-007101,25SBLDC01279-007111"
    },
    "014095": {
        "Stato": "IT",
        "CAP": "84012",
        "Localit\u00e0": "ANGRI",
        "Indirizzo": "VIA ZURLO 13 15",
        "Insegna": "FAST FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02191-004547,25SBLUT02110-006526,25SBLUC01211-007101,25SBLUT02310-006817,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958"
    },
    "014096": {
        "Stato": "IT",
        "CAP": "06128",
        "Localit\u00e0": "PERUGIA",
        "Indirizzo": "VIA MARTIRI DEI LAGER 3",
        "N.ri Tel.": "075-5056161 paolo",
        "Insegna": "LUCERTINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLDH02372-005707,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDX02235-006648,24WBLDC03036-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,25SBLUB01216-007111,25SBLUF03186-006804,25SBLUT02110-006526,24WBLDC02018-006648,25SBLUC02228-007104,25SBLUC02227-007104,24WBLDF08400-006987,25SBLUC04206-006535,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUM01476-006233"
    },
    "014121": {
        "Stato": "IT",
        "CAP": "67039",
        "Localit\u00e0": "SULMONA",
        "Indirizzo": "VIA SALLUSTRIO SNC",
        "N.ri Tel.": "0864/51126",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014127": {
        "Stato": "IT",
        "CAP": "10064",
        "Localit\u00e0": "PINEROLO",
        "Indirizzo": "PIAZZA FACTA, 2",
        "N.ri Tel.": "0121 71325",
        "Insegna": "ZEBRA SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDK03037-006950,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUN02510-007177,24WBLDC03036-006950,25SBLUP01189-006804,25SBLDP01079-007092,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUC03011-006719,25SBLUF01184-006804,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUT02312-006803,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUF02188-006804,25SBLDF08078-007092,25WBLDK03495-006047,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUF03185-006804"
    },
    "014133": {
        "Stato": "IT",
        "CAP": "22100",
        "Localit\u00e0": "COMO",
        "Indirizzo": "VIA BERNARDINO LUINI, 1",
        "N.ri Tel.": "031/265843",
        "Insegna": "BUTTI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLDC02072-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDX02235-006648,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUB01216-007111,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDK02363-005831,25SBLUX02230-005958,25WBLUA05298-006127,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUA05297-006127,24WBLDC02112-006631"
    },
    "014144": {
        "Stato": "IT",
        "CAP": "08100",
        "Localit\u00e0": "NUORO",
        "Indirizzo": "VIA BELLISSARIO, 113 - Z.I. PATROSARDO",
        "N.ri Tel.": "348 2292933",
        "Insegna": "TENDENZE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDK03039-006950,25SBLUT02310-006817,25WBLUC03086-006047,25WBLUC05125-007283,25SBLUX02230-005958,25WBLUK03142-005480,25WBLKC11416-007110,25SBLUT02308-006801,24WBLDC02314-006631,25SBLUH02196-004547,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC02177-007284,25WBLDC03099-006047,25WBLUL01316-007012,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,24WBLDC03038-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,25SBLUL02402-007153,25WBLDC11163-007110,25WBLDC02072-006648,25SBLUH02193-004547,24WBLDC03114-006719,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25WBLGC02391-006648,25SBLUH02191-004547,25SBLUH02192-004547,25WBLDK11162-007110,25SBLUT02306-006801,25WBLDC02170-006648,25WBLUC02079-A05958"
    },
    "014165": {
        "Stato": "IT",
        "CAP": "10092",
        "Localit\u00e0": "BEINASCO",
        "Indirizzo": "STRADA TORINO, 34/36 C/o C.C. LE FORNACI",
        "N.ri Tel.": "366-3007180",
        "Insegna": "MAKAKO",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLUS01339-007137,25WBLUC08078-006355,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25SBLKH02555-007188,25SBLUS01341-007136,24WBLDK03039-006950,25SBLUP04062-007092,25SBLDC11237-007110,25SBLKP05558-007187,25SBLUC01121-007105,25SBLKF02553-007187,25SBLUH02241-007100,25SBLDH02386-007144,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUH02030-006846,25WBLUC11083-007110,25WBLKC11416-007110,24WBLDC02314-006631,25SBLUH02196-004547,25SBLUS02336-007138,24WBLDK02556-006646,25SBLUH02195-004547,25WBLDK03527-006047,25SBLGP05549-007187,25SBLUC04206-006535,25SBLDK01249-007111,25SBLKP01554-007187,25SBLUF01055-007092,25WBLDK03495-006047,25SBLUH01149-007100,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUK11140-007286,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,24WBLDA05467-006434,25SBLDC03003-006950,25SBLUH02109-006526,25SBLKF03551-007187,25SBLUC01119-007105,25SBLUC01115-007105,24WBLDC03038-006950,25SBLUH02108-006864,25SBLUH02244-007100,25SBLKX02418-005958,25WBLDC03096-006047,25SBLUS02336-007137,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDC11163-007110,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,25SBLUC02280-005958,24WBLDK03052-006047,25SBLUC11207-006787,25SBLKC06443-007101,25WBLGA05461-007349,25SBLUB01216-007111,25SBLUH02192-004547,25SBLUC02228-007104,25SBLUH02199-004547,25SBLUH05028-006846,25SBLUT02315-007117,25WBLUA05297-006127"
    },
    "014178": {
        "Stato": "IT",
        "CAP": "81020",
        "Localit\u00e0": "SAN MARCO EVANGELISTA",
        "Indirizzo": "STRADA STATALE 265 KM 26.200",
        "Insegna": "MASSARO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02064-006100,24WBLDC02290-006646,24WBLDC02314-006631,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDK02042-006648,24WBLDK02556-006646,24WBLDK03052-006047,24WBLDK11337-006007,25SBLDC01279-007111,25SBLDC01328-007131,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC04206-006535,25SBLUC11541-007110,25SBLUH02108-006864,25SBLUH02191-004547,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUT02110-006526,25SBLUT02306-006801"
    },
    "014199": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "SAN GIOVANNI GEMINI",
        "Indirizzo": "PIAZZA PURRELLO 1",
        "N.ri Tel.": "0922-901174",
        "Insegna": "PARG",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUC01211-007101,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC01209-007101,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02132-007284,25SBLUH02199-004547,25WBLDK03102-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUC01281-007105"
    },
    "014201": {
        "Stato": "IT",
        "CAP": "87032",
        "Localit\u00e0": "AMANTEA",
        "Indirizzo": "VIA MARGHERITA 62",
        "N.ri Tel.": "0982/424546",
        "Insegna": "KAOS UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25SBLUH02194-004547,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUC01219-007108,25SBLUC02227-007104,25WBLUC03086-006047,25WBLUC05125-007283,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUL02583-007370,25WBLUK03142-005480,25WBLUC03090-006719,25SBLUH02109-006526,25SBLUL02412-007155,25SBLUH02108-006864,25SBLUT02309-007125,25SBLUS01342-007136,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUH02191-004547,25SBLUM12488-007170,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUT02306-006801,25SBLUC04082-007159,25WBLUC02079-A05958,25SBLUT02315-007117"
    },
    "014206": {
        "Stato": "IT",
        "CAP": "10024",
        "Localit\u00e0": "MONCALIERI",
        "Indirizzo": "VIA POSTIGLIONE 1- C.C 45o Parallelo",
        "N.ri Tel.": "011-6471474",
        "Insegna": "TRIBECA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03084-006976,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03039-006950"
    },
    "014211": {
        "Stato": "IT",
        "CAP": "66034",
        "Localit\u00e0": "LANCIANO",
        "Indirizzo": "VIA SANTO SPIRITO , 119",
        "N.ri Tel.": "0872712288",
        "Insegna": "OT STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,25WBLDK03527-006047,25SBLUH02191-004547,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDK05019-007298,25SBLUC11214-007111,25WBLDC02170-006648,25WBLUC03086-006047,25SBLUH02275-007100,25SBLUX02230-005958,25WBLDC03099-006047,25SBLUF03185-006804"
    },
    "014255": {
        "Stato": "IT",
        "CAP": "09044",
        "Localit\u00e0": "QUARTUCCIU",
        "Indirizzo": "VIA DELLE SERRE SNC",
        "N.ri Tel.": "070 8801251",
        "Insegna": "BACKSTAGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUC11207-006787,24WBLDC03038-006950,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC01209-007101,25WBLDC02170-006648,25SBLUH02275-007100,25SBLUX02230-005958,25SBLUP02352-006855,25SBLUC01217-007108"
    },
    "014269": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "SALITA SOLIMENA - PARCO PALLADINO-",
        "N.ri Tel.": "081-18676991",
        "Insegna": "SEVEN",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02064-006100,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02556-006646,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03052-006047,24WBLDK03052-006047,24WBLDK03052-006047"
    },
    "014293": {
        "Stato": "IT",
        "CAP": "98071",
        "Localit\u00e0": "CAPO D'ORLANDO",
        "Indirizzo": "VIA CRISPI 41/43",
        "N.ri Tel.": "0941-912488",
        "Insegna": "MANGANO",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUH02108-006864,25WBLGC02391-006648,25SBLUH02191-004547,25WBLKC02427-005958,24WBLDK03039-006950,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02079-A05958,25SBLUP02352-006855,25WBLKC02429-005958"
    },
    "014295": {
        "Stato": "IT",
        "CAP": "61043",
        "Localit\u00e0": "CAGLI",
        "Indirizzo": "PIAZZA MATTEOTTI 11",
        "N.ri Tel.": "0721 781795",
        "Insegna": "TOPI ROSALBA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02352-006977,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03040-006950,24WBLDK03120-006951"
    },
    "014341": {
        "Stato": "IT",
        "CAP": "73043",
        "Localit\u00e0": "COPERTINO",
        "Indirizzo": "VIA MARIANO ANGOLO VIA BATTISTI SNC",
        "N.ri Tel.": " 0832932939",
        "Insegna": "GYF",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03090-006719,25SBLDH02372-005707,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,25SBLUB01216-007111,25SBLDC01359-007101,25SBLDH02389-007144,25SBLUH02192-004547,25SBLUC01211-007101,25SBLUC04206-006535,25SBLDH02370-006845,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC06082-005480"
    },
    "014348": {
        "Stato": "IT",
        "CAP": "96010",
        "Localit\u00e0": "SORTINO",
        "Indirizzo": "VIA LIBERTA' 101",
        "Insegna": "ELVIRA BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDK03212-006990,25WBLDC03095-006047,25SBLUC01209-007101,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLDC03099-006047,24WBLDK03040-006950,25WBLUC02079-A05958"
    },
    "014362": {
        "Stato": "IT",
        "CAP": "06089",
        "Localit\u00e0": "TORGIANO",
        "Indirizzo": "VIA VIRGILIO MARONE 47",
        "N.ri Tel.": "075 9888182",
        "Insegna": "FAUSTO MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25SBLUH02194-004547,25WBLDC03100-006047,25SBLUT02110-006526,25SBLUP04353-007129,25WBLUC03086-006047,25WBLUC02080-005958,25WBLUC11083-007110,25WBLUK03142-005480,25SBLDC02234-006648,24WBLDC02314-006631,24WBLDK02042-006648,25WBLKC02427-005958,24WBLDC02018-006648,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUC04176-006854,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLDK03102-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25WBLGC02391-006648,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUT02313-006818,25WBLDK11162-007110,25WBLDC02170-006648,25SBLUB04167-006854,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "014371": {
        "Stato": "IT",
        "CAP": "94100",
        "Localit\u00e0": "ENNA",
        "Indirizzo": "VIA PERGUSINA 21",
        "N.ri Tel.": "0935 956084",
        "Insegna": "MANBITUS",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02556-006646,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03039-006950"
    },
    "014389": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "MARSICOVETERE",
        "Indirizzo": "VIA NAZIONALE 21",
        "N.ri Tel.": "0975 354447",
        "Insegna": "COIRO",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUC11215-007110,25SBLDX02235-006648,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUH02242-007100,25WBLDB03191-007294,24WBLDK03039-006950,25SBLUC02231-005958,25SBLDC03007-006950,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02241-007100,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLDC02236-006648,25SBLUH02275-007100,25SBLDC04070-007109,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02132-007284,25WBLUC02079-A05958,25WBLDC03097-006047"
    },
    "014395": {
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA DELLE PUGLIE 174",
        "N.ri Tel.": "081-7597236",
        "Insegna": "FARAONE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDK02042-006648,24WBLDK03052-006047"
    },
    "014398": {
        "Stato": "IT",
        "CAP": "38066",
        "Localit\u00e0": "SELVA DI CADORE",
        "Indirizzo": "VIA S.FOSCA 13",
        "N.ri Tel.": "0464 556168",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014427": {
        "Stato": "IT",
        "CAP": "80030",
        "Localit\u00e0": "SAN PAOLO BEL SITO",
        "Indirizzo": "STRADA PROVINCIALE PER LIVERI 15",
        "N.ri Tel.": "338-8411311",
        "Insegna": "SINISCALCHI",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUP01350-006855,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02108-006864,25WBLDK03527-006047,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC04206-006535,24WBLDC03051-006047,25WBLDK03103-006047,25SBLUP02352-006855,24WBLDC02112-006631"
    },
    "014441": {
        "Stato": "IT",
        "CAP": "85021",
        "Localit\u00e0": "AVIGLIANO",
        "Indirizzo": "VIA ROMA 181",
        "N.ri Tel.": "0971/700712",
        "Insegna": "VIA ROMA 181 ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDH02374-006842,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDB03191-007294,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC02227-007104,25SBLUC04206-006535,25SBLUT02310-006817,24WBLDC03051-006047,25SBLUH02275-007100,25SBLDH02375-006842,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "014448": {
        "Stato": "IT",
        "CAP": "58014",
        "Localit\u00e0": "MANCIANO",
        "Indirizzo": "VIA VERDI, 6",
        "N.ri Tel.": "075 800 4272",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02042-006648"
    },
    "014476": {
        "Stato": "IT",
        "CAP": "70127",
        "Localit\u00e0": "BARI",
        "Indirizzo": "SANTO SPIRITO VIA NAPOLI 87",
        "N.ri Tel.": "3333586062",
        "Insegna": "STELLACCI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDC03119-006951,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01222-007108,24WBLDM09261-006645,25SBLDH02374-006842,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDM13260-006645,25SBLDH02376-006842,25SBLUC11207-006787,25SBLUL02412-007155,25WBLUC03233-007308,25SBLUH02194-004547,25SBLDL02396-007152,25SBLUH02195-004547,25SBLDT02125-006526,25SBLUM01478-007167,25SBLUA04524-007182,24WBLDC02290-006646,25SBLUC01219-007108,25SBLUT02313-006818,25SBLUP04062-007092,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDF08400-006987,25SBLDK01249-007111,25SBLUP04353-007129,24WBLDC03051-006047,25SBLDC04333-007109,25SBLDP05141-007109,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUH02199-004547,25WBLDC03099-006047,25WBLDK03098-006047,25SBLUP02063-007092,25WBLDC03097-006047"
    },
    "014510": {
        "Stato": "IT",
        "CAP": "20094",
        "Localit\u00e0": "CORSICO",
        "Indirizzo": "VIA MILANO 25,",
        "N.ri Tel.": "02/4473871",
        "Insegna": "PANDA SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25WBLUC03090-006719,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDB03191-007294,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLDK03098-006047"
    },
    "014533": {
        "Stato": "IT",
        "CAP": "81030",
        "Localit\u00e0": "SANT'ARPINO",
        "Indirizzo": "VIA MARTIRI ATELLANI 169",
        "N.ri Tel.": "081-5011685",
        "Insegna": "KAOS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02108-006864,25WBLDK03527-006047,25WBLGC02391-006648,25WBLDC03100-006047,25WBLKC02427-005958,25SBLUH02197-004547,24WBLDC02290-006646,25WBLUC02151-007287,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLKC03400-007308,25SBLDC01279-007111,25WBLKC02429-005958"
    },
    "014535": {
        "Stato": "IT",
        "CAP": "00135",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA INZAGO 117",
        "N.ri Tel.": "06 5898254",
        "Insegna": "CASTELLESE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC08078-006355,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDX02113-006631,24WBLDK03052-006047,24WBLDC03047-006047,25WBLGC02391-006648,25WBLDB03191-007294,24WBLDB02092-006976,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,24WBLDK03086-006976,24WBLDC02064-006100,24WBLDC02352-006977,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLDC03097-006047,25WBLUC02079-A05958"
    },
    "014548": {
        "Stato": "IT",
        "CAP": "00055",
        "Localit\u00e0": "LADISPOLI",
        "Indirizzo": "VIALE ITALIA 75",
        "N.ri Tel.": "06/99222143",
        "Insegna": "ANTINORI",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUP03539-006873,25SBLUN01521-006581,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUT02346-007132,25SBLUL02412-007155,25SBLUF01184-006804,25SBLUH02108-006864,25SBLUH02191-004547,25SBLUA04524-007182,25SBLUH02197-004547,25SBLUT02110-006526,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUC03012-006719,25SBLUC03013-006719,25SBLUX02230-005958"
    },
    "014565": {
        "Stato": "IT",
        "CAP": "71042",
        "Localit\u00e0": "CERIGNOLA",
        "Indirizzo": "VIA PEBLISCITO",
        "Insegna": "ORLANDO MICHELE",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUC11207-006787,25SBLUH02194-004547,25SBLUH02108-006864,25SBLUX03226-006719,25SBLUM01478-007167,25SBLUC04176-006854,25SBLUH02197-004547,25SBLUH02244-007100,25SBLUH02241-007100,25SBLUF01055-007092,25WBLUC03086-006047,25SBLUH02275-007100,25SBLUP02063-007092"
    },
    "014569": {
        "Stato": "IT",
        "CAP": "55012",
        "Localit\u00e0": "CAPANNORI",
        "Indirizzo": "VIA PESCIATINA 562/BIS,",
        "N.ri Tel.": "0583928073",
        "Insegna": "MENCARI",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBLDK03101-006047,25WBLUC08078-006355,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUP01189-006804,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLGC02391-006648,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUH02275-007100,25SBLUM01486-007172,25SBLUC04168-006788,25WBLDK03495-006047,25SBLUH05028-006846,25WBLDK03098-006047,25SBLUC01281-007105"
    },
    "014590": {
        "Stato": "IT",
        "CAP": "00133",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DEI RUDERI DI TORRENOVA, 25",
        "N.ri Tel.": "06/2005495",
        "Insegna": "L' ELEFANTINO STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05467-006434,24WBLDC02041-006648,24WBLDC03051-006047,24WBLDH01432-006971,24WBLDH02433-006971,24WBLDK02042-006648,24WBLDK03086-006976"
    },
    "014603": {
        "Stato": "IT",
        "CAP": "80012",
        "Localit\u00e0": "CALVIZZANO",
        "Indirizzo": "VIALE DELLA REPUBBLICA 4 6",
        "Insegna": "MITI & MODE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02018-006648,24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02112-006631,24WBLDC02290-006646,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDF08400-006987,24WBLDK02042-006648,24WBLDK02556-006646,24WBLDK03052-006047,24WBLDK03086-006976,24WBLDM10259-006645,24WBLDM13260-006645,25SBLDC01221-007108,25SBLDC01279-007111,25SBLDC11237-007110,25SBLUC01210-007101,25SBLUC01211-007101,25SBLUC11207-006787,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUF01055-007092,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUP02063-007092,25SBLUP05190-006804,25SBLUX02230-005958,25SBLUX02255-007101"
    },
    "014619": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "PRATO",
        "Indirizzo": "VIA FABIO FILZI, 39/G",
        "N.ri Tel.": "0574/42371",
        "Insegna": "SPGJ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUP05190-006804,25WBLUC03090-006719,24WBLDC03114-006719,24WBLDC03295-006857,25SBLDC01279-007111,25SBLUH02196-004547,25SBLUP01189-006804,24WBLDC03047-006047,25SBLDC01358-007101,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUH02195-004547,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02197-004547,25SBLUP04062-007092,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLUF03119-007121,25WBLDC02170-006648,24WBLDC02250-007008,25SBLUF01055-007092,25WBLDC03092-006719,25WBLUC03086-006047,25SBLUH02275-007100,24WBLDX03280-006719,25SBLDC01328-007131,25WBLDK03102-006047,25SBLUC01281-007105"
    },
    "014625": {
        "Stato": "IT",
        "CAP": "60027",
        "Localit\u00e0": "OSIMO",
        "Indirizzo": "CORSO MAZZINI, 47",
        "N.ri Tel.": "328/6445076",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03297-006992,25SBLUM12488-007170,25SBLUS01339-007137"
    },
    "014626": {
        "Stato": "IT",
        "CAP": "70043",
        "Localit\u00e0": "MONOPOLI",
        "Indirizzo": "CORSO UMBERTO I, 34",
        "Insegna": "RINASCENTE SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUN02510-007177,25SBLUC01046-007120,25WBLUC03233-007308,25WBLDK03527-006047,25SBLDH02377-007144,25SBLUP05355-007139,25WBLDC03096-006047,25SBLUS02336-007137,25SBLUC04206-006535,25SBLDP02345-006855,25SBLUP04322-007129,25SBLUS01338-007137,25SBLUT02310-006817,25WBLDC03095-006047,25WBLUC03086-006047,24WBLDK03120-006951,25SBLDC01328-007131,25SBLUP04353-007139,25SBLUP03534-006873,25SBLUH02030-006846"
    },
    "014635": {
        "Stato": "IT",
        "CAP": "87036",
        "Localit\u00e0": "RENDE",
        "Indirizzo": "PIAZZA MARTIN LUTHER KING",
        "N.ri Tel.": "0984462363",
        "Insegna": "DO & BIZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUL02412-007155,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDK03039-006950,25SBLKX02418-005958,25WBLDC03096-006047,25SBLUC02231-005958,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDK03495-006047,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLUL01316-007012"
    },
    "014646": {
        "Stato": "IT",
        "CAP": "85040",
        "Localit\u00e0": "LAURIA",
        "Indirizzo": "CONTRADA GALDO ZONA F4 SNC",
        "N.ri Tel.": "0973620120",
        "Insegna": "CITY SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC08078-006355,25WBLDC03173-007307,25WBLDK01376-007378,25WBLUC02079-005958,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLKH02555-007188,25WBLDC03100-006047,25SBLDC11237-007110,25SBLKF02553-007187,25SBLDH02386-007144,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDH02373-005707,25SBLUH02030-006846,25WBLKC02429-005958,25SBLDC01222-007108,25SBLDH02374-006842,24WBLDK02556-006646,25WBLKC02427-005958,25SBLUS01338-007137,25SBLUH02275-007100,25SBLDC04070-007109,25WBLDC03099-006047,25SBLDX03008-006950,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDA05467-006434,25SBLKF03551-007187,25SBLUH02197-004547,24WBLDC02290-006646,25SBLDP04142-007109,25SBLKX02418-005958,24WBLDC03211-006990,24WBLDF08400-006987,25SBLUS01337-007137,24WBLDC03051-006047,25SBLDC04333-007109,25SBLDP01140-007109,25WBLDK03103-006047,24WBLDA05465-006127,24WBLDF03399-006987,25SBLDS01292-007141,25SBLUL02582-007370,25SBLKF08561-007187,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02376-006842,25WBLGC02391-006648,24WBLDB02092-006976,25SBLUH02192-004547,25SBLUK11239-007110,25SBLDF03257-007113,25WBLDC02170-006648,25SBLUC04163-006788"
    },
    "014649": {
        "Stato": "IT",
        "CAP": "87028",
        "Localit\u00e0": "PRAIA A MARE",
        "Indirizzo": "PIAZZA ITALIA, 19",
        "Insegna": "GIO' YOUR IDENTITY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25WBLDP01291-007324,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLUC03012-006719,24WBLDK03120-006951,25WBLUC05125-007283,25SBLUC03013-006719,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUP02352-006855,25WBLUC11083-007110,24WBLDC03084-006976,25SBLUP05190-006804,25WBLUK03142-005480,25SBLDC02234-006648,25WBLDC02196-007283,25SBLUC03011-006719,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUX03226-006719,25SBLUP04322-007129,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUP02063-007092,25WBLDF08236-007301,24WBLDK03037-006950,25SBLDC03003-006950,25SBLUH02109-006526,24WBLDC03038-006950,25SBLUH02108-006864,24WBLDC02290-006646,25SBLDC02264-006648,25WBLDC03096-006047,25SBLUT02309-007125,25SBLDC03007-006950,25WBLDC03095-006047,25SBLUS01342-007136,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02064-006100,25WBLDK03102-006047,25WBLDC03097-006047,25SBLUC11569-006787,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUH02191-004547,25SBLUT02306-006801"
    },
    "014650": {
        "Stato": "IT",
        "CAP": "74121",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA LIGURIA 49",
        "N.ri Tel.": "099 7313273",
        "Insegna": "JUNIOR PRIDE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02314-006631,24WBLDC02352-006977,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDK02042-006648"
    },
    "014651": {
        "Stato": "IT",
        "CAP": "89063",
        "Localit\u00e0": "MELITO DI PORTO SALVO",
        "Indirizzo": "VIA NAZIONALE",
        "N.ri Tel.": "0965-789911",
        "Insegna": "GIANNI FOTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03173-007307,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01211-007101,25WBLUC03086-006047,24WBLDK03120-006951,25SBLDF08078-007092,25WBLUL02318-007340,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUL02583-007370,25WBLKC03400-007308,25WBLKC02429-005958,25WBLUC11083-007110,24WBLDC03084-006976,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDP01079-007092,24WBLDK02556-006646,25SBLDL02396-007152,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUP04322-007129,25SBLUF01055-007092,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUL01316-007012,24WBLDC03119-006951,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUL02412-007155,24WBLDC03038-006950,24WBLDC02290-006646,25SBLDC02264-006648,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLUC06082-005480,25WBLUC02132-007284,24WBLDC11209-006007,25WBLDC02072-006648,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLDF03076-007092,25WBLDL01346-007354"
    },
    "014674": {
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA ASTALONGA 98",
        "Insegna": "CIVICO 66",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUH02196-004547,25WBBXC02456-005958,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25WBLGC02391-006648,25SBLUH02191-004547,25WBBXC02454-007110,25WBLKC02427-005958,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC02232-007104,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLKC03400-007308,25WBLDC11163-007110"
    },
    "014792": {
        "Stato": "RU",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA LUNGOLAGO REGINA ADELAIDE, 36",
        "N.ri Tel.": "045 7256884",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014925": {
        "Stato": "IT",
        "CAP": "10122",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GARIBALDI, 18/D",
        "N.ri Tel.": "0114363058",
        "Insegna": "CLASS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUH02193-004547,24WBLDC03084-006976,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUC11207-006787,25WBLUC03233-007308,25WBLDK03527-006047,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02310-006817,24WBLDC03051-006047,24WBLDB03294-005553,25SBLUC03012-006719,25SBLUX02230-005958,25SBLDC03006-006950,25SBLUC01210-007101"
    },
    "014926": {
        "Stato": "RU",
        "CAP": "65123",
        "Localit\u00e0": "PESCARA",
        "Indirizzo": "VIA NAZIONALE ADRIATICA NORD, 60",
        "N.ri Tel.": "+7(903)422-888-1",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014938": {
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "MISTERBIANCO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "095475432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03038-006950"
    },
    "014958": {
        "Stato": "IT",
        "CAP": "000049",
        "Localit\u00e0": "VELLETRI",
        "Indirizzo": "VIALE BRUNO BUOZZI, 66/74",
        "N.ri Tel.": "06 963 3238",
        "Insegna": "ANTIDOTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03047-006047,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUH02108-006864,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUH02241-007100,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25SBLUX02230-005958,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUM01479-007167,25SBLUM01476-006233"
    },
    "014967": {
        "Stato": "IT",
        "CAP": "00133",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE SAN LORENZO, 60",
        "N.ri Tel.": "06/2005495",
        "Insegna": "L' ELEFANTINO STORE",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02196-004547,25SBLDX02235-006648,25SBLUP01189-006804,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK02042-006648,25SBLUH02191-004547,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUT02306-006801,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25SBLDC01328-007131,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25SBLUP02063-007092"
    },
    "014992": {
        "Stato": "IT",
        "CAP": "71010",
        "Localit\u00e0": "LESINA",
        "Indirizzo": "VIA RAFFAELE CENTONZA, 20",
        "N.ri Tel.": "0882 216709",
        "Insegna": "FRIZZI E LAZZI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLUC02079-005958,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUC01219-007108,25SBLUT02110-006526,25SBLUP04062-007092,25SBLUC11083-007106,24WBLDC02352-006977,25WBLUC02080-005958,25WBLUC11083-007110,25SBLDC01222-007108,25SBLUC01046-007120,25SBLDB04068-007109,25SBLUC01047-007120,25SBLUH02195-004547,25SBLUC04206-006535,25SBLUF01055-007092,25SBLUH02275-007100,25SBLDC04070-007109,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUH02108-006864,25SBLUH02197-004547,24WBLDC02290-006646,25SBLDP04142-007109,24WBLDC03211-006990,25SBLDC04331-006788,24WBLDC03051-006047,25SBLDC04333-007109,25WBLUC06082-005480,25WBLDC03097-006047,25SBLUC11569-006787,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUH02191-004547,25SBLUB01216-007111,25WBLDC02170-006648,25WBLUC02079-A05958,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "014993": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA CIRCUMVALLAZIONE ESTERNA, 96/98",
        "N.ri Tel.": "081 7593838",
        "Insegna": "CHARME AND MORE",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,24WBLDC02044-006648,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,24WBLDC02314-006631,25SBLDC01221-007108,25SBLDH02374-006842,25SBLDF03201-006804,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUS02336-007138,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDP05205-006804,25SBLUH02108-006864,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,24WBLDC03211-006990,24WBLDF08400-006987,24WBLDK03212-006990,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLDH02375-006842,25SBLDC01328-007131,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC11163-007110"
    },
    "015004": {
        "Stato": "IT",
        "CAP": "26100",
        "Localit\u00e0": "CREMONA",
        "Indirizzo": "CORSO MAZZINI, 1",
        "N.ri Tel.": "0372/29280",
        "Insegna": "OLIVER",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01211-007101,25SBLUC02228-007104,25SBLUC11207-006787,25SBLUF01184-006804,25SBLUF02188-006804,25SBLUH02193-004547"
    },
    "015005": {
        "Stato": "IT",
        "CAP": "71121",
        "Localit\u00e0": "FOGGIA",
        "Indirizzo": "C.SO VITTORIO EMANUELE,86",
        "N.ri Tel.": "0881-587803",
        "Insegna": "SIMONE COLLECTION",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,24WBLDK03037-006950,25SBLDH02372-005707,24WBLDC02044-006648,25SBLUP05190-006804,25WBLKC11416-007110,25WBLDC02178-006646,25SBLUT02308-006801,25SBLDC03003-006950,25WBBXC02456-005958,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUS02336-007138,25SBLUH02194-004547,25SBLUX02255-007101,25SBLKH02555-007188,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUH02242-007100,25SBLKP05564-007187,25SBLGP05549-007187,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUH02244-007100,25SBLUH02192-004547,25SBLKP05558-007187,25SBLGH02550-007188,25SBLDC03007-006950,25SBLGH02495-007144,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25SBLDH02386-007144,25WBLDK03103-006047,25SBLDC03006-006950,25SBLDH02373-005707,25SBLUH02199-004547,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUP02063-007092,25SBLGH02492-007144,25WBLDK03098-006047,25WBLDC03097-006047,25WBLDK03102-006047"
    },
    "015023": {
        "Stato": "IT",
        "CAP": "80057",
        "Localit\u00e0": "SANT'ANTONIO",
        "Indirizzo": "VIA SANTA MARIA LA CARITA', 415",
        "N.ri Tel.": "081 8741741",
        "Insegna": "SANTONICOLA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02310-006817,25SBLUC11214-007111,25WBLUC02080-005958,24WBLDC03048-006047,25WBLUK03142-005480,25SBLDH02374-006842,25SBLUP01350-006855,24WBLDK02556-006646,25SBLUH02195-004547,25WBLDK03527-006047,25SBLDH02375-006842,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03037-006950,24WBLDC02044-006648,25SBLUH02109-006526,24WBLDH01432-006971,24WBLDC03038-006950,25SBLUH02108-006864,24WBLDC02290-006646,25SBLUH02244-007100,25WBLDC03096-006047,24WBLDF08400-006987,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDA05465-006127,24WBLDM01427-005794,25WBLDC03097-006047,25WBLUC03074-006355,24WBLDC03036-006950,25SBLDH02376-006842,25SBLUH02191-004547,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK01375-007378"
    },
    "015034": {
        "Stato": "IT",
        "CAP": "11100",
        "Localit\u00e0": "AOSTA",
        "Indirizzo": "VIA AUBERTI , 26",
        "N.ri Tel.": "0165 363544",
        "Insegna": "NEAPOLIS",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK11337-006007,24WBLDK02042-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDC02018-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDA05337-006127"
    },
    "015035": {
        "Stato": "IT",
        "CAP": "60019",
        "Localit\u00e0": "SENIGALLIA",
        "Indirizzo": "VIA GUGLIELMO OBERDAN,4",
        "N.ri Tel.": "071-79821811",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02313-006818,25SBLUX01218-007108,24WBLDK02353-006985,24WBLDM09261-006645,24WBLDK02363-005831"
    },
    "015051": {
        "Stato": "IT",
        "CAP": "89029",
        "Localit\u00e0": "TAURIANOVA",
        "Indirizzo": "VIALE PROFESSOR VINCENZO RICCI, 84",
        "N.ri Tel.": "0966/612417",
        "Insegna": "CORICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUF01184-006804,24WBLDC02041-006648,24WBLDK02353-006985,24WBLDC02251-006631,25WBLDB03191-007294,25WBLDC03100-006047,25WBLDK02073-006648,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUT02313-006818,24WBLDC02018-006648,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02310-006817,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDK03103-006047,24WBLDK03120-006951,25SBLUC03013-006719,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25SBLUH05028-006846,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLUL01316-007012"
    },
    "015054": {
        "Stato": "IT",
        "CAP": "74121",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA C.BATTISTI ANG. VICO S.GIO, 55/A",
        "N.ri Tel.": "099 4774653",
        "Insegna": "MALIZIA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC03173-007307,25WBLDK01376-007378,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,24WBLDM10408-007022,25WBLDC03100-006047,25SBLUP04062-007092,25SBLDC11237-007110,25SBLUT02310-006817,25SBLUP04353-007129,25SBLUC03012-006719,25SBLUC04168-006788,25SBLUP04354-007129,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDV01146-007107,25WBLUC11083-007110,25SBLUT02308-006801,24WBLDC02314-006631,25SBLUH02195-004547,25SBLUM01478-007167,24WBLDM04562-007021,25SBLUF01055-007092,25SBLDC04070-007109,25WBLDC03099-006047,25SBLDX03008-006950,24WBLDC03119-006951,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDH01432-006971,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDP01140-007109,25SBLUS01342-007136,25WBLUC06082-005480,25SBLDC03006-006950,24WBLDF03399-006987,25WBLDC03097-006047,25SBLDC02233-007104,25SBLUC11569-006787,25SBLUH02193-004547,25SBLDS01292-007141,25SBLDV02296-007143,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02387-007144,25SBLUH02191-004547,25SBLUT02313-006818,25WBLDM01463-007330,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUH02199-004547,25WBLDK03098-006047"
    },
    "015068": {
        "Stato": "IT",
        "CAP": "80069",
        "Localit\u00e0": "VICO EQUENSE",
        "Indirizzo": "CORSO UMBERTO I, 14",
        "N.ri Tel.": "0818027652",
        "Insegna": "COVI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDC02041-006648,25WBLDK03527-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC02080-005958,25SBLDC01328-007131,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "015070": {
        "Stato": "IT",
        "CAP": "76016",
        "Localit\u00e0": "MARGHERITA DI SAVOIA",
        "Indirizzo": "CORSO VITTORIO EMANUELE 15",
        "N.ri Tel.": "0883/657314",
        "Insegna": "NAPOLITANO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,25WBLUC03074-006355,25WBLUL01316-007012,25WBLUC02077-006943,24WBLDL01417-006668,24WBLDK03052-006047,25SBLDL02396-007152,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUS02336-007137,25SBLUC04206-006535,25SBLUC11083-007106,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDK03120-006951,25WBLUC06082-005480,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDC03097-006047"
    },
    "015072": {
        "Stato": "IT",
        "CAP": "24040",
        "Localit\u00e0": "VERDELLINO",
        "Indirizzo": "VIA PRINCIPE AMEDEO 18",
        "N.ri Tel.": "035 870010",
        "Insegna": "ARMANNI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,24WBLDC02044-006648,25WBLUC08078-006355,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,25SBLDP01079-007092,25SBLUL02412-007155,24WBLDC03047-006047,25SBLDL02396-007156,25SBLDF03076-007092,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUL02411-007155,25WBLDK03103-006047,25WBLUC06082-005480,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03097-006047,25SBLDC01279-007111,25SBLUC01217-007108,25WBLDL01346-007354"
    },
    "015080": {
        "Stato": "IT",
        "CAP": "04023",
        "Localit\u00e0": "FORMIA",
        "Indirizzo": "Via Mamurrano loc. S. Croce",
        "N.ri Tel.": "0776/310774",
        "Insegna": "TREND STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUT02317-007116,25WBLDK02073-006648,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01121-007105,25SBLUH02241-007100,25SBLUC11214-007111,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUP03534-006873,25SBLDH02377-007147,25SBLUS02336-007138,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDT02125-006526,25WBLDK03527-006047,25SBLUF03186-006804,25SBLUC04206-006535,25SBLUF01055-007092,25SBLUH02275-007100,25WBLDK03495-006047,25SBLDH02375-006842,25WBLDC03099-006047,25SBLUP02063-007092,25SBLDC01279-007111,25WBLDC02178-006646,25SBLUC11215-007110,25SBLUC01115-007105,24WBLDH01432-006971,24WBLDC03038-006950,25SBLUC04176-006854,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25WBLDK03103-006047,24WBLDK03086-006976,25WBLDC11163-007110,25SBLUM01476-006233,24WBLDC11209-006007,25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25WBLDK03101-006047,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDF03076-007092,25SBLDC01159-007105,25SBLUN02513-007179,24WBLDH02433-006971,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC02170-006648,25SBLDC01328-007131,25SBLUT02315-007117,25WBLDK03098-006047"
    },
    "015081": {
        "Stato": "IT",
        "CAP": "70019",
        "Localit\u00e0": "TRIGGIANO",
        "Indirizzo": "SP 60, C.C. BARIBLU Lotto 1-76a",
        "N.ri Tel.": "080/3210405",
        "Insegna": "REV 73",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25WBLDC03097-006047,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLDC01358-007101,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02195-004547,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUC01219-007108,25SBLUT02313-006818,24WBLDC03211-006990,25SBLUT02309-007125,25SBLUK11239-007110,25SBLUP04353-007129,25WBLDC03095-006047,25SBLDC04331-006788,24WBLDC03051-006047,25SBLDC04333-007109,25WBLDC02170-006648,25SBLUH02030-006846,25SBLUH02275-007100,24WBLDK03122-006955,25WBLUC06082-005480,24WBLDC02352-006977,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDK03098-006047,25WBLDC11163-007110"
    },
    "015086": {
        "Stato": "IT",
        "CAP": "70010",
        "Localit\u00e0": "VALENZANO",
        "Indirizzo": "VIA SAN ROCCO, 68",
        "N.ri Tel.": "080/4676397",
        "Insegna": "EMBLEMA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDC03119-006951,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02077-006943,24WBLDK03052-006047,24WBLDK11337-006007,25WBLUC03233-007308,24WBLDC02290-006646,24WBLDC03211-006990,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03120-006951,25WBLUC06082-005480,25WBLDC03099-006047"
    },
    "015098": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "CIRCUMVALLAZIONE ESTERNA, C.DA LOCATELLI",
        "N.ri Tel.": "081.7372902",
        "Insegna": "ALICE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25SBLUT02110-006526,25SBLUC01211-007101,24WBLDC03211-006990,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC06082-005480,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25WBLUC02079-A05958"
    },
    "015127": {
        "Stato": "IT",
        "CAP": "22040",
        "Localit\u00e0": "ANZANO DEL PARCO",
        "Indirizzo": "VIA PROVINCIALE, 4",
        "N.ri Tel.": "031/630080",
        "Insegna": "COITER",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUH02150-007100,25WBBXC02456-005958,24WBLDC03047-006047,25SBLUC01115-007105,25WBLGC02391-006648,25WBLDC03100-006047,25WBLKC02427-005958,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLKC02429-005958"
    },
    "015172": {
        "Stato": "IT",
        "CAP": "80055",
        "Localit\u00e0": "PORTICI",
        "Indirizzo": "VIA DELLA LIBERTA', 166",
        "N.ri Tel.": "3333098891",
        "Insegna": "MAGNI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC02079-005958,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25SBLUC11214-007111,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLUC02079-A05958"
    },
    "015179": {
        "Stato": "IT",
        "CAP": "80011",
        "Localit\u00e0": "ACERRA",
        "Indirizzo": "VIA DEI MILLE 55",
        "N.ri Tel.": "081-8857100",
        "Insegna": "LIFE STYLE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDC02041-006648,25WBLDK03527-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLUL01316-007012,25SBLDC01279-007111"
    },
    "015185": {
        "Stato": "IT",
        "CAP": "00060",
        "Localit\u00e0": "CAPENA",
        "Indirizzo": "VIA TIBERINA KM. 16,400",
        "Insegna": "NOI SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,24WBLDK03037-006950,25WBLDC02072-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,25WBLDC02196-007283,25WBLDP01291-007324,24WBLDK03052-006047,25SBLUL02412-007155,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUC11541-007110,25WBLUC03233-007308,24WBLDC02041-006648,25WBLDK03527-006047,25WBLGC02391-006648,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUC01121-007105,24WBLDC03211-006990,25SBLDC01159-007105,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25SBLUC03012-006719,25WBLUC05125-007283,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDC03252-007008,25SBLUH02274-007100,24WBLDC03048-006047,25WBLDK03102-006047,25WBLDF08236-007301,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "015197": {
        "Stato": "IT",
        "CAP": "80142",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO GARIBALDI, 378/E",
        "N.ri Tel.": "081 202474",
        "Insegna": "MEDITERRANEO",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25SBLUT02346-007132,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDK03527-006047,25WBLDB03191-007294,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC01121-007105,24WBLDC03051-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLDC01328-007131,25WBLUC02132-007284,25SBLUH02199-004547,25WBLDC03099-006047,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "015199": {
        "Stato": "IT",
        "CAP": "80049",
        "Localit\u00e0": "SOMMA VESUVIANA",
        "Indirizzo": "VIA SEGGIARI, 16",
        "Insegna": "CITY FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK03039-006950,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC02227-007104,25SBLDC02232-007104,25SBLUF03187-006804,25SBLUC11214-007111,25SBLDF08078-007092,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUM01479-007167,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDL01417-006668,25SBLDP01079-007092,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUX03226-006719,25WBLDK03527-006047,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUH02275-007100,25SBLDH02375-006842,25SBLDP05080-007092,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUP01189-006804,24WBLDH01432-006971,24WBLDC03038-006950,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUC11207-006787,25SBLDH02376-006842,25SBLUH02191-004547,25SBLUH02192-004547,24WBLDH02433-006971,25SBLDF03257-007113,25WBLDC02170-006648,25SBLUH02199-004547,25SBLDC04066-007109"
    },
    "015243": {
        "Stato": "IT",
        "CAP": "85038",
        "Localit\u00e0": "SENISE",
        "Indirizzo": "VIA MADONNA D'ANGLONA, 130",
        "N.ri Tel.": "0973 584426",
        "Insegna": "MIRAGE",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDC03119-006951,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUL02412-007155,25SBLUH02194-004547,25SBLUC03011-006719,25SBLUH02108-006864,25SBLUH02242-007100,25SBLUM01478-007167,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUT02309-007125,25SBLUC11083-007106,25SBLUT02310-006817,25SBLUP04353-007129,24WBLDC03051-006047,25SBLUT02306-006801,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "015253": {
        "Stato": "IT",
        "CAP": "00178",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA LUCREZIA ROMANA, 126",
        "N.ri Tel.": "0672670347",
        "Insegna": "SIR STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,25SBLUH02196-004547,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLGC02391-006648,25SBLUH02191-004547,25SBLUC04176-006854,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUL02318-007340,24WBLDK03122-006955,25WBLUC05125-007283,25WBLUC06082-005480,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03097-006047,25WBLDA05337-006127"
    },
    "015271": {
        "Stato": "IT",
        "CAP": "09040",
        "Localit\u00e0": "SENORBA",
        "Indirizzo": "VIA CARLO SANNA , 65",
        "N.ri Tel.": "0709809467",
        "Insegna": "ALMAX",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,25WBLUC03086-006047,25WBLDC03096-006047,24WBLDC02044-006648,24WBLDC02064-006100,24WBLDC02352-006977,25WBLUC02132-007284,24WBLDC03048-006047,25WBLUC03074-006355,25WBLUL01316-007012,25WBLDC03095-006047"
    },
    "015278": {
        "Stato": "IT",
        "CAP": "21100",
        "Localit\u00e0": "VARESE",
        "Indirizzo": "PIAZZA DEL PODESTA' 1",
        "N.ri Tel.": "0332/284402",
        "Insegna": "BASIC",
        "CODICE PRODOTTO KOOOMO": "25SBLUA04528-007183,25WBLUC08078-006355,25WBLDC03173-007307,25WBLDP01291-007324,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUT02317-007116,25WBLDC03100-006047,25SBLUT02110-006526,25SBLUP04062-007092,25SBLUC02227-007104,25SBLUT02310-006817,25SBLUH02241-007100,25SBLUC03012-006719,25WBLUC05125-007283,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUC01217-007108,25WBLDA05337-006127,25SBLUP05190-006804,25SBLUT02308-006801,25WBLUA05299-006127,25SBLDH02374-006842,25SBLUH02196-004547,25WBLDC02196-007283,25SBLDP01079-007092,25SBLUH02242-007100,25SBLDT02125-006526,25SBLUF03186-006804,25SBLUA04524-007182,25SBLUF01055-007092,25SBLUH02275-007100,25SBLDH02375-006842,25SBLUH01149-007100,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUP02063-007092,25WBLDF08236-007301,25SBLDC01279-007111,25SBLUF03185-006804,24WBLDC02112-006631,24WBLDK02045-006648,25SBLDX03008-006950,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUA04527-007182,24WBLDA05467-006434,25SBLUH02109-006526,25SBLUC01115-007105,25SBLUF01184-006804,25SBLUH02108-006864,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDP01140-007109,25SBLDP05141-007109,24WBLDB03294-005553,25WBLDK03103-006047,25SBLUF02188-006804,25WBLUC02132-007284,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDK03101-006047,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDH02376-006842,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDC01159-007105,25SBLUL02403-006543,25SBLDT02138-006526,25SBLUT02306-006801,24WBLDK02363-005831,25WBLUA05301-006434,25SBLDC04066-007109,25WBLDK03098-006047,25WBLUA05297-006127"
    },
    "015288": {
        "Stato": "IT",
        "CAP": "80143",
        "Localit\u00e0": "NOLA",
        "Indirizzo": "VIA GENOVA 90,",
        "N.ri Tel.": "0810146650",
        "Insegna": "SORECA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUH02109-006526,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02108-006864,25WBLDC03100-006047,25SBLUT02110-006526,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "015300": {
        "Stato": "IT",
        "CAP": "84102",
        "Localit\u00e0": "ANGRI",
        "Indirizzo": "CORSO ITALIA, 107",
        "N.ri Tel.": "0815132638",
        "Insegna": "PEPP O PIEZ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDK03527-006047,25SBLUH02191-004547,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDA05465-006127,25SBLUH02275-007100,24WBLDC02064-006100,24WBLDL01420-007016,25SBLDC01328-007131,25SBLDH02375-006842,25WBLUC02080-005958,25WBLUC02132-007284,25WBLDA05335-007349,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111,25WBLDA05337-006127"
    },
    "015319": {
        "Stato": "IT",
        "CAP": "89025",
        "Localit\u00e0": "ROSARNO",
        "Indirizzo": "VIA MARIA ZITA 4",
        "Insegna": "SP NEW IDEA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,24WBLDC03084-006976,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLDK01376-007378,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUL01316-007012,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03038-006950,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUF03186-006804,25WBLDC03096-006047,25SBLUC04206-006535,24WBLDC03051-006047,25SBLUT02306-006801,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC03097-006047,25WBLKC02429-005958"
    },
    "015382": {
        "Stato": "IT",
        "CAP": "75018",
        "Localit\u00e0": "STIGLIANO",
        "Indirizzo": "VIA ROMA, 14",
        "N.ri Tel.": "0835561281",
        "Insegna": "PUNTO SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDM09261-006645,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDM13260-006645,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUF01184-006804,25SBLUH02108-006864,25SBLUC02228-007104,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUM01476-006233"
    },
    "015394": {
        "Stato": "IT",
        "CAP": "03100",
        "Localit\u00e0": "FROSINONE",
        "Indirizzo": "VIA ARMANDO VONA, 20 - C.C. LE SORGENTI LIV.1",
        "Insegna": "AMORE CONCEPT STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUT02346-007132,25SBLUH02194-004547,25SBLUF03186-006804,24WBLDK03039-006950,25WBLDC03096-006047,25SBLUC01121-007105,25SBLUT02309-007125,25SBLUT02310-006817,25WBLDK03103-006047,25SBLUX02230-005958,25SBLUT02315-007117,25WBLUC02079-A05958,25SBLUC01210-007101,25SBLUP02352-006855"
    },
    "015397": {
        "Stato": "IT",
        "CAP": "03100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ARMANDO VONA, 20 - C.C. LE SORGENTI LIV.1",
        "Insegna": "AMORE CONCEPT STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDK02042-006648,24WBLDK03052-006047"
    },
    "015398": {
        "Stato": "IT",
        "CAP": "76121",
        "Localit\u00e0": "BARLETTA",
        "Indirizzo": "VIA BACCARINI , 2",
        "N.ri Tel.": "3288085675",
        "Insegna": "BROADWAY",
        "CODICE PRODOTTO KOOOMO": "25SBLUA04528-007183,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUS01340-007138,25WBLDC03100-006047,25SBLUP04062-007092,25SBLDC11237-007110,25SBLUC02227-007104,25SBLDC02232-007104,25SBLDH02386-007144,25SBLUC03012-006719,25WBLUC03086-006047,25SBLDF08078-007092,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDA05337-006127,25WBLUK03142-005480,24WBLDC02314-006631,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUF03186-006804,25SBLUC04206-006535,25SBLUF01055-007092,25SBLDC02236-006648,25SBLDP05080-007092,25SBLUP02063-007092,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUA04527-007182,24WBLDH01432-006971,25SBLDH02389-007144,25SBLUH02244-007100,24WBLDC03211-006990,24WBLDF08400-006987,25WBLDC03095-006047,25SBLUS01337-007137,24WBLDC03051-006047,24WBLDB03294-005553,25SBLDC03006-006950,24WBLDM01427-005794,24WBLDF03399-006987,25WBLDC03097-006047,24WBLDC11209-006007,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUH02191-004547,25SBLUT02313-006818,24WBLDP03447-007025,25SBLDH02377-007144,25SBLDF03257-007113,25WBLDC02170-006648,25SBLDC01328-007131,25SBLUH02199-004547,25WBLDK03098-006047"
    },
    "015411": {
        "Stato": "IT",
        "CAP": "81038",
        "Localit\u00e0": "TRENTOLA-DUCENTA",
        "Indirizzo": "VIA NUZIALE SANT'ANTONIO S.C.",
        "N.ri Tel.": "0815027131",
        "Insegna": "ROMANO",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUP01350-006855,25SBLUH02194-004547,25SBLUH02195-004547,25WBLDK03527-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLUC06082-005480,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "015414": {
        "Stato": "IT",
        "CAP": "80131",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA EDUARDO NICOLARDI 254",
        "N.ri Tel.": "081-7411171",
        "Insegna": "MONACO",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUH02109-006526,25SBLUC11215-007110,25SBLUH02196-004547,24WBLDK11337-006007,24WBLDC03047-006047,25SBLDH02376-006842,25SBLUC11541-007110,25SBLUS02336-007138,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02195-004547,25WBLDC03100-006047,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUT02110-006526,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25SBLDH02375-006842,25SBLDC01328-007131,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "015417": {
        "Stato": "IT",
        "CAP": "48683",
        "Localit\u00e0": "TERNI",
        "Indirizzo": "VIA GIOTTO 10/12",
        "N.ri Tel.": "0744-406498",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015418": {
        "Stato": "IT",
        "CAP": "81100",
        "Localit\u00e0": "CASERTA",
        "Indirizzo": "PIAZZA VANVITELLI, 48",
        "N.ri Tel.": "0823 456166",
        "Insegna": "JEAN CLAUDE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK02042-006648"
    },
    "015457": {
        "Stato": "IT",
        "CAP": "89125",
        "Localit\u00e0": "REGGIO CALABRIA",
        "Indirizzo": "CORSO G. GARIBALDI, 262",
        "N.ri Tel.": "0965 811730",
        "Insegna": "MYTHOS 262",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDK01376-007378,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUF02101-007121,25WBLDC03100-006047,25SBLUC01219-007108,25SBLUP04062-007092,25SBLUC01209-007101,25WBLUC03086-006047,25WBLUL02318-007340,24WBLDC03048-006047,25SBLUL02583-007370,25WBLDA05337-006127,25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDL02396-007156,25SBLDL02396-007152,24WBLDC02041-006648,25SBLUC04206-006535,25SBLUS01338-007137,25WBLUA05298-006127,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUL01316-007012,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDA05467-006434,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUX02255-007101,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDA05465-006127,25SBLUF02188-006804,25WBLDC03097-006047,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLUF01568-007121,25WBLDC02170-006648,25WBLDK03098-006047,25WBLDK01375-007378,25WBLDL01346-007354"
    },
    "015499": {
        "Stato": "IT",
        "CAP": "10147",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA NIZZA, 60",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015513": {
        "Stato": "IT",
        "CAP": "87023",
        "Localit\u00e0": "DIAMANTE",
        "Indirizzo": "CORSO V.EMANUELE, 23",
        "Insegna": "MIRIADE DIAMANTE UOMO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,25SBLDB04068-007109,24WBLDC03038-006950,24WBLDC02342-006631,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUH02191-004547,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC02232-007104,25SBLDC02128-007103,25WBLDC02170-006648,24WBLDK02363-005831,25SBLUF01055-007092,25WBLDK03103-006047,24WBLDK03120-006951,24WBLDC02064-006100,25WBLDK02192-006648,25WBLUC06082-005480,25WBLUC02080-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25SBLDV01146-007107"
    },
    "015518": {
        "Stato": "IT",
        "CAP": "59013",
        "Localit\u00e0": "MONTEMURLO",
        "Indirizzo": "VIA LABRIOLA, 243",
        "N.ri Tel.": "0574754171",
        "Insegna": "GUARDUCCI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUK03142-005480,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUS02336-007138,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUT02316-007116,25SBLUH02242-007100,25WBLDB03191-007294,25SBLUT02317-007116,25SBLUS01341-007136,25SBLUH02276-005695,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUH02241-007100,25SBLUS01342-007136,25SBLUF01055-007092,25SBLUH02275-007100,25SBLUC04168-006788,25SBLUX02230-005958,25WBLUA05301-006434,24WBLDC03252-007008,25WBLUA05297-006127,25WBLUK11140-007286"
    },
    "015520": {
        "Stato": "IT",
        "CAP": "23037",
        "Localit\u00e0": "TIRANO",
        "Indirizzo": "VIALE ITALIA, 14",
        "N.ri Tel.": "0342-702400",
        "Insegna": "ESSE TRE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDC02251-006631,25WBLDC03096-006047,25WBLDC02177-007284,24WBLDC02064-006100,25WBLDK02192-006648,25WBLUC02080-005958,25WBLUC02132-007284"
    },
    "015557": {
        "Stato": "IT",
        "CAP": "76011",
        "Localit\u00e0": "BISCEGLIE",
        "Indirizzo": "VIA ALDO MORO, 17",
        "N.ri Tel.": "0803968313",
        "Insegna": "LA FIORENTE",
        "CODICE PRODOTTO KOOOMO": "24WBLDM01437-007021,25WBLDC02072-006648,24WBLDC03119-006951,25WBLUC11083-007110,24WBLDC02044-006648,25WBLDC03173-007307,25SBLDC02234-006648,25SBLDC01222-007108,25SBLDH02374-006842,24WBLDK03052-006047,25SBLDC01358-007101,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDH02387-007144,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDP04142-007109,24WBLDP03447-007025,25SBLDH02377-007144,25WBLDC03096-006047,24WBLDC03211-006990,25WBLUA05297-006127,25SBLDK01249-007111,25SBLDC02128-007103,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDT02138-006526,25WBLDC02170-006648,24WBLDC02250-007008,24WBLDK03120-006951,25SBLDC03006-006950,25SBLDC02357-007124,25WBLDC03099-006047,25SBLDC04066-007109,25WBLDC03097-006047,25WBLDA05337-006127,25WBLDL01346-007354"
    },
    "015568": {
        "Stato": "IT",
        "CAP": "00044",
        "Localit\u00e0": "FRASCATI",
        "Indirizzo": "VIA BEZZECCA, 1",
        "N.ri Tel.": "069425631",
        "Insegna": "GENTE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25SBLDV02296-007143,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDC03047-006047,24WBLDC03038-006950,25SBLDV03365-007143,25SBLDT02125-006526,25WBLDK03527-006047,25WBLDB03191-007294,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDS01291-007141,24WBLDC02018-006648,25SBLDH02389-007144,25WBLDC03096-006047,25SBLDC01159-007105,25SBLDS01366-007141,25WBLDC03095-006047,25SBLDF03257-007113,25SBLDC04333-007109,25SBLDH02386-007144,25WBLDK03103-006047,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "015583": {
        "Stato": "IT",
        "CAP": "04020",
        "Localit\u00e0": "ITRI",
        "Indirizzo": "VIA CIVITA FARNESE , 18/20",
        "N.ri Tel.": "0771729393",
        "Insegna": "DIVA",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUP01189-006804,25SBLUC11541-007110,25SBLUS02336-007138,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02108-006864,25SBLUH02191-004547,25SBLUF03186-006804,25SBLUH02244-007100,25SBLUH02192-004547,25SBLUC01121-007105,25SBLUC04206-006535,25SBLUT02310-006817,25SBLUH02241-007100,25SBLUT02306-006801,25SBLUF02188-006804,25WBLUC06082-005480,25SBLUX02230-005958,25WBLUC02079-A05958,25SBLUM01476-006233"
    },
    "015586": {
        "Stato": "IT",
        "CAP": "63100",
        "Localit\u00e0": "ASCOLI PICENO",
        "Indirizzo": "CORSO GIUSEPPE MAZZINI, 132",
        "N.ri Tel.": "0736258963",
        "Insegna": "DI SABATINO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25SBLUC03012-006719,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUL02583-007370,25WBLUC02079-A05958"
    },
    "015588": {
        "Stato": "IT",
        "CAP": "31046",
        "Localit\u00e0": "ODERZO",
        "Indirizzo": "PIAZZA GRANDE, 5",
        "N.ri Tel.": "0422-814510",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015594": {
        "Stato": "IT",
        "CAP": "07047",
        "Localit\u00e0": "THIESI",
        "Indirizzo": "VIA ROMA, 107",
        "N.ri Tel.": "3939989664",
        "Insegna": "LINUS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25WBLDK02069-006648,25SBLUH02191-004547,25SBLUT02110-006526,25SBLUH02192-004547,25SBLUT02312-006803,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDC02064-006100,25SBLUX02230-005958,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "015600": {
        "Stato": "IT",
        "CAP": "87040",
        "Localit\u00e0": "LUZZI",
        "Indirizzo": "CONTRADA CAVONI",
        "N.ri Tel.": "0984/949004",
        "Insegna": "PELLE E CUOIO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC02227-007104,25SBLUH02241-007100,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDK03120-006951,25WBLUL02318-007340,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUL02583-007370,25WBLUK03142-005480,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC02177-007284,25SBLUH02275-007100,25SBLDC04070-007109,25WBLDC03099-006047,25WBLUL01316-007012,25SBLDX03008-006950,24WBLDK03037-006950,24WBLDC02044-006648,25SBLUH02109-006526,25SBLUL02412-007155,24WBLDC03038-006950,25SBLDC02264-006648,25SBLUS01337-007137,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDK03102-006047,25SBLUL02402-007153,25WBLDC02072-006648,25SBLUL02582-007370,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC02254-007101,25WBLDC02170-006648,25SBLUB04167-006854"
    },
    "015613": {
        "Stato": "IT",
        "CAP": "21040",
        "Localit\u00e0": "GERENZANO VARESE",
        "Indirizzo": "VIA CERVINIA, 1",
        "N.ri Tel.": "02 9668141",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC03119-006951,24WBLDC03084-006976,25WBLUC03090-006719,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUH02196-004547,25WBBXC02456-005958,25WBLDC02196-007283,25WBLDP01291-007324,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC01115-007105,24WBLDC03038-006950,25WBLUC03233-007308,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDB03191-007294,25WBLGC02391-006648,25SBLDC11237-007110,25WBLDC03096-006047,25SBLDC02232-007104,25WBLDC03095-006047,25SBLUC03012-006719,25WBLUC05125-007283,25WBLUC06082-005480,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUA05301-006434,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLDF08236-007301,25SBLDC01279-007111"
    },
    "015627": {
        "Stato": "IT",
        "CAP": "00148",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ANGELO VESCOVALI, 374",
        "N.ri Tel.": "3358429155",
        "Insegna": "MARCOR",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUC02132-007284,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDL01417-006668,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC01121-007105,25SBLDC01159-007105,25SBLUT02309-007125,24WBLDK03212-006990,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02241-007100,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC05125-007283,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25SBLUH02394-007114,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "015636": {
        "Stato": "IT",
        "CAP": "25124",
        "Localit\u00e0": "BRESCIA",
        "Indirizzo": "VIA CODIGNOLE, 45",
        "Insegna": "G&B",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03048-006047"
    },
    "015644": {
        "Stato": "IT",
        "CAP": "07044",
        "Localit\u00e0": "ITTIRI",
        "Indirizzo": "VIA GUGLIELMO MARCONI, 47/49",
        "N.ri Tel.": "3475339168",
        "Insegna": "TAVERNA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25SBLDH02372-005707,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03114-006719,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDH02374-006842,25SBLDB04068-007109,24WBLDC03047-006047,25SBLUC03011-006719,24WBLDK02042-006648,25SBLUH02195-004547,25SBLUH02108-006864,24WBLDK03039-006950,25SBLDP04142-007109,25SBLUT02110-006526,25SBLUH02192-004547,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDC03007-006950,25SBLUT02310-006817,25SBLDH02370-006845,25WBLDC03095-006047,25SBLUC01209-007101,25SBLDC04333-007109,25WBLDC02170-006648,25SBLDH02386-007144,25WBLDK03103-006047,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "015663": {
        "Stato": "IT",
        "CAP": "04021",
        "Localit\u00e0": "CASTELFORTE",
        "Indirizzo": "VIA ALFREDO FUSCO, 12",
        "Insegna": "EXCLUSIVE DI PANZAVOLTA VALERIANO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK11337-006007"
    },
    "015664": {
        "Stato": "IT",
        "CAP": "76012",
        "Localit\u00e0": "CANOSA DI PUGLIA",
        "Indirizzo": "VIA SAVINO DI BARI 3",
        "Insegna": "ANTROPOS",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05467-006434,24WBLDA05467-006434,24WBLDA05467-006434,24WBLDA05467-006434,24WBLDC02044-006648,24WBLDC02049-006636,24WBLDC02290-006646,24WBLDC03038-006950,24WBLDC03114-006719,24WBLDC03211-006990,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDM04562-007021"
    },
    "015669": {
        "Stato": "IT",
        "CAP": "81030",
        "Localit\u00e0": "SAN MARCELLINO",
        "Indirizzo": "CORSO EUROPA, 205,",
        "N.ri Tel.": "081-5041085",
        "Insegna": "L'EQUIPE BOUT.",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02064-006100,24WBLDC02112-006631,24WBLDC02112-006631,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03047-006047"
    },
    "015703": {
        "Stato": "IT",
        "CAP": "71013",
        "Localit\u00e0": "SAN GIOVANNI ROTONDO",
        "Indirizzo": "VIALE ALDO MORO, 71",
        "N.ri Tel.": "0882454529",
        "Insegna": "CANISTRO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDC03038-006950,25SBLDF03076-007092,25WBLDB03191-007294,25SBLUM01478-007167,25SBLUC04176-006854,24WBLDK03039-006950,25SBLUT02312-006803,25WBLDK11162-007110,25SBLDC02232-007104,25SBLUT02310-006817,25SBLDF03257-007113,24WBLDC03051-006047,25WBLDK03103-006047,25SBLDF08078-007092,25SBLUH02275-007100,25WBLUC06082-005480,25SBLDC01328-007131,25WBLDK03102-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDA05337-006127"
    },
    "015714": {
        "Stato": "IT",
        "CAP": "27029",
        "Localit\u00e0": "VIGEVANO",
        "Indirizzo": "VIA GIORGIO SILVA, 2",
        "N.ri Tel.": "0381/90196",
        "Insegna": "BOSTON CLASS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUT02308-006801,24WBLDA05467-006434,25WBLUC03074-006355,25SBLDX02235-006648,24WBLDX02113-006631,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,24WBLDC02342-006631,25WBLUC03233-007308,24WBLDM10408-007022,25SBLUF01184-006804,25SBLDF03076-007092,25SBLUB01216-007111,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,24WBLDX03318-006992,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDC02170-006648,25WBLUC02153-007300,25WBLDK03103-006047,24WBLDA05465-006127,25SBLDF08078-007092,24WBLDL01420-007016,25SBLUX02230-005958,25WBLUA05298-006127,25WBLDK03102-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "015715": {
        "Stato": "IT",
        "CAP": "16164",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA ANFOSSI, 118R",
        "N.ri Tel.": "010/715606",
        "Insegna": "OLIVA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUH02192-004547,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDK03103-006047,25SBLUF02188-006804,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25SBLUT02315-007117,25WBLDC03099-006047"
    },
    "015749": {
        "Stato": "IT",
        "CAP": "73016",
        "Localit\u00e0": "SAN CESARIO",
        "Indirizzo": "S.S.476 KM 2+110 N.72",
        "N.ri Tel.": "0832350466",
        "Insegna": "STEP BY STEP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUC11569-006787,24WBLDK03037-006950,24WBLDC02044-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUC02077-006943,24WBLDC03036-006950,25SBLUC11207-006787,25SBLDC01358-007101,25SBLUC11541-007110,25WBLUC03233-007308,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUK11239-007110,24WBLDC03051-006047,25SBLDC04333-007109,25WBLDC02170-006648,25WBLUC03086-006047,25WBLUC02080-005958,25SBLDC01328-007131,25SBLUX02230-005958,25WBLDK03102-006047,25SBLDC04066-007109,25WBLDC03099-006047"
    },
    "015765": {
        "Stato": "IT",
        "CAP": "20812",
        "Localit\u00e0": "LIMBIATE",
        "Indirizzo": "EX SS527 ANG VIA GARIBALDI -",
        "N.ri Tel.": "0362 850178",
        "Insegna": "MASCHERONI",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015774": {
        "Stato": "IT",
        "CAP": "73058",
        "Localit\u00e0": "TUGLIE",
        "Indirizzo": "VIA TRIESTE, 30",
        "N.ri Tel.": "0833598047",
        "Insegna": "RAINBOW",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,24WBLDC02044-006648,25WBLUC02079-005958,24WBLDA05467-006434,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUP01189-006804,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUH02108-006864,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02275-007100,24WBLDK03122-006955,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUC04163-006788"
    },
    "015808": {
        "Stato": "IT",
        "CAP": "00143",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "c/o C-C- MAXIMO (da confermare) - Quartiere Laurentino",
        "N.ri Tel.": "06 87074325",
        "Insegna": "NEGOZI PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03092-006719,24WBLDC03047-006047,25WBLUC02079-005958,24WBLDC03114-006719,25WBLUX02081-005958,25WBLDC03099-006047,25WBLKC02427-005958,24WBLDC03036-006950,25WBLKC02429-005958"
    },
    "015820": {
        "Stato": "IT",
        "CAP": "70011",
        "Localit\u00e0": "ALBEROBELLO",
        "Indirizzo": "VICOLO SOLDATO IGNOTO, 10",
        "N.ri Tel.": "3921953017 TOMMASO",
        "Insegna": "CARISMA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC03119-006951,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK03120-006951"
    },
    "015822": {
        "Stato": "IT",
        "CAP": "700121",
        "Localit\u00e0": "BARI",
        "Indirizzo": "VIA PRINCIPE AMEDEO, 43",
        "N.ri Tel.": "0805242936",
        "Insegna": "LUXX",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC02049-006636,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDB04068-007109,25SBLUC11207-006787,25WBLUC03233-007308,25WBLDC03100-006047,25SBLDC11237-007110,25WBLDC03096-006047,24WBLDF08400-006987,24WBLDC03051-006047,25SBLDT02138-006526,25SBLDC04333-007109,25WBLDC02170-006648,25SBLDH02386-007144,24WBLDK03120-006951,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDC03097-006047,25WBLDA05337-006127"
    },
    "015853": {
        "Stato": "IT",
        "CAP": "03043",
        "Localit\u00e0": "CASSINO",
        "Indirizzo": "CORSO DELLA REPUBBLICA, 62",
        "N.ri Tel.": "0776 310260",
        "Insegna": "NEW COMPANY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25SBLUS01339-007137,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUC04176-006854,24WBLDC02290-006646,25SBLUT02312-006803,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUL02318-007340,25WBLUC06082-005480,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUL02583-007370,25SBLUM01479-007167,25WBLDC03099-006047,25SBLUP02352-006855"
    },
    "015861": {
        "Stato": "IT",
        "CAP": "56038",
        "Localit\u00e0": "PONSACCO",
        "Indirizzo": "PIAZZA D'APPIANO, 31",
        "N.ri Tel.": " 0587732836",
        "Insegna": "FEDERICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUT02346-007132,25SBLUP01189-006804,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK02042-006648,25SBLUH02108-006864,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUB04360-006788,25SBLUT02306-006801,25SBLUH02275-007100,25WBLUL02318-007340,25SBLUC04168-006788,25WBLUA05301-006434,25WBLUC02079-A05958,25WBLUK11140-007286"
    },
    "015886": {
        "Stato": "IT",
        "CAP": "90146",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA STAZIONE SAN LORENZO, 6",
        "N.ri Tel.": "091 6257727",
        "Insegna": "GIGLIO IN",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUP01350-006855,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDC03100-006047,25WBLKC02427-005958,25SBLUH02192-004547,25SBLUT02312-006803,25SBLKX02418-005958,25WBLDC03096-006047,25SBLUC02231-005958,25SBLKC01445-007101,25SBLUS01337-007137,25SBLUT02306-006801,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUP04354-007129,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDK03098-006047,25WBLUC02079-A05958,25SBLUP02352-006855"
    },
    "015912": {
        "Stato": "IT",
        "CAP": "51031",
        "Localit\u00e0": "AGLIANA",
        "Indirizzo": "VIA FRATELLI CERVI, 66",
        "N.ri Tel.": "0574 718234",
        "Insegna": "ABBIGLIAMENTO VARO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUH02193-004547,25SBLUP03539-006873,25WBLUC03090-006719,25WBLDK03101-006047,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25SBLUL02582-007370,25WBLUC08078-006355,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDX02113-006631,24WBLDC03047-006047,25SBLUP01350-006855,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,25SBLUM01478-007167,25SBLUT02110-006526,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC03095-006047,25SBLUF03187-006804,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUF02188-006804,25SBLUH02275-007100,25SBLUM01486-007172,25WBLUA05298-006127,24WBLDC03048-006047,25SBLUL02583-007370,25SBLUT02315-007117,25WBLUC02079-A05958,25SBLUM01476-006233"
    },
    "015927": {
        "Stato": "IT",
        "CAP": "76011",
        "Localit\u00e0": "BISCEGLIE",
        "Indirizzo": "LARGO CANONICO PASQUALE UVA, 6",
        "N.ri Tel.": "380-3876995",
        "Insegna": "JEK.PIT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDP01079-007092,24WBLDC03047-006047,25SBLDC01358-007101,25SBLUC01115-007105,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUX03226-006719,25SBLDF03076-007092,25WBLDC03100-006047,25SBLUC01219-007108,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDC03095-006047,25SBLUL02409-006547,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUX02230-005958,25SBLUH02199-004547,24WBLDC03048-006047,25SBLUL02583-007370,25WBLDC03099-006047,25SBLUC01210-007101,25WBLUC02079-A05958,25SBLUC01281-007105"
    },
    "015932": {
        "Stato": "IT",
        "CAP": "000133",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DELLA TENUTA DI TERRANOVA 154/156",
        "N.ri Tel.": "3478865069",
        "Insegna": "PACHA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC03097-006047"
    },
    "015940": {
        "Stato": "IT",
        "CAP": "50113",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA UGO OJETTI, 141",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02244-007100,25WBLUL02318-007340,25SBLUC01121-007105,25SBLUC04206-006535,25SBLUA04527-007182,25SBLUX02230-005958,25SBLUT02308-006801,25SBLUT02315-007117"
    },
    "015941": {
        "Stato": "IT",
        "CAP": "04011",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE DELL'OCEANO PACIFICO, 83 - UNITA' T106 C/o C.C. EUR ROMA 2",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015946": {
        "Stato": "IT",
        "CAP": "67100",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "393 4840377",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11214-007111,25SBLUT02312-006803"
    },
    "015950": {
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "LEPORANO",
        "Indirizzo": "VIA PORTA TARANTO 40",
        "N.ri Tel.": "099- 5316143",
        "Insegna": "FERRANTINO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,24WBLDK03037-006950,25SBLDH02372-005707,25WBLDC02178-006646,25SBLDC01222-007108,25SBLDH02374-006842,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDK03052-006047,25SBLDB04068-007109,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUF02101-007121,25SBLDV03365-007143,25SBLDF03076-007092,25SBLDP04142-007109,25SBLUT02313-006818,25SBLDH02389-007144,25SBLDC11237-007110,25WBLDC03096-006047,25WBLUF02118-007121,25SBLUP01183-007121,24WBLDF08400-006987,24WBLDH02433-006971,25SBLDC03007-006950,25SBLDS01366-007141,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04331-006788,25SBLDF03257-007113,25SBLDC04333-007109,25WBLDC02170-006648,25WBLUF03119-007121,25SBLUF01055-007092,25SBLDH02386-007144,25WBLDK03103-006047,24WBLDK03120-006951,24WBLDK03122-006955,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUP02063-007092,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "016018": {
        "Stato": "IT",
        "CAP": "10141",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "C.C. AUCHAN VIA ROMANIA, 460",
        "N.ri Tel.": "011/5137187",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH05028-006846"
    },
    "016020": {
        "Stato": "IT",
        "CAP": "70037",
        "Localit\u00e0": "RUVO",
        "Indirizzo": "CORSO JATTA, 42",
        "N.ri Tel.": "0803601143",
        "Insegna": "CIRASIELLO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDX03008-006950,24WBLDC02044-006648,25SBLDS01292-007141,25WBLUC08078-006355,25WBLDC03173-007307,25SBLUT02308-006801,25SBLDC01222-007108,25SBLUT02346-007132,24WBLDC03036-006950,25SBLDH03371-005707,24WBLDK03052-006047,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUC02153-007124,25SBLUH02191-004547,25SBLUC04176-006854,25SBLDC01359-007101,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUT02313-006818,25SBLDH02389-007144,25SBLUC01211-007101,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDF03257-007113,24WBLDC03051-006047,25SBLUS01337-007137,25SBLUT02306-006801,25SBLDP05141-007109,25WBLDC02170-006648,25SBLDM01473-007166,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDK03122-006955,25WBLUC06082-005480,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUA05298-006127,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDF03399-006987,25SBLUH02030-006846,25WBLDA05337-006127"
    },
    "016023": {
        "Stato": "IT",
        "CAP": "24122",
        "Localit\u00e0": "BERGAMO",
        "Indirizzo": "PIAZZA PONTIDA, 15/G",
        "Insegna": "MR WHITE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUB01216-007111,25SBLUC01219-007108,25SBLUC01211-007101,25WBLUC06082-005480,25WBLUC02079-A05958,25SBLUL02583-007370,25WBLUK11140-007286,25SBLUC01281-007105"
    },
    "016024": {
        "Stato": "IT",
        "CAP": "80036",
        "Localit\u00e0": "PALMA CAMPANIA",
        "Indirizzo": "NUOVA SARNO, 111",
        "N.ri Tel.": "081-5103836",
        "Insegna": "SORRENTINO SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDC11163-007110"
    },
    "016039": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA TEVERE, 7",
        "N.ri Tel.": "0544 1847340",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03039-006950"
    },
    "016065": {
        "Stato": "IT",
        "CAP": "74020",
        "Localit\u00e0": "SAN MARZANO",
        "Indirizzo": "VIA VITTORIO EMANUELE, 164",
        "N.ri Tel.": "099 6618307",
        "Insegna": "FF",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUH02193-004547,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUX02081-005958,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUT02346-007132,25WBLDC03097-006047,24WBLDC03036-006950,25SBLUP01189-006804,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02195-004547,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUF03186-006804,25SBLDP01344-006855,24WBLDC02290-006646,25SBLUA04524-007182,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUN02513-007179,24WBLDC03051-006047,25SBLDC04333-007109,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25SBLDF08078-007092,25WBLUC06082-005480,25SBLUX02230-005958,25SBLUH02030-006846,25WBLDC11163-007110"
    },
    "016067": {
        "Stato": "IT",
        "CAP": "71121",
        "Localit\u00e0": "FOGGIA",
        "Indirizzo": "VIA LECCE, 24",
        "N.ri Tel.": "0881-637512",
        "Insegna": "ZENO NEGOZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03173-007307,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUH02348-007132,25SBLUP04062-007092,25SBLDP01326-007143,24WBLDC02314-006631,25SBLDC01222-007108,25SBLDH02374-006842,25SBLUX02147-007103,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02018-006648,25SBLUH02276-005695,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUP02063-007092,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDH02381-007114,24WBLDC02290-006646,25SBLDS01291-007141,25SBLDH02389-007144,25SBLDC02264-006648,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDF08400-006987,25SBLDC02128-007103,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDP03447-007029,24WBLDA05465-006127,24WBLDC02064-006100,25WBLDK03102-006047,24WBLDF03399-006987,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUT02313-006818,25WBLDC02170-006648,24WBLDK02363-005831,25WBLUA05301-006434"
    },
    "016071": {
        "Stato": "IT",
        "CAP": "89015",
        "Localit\u00e0": "PALMI",
        "Indirizzo": "CORSO TENENTE A.BARBARO 42",
        "N.ri Tel.": "0966 421155",
        "Insegna": "YIN",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25SBLDC03003-006950,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDC03047-006047,24WBLDH01432-006971,25WBLDK02069-006648,25WBLGA05461-007349,25WBLDK03527-006047,25SBLDF03076-007092,25WBLGC02391-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02018-006648,25SBLDC11237-007110,25SBLGC02432-007104,25WBLDC03096-006047,24WBLDF08400-006987,24WBLDK03212-006990,24WBLDC03051-006047,25WBLDC02177-007284,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDK03120-006951,24WBLDC02064-006100,24WBLDK03122-006955,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "016078": {
        "Stato": "IT",
        "CAP": "10098",
        "Localit\u00e0": "RIVOLI",
        "Indirizzo": "CORSO SUSA 301/307- c/o CC Galleria dei Mercanti n. 34",
        "Insegna": "FREEDOM",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDA05467-006434,25SBLDC03003-006950,25WBLUC03074-006355,25WBLDC03097-006047,25SBLUP01189-006804,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUF01184-006804,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUH02244-007100,25WBLDC03096-006047,25WBLUA05297-006127,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02241-007100,25WBLDK03103-006047,25SBLUC03012-006719,24WBLDC02016-006940,24WBLDA05465-006127,25SBLUH02275-007100,25WBLDK03495-006047,25SBLDC03006-006950,25SBLUX02230-005958,25WBLDA05335-007349,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03102-006047,25SBLUP02352-006855,25WBLDA05337-006127"
    },
    "016098": {
        "Stato": "IT",
        "CAP": "89034",
        "Localit\u00e0": "BOVALINO",
        "Indirizzo": "VIA XXIV MAGGIO 1/A",
        "N.ri Tel.": "3357826197",
        "Insegna": "ANTONELLA ABBIGLIAMENTO BOVALINO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03039-006950,24WBLDK03052-006047"
    },
    "016106": {
        "Stato": "IT",
        "CAP": "05018",
        "Localit\u00e0": "ORVIETO",
        "Indirizzo": "VIA DEL DUOMO, 68",
        "N.ri Tel.": "3480886463",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUM01482-007168,25SBLUM01480-007168,24WBLDX03318-006992"
    },
    "016117": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "SQUINZANO",
        "Indirizzo": "VIA GINO DE SANCTIS",
        "N.ri Tel.": "393 4840377",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP04353-007129"
    },
    "016121": {
        "Stato": "IT",
        "CAP": "73024",
        "Localit\u00e0": "MAGLIE",
        "Indirizzo": "VIA ROMA,26",
        "N.ri Tel.": "328 4548830",
        "Insegna": "VIA ROMA",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25WBLUC02079-005958,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,25WBLDB03191-007294,25SBLUP04062-007092,25SBLUC01211-007101,25SBLDS01366-007141,25SBLUP04353-007129,25SBLUM01486-007172,24WBLDK03122-006955,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDA05337-006127,25WBLUK03142-005480,25WBLUA05299-006127,25SBLUH02195-004547,25SBLUM01478-007167,25SBLDP01344-006855,25SBLUC04206-006535,25SBLDC04070-007109,25SBLUP02063-007092,25WBLUC03090-006719,25SBLUH02109-006526,24WBLDL01421-007016,25SBLDV03365-007143,25SBLDP04142-007109,25SBLDS01291-007141,25SBLDC02264-006648,25SBLDC03007-006950,25SBLUS01337-007137,25SBLDC04333-007109,24WBLDA05465-006127,25WBLUC06082-005480,25WBLDA05335-007349,25SBLUM01476-006233,25SBLUC11569-006787,25SBLDS01292-007141,25WBLUX02081-005958,25WBLUC03074-006355,25WBLDP04294-007324,25SBLUC11207-006787,25SBLUF01568-007121,24WBLDP03447-007025,25WBLDC02170-006648,25WBLUA05301-006434,25SBLUH05028-006846,25WBLUC02079-A05958"
    },
    "016128": {
        "Stato": "IT",
        "CAP": "70122",
        "Localit\u00e0": "BARI",
        "Indirizzo": "VIA NICCOLO' PICCINI, 49",
        "Insegna": "SAMUEL",
        "CODICE PRODOTTO KOOOMO": "25SBLUC04176-006854,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUC11569-006787,25SBLUH02196-004547,25SBLUK11239-007110,25SBLUM01476-006233,25SBLUS01340-007138,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUT02313-006818"
    },
    "016142": {
        "Stato": "IT",
        "CAP": "26013",
        "Localit\u00e0": "CREMA",
        "Indirizzo": "VIA CAVOUR 2 ANGOLO VIA MAZZINI",
        "N.ri Tel.": "0373/81837",
        "Insegna": "ENRICO IV",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUC03012-006719,24WBLDA05465-006127,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25SBLUF03185-006804"
    },
    "016149": {
        "Stato": "IT",
        "CAP": "73020",
        "Localit\u00e0": "CASTRI' DI LECCE",
        "Indirizzo": "VIA G. BRODOLINI ANG VIA MENOTTI SNC",
        "Insegna": "SMACH",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC03233-007308,24WBLDC02064-006100,25WBLUC02080-005958,25WBLUC02079-005958,24WBLDC02041-006648,25WBLUC03074-006355,25WBLDC03095-006047"
    },
    "016244": {
        "Stato": "IT",
        "CAP": "93012",
        "Localit\u00e0": "GELA",
        "Indirizzo": "CORSO SALVATORE ALDISIO, 78",
        "N.ri Tel.": "3935299693",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787"
    },
    "016281": {
        "Stato": "IT",
        "CAP": "56031",
        "Localit\u00e0": "BIANTINA",
        "Indirizzo": "VIA DEL MONTE EST, 91",
        "N.ri Tel.": "0587 398155",
        "Insegna": "DIVO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02177-007284,25WBLUC03086-006047,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "016427": {
        "Stato": "IT",
        "CAP": "20095",
        "Localit\u00e0": "CUSANO MILANINO",
        "Indirizzo": "VIA SORMANI, 52",
        "N.ri Tel.": "347/5337685",
        "Insegna": "BROOMLEY",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648"
    },
    "016434": {
        "Stato": "IT",
        "CAP": "20021",
        "Localit\u00e0": "BOLLATE",
        "Indirizzo": "VIA CAVOUR, 14",
        "N.ri Tel.": "02-3503468",
        "Insegna": "CALZATURE DANIEL",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC03090-006719,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDH02374-006842,25SBLUP01189-006804,25SBLDP01079-007092,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLDF03076-007092,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUH02192-004547,25WBLDC03096-006047,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUT02306-006801,25SBLUC03012-006719,25WBLDK03103-006047,25SBLDF08078-007092,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUC01281-007105"
    },
    "016437": {
        "Stato": "IT",
        "CAP": "20089",
        "Localit\u00e0": "ROZZANO",
        "Indirizzo": "VIA ISONZO , 26",
        "N.ri Tel.": "339/2321992",
        "Insegna": "BROOMLEY",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,25WBLUC03090-006719,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDK02363-005831,25WBLDK03103-006047,25SBLUC03012-006719,25SBLDC04070-007109,24WBLDK03122-006955,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111,25SBLUC01217-007108,25WBLDC11163-007110,25SBLUF03185-006804"
    },
    "016510": {
        "Stato": "IT",
        "CAP": "17011",
        "Localit\u00e0": "ALBISOLA SUPERIORE",
        "Indirizzo": "VIA COLOMBO, 48",
        "N.ri Tel.": "019-488277",
        "Insegna": "L'OSTRICA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDX02235-006648,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDK03103-006047,25SBLUX02230-005958,25SBLUL02583-007370,25SBLUT02315-007117,25SBLDC01279-007111"
    },
    "016627": {
        "Stato": "IT",
        "CAP": "80058",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PLINIO, 377",
        "N.ri Tel.": "340 4110645",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03086-006976,25SBLUC11541-007110"
    },
    "016629": {
        "Stato": "IT",
        "CAP": "74100",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA F. DI PALMA, 130",
        "N.ri Tel.": "099 4593571",
        "Insegna": "ANDRIANI",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05467-006434,24WBLDA05467-006434,24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDK03052-006047,24WBLDK03052-006047"
    },
    "016640": {
        "Stato": "IT",
        "CAP": "73018",
        "Localit\u00e0": "SQUINZANO",
        "Indirizzo": "VIA MAZZINI 8",
        "N.ri Tel.": "3384096404",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016642": {
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PLINIO, 377",
        "N.ri Tel.": "340 4110645",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016649": {
        "Stato": "RU",
        "CAP": "6100",
        "Localit\u00e0": "TULA",
        "Indirizzo": "VIA INDIPENDENZA, 52",
        "N.ri Tel.": "06 9397742",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03527-006047,25SBLUS01337-007137,25SBLUC11215-007110"
    },
    "016730": {
        "Stato": "IT",
        "CAP": "84086",
        "Localit\u00e0": "ROCCAPIEMONTE",
        "Indirizzo": "CORSO MARIO PAGANO 81",
        "N.ri Tel.": "081 933907",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016768": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA SANTA MARIA ANTESAECULA 1",
        "N.ri Tel.": "081 456111",
        "Insegna": "BY ANITA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,24WBLDK03037-006950,25WBLDK03101-006047,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,24WBLDK02556-006646,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLDC03099-006047,24WBLDC02112-006631"
    },
    "016781": {
        "Stato": "IT",
        "CAP": "80146",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO SAN GIOVANNI A TEDUCCIO, 246",
        "N.ri Tel.": "366 3757055",
        "Insegna": "NIKLO'",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC01221-007108,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02556-006646,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDK02073-006648,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,24WBLDK03212-006990,24WBLDC03051-006047,25WBLDC02170-006648,25SBLDC01328-007131,25WBLDK03098-006047,24WBLDK03040-006950,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "016807": {
        "Stato": "IT",
        "CAP": "64011",
        "Localit\u00e0": "ALBA ADRIATICA",
        "Indirizzo": "VIA VITTORIO VENETO, 57",
        "Insegna": "FASHION",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25WBLUC03086-006047,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUP02352-006855,25SBLUC01217-007108,25WBLDA05337-006127,25WBLUC11083-007110,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDK02042-006648,25SBLUF03186-006804,25SBLDP01344-006855,25SBLUH02276-005695,25SBLUC04206-006535,25SBLUH02275-007100,25SBLUC01034-007111,25WBLDC03099-006047,25SBLDC01279-007111,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLDC03003-006950,24WBLDC03038-006950,24WBLDC02290-006646,25SBLUH02379-007147,25WBLDC03096-006047,25SBLUT02309-007125,25SBLDC03007-006950,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDC03097-006047,25SBLDH02372-005707,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUT02313-006818,25SBLUH02192-004547,25WBLDK11162-007110,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUH02199-004547,25SBLUH02274-007100,25WBLDK03098-006047"
    },
    "016845": {
        "Stato": "IT",
        "CAP": "08048",
        "Localit\u00e0": "TORTOLI",
        "Indirizzo": "VIA MICHELANGELO, 24",
        "N.ri Tel.": "0782 624122",
        "Insegna": "VICEVERSA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,25WBLUC03233-007308,24WBLDC02352-006977,25WBLUX02081-005958,25WBLUC03074-006355,25WBLDC03095-006047"
    },
    "016948": {
        "Stato": "IT",
        "CAP": "35028",
        "Localit\u00e0": "PIOVE DI SACCO",
        "Indirizzo": "VIA FRATELLI SANGUINAZZI, 1",
        "Insegna": "UOMO FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUT02110-006526,25SBLUT02312-006803,25SBLUT02310-006817,25SBLUC03012-006719,25SBLUX02230-005958,25WBLUK03142-005480,25WBLUA05299-006127,25SBLUC03011-006719,25SBLUH02195-004547,25SBLUH02242-007100,25SBLUM01478-007167,25SBLUH02276-005695,25WBLUA05298-006127,25WBLDC03099-006047,25SBLUF03185-006804,25WBLUC03090-006719,25SBLUH02109-006526,25SBLUC11215-007110,25SBLUF01184-006804,25SBLUH02197-004547,25SBLUH02244-007100,25SBLUS02336-007137,25SBLUT02309-007125,24WBLDB03294-005553,25SBLUF02188-006804,25SBLUM01476-006233,25SBLUH02193-004547,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,25SBLUH02191-004547,25SBLUB01216-007111,25SBLUT02313-006818,25SBLUH02192-004547"
    },
    "016955": {
        "Stato": "IT",
        "CAP": "83024",
        "Localit\u00e0": "MONTEFORTE IRPINO",
        "Indirizzo": "VIA VALLE, 20 - C.C. MONTEDORO",
        "N.ri Tel.": "081 7595711",
        "Insegna": "FASHION ITALY",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC03047-006047,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25WBLDK03102-006047,24WBLDC03048-006047"
    },
    "016991": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "PIAZZA XX SETTEMBRE, 8",
        "N.ri Tel.": "055 8798664",
        "Insegna": "RICICLO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02242-007100,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02197-004547,24WBLDC02018-006648,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDC03048-006047,25WBLDK03098-006047,25WBLUC02079-A05958"
    },
    "017004": {
        "Stato": "IT",
        "CAP": "72027",
        "Localit\u00e0": " SAN PIETRO VERNOTICO",
        "Indirizzo": "VIA BRINDISI 258",
        "N.ri Tel.": "3935328458",
        "Insegna": "FULL SERVICE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLDX03008-006950,25SBLUC11569-006787,25SBLUH02193-004547,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUK03142-005480,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUC04163-006788,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUH02191-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC11083-007106,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUC02079-A05958"
    },
    "017006": {
        "Stato": "IT",
        "CAP": "70054",
        "Localit\u00e0": "GIOVINAZZO",
        "Indirizzo": "VIA AGOSTINO GIOIA 13 15",
        "N.ri Tel.": "3461356719",
        "Insegna": "DEPERGOLA DAL 1942",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDA05467-006434,25SBLDH02374-006842,25SBLUP01189-006804,24WBLDL01417-006668,24WBLDK03052-006047,25SBLDF03201-006804,25SBLUC11207-006787,25SBLUH02194-004547,25WBLDK02069-006648,24WBLDK02042-006648,25WBLUC03233-007308,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02195-004547,25WBLDB03191-007294,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUH02197-004547,25SBLDH02389-007144,25SBLUT02313-006818,25SBLDH02377-007144,24WBLDF08400-006987,25SBLUT02309-007125,25SBLDC02232-007104,25SBLUT02310-006817,25SBLDF03257-007113,24WBLDC03051-006047,24WBLDK03120-006951,25SBLUH02275-007100,25SBLDC04070-007109,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUM01476-006233"
    },
    "017013": {
        "Stato": "IT",
        "CAP": "36047",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "0444 635146",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDM01427-005794,25SBLDB04068-007109,25SBLDC01329-007131,25SBLDC02234-006648,25SBLDC02236-006648,25SBLDC02251-006648,25SBLDC02264-006648,25SBLDC02266-007124,25SBLDC02289-007119,25SBLDC02330-007119,25SBLDC02357-007124,25SBLDC03003-006950,25SBLDC03006-006950,25SBLDC03007-006950,25SBLDC04331-006788,25SBLDC04333-007109,25SBLDF03201-006804,25SBLDF03257-007113,25SBLDH02389-007144,25SBLDL02396-007156,25SBLDL02399-007155,25SBLDP01140-007109,25SBLDP02143-007109,25SBLDP04142-007109,25SBLDX02235-006648,25SBLDX02290-007119,25SBLDX03008-006950"
    },
    "017016": {
        "Stato": "IT",
        "CAP": "20025",
        "Localit\u00e0": "LEGNANO",
        "Indirizzo": "VIA CORRIDONI, 3",
        "N.ri Tel.": "0331 453436",
        "Insegna": "BLOCK61",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUX02081-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC02080-005958,25WBLUC02132-007284"
    },
    "017033": {
        "Stato": "IT",
        "CAP": "18038",
        "Localit\u00e0": "SANREMO",
        "Indirizzo": "VIA FERALDI 9",
        "N.ri Tel.": "0184- 540048",
        "Insegna": "DENIM",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03090-006719,25WBLDC03096-006047,25WBLUC03233-007308,25WBLDC02178-006646,25WBLDC03099-006047,25WBLUC03074-006355,25WBLDC03095-006047,24WBLDK03039-006950"
    },
    "017074": {
        "Stato": "IT",
        "CAP": "16036",
        "Localit\u00e0": "RECCO",
        "Indirizzo": "VIA ROMA 36",
        "N.ri Tel.": "334 - 7239205",
        "Insegna": "GIUSE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUF01184-006804,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUB04167-006854,25WBLDK03495-006047,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUT02315-007117"
    },
    "017088": {
        "Stato": "IT",
        "CAP": "20146",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "PIAZZA FRATTINI ANG. VIA BARZILLAI 2",
        "Insegna": "DIANA SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDK02042-006648,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDC03048-006047,25WBLUC02079-A05958"
    },
    "017187": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "BENEVENTO",
        "Indirizzo": "CORSO GARIBALDI, 119-121",
        "N.ri Tel.": "0824 21110",
        "Insegna": "MAG JHON",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,24WBLDC02314-006631,24WBLDK03052-006047,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUM06481-007168,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDA05465-006127,25WBLUC06082-005480,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25SBLUM01479-007167,25SBLUC04163-006788,25SBLDC01279-007111"
    },
    "017190": {
        "Stato": "IT",
        "CAP": "88811",
        "Localit\u00e0": "CIRO' MARINA",
        "Indirizzo": "VIALE DELLA LIBERTA', 79",
        "N.ri Tel.": "0962 1905259",
        "Insegna": "GENTILE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC01260-007108,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03036-006950,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUC03011-006719,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25WBLDC03096-006047,24WBLDC03051-006047,25SBLUT02306-006801,25SBLDC04333-007109,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDK03120-006951,25SBLDC02236-006648,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDC03099-006047,25SBLDC04066-007109,25SBLUC01281-007105"
    },
    "017192": {
        "Stato": "IT",
        "CAP": "17031",
        "Localit\u00e0": "ALBENGA",
        "Indirizzo": "VIA GIAN MARIA ODDO, 13",
        "N.ri Tel.": "0182 020991",
        "Insegna": "VIA ODDO 13",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017201": {
        "Stato": "IT",
        "CAP": "87063",
        "Localit\u00e0": "CARIATI MARINA",
        "Indirizzo": "VIA BARI, 37/A",
        "Insegna": "CENTRO MODA GINA NIGRO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25SBLUS01339-007137,25SBLDH02372-005707,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUP01350-006855,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUH02108-006864,25SBLDT02125-006526,25SBLUH02191-004547,25SBLUF03186-006804,25SBLUH02197-004547,25SBLUH02244-007100,25SBLUH02192-004547,25SBLDC02264-006648,25SBLDH02377-007144,25SBLUT02309-007125,25SBLUC04206-006535,25SBLDK01249-007111,25SBLUT02310-006817,25SBLUS01338-007137,25WBLDC03095-006047,25SBLDT02138-006526,25SBLDC04333-007109,25WBLDC02170-006648,25SBLUF01055-007092,25SBLDH02375-006842,25SBLUX02230-005958,25WBLUC02132-007284,25WBLDC03099-006047"
    },
    "017203": {
        "Stato": "IT",
        "CAP": "80013",
        "Localit\u00e0": "CASALNUOVO DI NAPOLI",
        "Indirizzo": "VIA BENEDETTO FONTANA, 10",
        "N.ri Tel.": "081-8425474",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02251-006631"
    },
    "017248": {
        "Stato": "IT",
        "CAP": "33170",
        "Localit\u00e0": "PORDENONE",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 16",
        "N.ri Tel.": "349 4314897",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950"
    },
    "017258": {
        "Stato": "IT",
        "CAP": "25017",
        "Localit\u00e0": "LONATO DEL GARDA",
        "Indirizzo": "VIA MANTOVA, 36 - C.C. IL LEONE SHOPPING CENTER",
        "N.ri Tel.": "0423 400145",
        "Insegna": "NEGOZI PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,24WBLDC02049-006636,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUH02196-004547,25WBBXC02456-005958,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLGC02391-006648,25SBLUH02191-004547,25WBLDC03100-006047,25WBLKC02427-005958,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUH02276-005695,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUC03012-006719,25WBLDK03103-006047,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDA05335-007349,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "017288": {
        "Stato": "IT",
        "CAP": "03011",
        "Localit\u00e0": "ALATRI",
        "Indirizzo": "VIA LA STAZZA 34",
        "N.ri Tel.": "0775443004",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03051-006047,24WBLDK11337-006007"
    },
    "017293": {
        "Stato": "IT",
        "CAP": "45014",
        "Localit\u00e0": "PORTO VIRO",
        "Indirizzo": "VIA PO VECCHIO 5",
        "N.ri Tel.": "3392686972",
        "Insegna": "BRANDS FACTORY",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC03114-006719,25WBLUC02079-005958,25WBLUK03142-005480,25WBLUC03074-006355,25SBLDC01222-007108,25SBLUC11215-007110,24WBLDC03036-006950,25SBLDH02381-007114,25SBLDF03201-006804,25SBLUC11541-007110,25SBLUH02194-004547,24WBLDC03298-006992,24WBLDK02042-006648,25SBLUF01184-006804,25SBLDT02125-006526,25SBLUX03226-006719,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDK03039-006950,25SBLUH02197-004547,25SBLDH02389-007144,25SBLUT02312-006803,25SBLUC01211-007101,25SBLUH02379-007147,25WBLDK11162-007110,25SBLDK01249-007111,25SBLUT02310-006817,25SBLDT02138-006526,25SBLUT02306-006801,25WBLDC03092-006719,25WBLDK02192-006648,25SBLUH02199-004547,25WBLDK03102-006047,25SBLDC04066-007109,25SBLDC01279-007111"
    },
    "017297": {
        "Stato": "IT",
        "CAP": "10079",
        "Localit\u00e0": "MONCALIERI",
        "Indirizzo": "VIA RIVAROLO , 71",
        "N.ri Tel.": "011-8953288",
        "Insegna": "MOMI PLANET",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDK02556-006646,25SBLUF01184-006804,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUT02312-006803,25WBLDC03096-006047,25SBLUC02231-005958,25WBLDC03095-006047,24WBLDB03294-005553,25WBLUC03086-006047,25SBLUF02188-006804,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "017304": {
        "Stato": "IT",
        "CAP": "76013",
        "Localit\u00e0": "MINERVINO MURGE",
        "Indirizzo": "CORSO MATTEOTTI 6",
        "N.ri Tel.": "0883 692933",
        "Insegna": "BLU & CO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25SBLDC01222-007108,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUH02108-006864,25WBLDC03100-006047,25SBLUB01216-007111,25SBLUC04176-006854,24WBLDC02290-006646,25SBLUC01219-007108,25SBLDC11237-007110,25WBLDK11162-007110,24WBLDC03211-006990,25SBLDC04331-006788,25WBLDC02170-006648,25SBLUC03012-006719,24WBLDF01398-006987,25SBLDC02236-006648,25SBLDC04070-007109,25WBLUC06082-005480,24WBLDC02352-006977,25SBLUX02230-005958,25SBLDC03006-006950,25SBLDC04066-007109,25WBLUC02079-A05958"
    },
    "017366": {
        "Stato": "IT",
        "CAP": "74023",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA BERARDI, 59",
        "N.ri Tel.": "099 4529108 amm",
        "Insegna": "DI PIERRO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02049-006636,24WBLDC02112-006631,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03252-007008,24WBLDK03037-006950,24WBLDP03447-007029,25SBLDC01222-007108,25SBLDC01260-007108,25SBLDC01359-007101,25SBLDC02128-007103,25SBLDC02232-007104,25SBLDC02233-007104,25SBLDX03008-006950"
    },
    "017370": {
        "Stato": "IT",
        "CAP": "50058",
        "Localit\u00e0": "SIGNA",
        "Indirizzo": "VIA MACELLI, 22",
        "N.ri Tel.": "366-2045058 Giuseppe",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017371": {
        "Stato": "IT",
        "CAP": "72100",
        "Localit\u00e0": "BRINDISI",
        "Indirizzo": "VIA APPIA 269",
        "N.ri Tel.": "0831 514242",
        "Insegna": "FREE TIME",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,25SBLUC01219-007108,25SBLUP04062-007092,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02310-006817,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUM01479-007167,25WBLUC11083-007110,25SBLUP05190-006804,25SBLUT02308-006801,25SBLDP01079-007092,25SBLUH02195-004547,24WBLDC02041-006648,25SBLDK01249-007111,25SBLUH02275-007100,25WBLDC03099-006047,25SBLUF03185-006804,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25SBLUP01189-006804,25SBLDC01358-007101,25SBLUF01184-006804,25SBLUH02108-006864,25SBLUH02244-007100,25WBLDC03095-006047,25SBLDC04333-007109,25WBLDC11163-007110,24WBLDC11209-006007,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03098-006047"
    },
    "017384": {
        "Stato": "IT",
        "CAP": "07026",
        "Localit\u00e0": "OLBIA",
        "Indirizzo": "VIALE ALDO MORO, 219 - ANGOLO VIA VIGNOLA",
        "N.ri Tel.": "078958344",
        "Insegna": "GENTRY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25WBLDK11162-007110,24WBLDC02352-006977,25WBLDC02178-006646,25SBLUX03226-006719"
    },
    "017386": {
        "Stato": "IT",
        "CAP": "00012",
        "Localit\u00e0": "GUIDONIA",
        "Indirizzo": "VIA DELLE GENZIANE, 13E",
        "N.ri Tel.": "0774-552687",
        "Insegna": "GOCCIA SHOP",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,25WBLDC02072-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC02234-006648,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDK03052-006047,25SBLUL02412-007155,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUC02254-007101,25SBLUX03226-006719,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,24WBLDF08400-006987,25SBLDC01159-007105,25SBLUC04206-006535,24WBLDH02433-006971,25WBLDC03095-006047,25SBLDC04333-007109,25SBLUC11214-007111,24WBLDB03294-005553,25SBLUC03012-006719,24WBLDC02064-006100,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "017393": {
        "Stato": "IT",
        "CAP": "71036",
        "Localit\u00e0": "LUCERA",
        "Indirizzo": "VIA ZUPPETTA, 24",
        "N.ri Tel.": "0881 530513",
        "Insegna": "REBECCA FASHION STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03038-006950,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDA05337-006127"
    },
    "017405": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA FORIA, 44",
        "N.ri Tel.": "081 450265",
        "Insegna": "DRESS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUK03142-005480,25WBLKC11416-007110,25WBLUC02079-005958,25WBBXC02456-005958,25SBLKF03551-007187,25SBLGF02547-007187,25SBLGC01441-007111,25WBLUC03233-007308,25SBLKH02555-007188,25SBLGP05549-007187,25WBLKC02427-005958,25SBLKC11440-007111,25SBLKP05558-007187,25SBLKF02553-007187,25SBLKP01554-007187,25WBLUC06082-005480,25WBLUC02079-A05958,25SBLGH02550-007188,25WBLKC02429-005958"
    },
    "017410": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "SENIGALLIA",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "071-79821811",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDL01417-006668,25WBLDK02069-006648,24WBLDC02044-006648"
    },
    "017450": {
        "Stato": "IT",
        "CAP": "66051",
        "Localit\u00e0": "CUPELLO",
        "Indirizzo": "CORSO DUCA DEGLI ABRUZZI 50,",
        "N.ri Tel.": "0873 319758",
        "Insegna": "MARCHESANI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDA05336-007349,25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,25WBLDC03100-006047,25WBLDK02073-006648,24WBLDK03039-006950,25SBLDC02232-007104,25SBLUF03187-006804,25SBLUC03012-006719,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDH02373-005707,24WBLDC03048-006047,25WBLDA05337-006127,25WBLUC11083-007110,24WBLDC03084-006976,25SBLUN01521-006581,25WBLUK03142-005480,25SBLDC02234-006648,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUF03186-006804,24WBLDK03297-006992,25WBLDC02177-007284,25WBLUC02153-007300,25WBLDC03099-006047,25SBLUF03185-006804,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03298-006992,25SBLUH02108-006864,25WBLDC03096-006047,25SBLUT02309-007125,24WBLDX03318-006992,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02132-007284,25WBLDK03102-006047,25WBLDA05335-007349,25WBLDC03097-006047,25SBLDC02233-007104,25WBLDC02072-006648,25WBLUX02081-005958,25WBLDC03357-007294,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUH02191-004547,25SBLUC02228-007104,25SBLUC02231-005958,25WBLDC02170-006648,25WBLDF08248-006948,25WBLDK03098-006047"
    },
    "017456": {
        "Stato": "IT",
        "CAP": "73042",
        "Localit\u00e0": "CASARANO",
        "Indirizzo": "ZONA INDUSTRIALE TRONCO A 5/6",
        "N.ri Tel.": "0833 502452",
        "Insegna": "MAXIMUS",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25WBLDC02072-006648,24WBLDC03119-006951,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLDC03173-007307,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDK02556-006646,25SBLUC04176-006854,25SBLDC01359-007101,24WBLDB02092-006976,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02276-005695,25WBLDC03096-006047,25SBLUK11239-007110,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC06082-005480,24WBLDC02352-006977,25WBLUC02080-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "017481": {
        "Stato": "IT",
        "CAP": "89024",
        "Localit\u00e0": "POLISTENA",
        "Indirizzo": "PIAZZETTA GARIBALDI 4",
        "N.ri Tel.": "0966 931479",
        "Insegna": "CARBONE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03084-006976,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,25WBLUC02077-006943,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDC03100-006047,25SBLUC01219-007108,25WBLDC03096-006047,25SBLDC02232-007104,24WBLDC03051-006047,25WBLUC03086-006047,25SBLUC03013-006719,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLDC03097-006047,25SBLDC01279-007111"
    },
    "017499": {
        "Stato": "IT",
        "CAP": "70010",
        "Localit\u00e0": "CAPURSO",
        "Indirizzo": "LARGO SAN FRANCESCO 5",
        "N.ri Tel.": "080 4559692",
        "Insegna": "KATERINA PI",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,25WBLDC02178-006646,25WBLDK03102-006047,25WBLDC03099-006047"
    },
    "017504": {
        "Stato": "IT",
        "CAP": "75014",
        "Localit\u00e0": "GRASSANO",
        "Indirizzo": "VIA MERIDIONALE 122",
        "N.ri Tel.": "0835721025",
        "Insegna": "BOUTIQUE ANNECCA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDC03119-006951,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDH02374-006842,25WBLUC02077-006943,24WBLDC03036-006950,25SBLDP01079-007092,24WBLDK03052-006047,25SBLUH02194-004547,25SBLDV03365-007143,25SBLDF03076-007092,25WBLDB03191-007294,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUP04062-007092,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDK11162-007110,24WBLDC03211-006990,25SBLDC02232-007104,25SBLUC11083-007106,25SBLDC02128-007103,25WBLDC03095-006047,25SBLDC04331-006788,24WBLDC03051-006047,25SBLDC04333-007109,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02079-A05958,25SBLUP02063-007092,25WBLDC03097-006047"
    },
    "017547": {
        "Stato": "IT",
        "CAP": "67050",
        "Localit\u00e0": "LECCE NEI MARSI",
        "Indirizzo": "CORSO ITALIA 43",
        "N.ri Tel.": "3271761938",
        "Insegna": "LA BELLA VITA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC02234-006648,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,25SBLUP01189-006804,25SBLDP01079-007092,24WBLDK03052-006047,25SBLUH02194-004547,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUB01216-007111,25SBLUF03186-006804,25SBLUP04043-007130,24WBLDC02290-006646,25SBLUT02313-006818,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC02232-007104,24WBLDC03051-006047,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUC03012-006719,25WBLUC03086-006047,25SBLDF08078-007092,25SBLUF02188-006804,25SBLUC01034-007111,25SBLDC03006-006950,25SBLUX02230-005958,25WBLDA05335-007349,25WBLDC03099-006047"
    },
    "017552": {
        "Stato": "IT",
        "CAP": "06061",
        "Localit\u00e0": "CASTIGLIONE DEL LAGO",
        "Indirizzo": "VIA INDIPENDENZA 116 - POZZUOLO UMBRO",
        "N.ri Tel.": "3495104684",
        "Insegna": "CAMILLONI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25SBLDC02234-006648,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUF03186-006804,25SBLUT02313-006818,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLUS01337-007137,24WBLDC03051-006047,25WBLDK03103-006047,25WBLUC06082-005480,25WBLUC02080-005958,25WBLDK03098-006047,25WBLDC03097-006047,25SBLUM01476-006233"
    },
    "017555": {
        "Stato": "IT",
        "CAP": "40037",
        "Localit\u00e0": "SASSO MARCONI",
        "Indirizzo": "GALLERIA GUGLIELMO MARCONI 2 4",
        "N.ri Tel.": "335470192",
        "Insegna": "BERTOCCHI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02049-006636,25WBLUC08078-006355,25WBLDC02178-006646,24WBLDC03036-006950,25WBLUC03233-007308,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDK03297-006992,25WBLDK03103-006047,24WBLDC05357-005831,25WBLUC06082-005480,25WBLUC02080-005958,25WBLDC03099-006047"
    },
    "017562": {
        "Stato": "IT",
        "CAP": "95014",
        "Localit\u00e0": "GIARRE",
        "Indirizzo": " CORSO ITALIA 118",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017595": {
        "Stato": "IT",
        "CAP": "92100",
        "Localit\u00e0": "AGRIGENTO",
        "Indirizzo": "VIA ATENEA 159",
        "N.ri Tel.": "092222230",
        "Insegna": "CALABRO'",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDH02374-006842,25SBLDC01221-007108,25SBLUH02196-004547,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "017613": {
        "Stato": "IT",
        "CAP": "64010",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE ERITREA 70/D/E/F - AFRICANO",
        "N.ri Tel.": "O6 41734336",
        "Insegna": "NUVOLARI",
        "CODICE PRODOTTO KOOOMO": "25SBLUX02230-005958,25SBLUH02242-007100,25SBLUT02308-006801,25SBLUH02150-007100,25WBLUC03074-006355,25SBLUT02346-007132"
    },
    "017617": {
        "Stato": "IT",
        "CAP": "89900",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIA SPOGLIATORE SNC",
        "N.ri Tel.": "0963 604110",
        "Insegna": "GIANNINI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02018-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDK03039-006950"
    },
    "017618": {
        "Stato": "IT",
        "CAP": "89861",
        "Localit\u00e0": "TROPEA",
        "Indirizzo": "PIAZZA ERCOLE 24/25",
        "N.ri Tel.": "0963 604110",
        "Insegna": "GIANNINI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25WBLDC02072-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02109-006526,25WBLUC02077-006943,25SBLUC11207-006787,25SBLUL02412-007155,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02108-006864,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLDC02232-007104,25SBLDC03007-006950,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUT02306-006801,25WBLDK03103-006047,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDC03099-006047,25WBLUC02132-007284,25WBLUL01316-007012"
    },
    "017625": {
        "Stato": "IT",
        "CAP": "00172",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DEI CASTANI 59 63",
        "N.ri Tel.": " 3936272659",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017650": {
        "Stato": "IT",
        "CAP": "20841",
        "Localit\u00e0": "LIMBIATE",
        "Indirizzo": "VIA PREALPI 28",
        "N.ri Tel.": "0362 850179",
        "Insegna": "MASCHERONI",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017700": {
        "Stato": "IT",
        "CAP": "20831",
        "Localit\u00e0": "SEREGNO",
        "Indirizzo": "VIA MILANO 46",
        "N.ri Tel.": "0362-265780",
        "Insegna": "SPORTIT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDC02072-006648,25WBLUC03090-006719,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUH02196-004547,25SBLUP01189-006804,25SBLDP01079-007092,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC02342-006631,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLDF03076-007092,25SBLUB01216-007111,25SBLUF03186-006804,25SBLUH02192-004547,25SBLUC02228-007104,25SBLUC01211-007101,25SBLUP04062-007092,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDB03294-005553,25SBLUC03012-006719,25WBLDK03103-006047,25SBLDF08078-007092,25SBLDC03006-006950,24WBLDC03048-006047,25SBLDC04066-007109,24WBLDK03040-006950,25SBLDP05080-007092,25WBLDC03099-006047,25SBLDC01279-007111"
    },
    "017730": {
        "Stato": "IT",
        "CAP": "96014",
        "Localit\u00e0": "FLORIDIA",
        "Indirizzo": "VIA ROMA 11",
        "N.ri Tel.": "3891121405",
        "Insegna": "BON TON",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDK03052-006047,25SBLUC11541-007110,24WBLDC02041-006648,25WBLGC02391-006648,25SBLDC01359-007101,25SBLDC11237-007110,25WBLDC03096-006047,25SBLDC03007-006950,25WBLDC02170-006648,25SBLUC11214-007111,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLKC02429-005958"
    },
    "017750": {
        "Stato": "IT",
        "CAP": "64100",
        "Localit\u00e0": "TERAMO",
        "Indirizzo": "CORSO SAN GIORGIO, 8",
        "N.ri Tel.": "0861252347",
        "Insegna": "SOTTOSOPRA",
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02290-006646,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDK02556-006646,24WBLDK03037-006950,24WBLDK03040-006950,24WBLDK03052-006047,24WBLDK03122-006955,24WBLDK03297-006992,24WBLDX03318-006992,25SBLDC02289-007119,25SBLUH02394-007114"
    },
    "017799": {
        "Stato": "IT",
        "CAP": "LL53 7AS",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "0444 635146",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03346-006047"
    },
    "017803": {
        "Stato": "IT",
        "CAP": "88836",
        "Localit\u00e0": "VILLAGGIO PALUMBO",
        "Indirizzo": "PIAZZA PALAGHIACCIO",
        "N.ri Tel.": "0962/493042",
        "Insegna": "360 SLIDE SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25WBLUC02077-006943,25SBLUH02196-004547,24WBLDC03036-006950,25SBLUL02412-007155,24WBLDC03047-006047,24WBLDC03038-006950,25SBLDL02396-007156,25SBLUF01184-006804,24WBLDC02041-006648,24WBLDC02251-006631,25WBLGC02391-006648,25WBLKC02427-005958,25SBLUF03186-006804,24WBLDC02290-006646,25SBLUH02192-004547,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC03007-006950,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLDK03103-006047,25SBLDF08078-007092,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLKC02429-005958"
    },
    "017822": {
        "Stato": "IT",
        "CAP": "59013",
        "Localit\u00e0": "MONTEMURLO",
        "Indirizzo": "VIA MONTALESE, 475",
        "N.ri Tel.": "320 1157236",
        "Insegna": "NOIR BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC03119-006951,25SBLUH02193-004547,24WBLDC02049-006636,25WBLDK03101-006047,25WBLDC02178-006646,24WBLDC03114-006719,24WBLDA05467-006434,25SBLDC01222-007108,25SBLDH02374-006842,25WBLDK02069-006648,24WBLDC02041-006648,24WBLDC02290-006646,25SBLDC02264-006648,25WBLDC03096-006047,24WBLDH02433-006971,25SBLDC02232-007104,25SBLDK01249-007111,25SBLDH02370-006845,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDC02250-007008,25WBLDK03103-006047,25SBLDC02236-006648,24WBLDX03280-006719,25SBLDC01328-007131,25SBLDH02373-005707,25SBLUX02230-005958,25WBLDC03099-006047"
    },
    "017826": {
        "Stato": "IT",
        "CAP": "39011",
        "Localit\u00e0": "LANA",
        "Indirizzo": "VIA ANDREAS HOFER, 12",
        "N.ri Tel.": "0473 090244",
        "Insegna": "MAVE'",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25SBLUC11569-006787,25WBLDK03161-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDC01221-007108,25SBLDC11335-007110,25SBLUC11207-006787,24WBLDK02556-006646,25WBLDK02073-006648,24WBLDC02290-006646,25SBLUC01219-007108,25SBLUT02110-006526,25SBLDK01249-007111,25SBLUP04322-007129,25SBLUT02310-006817,25SBLDC02251-006648,25WBLDC02170-006648,24WBLDK02363-005831,24WBLDK03120-006951,25SBLDC01328-007131,25SBLUH02030-006846"
    },
    "017869": {
        "Stato": "IT",
        "CAP": "38010",
        "Localit\u00e0": "ANDALO",
        "Indirizzo": "VIALE TRENTO 7",
        "N.ri Tel.": "046-589003",
        "Insegna": "BOTTAMEDI SPORT ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25SBLDC01260-007108,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDH02377-007147,25SBLUH02196-004547,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUS02336-007138,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUT02313-006818,25SBLDH02377-007144,25WBLDC03096-006047,25SBLUS02336-007137,25WBLDC02170-006648,25SBLUL02409-006547,24WBLDB03294-005553,25SBLDH02386-007144,24WBLDL01420-007016,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDC11163-007110"
    },
    "017892": {
        "Stato": "IT",
        "CAP": "83059",
        "Localit\u00e0": "VALLATA",
        "Indirizzo": "CORSO KENNEDY, 86",
        "N.ri Tel.": "349-1492635",
        "Insegna": "PUOPOLO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03052-006047,24WBLDK03052-006047"
    },
    "017903": {
        "Stato": "IT",
        "CAP": "87075",
        "Localit\u00e0": "TREBISACCE",
        "Indirizzo": "VIA LEONCAVALLO SNC",
        "N.ri Tel.": "0981-551002",
        "Insegna": "PERESTROIKA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDA05467-006434,25WBLUC03074-006355,25SBLUN02510-007177,25SBLUC02280-005958,24WBLDC03038-006950,25SBLUH02194-004547,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUC01219-007108,25SBLUN02516-007177,25SBLUT02313-006818,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUN02513-007179,25SBLUH02241-007100,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC02170-006648,25SBLUF01055-007092,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDA05465-006127,25SBLUC04082-007159,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUA05298-006127,25WBLDA05335-007349,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUA05297-006127,25WBLDA05337-006127"
    },
    "017904": {
        "Stato": "IT",
        "CAP": "75013",
        "Localit\u00e0": "FERRANDINA",
        "Indirizzo": "CORSO VITTORIO EMANUELE 60",
        "N.ri Tel.": "0835554619",
        "Insegna": "TUNNEL",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,24WBLDC02049-006636,24WBLDC02044-006648,25SBLDS01292-007141,25WBLDA05336-007349,25WBLDC02178-006646,25WBLDK01376-007378,25WBLUC02079-005958,25WBLUK03142-005480,25SBLDH02374-006842,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02108-006864,25SBLUB01216-007111,25SBLDC01359-007101,24WBLDK03039-006950,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDH02377-007144,25WBLDK11162-007110,24WBLDF08400-006987,25SBLUC04206-006535,25SBLDK01249-007111,25SBLUT02310-006817,25SBLDC02128-007103,25SBLUP04353-007129,25SBLDF03257-007113,24WBLDC03051-006047,25SBLUT02306-006801,25SBLDP01140-007109,25SBLUC11214-007111,25WBLDC02170-006648,25SBLDH02386-007144,25SBLDC04070-007109,25SBLUP04354-007129,25SBLUX02230-005958,25WBLUA05301-006434,24WBLDF03399-006987,25WBLDC11163-007110,25SBLUM01476-006233"
    },
    "017943": {
        "Stato": "IT",
        "CAP": "24060",
        "Localit\u00e0": "SOVERE",
        "Indirizzo": "VIA PAPA GIOVANNI PAOLO I 9",
        "N.ri Tel.": "035/982627",
        "Insegna": "BOSIO FASHION",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUK03142-005480,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDK03527-006047,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDK03122-006955,25WBLUC06082-005480,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950"
    },
    "017944": {
        "Stato": "IT",
        "CAP": "20123",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA OLONA, 5",
        "N.ri Tel.": "02/89406514",
        "Insegna": "GRANDI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUK03142-005480,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDC11163-007110"
    },
    "017968": {
        "Stato": "IT",
        "CAP": "70026",
        "Localit\u00e0": "MODUGNO",
        "Indirizzo": "VIA PARADISO, 31 Z/B",
        "N.ri Tel.": "0805239462",
        "Insegna": "LIBRA ABBIGLIAMENTO UOMO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC04206-006535,25SBLUH02108-006864,25SBLUH02242-007100,25SBLUH02244-007100,25SBLUT02346-007132"
    },
    "018040": {
        "Stato": "IT",
        "CAP": "12100",
        "Localit\u00e0": "CUNEO",
        "Indirizzo": "CORSO GIOLITTI 17",
        "N.ri Tel.": "3470060821",
        "Insegna": "CERUTTI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUC03013-006719,25SBLUX02230-005958,25WBLDC03099-006047"
    },
    "018061": {
        "Stato": "IT",
        "CAP": "72015",
        "Localit\u00e0": "FASANO",
        "Indirizzo": "CORSO VITTORIO EMANUELE",
        "N.ri Tel.": "3381307821",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDV01146-007107,25SBLDC04070-007109"
    },
    "018066": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "VIA DEL CHIOSTRO, 9",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018090": {
        "Stato": "IT",
        "CAP": "80058",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PLINIO, 377",
        "N.ri Tel.": "340 4110645",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018092": {
        "Stato": "IT",
        "CAP": "15011",
        "Localit\u00e0": "ACQUI TERME",
        "Indirizzo": "CORSO ITALIA 95",
        "N.ri Tel.": "0144/55709",
        "Insegna": "Monkey Street",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUP05190-006804,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUP01189-006804,24WBLDC03047-006047,25SBLUF03186-006804,25SBLUH02192-004547,25SBLUT02310-006817,25WBLUC03086-006047,25SBLUF02188-006804,25SBLUH02199-004547"
    },
    "018104": {
        "Stato": "IT",
        "CAP": "16121",
        "Localit\u00e0": "SESTRI PONENTE",
        "Indirizzo": "VIA SESTRI 105 -107 R",
        "N.ri Tel.": "010 6531528",
        "Insegna": "BEBO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUC11215-007110,25SBLDX02235-006648,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC01115-007105,24WBLDC03038-006950,25SBLUC11541-007110,25SBLUF01184-006804,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDB03294-005553,25WBLUC03086-006047,24WBLDA05465-006127,25WBLDK03495-006047,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDK03102-006047,25SBLUT02315-007117,25WBLDK03098-006047,25WBLUA05297-006127,25SBLDC01279-007111,25SBLUF03185-006804"
    },
    "018117": {
        "Stato": "IT",
        "CAP": "26013",
        "Localit\u00e0": "CREMA",
        "Indirizzo": "VIA XX SETTEMBRE, 105",
        "N.ri Tel.": "0373 222997",
        "Insegna": "PETITE BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBLUC08078-006355,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02196-004547,24WBLDC03047-006047,25WBLGA05461-007349,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02192-004547,25SBLKX02418-005958,25WBLDC03096-006047,25SBLKC01445-007101,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,24WBLDB03294-005553,25SBLUC03012-006719,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDK03098-006047,25WBLKC02429-005958"
    },
    "018121": {
        "Stato": "IT",
        "CAP": "10147",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA STRADELLA, 215",
        "N.ri Tel.": "3462150758",
        "Insegna": "MOD EMPORIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC03090-006719,25SBLUA04528-007183,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDA05467-006434,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25WBLDC02196-007283,25WBLDP01291-007324,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDK03527-006047,25WBLDB03191-007294,25SBLUH02192-004547,25SBLUC02228-007104,24WBLDA05469-007037,25SBLUC01121-007105,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUF01055-007092,24WBLDB03294-005553,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC05125-007283,25WBLUA05298-006127,25SBLUH02199-004547,25WBLUA05301-006434,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDF08236-007301"
    },
    "018125": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "347 7006858",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01119-007105,24WBLDC02018-006648,25SBLUC03011-006719,25WBLUX02081-005958"
    },
    "018153": {
        "Stato": "IT",
        "CAP": "03024",
        "Localit\u00e0": "CEPRANO",
        "Indirizzo": "VIA CAMPIDOGLIO, 233",
        "N.ri Tel.": "0775 911122",
        "Insegna": "NEW AGE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC02044-006648,25WBLDC02178-006646,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUH02196-004547,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDK02073-006648,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,24WBLDC02018-006648,25SBLUH02192-004547,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25SBLUH02241-007100,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC06082-005480,24WBLDC02352-006977,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25SBLUL02583-007370,25WBLDC03099-006047,25WBLUC02079-A05958"
    },
    "018154": {
        "Stato": "IT",
        "CAP": "22032",
        "Localit\u00e0": "ALBESE CON CASSANO",
        "Indirizzo": "VIA MARCONI, 11",
        "N.ri Tel.": "031.422.0507",
        "Insegna": "CERES",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03114-006719,25WBLUX02081-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUB01216-007111,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUF03185-006804"
    },
    "018163": {
        "Stato": "IT",
        "CAP": "23041",
        "Localit\u00e0": "LIVIGNO",
        "Indirizzo": "VIA OSTARIA, 179",
        "N.ri Tel.": "0342 970210",
        "Insegna": "JACK & JACK",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05467-006434,24WBLDA05467-006434,24WBLDB03294-005553,24WBLDB03294-005553,24WBLDB03294-005553,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC02064-006100,24WBLDC02064-006100,24WBLDC02064-006100,24WBLDC02314-006631,24WBLDC02314-006631,24WBLDC02314-006631,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDC03119-006951,24WBLDC03119-006951,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK03040-006950,24WBLDK03040-006950,24WBLDK03052-006047,24WBLDK03052-006047,24WBLDK03052-006047,24WBLDK03122-006955,24WBLDK03122-006955,24WBLDM01427-005794,24WBLDM01427-005794,24WBLDM04428-005794,24WBLDM04428-005794,24WBLDM09261-006645,24WBLDM09261-006645,24WBLDM10259-006645,24WBLDM10259-006645,24WBLDM10408-007022,24WBLDM10408-007022,24WBLDM10555-007022,24WBLDM10555-007022,24WBLDP01448-006420,24WBLDP01448-006420,24WBLDP03446-007029,24WBLDP03447-007029"
    },
    "018169": {
        "Stato": "IT",
        "CAP": "07026",
        "Localit\u00e0": "OLBIA",
        "Indirizzo": "VIALE ALDO MORO, 219 - ANGOLO VIA VIGNOLA",
        "N.ri Tel.": "078958344",
        "Insegna": "GENTRY",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLUK03142-005480,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,25SBLUC11207-006787,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUH02108-006864,25SBLDT02125-006526,25SBLUX03226-006719,24WBLDK03039-006950,25SBLUT02110-006526,25WBLDC03096-006047,25WBLDK11162-007110,25SBLDC03007-006950,25SBLDT02138-006526,25WBLDC02170-006648,25SBLUF01055-007092,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC03048-006047,25SBLDC04066-007109,25WBLDC03099-006047,25SBLUC01217-007108"
    },
    "018179": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "POTENZA",
        "Indirizzo": "VIA ROMA, 18",
        "N.ri Tel.": "0971 21645",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01047-007120,25SBLUF03031-007094,25SBLUP05033-007094,25SBLUH02108-006864,25SBLUC02228-007104,25SBLDP04142-007109"
    },
    "018194": {
        "Stato": "IT",
        "CAP": "10137",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA BOSTON, 73/E",
        "N.ri Tel.": "011 327 9800",
        "Insegna": "DREAM SHOP",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,24WBLDC03084-006976,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25SBLDC02234-006648,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDK03052-006047,25SBLUC02229-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDK03293-005553,25WBLDC03100-006047,25SBLDC01359-007101,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02197-004547,24WBLDC02018-006648,25SBLUP04062-007092,25SBLUT02313-006818,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUT02309-007125,25SBLDC03007-006950,25SBLDC02232-007104,24WBLDC03051-006047,25SBLUF01055-007092,25WBLDK03103-006047,24WBLDC02016-006940,25WBLUC03086-006047,25SBLDC02236-006648,25SBLUF02188-006804,25WBLDK03495-006047,25WBLUC06082-005480,25SBLDC01328-007131,25WBLDK03102-006047,25WBLDC03099-006047"
    },
    "018202": {
        "Stato": "IT",
        "CAP": "00172",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DEI CASTANI, 41/43",
        "N.ri Tel.": "06 23234353",
        "Insegna": "GIANO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,25SBLKH02555-007188,25WBLDK02073-006648,25SBLUT02312-006803,25SBLKP05558-007187,25SBLKF02553-007187,25SBLUH02241-007100,24WBLDK03120-006951,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUM01479-007167,25SBLUH02030-006846,25SBLUP05190-006804,24WBLDK02042-006648,25SBLUX03226-006719,25SBLGP05549-007187,25WBLDK03527-006047,25SBLUF03186-006804,25SBLUC04206-006535,25SBLKP01554-007187,25WBLDC03099-006047,25WBLDC02178-006646,25SBLUP01189-006804,25SBLKF03551-007187,25SBLUF01184-006804,24WBLDC02290-006646,25SBLKX02418-005958,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDA05465-006127,25SBLGH02550-007188,25SBLUM01476-006233,24WBLDC11209-006007,25SBLUH02193-004547,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDK03052-006047,25SBLGC01441-007111,25SBLKC06443-007101,25SBLUH02191-004547,25SBLUT02306-006801,25SBLUH05028-006846,25SBLUT02315-007117"
    },
    "018208": {
        "Stato": "PL",
        "CAP": "95045",
        "Localit\u00e0": "RAVENNA",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "48 573 901 076",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02314-006631"
    },
    "018246": {
        "Stato": "IT",
        "CAP": "04022",
        "Localit\u00e0": "FONDI",
        "Indirizzo": "CORSO ITALIA, 30",
        "N.ri Tel.": "0773 709592",
        "Insegna": "SBARAGLIA",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,25SBLUS01339-007137,25SBLUN01521-006581,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC02342-006631,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDC02041-006648,25SBLUH02191-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDB03294-005553,24WBLDK03086-006976,25WBLUC03086-006047,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDK03098-006047,25SBLUM01476-006233"
    },
    "018258": {
        "Stato": "IT",
        "CAP": "54100",
        "Localit\u00e0": "MASSA",
        "Indirizzo": "VIA PUCCINI 12",
        "N.ri Tel.": "0585281506",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUT02110-006526"
    },
    "018268": {
        "Stato": "IT",
        "CAP": "18038",
        "Localit\u00e0": "SANREMO",
        "Indirizzo": "VIA VOLTURNO, 9/11",
        "N.ri Tel.": "0184/506093",
        "Insegna": "FREE ZONE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDC03047-006047,25SBLUC11541-007110,25SBLKH02555-007188,25SBLGC02426-006648,25WBLDC03100-006047,25SBLKP05558-007187,25SBLUC01121-007105,25SBLDC02232-007104,25SBLKF02553-007187,25SBLUC03012-006719,25WBLUC03086-006047,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUP05190-006804,25WBLUK03142-005480,24WBLDL01417-006668,25SBLUC01046-007120,25SBLUC03011-006719,25SBLDL02396-007152,25SBLUC01047-007120,25WBLDK03527-006047,25SBLGP05549-007187,25SBLUA04524-007182,25SBLKP01554-007187,25SBLUL02409-006547,24WBLDL01416-006669,25WBLDC03099-006047,25SBLGC02429-006648,25SBLDC01279-007111,25SBLDX03008-006950,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUA04527-007182,25WBBXC02456-005958,25SBLUP01189-006804,25SBLGF02547-007187,24WBLDC03038-006950,25SBLUX02255-007101,24WBLDC02290-006646,25WBLDC03096-006047,25SBLDC03007-006950,24WBLDC03051-006047,25WBLDK03103-006047,25SBLUF02188-006804,25SBLGH02550-007188,25WBLDC03097-006047,24WBLDC11209-006007,25SBLDC02233-007104,25SBLKF08561-007187,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC02254-007101,25SBLUH02192-004547,25WBLDC02170-006648,25SBLDC01328-007131,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "018270": {
        "Stato": "IT",
        "CAP": "96100",
        "Localit\u00e0": "SIRACUSA",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "0931-483634",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC02254-007101"
    },
    "018272": {
        "Stato": "IT",
        "CAP": "48124",
        "Localit\u00e0": "ALFONSINE",
        "Indirizzo": "CORSO MATTEOTTI, 69",
        "N.ri Tel.": "0544 864286",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDP01448-006420,25SBLDC02234-006648,25SBLDP01344-006855"
    },
    "018281": {
        "Stato": "IT",
        "CAP": "00177",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DI ACQUA BULLICANTE, 343",
        "N.ri Tel.": "06 299598",
        "Insegna": "BISOZIO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUT02346-007132,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDC02290-006646,25SBLUH02348-007132,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDB03294-005553,25SBLUC03012-006719,25SBLUH02275-007100,25WBLUC05125-007283,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLUC02079-A05958,25WBLDC03097-006047"
    },
    "018299": {
        "Stato": "IT",
        "CAP": "84012",
        "Localit\u00e0": "ANGRI",
        "Indirizzo": "VIA NAZIONALE, 178",
        "N.ri Tel.": "081947500",
        "Insegna": "MONTORO ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUC11214-007111,25WBLUC03086-006047,25SBLUP05190-006804,25WBLUK03142-005480,24WBLDC02314-006631,25SBLDH02374-006842,24WBLDK02556-006646,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDC03038-006950,25SBLUH02108-006864,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDC03211-006990,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDA05465-006127,24WBLDC02064-006100,25WBLUC06082-005480,25WBLDC03097-006047,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLDH02376-006842,25SBLUC11207-006787,24WBLDK03212-006990,25WBLDC02170-006648,25SBLDC01328-007131,25SBLDC04066-007109,25WBLDK03098-006047"
    },
    "018300": {
        "Stato": "IT",
        "CAP": "16139",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "335.6050313",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03252-007008,25SBLDC01279-007111"
    },
    "018301": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA ALIMENA SNC",
        "N.ri Tel.": "0968/750121",
        "Insegna": "MARVIN",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,25SBLUH02109-006526,25WBLUC02077-006943,25SBLUP01189-006804,25SBLUC11207-006787,25SBLUL02412-007155,25SBLUS02336-007138,25SBLUH02194-004547,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUF03186-006804,25SBLUH02197-004547,25SBLUC01219-007108,25SBLUC01211-007101,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUT02306-006801,25SBLUF01055-007092,25SBLUF02188-006804,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUP02063-007092,25SBLUM01476-006233"
    },
    "018315": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "C.SO VITTORIO EMANUELE 103",
        "N.ri Tel.": "0998 883040",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02199-004547,24WBLDC03048-006047,24WBLDF03399-006987"
    },
    "018316": {
        "Stato": "IT",
        "CAP": "74013",
        "Localit\u00e0": "GINOSA",
        "Indirizzo": "VIA LUGI GLIONNA, 40",
        "N.ri Tel.": "338- 9842960",
        "Insegna": "I MASCHI",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDL01417-006668,24WBLDK03052-006047,25SBLDB04068-007109,25SBLUC11207-006787,24WBLDK02042-006648,25SBLUF02101-007121,25SBLUM01478-007167,25SBLUP04043-007130,25SBLDP04142-007109,25SBLUT02313-006818,25SBLDC11237-007110,25WBLDC03096-006047,25WBLUF02118-007121,24WBLDM04428-005794,24WBLDC03051-006047,25SBLDT02138-006526,25WBLUF03119-007121,25SBLDC04333-007109,25WBLDC02170-006648,25SBLDH02386-007144,25WBLDK03103-006047,24WBLDA05465-006127,25SBLDC01328-007131,25SBLUX02230-005958,25WBLDF08248-006948,25WBLDC03099-006047,25SBLDC01329-007131"
    },
    "018326": {
        "Stato": "IT",
        "CAP": "00053",
        "Localit\u00e0": "CIVITAVECCHIA",
        "Indirizzo": "VIA SETTEVENE PALO ,81",
        "N.ri Tel.": "0766 370357",
        "Insegna": "PER LUI PER LEI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDC03084-006976,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01221-007108,25SBLUT02346-007132,24WBLDC03047-006047,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDB02092-006976,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUH02241-007100,25SBLUT02306-006801,25WBLDC02177-007284,25SBLUC03012-006719,24WBLDC02064-006100,25SBLUX02230-005958,25WBLUC02132-007284,25SBLUH02274-007100,24WBLDC03048-006047,25SBLDC04066-007109,25SBLUT02315-007117,25WBLUC02079-A05958"
    },
    "018328": {
        "Stato": "IT",
        "CAP": "00132",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA MASSA DI SAN GIULIANO, 329-331",
        "N.ri Tel.": "3398134761",
        "Insegna": "ORIANA",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDC03100-006047,25SBLUP04062-007092,25SBLUT02310-006817,25SBLDH02386-007144,25SBLDF08078-007092,25SBLUX02230-005958,24WBLDC03048-006047,25WBLDA05337-006127,25SBLUP05190-006804,25WBLUA05299-006127,25SBLDH02374-006842,25SBLDP01079-007092,25SBLUC02229-005958,25SBLUH02195-004547,25SBLDP05205-006804,25SBLDT02125-006526,25SBLUP04322-007129,25SBLUH02275-007100,25SBLDC04070-007109,25WBLUA05298-006127,25SBLDP05080-007092,25SBLUP02063-007092,25SBLDX03008-006950,24WBLDK03037-006950,25SBLDC03003-006950,25SBLUH02109-006526,25SBLUC11215-007110,25SBLUP01189-006804,24WBLDH01432-006971,25SBLUX02255-007101,25SBLUF01184-006804,24WBLDC02290-006646,25SBLUP05355-007139,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDP05141-007109,25WBLDK03103-006047,24WBLDA05465-006127,25WBLUC06082-005480,25WBLUC02132-007284,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDA05335-007349,25WBLDC03097-006047,25WBLDC11163-007110,25SBLDH02372-005707,25WBLUC03074-006355,24WBLDC03036-006950,25SBLDH02387-007144,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUT02313-006818,25SBLUH02192-004547,24WBLDH02433-006971,25SBLDF03257-007113,25WBLUC02079-A05958,25SBLUT02315-007117"
    },
    "018335": {
        "Stato": "IT",
        "CAP": "37016",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIA TOLMEZZO,34",
        "N.ri Tel.": "06-83923944",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018336": {
        "Stato": "IT",
        "CAP": "09028",
        "Localit\u00e0": "SESTU",
        "Indirizzo": "EX STRADA STATALE 131 KM 10,800",
        "N.ri Tel.": "070 22056",
        "Insegna": "ANTUOFERMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25WBLUC03090-006719,25WBLDC02178-006646,24WBLDC03114-006719,25WBLUC03074-006355,25WBLUL01316-007012,25SBLUH02109-006526,24WBLDC03036-006950,24WBLDC03038-006950,25SBLUC03011-006719,25SBLUH02191-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDC02170-006648,25SBLUC03012-006719,25WBLDC03092-006719,25WBLUC03086-006047,25SBLUC03013-006719,24WBLDC02352-006977,25SBLUX02230-005958,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25SBLUH02030-006846"
    },
    "018341": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "0444 356044",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02314-006631"
    },
    "018350": {
        "Stato": "IT",
        "CAP": "85022",
        "Localit\u00e0": "BARILE",
        "Indirizzo": "STRADA STATALE 93, snc",
        "N.ri Tel.": "0972 724350",
        "Insegna": "ROLEMA ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,25SBLUH02193-004547,25SBLDH02372-005707,25SBLDS01292-007141,25WBLDC02178-006646,25WBLDC03173-007307,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC03074-006355,25SBLDC01222-007108,25WBLDC03097-006047,25SBLDH02377-007147,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUP01350-006855,25WBLUC03233-007308,25SBLUH02195-004547,25SBLDH02387-007144,25WBLDC03100-006047,25SBLDC01359-007101,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDS01291-007141,24WBLDC02018-006648,25SBLUC01219-007108,25SBLUC02228-007104,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDK02363-005831,25SBLUF01055-007092,24WBLDB03294-005553,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDM01427-005794,25WBLDC03099-006047,25WBLDK03098-006047,25SBLUH02030-006846,25SBLUM01476-006233"
    },
    "018362": {
        "Stato": "IT",
        "CAP": "071000",
        "Localit\u00e0": "SASSARI",
        "Indirizzo": "VIA CAVOUR , 67",
        "N.ri Tel.": "347-6706763",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUM01479-007167"
    },
    "018365": {
        "Stato": "IT",
        "CAP": "90143",
        "Localit\u00e0": "ROSCIANO",
        "Indirizzo": "VIA VITTORIA, 15",
        "N.ri Tel.": "085 8505702",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUS02336-007138,24WBLDC03252-007008,25SBBGC02453-005958"
    },
    "018368": {
        "Stato": "IT",
        "CAP": "89231",
        "Localit\u00e0": "WIEN",
        "Indirizzo": "VIA GUGLIELMO OBERDAN,4",
        "N.ri Tel.": "0731-1409726",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018379": {
        "Stato": "IT",
        "CAP": "71042",
        "Localit\u00e0": "CERIGNOLA",
        "Indirizzo": "CORSO ALDO MORO 67/69",
        "N.ri Tel.": "0885 414821",
        "Insegna": "NEW TREND",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,24WBLDC02044-006648,25WBLDC02178-006646,24WBLDA05467-006434,25SBLDH02374-006842,25SBLDP01079-007092,24WBLDK03052-006047,25SBLDH02376-006842,25SBLDV03365-007143,25SBLDF03076-007092,25WBLDB03191-007294,24WBLDK03039-006950,25SBLDP04142-007109,25SBLDC11237-007110,25WBLDC03096-006047,24WBLDC03211-006990,24WBLDF08400-006987,24WBLDC03051-006047,25SBLDT02138-006526,25SBLDP01140-007109,25WBLDC02170-006648,25WBLDC11163-007110,25SBLDF08078-007092,25SBLDH02375-006842,25SBLDC01328-007131,25WBLUA05298-006127,25WBLDA05335-007349,25SBLDC04066-007109,25WBLDC03099-006047,24WBLDF03399-006987,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDV01146-007107,25WBLDA05337-006127,24WBLDC02112-006631"
    },
    "018381": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "TRAVERSETOLO",
        "Indirizzo": "VIALE DELLA VITTORIA 214",
        "N.ri Tel.": "368-3111345",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648"
    },
    "018384": {
        "Stato": "IT",
        "CAP": "90032",
        "Localit\u00e0": "BISACQUINO",
        "Indirizzo": "VIA DECANO DI VINCENTI, 82",
        "N.ri Tel.": "0918351214",
        "Insegna": "MC DOWELL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25WBLDC02178-006646,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUP01350-006855,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDB03191-007294,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "018385": {
        "Stato": "IT",
        "CAP": "58022",
        "Localit\u00e0": "FOLLONICA",
        "Indirizzo": "VIALE CARDUCCI, 31/33",
        "N.ri Tel.": "0566 58673",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUN01521-006581"
    },
    "018399": {
        "Stato": "IT",
        "CAP": "84122",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 184",
        "Insegna": "LAMBERTI FASHION",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,24WBLDC02044-006648,25WBLDA05336-007349,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,24WBLDK03086-006976,24WBLDA05465-006127,25WBLDK03102-006047,25WBLDA05335-007349,24WBLDC03048-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLDA05337-006127"
    },
    "018408": {
        "Stato": "IT",
        "CAP": "67051",
        "Localit\u00e0": "AVEZZANO",
        "Indirizzo": "VIA GARIBALDI, 106",
        "N.ri Tel.": "0863441428",
        "Insegna": "EMPORIO D'ANTONI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03051-006047,24WBLDC03051-006047,24WBLDK03052-006047"
    },
    "018411": {
        "Stato": "IT",
        "CAP": "25121",
        "Localit\u00e0": "BRESCIA",
        "Indirizzo": "CORSO PALESTRO, 28",
        "N.ri Tel.": "335/5630341",
        "Insegna": "SUITCORSOPALESTRO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUP01189-006804,25SBLUC11207-006787,25WBLUC03233-007308,25SBLUF01184-006804,25WBLUK11140-007286,25SBLUH02191-004547,25SBLUF03186-006804,25WBLUC02151-007287,25SBLUC02228-007104,25SBLUB04167-006854,25SBLUC04163-006788,25SBLUC01217-007108"
    },
    "018414": {
        "Stato": "IT",
        "CAP": "01037",
        "Localit\u00e0": "RONCIGLIONE",
        "Indirizzo": "VIALE 5 GIUGNO SNC",
        "Insegna": "BAGGIANI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDX03008-006950,24WBLDC03119-006951,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLDC03173-007307,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUP01189-006804,25SBLDP01079-007092,25SBLUC11207-006787,25SBLDH02376-006842,24WBLDC03047-006047,25SBLDC01358-007101,25WBLUC03233-007308,25SBLUF01184-006804,24WBLDC02041-006648,25SBLDT02125-006526,25SBLDF03076-007092,25SBLDP01344-006855,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUF01055-007092,25SBLUF02188-006804,24WBLDC02064-006100,25SBLDC01328-007131,25SBLUX02230-005958,25WBLDC03099-006047,24WBLDK03040-006950,25SBLUH02030-006846"
    },
    "018420": {
        "Stato": "IT",
        "CAP": "26900",
        "Localit\u00e0": "LODI",
        "Indirizzo": "CORSO VITTORIO EMANUELE II N 16",
        "N.ri Tel.": "0371/420163",
        "Insegna": "D&D",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLUC03090-006719,25WBLUK03142-005480,25WBLUC02079-005958,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02150-007100,25SBLUC11215-007110,24WBLDC03036-006950,25SBLUP01189-006804,25SBLDP01079-007092,25SBLUC11541-007110,25SBLUF01184-006804,25SBLDF03076-007092,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25SBLDC04333-007109,24WBLDK02363-005831,25WBLDK03103-006047,25SBLUH02275-007100,25SBLDC01328-007131,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,24WBLDK03040-006950,25SBLDC04066-007109,25WBLUC02079-A05958,25SBLUF03185-006804"
    },
    "018427": {
        "Stato": "IT",
        "CAP": "28883",
        "Localit\u00e0": "GRAVELLONA TOCE",
        "Indirizzo": "VIA GRANEROLO ANG. CORSO MILANO 141",
        "N.ri Tel.": "0323 840351",
        "Insegna": "SPORTWAY KIDS",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648"
    },
    "018462": {
        "Stato": "IT",
        "CAP": "28845",
        "Localit\u00e0": "DOMODOSSOLA",
        "Indirizzo": "CORSO PAOLO FERRARIS, 4",
        "N.ri Tel.": "0324 45878",
        "Insegna": "TOMMY IMMAGINE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308,25WBLUC02079-005958,25SBLUX02230-005958,25WBLUC03074-006355"
    },
    "018518": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA CARLO ALBERTO , 2",
        "N.ri Tel.": "3472541996",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,24WBLDK03039-006950"
    },
    "018532": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "BENEVENTO",
        "Indirizzo": "VIA DEI LONGOBARDI , 24",
        "Insegna": "ZEUS STORE",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018533": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "BENEVENTO",
        "Indirizzo": "VIA DEI LONGOBARDI , 24",
        "Insegna": "ZEUS STORE DONNA",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDK02556-006646,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03040-006950,24WBLDK11337-006007"
    },
    "018555": {
        "Stato": "IT",
        "CAP": "61032",
        "Localit\u00e0": "BELLOCCHI DI FANO",
        "Indirizzo": "VIA LUIGI EINAUDI, 90",
        "N.ri Tel.": "0717950215",
        "Insegna": "FEDERICO GIOMMI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDK03052-006047,24WBLDK11337-006007,25WBLUC03233-007308,24WBLDK02556-006646,24WBLDK02042-006648,25SBLUF01184-006804,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25SBLDS01291-007141,25SBLUT02110-006526,25SBLUT02313-006818,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,25SBLDK01249-007111,25SBLDS01366-007141,25WBLDC03095-006047,25SBLUT02306-006801,25SBLDH02386-007144,24WBLDK03120-006951,25WBLUC02080-005958,25WBLDC03099-006047"
    },
    "018571": {
        "Stato": "IT",
        "CAP": "60044",
        "Localit\u00e0": "FABRIANO",
        "Indirizzo": "VIALE PIETRO SERAFINI, 39",
        "Insegna": "RANALDI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02290-006646,24WBLDC03047-006047,24WBLDK03037-006950,24WBLDK03052-006047,24WBLDK03293-005553,25SBLDC01222-007108,25SBLDC02233-007104,25SBLDC02289-007119,25SBLDH02374-006842,25SBLDK01249-007111,25SBLDS01291-007141,25SBLDV03365-007143,25SBLUB04167-006854,25SBLUC04206-006535,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUF02188-006804,25SBLUH02191-004547,25SBLUH02276-005695,25SBLUP01189-006804,25SBLUP04043-007130,25SBLUT02313-006818"
    },
    "018575": {
        "Stato": "IT",
        "CAP": "28717",
        "Localit\u00e0": "TERNI",
        "Indirizzo": "VIA L. NOBILI, 24",
        "N.ri Tel.": "0744 429523",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018580": {
        "Stato": "IT",
        "CAP": "84010",
        "Localit\u00e0": "SANTA MARIA A VICO",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP02063-007092,25SBLUH02197-004547"
    },
    "018602": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "GROTTE",
        "Indirizzo": "VIALE DELLA VITTORIA, 52",
        "N.ri Tel.": "0922838751",
        "Insegna": "LA MENDOLA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25SBLUS01339-007137,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUN02514-007179,25SBLUH02195-004547,25WBLDB03191-007294,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUA04524-007182,25SBLUT02313-006818,25SBLUC01211-007101,25SBLUN02513-007179,25SBLUS01337-007137,25SBLUP02352-006855,25WBLDK03103-006047,25SBLUF02188-006804,25SBLUH02275-007100,25WBLUC02080-005958,25SBLUX02230-005958,25WBLUA05301-006434,25SBLUH02199-004547,25WBLUC02132-007284"
    },
    "018605": {
        "Stato": "IT",
        "CAP": "59872",
        "Localit\u00e0": "TRIER",
        "Indirizzo": "WINZIGER PLATZ 4",
        "N.ri Tel.": "915220722",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03114-006719"
    },
    "018613": {
        "Stato": "IT",
        "CAP": "89035",
        "Localit\u00e0": "BOVA MARINA",
        "Indirizzo": "CORSO UMBERTO I, 200/B",
        "N.ri Tel.": "0965760016",
        "Insegna": "GLAMOUR",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDH02372-005707,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDC03036-006950,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLDT02125-006526,25SBLUX03226-006719,25WBLDC03100-006047,25SBLUA04524-007182,24WBLDC02290-006646,25SBLDP04142-007109,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDC02264-006648,25WBLDC03096-006047,25SBLUT02309-007125,25SBLDK01249-007111,25SBLDT02138-006526,25SBLUT02306-006801,25SBLDC04333-007109,25WBLDK03103-006047,25WBLUC06082-005480,25WBLUC02080-005958,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDV01146-007107"
    },
    "018626": {
        "Stato": "IT",
        "CAP": "25035",
        "Localit\u00e0": "OSPITALETTO",
        "Indirizzo": "VIA PADANA SUPERIORE",
        "N.ri Tel.": "340 2373984",
        "Insegna": "SPORTLAND STILE OSPITALETTO",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLDX03008-006950,25WBLUC03090-006719,25WBLUC03074-006355,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC02064-006100,25SBLUX02230-005958,24WBLDC03048-006047"
    },
    "018628": {
        "Stato": "IT",
        "CAP": "25055",
        "Localit\u00e0": "PISOGNE",
        "Indirizzo": "VIA DELLA REPUBBLICA, 1",
        "N.ri Tel.": "340 2373984",
        "Insegna": "SPORTLAND PISOGNE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLDX03008-006950,25WBLUC03090-006719,25WBLUC03074-006355,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUC02228-007104,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC02232-007104,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC02064-006100,25SBLUX02230-005958,24WBLDC03048-006047"
    },
    "018629": {
        "Stato": "IT",
        "CAP": "08029",
        "Localit\u00e0": "SINISCOLA",
        "Indirizzo": "VIA GRAMSCI, 20",
        "Insegna": "ALMON 20",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUK03142-005480,25SBLUC11207-006787,25WBLUC03233-007308,24WBLDK03039-006950,25SBLUC01211-007101,25WBLUC03086-006047,25SBLUB04167-006854"
    },
    "018630": {
        "Stato": "IT",
        "CAP": "53026",
        "Localit\u00e0": "PIENZA",
        "Indirizzo": "VIA CONDOTTI, 4",
        "N.ri Tel.": "0578748586",
        "Insegna": "COLOMBINI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02044-006648,24WBLDC02112-006631,24WBLDC02290-006646"
    },
    "018651": {
        "Stato": "IT",
        "CAP": "95037",
        "Localit\u00e0": "SAN GIOVANNI LA PUNTA",
        "Indirizzo": "VIA COLOMBO (PARCO COMMERCIALE I PORTALI BOX 105)",
        "N.ri Tel.": "095-387799",
        "Insegna": "DISTEFANO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUC11541-007110,25SBLUC01211-007101,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUC01209-007101,25WBLUC06082-005480,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02079-A05958"
    },
    "018674": {
        "Stato": "IT",
        "CAP": "10093",
        "Localit\u00e0": "COLLEGNO",
        "Indirizzo": "VIA OBERDAN, 14",
        "N.ri Tel.": "011-4053827",
        "Insegna": "APOTEMA",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25WBLUK03142-005480,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDC03038-006950,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "018676": {
        "Stato": "IT",
        "CAP": "87024",
        "Localit\u00e0": "FUSCALDO",
        "Indirizzo": "VIA MOLINO 6",
        "N.ri Tel.": "0982-686052",
        "Insegna": "MAY FLOWER",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUK03142-005480,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02080-005958,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUL01316-007012"
    },
    "018693": {
        "Stato": "IT",
        "CAP": "80065",
        "Localit\u00e0": "SANT'AGNELLO",
        "Indirizzo": "CORSO ITALIA, 4",
        "N.ri Tel.": "334 8030933",
        "Insegna": "ACANFORA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25SBLUH02193-004547,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUC11207-006787,24WBLDC03047-006047,25SBLDH02376-006842,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDK03527-006047,25SBLUH02191-004547,25WBLDB03191-007294,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUT02309-007125,24WBLDK03212-006990,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDC04333-007109,25SBLUC11214-007111,25WBLDC02170-006648,25SBLUF01055-007092,24WBLDB03294-005553,25WBLDK03103-006047,25SBLUH02275-007100,25SBLDC01328-007131,25SBLUX02230-005958,25SBLDC04066-007109,25WBLDC03099-006047,25SBLUC04163-006788,25SBLDC01279-007111"
    },
    "018719": {
        "Stato": "IT",
        "CAP": "20013",
        "Localit\u00e0": "MAGENTA",
        "Indirizzo": "PIAZZA LIBERAZIONE, 17",
        "N.ri Tel.": "02/36738277",
        "Insegna": "AL DIECI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDC02072-006648,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25SBLDH02374-006842,25SBLDP01079-007092,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25WBLDK03527-006047,25SBLDF03076-007092,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDK03103-006047,25SBLUC03012-006719,25SBLDH02375-006842,25SBLUX02230-005958,25SBLDC03006-006950,24WBLDC03048-006047,25SBLUT02315-007117,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "018728": {
        "Stato": "IT",
        "CAP": "47921",
        "Localit\u00e0": "RIMINI",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "0541-1416436",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,24WBLDM10408-007022,25SBLDS01366-007141,25SBLUM01479-007167,25SBLUP05033-007094,25SBLUN01521-006581,25SBLDB04068-007109,25SBLUP01350-006855,24WBLDK02042-006648,25SBLUP04322-007129,25SBLUS01338-007137,25SBLDC03003-006950,25SBLDL02397-007156,24WBLDH01432-006971,24WBLDC02290-006646,25SBLDP04142-007109,25SBLDC02264-006648,25SBLUB04360-006788,25SBLDC04333-007109,24WBLDA05465-006127,24WBLDF01398-006987,25SBLUH02193-004547,25SBLUL02582-007370,25SBLDP01300-007140,24WBLDP03447-007025,24WBLDA05469-007037,24WBLDM04428-005794,24WBLDH02433-006971"
    },
    "018745": {
        "Stato": "IT",
        "CAP": "95030",
        "Localit\u00e0": "GRAVINA DI CATANIA",
        "Indirizzo": "VIA CADUTI DEL LAVORO, 2",
        "Insegna": "LUXURY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,25WBLDP01291-007324,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25SBLKH02555-007188,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLKP05558-007187,25SBLUC01121-007105,25SBLKC01445-007101,25SBLDC02232-007104,25SBLUT02310-006817,25SBLKF02553-007187,25SBLUC01209-007101,25SBLUC11214-007111,25WBLUC05125-007283,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25WBLKC02429-005958,25WBLUC11083-007110,25WBLUK03142-005480,25SBLUT02308-006801,24WBLDC02314-006631,25SBLUH02196-004547,25WBLDC02196-007283,25SBLUC03011-006719,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUX03226-006719,25WBLKC02427-005958,25SBLUA04524-007182,25SBLGC02432-007104,25SBLUC04206-006535,25SBLKP01554-007187,25WBLUC02153-007300,25SBLDC02236-006648,25SBLUH02275-007100,25SBLUH01149-007100,25WBLUA05298-006127,25WBLDC03099-006047,25WBLDF08236-007301,24WBLDK03037-006950,25WBLUC03090-006719,25WBLDC02178-006646,25SBLDC03003-006950,25SBLUH02109-006526,25SBLKF03551-007187,24WBLDC03038-006950,25SBLUH02108-006864,25SBLKC02430-007104,24WBLDC02290-006646,25SBLKC11440-007111,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02132-007284,25WBLDK03102-006047,25SBLGH02550-007188,25SBLUC01281-007105,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25SBLGC01441-007111,25SBLKC06443-007101,25WBLGC02391-006648,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC02228-007104,24WBLDL01420-007016,25SBLDC01328-007131,25WBLUC02079-A05958"
    },
    "018759": {
        "Stato": "IT",
        "CAP": "81058",
        "Localit\u00e0": "VAIRANO PATENORA",
        "Indirizzo": "PIAZZA UNITA' D'ITALIA 9",
        "N.ri Tel.": "0823 988924",
        "Insegna": "CLOTHES LIFE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUH02194-004547,24WBLDK03039-006950,25SBLUX02230-005958,25WBLKC02429-005958,25SBLUP05190-006804,25WBLUK03142-005480,25SBLDH02374-006842,25SBLUH02196-004547,25SBLDP01079-007092,24WBLDK02042-006648,24WBLDC02041-006648,25WBLKC02427-005958,25SBLUH02275-007100,25SBLDH02375-006842,25SBLDC01279-007111,25WBLUC03090-006719,24WBLDC02044-006648,25SBLUH02109-006526,24WBLDM13260-006645,25SBLDF03201-006804,24WBLDC03038-006950,25SBLUH02197-004547,24WBLDC02290-006646,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDB03294-005553,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC03074-006355,25SBLUC11207-006787,25SBLDH02376-006842,25SBLDF03076-007092,25SBLUH02191-004547,25WBLGC02391-006648,25SBLUB04167-006854,24WBLDM10259-006645,25WBLUC02079-A05958"
    },
    "018811": {
        "Stato": "IT",
        "CAP": "06024",
        "Localit\u00e0": "GUBBIO",
        "Indirizzo": "VIA BENIAMINO UBALDI, 21",
        "N.ri Tel.": "075 927 6333",
        "Insegna": "ACCIAIO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUH02109-006526,24WBLDK03052-006047,25SBLUC11541-007110,25SBLUS02336-007138,25SBLUH02194-004547,25SBLUH02191-004547,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUC02227-007104,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLUT02306-006801,25SBLUP01324-007130,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,25SBLDC02236-006648,25SBLUX02230-005958,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "018815": {
        "Stato": "IT",
        "CAP": "04023",
        "Localit\u00e0": "FORMIA",
        "Indirizzo": "VIA VITRUVIO, 27",
        "N.ri Tel.": "0773 709592",
        "Insegna": "SBARAGLIA STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,25SBLUS01339-007137,25SBLUN01521-006581,25WBLUC03090-006719,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC02342-006631,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDC02041-006648,25SBLUH02191-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDB03294-005553,25WBLUC03086-006047,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDK03098-006047,25SBLUM01476-006233"
    },
    "018832": {
        "Stato": "IT",
        "CAP": "35100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DELLE CONVERTITE 12/13",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDB02092-006976"
    },
    "018837": {
        "Stato": "IT",
        "CAP": "60021",
        "Localit\u00e0": "CAMERANO",
        "Indirizzo": "VIA PRIMO MAGGIO, 1",
        "N.ri Tel.": "3205672142",
        "Insegna": "+39",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDC03114-006719,24WBLDC03114-006719,24WBLDK03037-006950,24WBLDK03037-006950,24WBLDK03052-006047,24WBLDK03120-006951,24WBLDK03120-006951"
    },
    "018845": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIALE CARDUCCI, 79",
        "N.ri Tel.": "3935299693",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047"
    },
    "018872": {
        "Stato": "IT",
        "CAP": "95048",
        "Localit\u00e0": "SCORDIA",
        "Indirizzo": "VIA SIMETO 4/A",
        "Insegna": "ODISSEA",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018874": {
        "Stato": "IT",
        "CAP": "43126",
        "Localit\u00e0": "PARMA",
        "Indirizzo": "VIA BUFFOLARA 92/A",
        "N.ri Tel.": "335 711 6528",
        "Insegna": "WINNER",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03038-006950,25SBLUS02336-007138,25SBLUS01340-007138,25WBLDC03100-006047,25SBLUC04176-006854,24WBLDC02290-006646,25SBLUT02110-006526,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDK03102-006047,25WBLDC03099-006047,25SBLUT02315-007117,24WBLDK03040-006950,25WBLDK03098-006047"
    },
    "018890": {
        "Stato": "IT",
        "CAP": "10057",
        "Localit\u00e0": "SANT'AMBROGIO DI TORINO",
        "Indirizzo": "C.SO MONCENISIO 125",
        "N.ri Tel.": "011/939241",
        "Insegna": "GIUGLAR SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25WBLDK02069-006648,25SBLUF01184-006804,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC02227-007104,25WBLDC03096-006047,25SBLDC02232-007104,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUH02275-007100,25WBLDK03495-006047,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDK03098-006047,25SBLUC01210-007101"
    },
    "018898": {
        "Stato": "IT",
        "CAP": "96100",
        "Localit\u00e0": "SIRACUSA",
        "Indirizzo": "VIA TISIA, 35",
        "N.ri Tel.": "0931 464505",
        "Insegna": "POP OFF",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC01260-007108,25WBLDC02072-006648,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,24WBLDK02042-006648,25WBLDC03100-006047,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUC11214-007111,25WBLDC02170-006648,25SBLUH02275-007100,24WBLDC02064-006100,25SBLUX02230-005958,25WBLUC02132-007284,25SBLDC01279-007111"
    },
    "018901": {
        "Stato": "IT",
        "CAP": "74024",
        "Localit\u00e0": "MANDURIA",
        "Indirizzo": "VIA XX SETTEMBRE, 56/A",
        "N.ri Tel.": "392 2652143",
        "Insegna": "GRANATO STORE ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25SBLUX03226-006719,25SBLUB01216-007111,25SBLUF03186-006804,25SBLUA04524-007182,25SBLUC01211-007101,25WBLUC03086-006047,25SBLUX02230-005958,25WBLUK11140-007286"
    },
    "018904": {
        "Stato": "IT",
        "CAP": "80045",
        "Localit\u00e0": "POMPEI",
        "Indirizzo": "VIA MACELLO, 22 - C.C. LA CARTIERA",
        "Insegna": "LOUNGE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDC03100-006047,24WBLDC02290-006646,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC01121-007105,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC11214-007111,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,25WBLDC03099-006047,25SBLUC01210-007101,25SBLDC01279-007111,25SBLUC01281-007105"
    },
    "018918": {
        "Stato": "IT",
        "CAP": "47921",
        "Localit\u00e0": "TRAVERSETOLO",
        "Indirizzo": "VIA TRIESTE, 1/E",
        "N.ri Tel.": "0541-1416436",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018922": {
        "Stato": "IT",
        "CAP": "98123",
        "Localit\u00e0": "MESSINA",
        "Indirizzo": "VIA CAMICIOTTI, 75",
        "N.ri Tel.": "090663647",
        "Insegna": "COUNTRY CLUB",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03114-006719,24WBLDK02042-006648,25SBLUC01211-007101,25SBLUC11207-006787,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUH02275-007100,25SBLUP04322-007129"
    },
    "018934": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "RIONERO IN VOLTURE",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "340-2118813 ANTON",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03052-006047"
    },
    "018968": {
        "Stato": "IT",
        "CAP": "98028",
        "Localit\u00e0": "SANTA TERESA DI RIVA",
        "Indirizzo": "VIA REGINA MARGHERITA, 25",
        "N.ri Tel.": "09-42794803",
        "Insegna": "BRETELLA LAB",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBLUC08078-006355,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUH02196-004547,25SBLKF03551-007187,25SBLDH02376-006842,24WBLDC03047-006047,25SBLUC11541-007110,25SBLGC01441-007111,25SBLUH02194-004547,25SBLKH02555-007188,25WBLGA05461-007349,24WBLDK03293-005553,25SBLUH02108-006864,25WBLGC02391-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUT02110-006526,25SBLKC11440-007111,25SBLDC11237-007110,25SBLKP05558-007187,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLKC01445-007101,25SBLGH02495-007144,25SBLKT02464-006818,25WBLDC03095-006047,25SBLKP01554-007187,25SBLDH02386-007144,25WBLDK03103-006047,25SBLUH02275-007100,24WBLDC02352-006977,25SBLDC01328-007131,25SBLUX02230-005958,25SBLUH02199-004547,25WBLDC03099-006047,25SBLGH02550-007188,25SBLDC01279-007111,25WBLDA05337-006127"
    },
    "018983": {
        "Stato": "IT",
        "CAP": "10139",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA FREJUS, 99",
        "N.ri Tel.": "334 9096724",
        "Insegna": "JEANS BLUE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC01115-007105,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUF01184-006804,25WBLDC03100-006047,25SBLUS01341-007136,25SBLUH02197-004547,24WBLDC02018-006648,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC01121-007105,25SBLUL02403-006543,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDK11162-007110,25SBLUT02310-006817,25WBLDC03095-006047,24WBLDB03294-005553,25WBLDK03103-006047,25SBLUF02188-006804,25WBLDK03495-006047,25WBLUC05125-007283,25SBLUX02230-005958,25WBLDK03102-006047,25WBLDC03099-006047,24WBLDK03040-006950,25WBLUA05297-006127"
    },
    "018990": {
        "Stato": "IT",
        "CAP": "74016",
        "Localit\u00e0": "MASSAFRA",
        "Indirizzo": "VIA GUGLIELMO MARCONI 75",
        "N.ri Tel.": "099 4005589",
        "Insegna": "SALVATORE VALENTINI",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,24WBLDK03037-006950,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDV02296-007143,25WBLUC03074-006355,25SBLDC01222-007108,24WBLDC03036-006950,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUH02194-004547,25SBLUH02195-004547,25WBLDC03100-006047,25SBLUC04176-006854,24WBLDK03039-006950,25SBLUC01219-007108,25SBLUT02313-006818,25SBLDC11237-007110,25WBLDC03096-006047,25SBLUC04206-006535,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDC02177-007284,25SBLDC04333-007109,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC06082-005480,24WBLDC02352-006977,25WBLUC02080-005958,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25SBLDV01146-007107"
    },
    "019010": {
        "Stato": "IT",
        "CAP": "72017",
        "Localit\u00e0": "OSTUNI",
        "Indirizzo": "VIA GIOVANNI XXIII 82,",
        "N.ri Tel.": "0831-305341",
        "Insegna": "META SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDX03008-006950,24WBLDK03037-006950,24WBLDC02044-006648,25SBLDS01292-007141,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLKC11416-007110,25WBLUC03074-006355,25SBLDC01222-007108,24WBLDK03052-006047,25SBLUC11207-006787,25SBLGC01441-007111,25SBLUC11541-007110,24WBLDC03038-006950,25WBLUC03233-007308,25SBLKC06443-007101,25SBLDT02125-006526,25WBLGC02391-006648,25WBLDC03100-006047,25WBLKC02427-005958,25SBLUC04176-006854,25SBLDS01291-007141,25SBLKX02418-005958,25WBLDC03096-006047,25SBLUC11083-007106,25WBLDC03095-006047,24WBLDC03051-006047,25SBLDP05141-007109,24WBLDC02112-006631,25SBLUS01342-007136,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,24WBLDA05465-006127,25SBLDV04293-007143,25WBLUC06082-005480,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDH02373-005707,25WBLDK03102-006047,25SBLUM01479-007167,25WBLDC03099-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLKC02429-005958,25SBLUM01476-006233"
    },
    "019021": {
        "Stato": "IT",
        "CAP": "50022",
        "Localit\u00e0": "GREVE IN CHIANTI",
        "Indirizzo": "VIA CESARE BATTISTI 3",
        "N.ri Tel.": "0558544750",
        "Insegna": "MARILLI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,24WBLDC02290-006646,24WBLDC02290-006646,24WBLDC03047-006047"
    },
    "019037": {
        "Stato": "IT",
        "CAP": "89044",
        "Localit\u00e0": "LOCRI",
        "Indirizzo": "TRAVERSA I DI VIA MARCONI",
        "N.ri Tel.": "393-9698041",
        "Insegna": "WANTED",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC02227-007104,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUC03012-006719,25WBLUC03086-006047,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC02077-006943,25SBLUH02196-004547,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25SBLUX03226-006719,25SBLUF03186-006804,25SBLUC04206-006535,25WBLDC02177-007284,25SBLUH02275-007100,25WBLDK03495-006047,25WBLDC03099-006047,25WBLUL01316-007012,25SBLUF03185-006804,25WBLUC03090-006719,25WBLDC02178-006646,25SBLDC03003-006950,25SBLUH02109-006526,25SBLUP01189-006804,25SBLUL02412-007155,24WBLDC03038-006950,25SBLUH02197-004547,25SBLDC02264-006648,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,25WBLDK03103-006047,25SBLUF02188-006804,24WBLDC02064-006100,25WBLUC06082-005480,25WBLUC02132-007284,25SBLDC03006-006950,25SBLUM01476-006233,25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25SBLUC02254-007101,25SBLUH02191-004547,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUT02306-006801,25WBLDC02170-006648"
    },
    "019049": {
        "Stato": "IT",
        "CAP": "40128",
        "Localit\u00e0": "BOLOGNA",
        "Indirizzo": "PIAZZA DELL'UNITA', 11/D",
        "N.ri Tel.": "051 353727",
        "Insegna": "AMERICAN DREAM",
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDC02251-006631,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUC02227-007104,25WBLUC03086-006047,25WBLUL02318-007340,25WBLUC05125-007283,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,24WBLDC03084-006976,25WBLUK03142-005480,24WBLDC02314-006631,25WBLUC02077-006943,24WBLDK02042-006648,25SBLDL02396-007152,24WBLDC02041-006648,25SBLUL02409-006547,25WBLDC03099-006047,25WBLUL01316-007012,24WBLDK02045-006648,24WBLDK03037-006950,24WBLDC02044-006648,25WBLDC02178-006646,25SBLUL02412-007155,25SBLUC01115-007105,24WBLDC03038-006950,24WBLDC02290-006646,25WBLUC02151-007287,25WBLDC03096-006047,24WBLDF08400-006987,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,24WBLDF01398-006987,25WBLDK03102-006047,25WBLDC03097-006047,25WBLDC02072-006648,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,25WBLDC02170-006648,25WBLUC02079-A05958"
    },
    "019052": {
        "Stato": "IT",
        "CAP": "80035",
        "Localit\u00e0": "NOLA",
        "Indirizzo": "VIA SARNELLA, 9",
        "N.ri Tel.": "081 8232420",
        "Insegna": "FEDELE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLDC02072-006648,25WBLDA05336-007349,25SBLUH02109-006526,24WBLDK03052-006047,24WBLDM13260-006645,24WBLDK11337-006007,25SBLUC11207-006787,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUH02195-004547,25SBLUH02108-006864,24WBLDC02290-006646,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC01211-007101,24WBLDK03212-006990,25SBLUT02310-006817,24WBLDC03051-006047,25SBLUH02241-007100,25SBLUT02306-006801,25SBLUC11214-007111,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDM10259-006645,25WBLDC03099-006047,25SBLUP02063-007092,25SBLDC01279-007111"
    },
    "019163": {
        "Stato": "IT",
        "CAP": "63014",
        "Localit\u00e0": "MONTEGRANARO",
        "Indirizzo": "VIA ALPI, 200",
        "N.ri Tel.": "0734 891689",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02314-006631"
    },
    "019186": {
        "Stato": "IT",
        "CAP": "22036",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "P.ZZA XXV APRILE, 1",
        "N.ri Tel.": "334 2956780",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDM10555-007022"
    },
    "019191": {
        "Stato": "IT",
        "CAP": "66016",
        "Localit\u00e0": "GARDIAGRELE",
        "Indirizzo": "VIA ROMA 150",
        "N.ri Tel.": "087182768",
        "Insegna": "DES STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUS01340-007138,25SBLUT02312-006803,25SBLDP01326-007143,25SBLDC02232-007104,25SBLUC03012-006719,25SBLDF08078-007092,25WBLUC02080-005958,25SBLUX02230-005958,24WBLDK03040-006950,25WBLKC02429-005958,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUH02196-004547,25SBLDP01079-007092,24WBLDK02042-006648,24WBLDC02041-006648,25WBLKC02427-005958,25SBLUF03186-006804,25SBLUC04206-006535,25SBLDK01249-007111,25SBLDC02236-006648,24WBLDK03037-006950,25WBLDC02178-006646,25WBBXC02456-005958,25SBLUP01189-006804,25SBLUF01184-006804,25SBLUP04043-007130,25WBLDC03096-006047,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25WBLUC06082-005480,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDC03097-006047,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUH02191-004547,25WBLDK11162-007110,25WBLDC02170-006648,25WBLUC02079-A05958,25WBLDK03098-006047"
    },
    "019195": {
        "Stato": "IT",
        "CAP": "03100",
        "Localit\u00e0": "FROSINONE",
        "Indirizzo": "VIA ALDO MORO, 136",
        "N.ri Tel.": "0775 246015",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUL02583-007370"
    },
    "019196": {
        "Stato": "IT",
        "CAP": "10071",
        "Localit\u00e0": "BORGARO TORINESE",
        "Indirizzo": "VIA PRIMO MAGGIO, 14",
        "N.ri Tel.": "011 4501885",
        "Insegna": "ITALIAN GRIFFE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUK03142-005480,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25WBLUC02077-006943,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25SBLUS02336-007138,25SBLUH02194-004547,25WBLDK02069-006648,25WBLDK03527-006047,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUH02197-004547,25SBLUH02192-004547,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25SBLUT02306-006801,25WBLDK03103-006047,25WBLUC03086-006047,25SBLUH02275-007100,25WBLDK03495-006047,25WBLUC02080-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUK11140-007286"
    },
    "019199": {
        "Stato": "IT",
        "CAP": "19038",
        "Localit\u00e0": "SARZANA",
        "Indirizzo": "PIAZZA GARIBALDI, 19",
        "N.ri Tel.": "0187 621890",
        "Insegna": "QUASAR",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25SBLUN01521-006581,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUC03074-006355,24WBLDC03047-006047,25SBLUC11541-007110,24WBLDC03038-006950,25SBLUP01350-006855,25SBLUH02191-004547,25SBLUA04524-007182,25WBLDC03096-006047,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,25WBLDK03495-006047,25SBLUX02230-005958,25SBLUT02315-007117,25WBLDC03099-006047,25SBLUH02394-007114,25SBLUA04525-007182"
    },
    "019208": {
        "Stato": "IT",
        "CAP": "30015",
        "Localit\u00e0": "CHIOGGIA",
        "Indirizzo": "CORSO DEL POPOLO , 1224",
        "N.ri Tel.": "041-401911",
        "Insegna": "FERRY BOAT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02251-006631,24WBLDC02290-006646,24WBLDC02314-006631,24WBLDC02342-006631,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDC03211-006990,24WBLDK02042-006648,24WBLDK02556-006646,24WBLDK03040-006950,24WBLDK03052-006047,24WBLDK03212-006990,25SBLGC02426-006648,25SBLKC02417-005958,25SBLKF02553-007187,25SBLKF08561-007187,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKX02418-005958"
    },
    "019209": {
        "Stato": "IT",
        "CAP": "81055",
        "Localit\u00e0": "SANTA MARIA CAPUA VETERE",
        "Indirizzo": "VIA ALDO MORO, 85/89",
        "N.ri Tel.": "0823 840550",
        "Insegna": "DEL RE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLDC02178-006646,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "019216": {
        "Stato": "IT",
        "CAP": "43043",
        "Localit\u00e0": "FIUMICINO",
        "Indirizzo": "PIAZZA MICHELANGELO BUONARROTI, 36",
        "N.ri Tel.": "0525 916033",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDB02092-006976"
    },
    "019219": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA XX SETTEMBRE, 45A",
        "N.ri Tel.": "340 1796989",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03052-006047"
    },
    "019226": {
        "Stato": "IT",
        "CAP": "21047",
        "Localit\u00e0": "SARONNO",
        "Indirizzo": "VIALE LOMBARDIA 21/A",
        "Insegna": "BRANDS FACTORY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25SBLDH03371-005707,24WBLDC03047-006047,25WBLUC03233-007308,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDP02345-006855,25SBLDF08078-007092,25WBLDP01295-007323,24WBLDK03122-006955,24WBLDC03048-006047,24WBLDK03040-006950,25WBLDA05337-006127,25WBLUC11083-007110,25SBLUP05190-006804,25WBLUK03142-005480,25SBLUT02308-006801,25SBLDH02374-006842,25SBLUH02196-004547,25SBLDP01079-007092,25WBLDK03527-006047,25SBLUF03186-006804,25SBLDP01344-006855,25WBLDC03099-006047,25SBLDC01279-007111,25SBLUF03185-006804,25SBLDP05301-007140,24WBLDK03037-006950,25WBLUC03090-006719,25SBLUP01189-006804,25SBLDC01358-007101,24WBLDC03038-006950,25SBLUF01184-006804,24WBLDC02290-006646,25SBLDH02389-007144,25WBLDC03096-006047,25WBLDC03095-006047,25SBLDC04333-007109,25SBLDM01473-007166,25WBLDK03103-006047,25SBLUF02188-006804,24WBLDC02064-006100,25WBLDK03102-006047,25SBLDC01329-007131,25WBLDC11163-007110,25SBLDH02372-005707,25SBLDS01292-007141,24WBLDC03114-006719,25SBLDP01300-007140,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUB01216-007111,25SBLDF03257-007113,25WBLDC02170-006648"
    },
    "019227": {
        "Stato": "IT",
        "CAP": "91025",
        "Localit\u00e0": "MARSALA",
        "Indirizzo": "C.DA COZZARO, 323D - INT. 1-2",
        "N.ri Tel.": "0923-951043",
        "Insegna": "BONINI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,24WBLDC03038-006950,24WBLDC02041-006648,25WBLGC02391-006648,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,24WBLDB03294-005553,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLKC02429-005958"
    },
    "019232": {
        "Stato": "PL",
        "CAP": "95129",
        "Localit\u00e0": "SQUINZANO",
        "Indirizzo": "VIA SAN LEONARDO. 60",
        "N.ri Tel.": "3384096404",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019236": {
        "Stato": "IT",
        "CAP": "16121",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA FIESCHI 8/9",
        "N.ri Tel.": "345-1773717",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019244": {
        "Stato": "IT",
        "CAP": "64021",
        "Localit\u00e0": "GIULIANOVA",
        "Indirizzo": "VIA TRIESTE, 30",
        "N.ri Tel.": "085 8008606",
        "Insegna": "LA GENOVESE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUS01339-007137,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDC01221-007108,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUL02412-007155,25SBLUS02336-007138,25SBLUH02194-004547,24WBLDK02556-006646,25SBLUF01184-006804,25SBLDV03365-007143,25WBLDK03527-006047,25SBLUF03186-006804,25SBLUP04043-007130,24WBLDC02290-006646,25SBLUT02312-006803,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUP04322-007129,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDC02170-006648,25SBLUM01482-007168,25SBLDH02386-007144,25SBLUC03012-006719,25SBLDF08078-007092,25SBLUM01486-007172,25SBLUC03013-006719,25WBLDK03495-006047,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUC02080-005958,25SBLUL02583-007370,25SBLDC01279-007111,25SBLUM01476-006233"
    },
    "019250": {
        "Stato": "IT",
        "CAP": "72021",
        "Localit\u00e0": "FRANCAVILLA FONTANA",
        "Indirizzo": "VIALE LILLA 20",
        "N.ri Tel.": "0831 091415",
        "Insegna": "LILLA CIVICO 20",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25SBLUH02193-004547,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25SBLDH02374-006842,25SBLUH02196-004547,25SBLUC11207-006787,24WBLDC03047-006047,25SBLUH02194-004547,25SBLUH02195-004547,25SBLDT02125-006526,25WBLGC02391-006648,25SBLUH02191-004547,25WBLDC03100-006047,25WBLKC02427-005958,25SBLDC01359-007101,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUC01211-007101,25SBLUT02309-007125,25SBLDK01249-007111,25SBLUT02310-006817,25WBLDC03095-006047,25SBLDT02138-006526,25WBLDC02170-006648,25WBLUC02080-005958,25SBLUX02230-005958,25WBLKC02429-005958,25WBLDC11163-007110,24WBLDC02112-006631"
    },
    "019351": {
        "Stato": "IT",
        "CAP": "20037",
        "Localit\u00e0": "PADERNO DUGNANO",
        "Indirizzo": "STRADA STATALE DEI GIOVI, 35",
        "N.ri Tel.": "3387644591",
        "Insegna": "MARTINS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLUC03090-006719,24WBLDC02044-006648,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,24WBLDX02113-006631,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLUC03233-007308,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUH02195-004547,24WBLDC02041-006648,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUC02228-007104,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03096-006047,25SBLUC01121-007105,25SBLDC01159-007105,25WBLDC03095-006047,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUC03012-006719,25WBLDC03092-006719,25SBLUH01149-007100,25WBLUC02080-005958,25SBLDC03006-006950,25SBLUX02230-005958,25WBLDK03102-006047,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02132-007284,25SBLDC01279-007111"
    },
    "019353": {
        "Stato": "IT",
        "CAP": "73048",
        "Localit\u00e0": "NARDO'",
        "Indirizzo": "VIA SARAGAT, SNC",
        "N.ri Tel.": "0833/835235",
        "Insegna": "GOGGI SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25WBLDC02072-006648,24WBLDK03037-006950,25SBLUH02193-004547,25SBLDH02372-005707,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC02077-006943,24WBLDC03036-006950,24WBLDK11337-006007,25SBLDC01358-007101,25SBLUH02194-004547,24WBLDK02042-006648,24WBLDC02041-006648,25SBLUH02191-004547,25WBLDC03100-006047,25SBLUB01216-007111,25SBLUC04176-006854,25SBLDH02377-007144,25WBLDK11162-007110,25WBLDC03095-006047,25WBLDC02170-006648,25SBLDH02386-007144,25WBLUC03086-006047,25SBLDH02375-006842,25WBLDK03102-006047,25WBLDC11163-007110"
    },
    "019365": {
        "Stato": "IT",
        "CAP": "80079",
        "Localit\u00e0": "PROCIDA",
        "Indirizzo": "VIA VITTORIO EMANUELE, 307",
        "N.ri Tel.": "081/19564365",
        "Insegna": "LUPES",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25WBLUC08078-006355,25WBLDA05336-007349,25WBLUC02079-005958,24WBLDK11337-006007,24WBLDC03047-006047,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUT02310-006817,25SBLUF03187-006804,25SBLUC11214-007111,25SBLDH02386-007144,25SBLDF08078-007092,25WBLUC02080-005958,24WBLDC03048-006047,25SBLUS02336-007138,24WBLDK02556-006646,25SBLUH02195-004547,25SBLUA04524-007182,25SBLUH02275-007100,25SBLDH02375-006842,25SBLUC01034-007111,25WBLDC03099-006047,25SBLDC01279-007111,24WBLDK03037-006950,24WBLDC02044-006648,25SBLUA04527-007182,25SBLUH02109-006526,25SBLUC11215-007110,24WBLDC03038-006950,25SBLUH02197-004547,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDF08400-006987,25SBLUT02309-007125,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDK03086-006976,25SBLUF02188-006804,25WBLUC06082-005480,25WBLDK03102-006047,25WBLDC11163-007110,25SBLUC01281-007105,25SBLUM01476-006233,24WBLDC11209-006007,25SBLUH02193-004547,25WBLUC03074-006355,25SBLDC01221-007108,24WBLDC03036-006950,25SBLDH02376-006842,25WBLDK11162-007110,25SBLDF03257-007113,25WBLDF08248-006948,25SBLUH02199-004547,25WBLUC02079-A05958,25SBLDC04066-007109"
    },
    "019370": {
        "Stato": "IT",
        "CAP": "00198",
        "Localit\u00e0": "ROMA - ACILIA",
        "Indirizzo": "VIA SALARIA 224",
        "N.ri Tel.": "06/65746565",
        "Insegna": "sportcenter",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25SBLUT02308-006801,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,25SBLUH02196-004547,24WBLDC03036-006950,25SBLUP01189-006804,24WBLDK03052-006047,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUH02191-004547,24WBLDC02290-006646,25WBLDC03096-006047,25SBLDC01159-007105,25SBLUT02309-007125,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDK03103-006047,25SBLUC03012-006719,25SBLDC03006-006950,25WBLDC03097-006047"
    },
    "019377": {
        "Stato": "IT",
        "CAP": "70017",
        "Localit\u00e0": "PUTIGNANO",
        "Indirizzo": "VIA TURI, 68",
        "N.ri Tel.": "3939161185",
        "Insegna": "PROGETTO STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDB02092-006976,24WBLDC02041-006648,24WBLDC02044-006648,24WBLDC02064-006100,24WBLDC02314-006631,24WBLDF08400-006987,24WBLDK02042-006648,24WBLDK02363-005831,24WBLDK03037-006950,24WBLDK03039-006950,24WBLDM01427-005794,25SBLDC01358-007101,25SBLDC02233-007104,25SBLDC04333-007109,25SBLDF03076-007092,25SBLDH02374-006842,25SBLDM01473-007166,25SBLDP01079-007092,25SBLDS01292-007141,25SBLDT02138-006526,25SBLDV02296-007143,25SBLDV05299-007138,25SBLUC02228-007104,25SBLUC02229-005958,25SBLUF01055-007092,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUK11239-007110,25SBLUM01476-006233,25SBLUP04062-007092,25SBLUS01340-007138,25SBLUS02336-007137,25SBLUT02313-006818,25SBLUT02346-007132,25SBLUX02230-005958"
    },
    "019409": {
        "Stato": "IT",
        "CAP": "76011",
        "Localit\u00e0": "RUTIGLIANO",
        "Indirizzo": "VIA S. FRANCESCO D'ASSISI, 9",
        "N.ri Tel.": "080 4769091",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUP04062-007092,25SBLDC04333-007109"
    },
    "019446": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "ROMANO D'EZZELINO",
        "Indirizzo": "VIA MARCHESE DI VILLABIANCA, 3A",
        "N.ri Tel.": "0424521113",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02049-006636"
    },
    "019461": {
        "Stato": "IT",
        "CAP": "66023",
        "Localit\u00e0": "FRANCAVILLA AL MARE",
        "Indirizzo": "VIALE NETTUNO, 116",
        "N.ri Tel.": "085 4910656",
        "Insegna": "DEL RE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03051-006047,24WBLDC03051-006047"
    },
    "019485": {
        "Stato": "IT",
        "CAP": "18018",
        "Localit\u00e0": "TAGGIA",
        "Indirizzo": "VIA QUEIROLO, 49",
        "N.ri Tel.": "393.2888859",
        "Insegna": "IN...SIEME",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,24WBLDC03047-006047,25WBLDC03099-006047,24WBLDK03039-006950"
    },
    "019493": {
        "Stato": "PL",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA LEONARDO DA VINCI, 3H",
        "N.ri Tel.": "3480886463",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUB01216-007111,25SBLUC01209-007101,25SBLUC01211-007101"
    },
    "019501": {
        "Stato": "IT",
        "CAP": "09028",
        "Localit\u00e0": "SESTU",
        "Indirizzo": "MORE CORRAXE STRADA STATALE 131 EX SNC KM 10800",
        "N.ri Tel.": "346 6062004",
        "Insegna": "PULCKRA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,24WBLDC03036-006950,25WBLDK02069-006648,24WBLDK02042-006648,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLDK03103-006047,25WBLDC03092-006719,25WBLUC03086-006047,24WBLDC02064-006100,24WBLDC02352-006977,24WBLDX03280-006719,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "019508": {
        "Stato": "IT",
        "CAP": "48018",
        "Localit\u00e0": "FAENZA",
        "Indirizzo": "C.SO MAZZINI, 30",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03039-006950,25SBLUM01478-007167"
    },
    "019521": {
        "Stato": "IT",
        "CAP": "24067",
        "Localit\u00e0": "SARNICO",
        "Indirizzo": "PIAZZA XX SETTEMBRE 1",
        "N.ri Tel.": "035/774303",
        "Insegna": "CERDELLI UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUP01189-006804,25SBLUC11207-006787,25SBLUC01115-007105,25WBLUC03233-007308,25SBLUF01184-006804,25SBLUB01216-007111,25SBLUH01149-007100,25SBLUX02230-005958"
    },
    "019554": {
        "Stato": "SM",
        "CAP": "80144",
        "Localit\u00e0": "SAN GIOVANNI TEATINO",
        "Indirizzo": "VIA TEVERE, 7",
        "N.ri Tel.": "334 2267373",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648"
    },
    "019574": {
        "Stato": "SK",
        "CAP": "95045",
        "Localit\u00e0": "VILLABATE",
        "Indirizzo": "VIALE EUROPA, 7",
        "N.ri Tel.": "095475432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019774": {
        "Stato": "IT",
        "CAP": "95014",
        "Localit\u00e0": "GIARRE",
        "Indirizzo": "VIA RUGGERO I, 1/B",
        "N.ri Tel.": "3939626955",
        "Insegna": "SENSAZIONI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,25SBLUC11541-007110,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLDC11237-007110,25SBLUC01211-007101,25SBLKC01445-007101,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUC11214-007111,25SBLUX02230-005958,25SBLUP02352-006855,25WBLUC11083-007110,25WBLUK03142-005480,25WBLKC11416-007110,25SBLUT02308-006801,25SBLDH02374-006842,25SBLGC02432-007104,25SBLUH02275-007100,25WBLDC03099-006047,25SBLGC02429-006648,25SBLDC01279-007111,24WBLDK03037-006950,25WBLDC02178-006646,25SBLUH02108-006864,25SBLUH02197-004547,25SBLKX02418-005958,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDC02064-006100,25WBLUC02132-007284,25WBLDC11163-007110,25SBLDC02233-007104,25SBLUH02193-004547,25WBLUC03074-006355,24WBLDC03036-006950,25SBLUC11207-006787,25SBLDH02376-006842,25SBLGC01441-007111,25SBLKC06443-007101,25SBLDF03076-007092,25SBLUH02191-004547,25WBLGC02391-006648,25SBLUT02313-006818,25WBLDK11162-007110,25SBLUT02306-006801,25WBLDC02170-006648,25SBLDC01328-007131"
    },
    "019816": {
        "Stato": "IT",
        "CAP": "93014",
        "Localit\u00e0": "MUSSOMELI",
        "Indirizzo": "CONTRADA MONTICELLI S.N.",
        "N.ri Tel.": "0934992527",
        "Insegna": "FASINO",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUL01316-007012,25SBLDH02374-006842,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDC03047-006047,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25SBLDF03076-007092,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC02227-007104,25SBLUT02309-007125,25SBLDC03007-006950,25SBLUT02310-006817,25WBLDC03095-006047,25WBLDC02177-007284,25SBLUC01209-007101,25SBLDH02386-007144,25WBLDK03103-006047,25SBLDC02236-006648,25SBLUF02188-006804,25SBLUH02275-007100,24WBLDC02064-006100,25WBLUC06082-005480,25SBLUX02230-005958,25WBLUA05301-006434,25WBLUC02132-007284,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUP02352-006855,25SBLDC01279-007111"
    },
    "019843": {
        "Stato": "IT",
        "CAP": "62012",
        "Localit\u00e0": "CIVITANOVA MARCHE",
        "Indirizzo": "PIAZZA 20 SETTEMBRE, 43",
        "N.ri Tel.": "0733771748",
        "Insegna": "IL GALEONE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02044-006648,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUC02080-005958,25WBLDK03098-006047"
    },
    "019850": {
        "Stato": "IT",
        "CAP": "85100",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIA TOLMEZZO,34",
        "N.ri Tel.": "340-2118813 ANTON",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03211-006990,25SBLDC01359-007101"
    },
    "019865": {
        "Stato": "IT",
        "CAP": "33054",
        "Localit\u00e0": "LIGNANO SABBIADORO",
        "Indirizzo": "VIA LOVATO, 23",
        "N.ri Tel.": "3491245378",
        "Insegna": "BEI MERLIN",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25SBLDX03008-006950,25WBLDC02072-006648,25WBLDK03101-006047,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01222-007108,25SBLDC01221-007108,24WBLDC03036-006950,25SBLDC11335-007110,25SBLUC11207-006787,25SBLUL02412-007155,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDC11237-007110,25SBLUC01211-007101,25WBLDC03096-006047,24WBLDC03211-006990,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUB04167-006854,25WBLUC06082-005480,25SBLDC01328-007131,25SBLUX02230-005958"
    },
    "019866": {
        "Stato": "IT",
        "CAP": "84091",
        "Localit\u00e0": "SANTIAGO DE COMPOSTELA",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 8",
        "N.ri Tel.": "620885870",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01121-007105,25SBLUC01281-007105,25SBLUH02197-004547"
    },
    "019874": {
        "Stato": "IT",
        "CAP": "95463",
        "Localit\u00e0": "VARNA",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "335349300",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,25WBLDC03097-006047"
    },
    "019880": {
        "Stato": "IT",
        "CAP": "08022",
        "Localit\u00e0": "DORGALI",
        "Indirizzo": "VIA LAMARMORA, 161",
        "N.ri Tel.": "078495318",
        "Insegna": "MARIPIE'",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLUH02193-004547,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUC11207-006787,25WBLDK02069-006648,24WBLDK02042-006648,25SBLUH02108-006864,25SBLUH02191-004547,24WBLDK03039-006950,25SBLUT02313-006818,24WBLDC02018-006648,25WBLDC03096-006047,25WBLDC02177-007284,25SBLUT02306-006801,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDC02064-006100,24WBLDC02352-006977,25SBLUX02230-005958,25WBLUC02132-007284"
    },
    "019886": {
        "Stato": "RU",
        "CAP": "97-306",
        "Localit\u00e0": "SAN PIETROBURGO",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "3386722069",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,24WBLDK03212-006990"
    },
    "019893": {
        "Stato": "IT",
        "CAP": "80133",
        "Localit\u00e0": "RUTIGLIANO",
        "Indirizzo": "VIA VITTORIO VENETO, 25",
        "N.ri Tel.": "3381307821",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019896": {
        "Stato": "IT",
        "CAP": "00156",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DONATO MENICHELLA, 150",
        "Insegna": "CACTUS",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25SBLUP05190-006804,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC08078-006355,25WBLUK03142-005480,25SBLUT02308-006801,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDH02374-006842,25SBLDC01279-007111,25SBLUC11215-007110,25SBLUH02150-007100,25SBLUH02196-004547,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUS02336-007138,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25SBLDP05205-006804,25WBLDK03527-006047,25SBLUH02191-004547,25SBLUS01340-007138,24WBLDC02290-006646,25SBLUA04524-007182,25SBLUH02192-004547,25SBLDC11237-007110,25SBLDH02377-007144,25SBLUC01121-007105,25SBLUT02309-007125,25WBLDC03096-006047,25SBLUC04206-006535,25SBLUT02310-006817,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDC02170-006648,24WBLDC02064-006100,25SBLDH02373-005707,24WBLDC03048-006047,25SBLUM01476-006233"
    },
    "019909": {
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "P.ZZA CAIROLI, I S.221",
        "N.ri Tel.": "973249885",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03048-006047"
    },
    "019912": {
        "Stato": "IT",
        "CAP": "87029",
        "Localit\u00e0": "SCALEA",
        "Indirizzo": "CORSO MEDITERRANEO, 343",
        "N.ri Tel.": "0973 876351",
        "Insegna": "MICHELE ESPOSITO",
        "CODICE PRODOTTO KOOOMO": "25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC03003-006950,25SBLUH02109-006526,25WBLUC02077-006943,25SBLUP01189-006804,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03047-006047,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02108-006864,25WBLDB03191-007294,25WBLDC03100-006047,24WBLDK03039-006950,25SBLUT02313-006818,25SBLDC02264-006648,25SBLUC02227-007104,25SBLDK01249-007111,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUC02132-007284,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25WBLUK11140-007286,25SBLUF03185-006804"
    },
    "019913": {
        "Stato": "RU",
        "CAP": "39031",
        "Localit\u00e0": "RIVA DEL GARDA",
        "Indirizzo": "VIA DIAZ 14",
        "N.ri Tel.": "943811088",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019938": {
        "Stato": "LV",
        "CAP": "70021",
        "Localit\u00e0": "SPINEA",
        "Indirizzo": "VIA MASELLI CAMPAGNA 31",
        "N.ri Tel.": "0421 1541470 AMM.",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02313-006818,25SBLUS02336-007138,25SBLUP02063-007092,25SBLUT02346-007132"
    },
    "019958": {
        "Stato": "IT",
        "CAP": "67100",
        "Localit\u00e0": "L' AQUILA",
        "Indirizzo": "VIA SARAGAT SNC",
        "N.ri Tel.": "0776-855029",
        "Insegna": "BROGI ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUC02079-005958,25SBLDC02234-006648,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11207-006787,25SBLUL02412-007155,24WBLDC03047-006047,24WBLDC02041-006648,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUT02306-006801,25WBLDK03103-006047,25SBLUC03012-006719,25SBLDC03006-006950,25SBLUT02315-007117,25SBLDC01279-007111"
    },
    "019960": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDF02101-006960,24WBLDF16106-006960,24WBLDK02124-006631,24WBLDK02353-006985,24WBLDL01420-007016,24WBLDM04428-005794"
    },
    "019972": {
        "Stato": "IT",
        "CAP": "71037",
        "Localit\u00e0": "MONTE SANT'ANGELO",
        "Indirizzo": "VIA GIUSEPPE GARIBALDI, 88",
        "N.ri Tel.": "0884/964562",
        "Insegna": "BOUTIQUE CAPRICCIO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,24WBLDK03037-006950,25SBLDH02372-005707,25WBLUK03142-005480,25WBLUC02079-005958,25SBLDV02296-007143,25WBLUC03074-006355,25SBLDC01222-007108,25WBLUA05299-006127,25SBLUT02346-007132,24WBLDC03036-006950,24WBLDK03052-006047,24WBLDC03047-006047,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUH02195-004547,25SBLDV03365-007143,25WBLDC03100-006047,25SBLUF03186-006804,24WBLDC02290-006646,25SBLDS01291-007141,25SBLUT02313-006818,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUS01338-007137,25SBLDF03257-007113,24WBLDF01398-006987,25WBLUA05298-006127,25WBLUC02079-A05958,24WBLDC02112-006631"
    },
    "019977": {
        "Stato": "IT",
        "CAP": "22070",
        "Localit\u00e0": "LIMBIATE",
        "Indirizzo": "VIA PREALPI 28",
        "N.ri Tel.": "338 583581 MONICA",
        "Insegna": "MASCHERONI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03048-006047,25SBLDC01221-007108,25SBLDC01279-007111,25SBLDC02233-007104,25SBLDC03006-006950,25SBLDF03076-007092,25SBLDF08078-007092,25SBLDH02374-006842,25SBLDP01079-007092,25SBLDX03008-006950,25SBLUC03012-006719,25SBLUC11207-006787,25SBLUF01184-006804,25SBLUF03186-006804,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUH02193-004547,25SBLUH02196-004547,25SBLUH02275-007100,25SBLUP05190-006804,25SBLUT02310-006817,25SBLUX02230-005958"
    },
    "019983": {
        "Stato": "IT",
        "CAP": "000124",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA RAVEL MAURICE, 408",
        "N.ri Tel.": "3933127023",
        "Insegna": "LE COSE DI......",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,25SBLDH02372-005707,25SBLUP05190-006804,25WBLDK03101-006047,25WBLDA05336-007349,25WBLDC02178-006646,25SBLUA04527-007182,25WBLUC03074-006355,25SBLDC01221-007108,25SBLDP01079-007092,25SBLUC01119-007105,24WBLDK11337-006007,24WBLDC03047-006047,24WBLDK02042-006648,25SBLUT02316-007116,24WBLDC02041-006648,25SBLDP05205-006804,25SBLDT02125-006526,25SBLUF03186-006804,24WBLDK03039-006950,24WBLDC02290-006646,25SBLDH02389-007144,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC01121-007105,25SBLUN02513-007179,25WBLDC03095-006047,25WBLDK03103-006047,25WBLDA05337-006127,24WBLDA05465-006127,25SBLDF08078-007092,25WBLUA05298-006127,25WBLDA05335-007349,24WBLDC03048-006047,25SBLUT02315-007117,24WBLDK03040-006950,25SBLDC01279-007111,25SBLUF03185-006804"
    },
    "019984": {
        "Stato": "IT",
        "CAP": "35100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA DELLE CONVERTITE 12/13",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25WBLUC03233-007308,24WBLDK03122-006955,24WBLDL01420-007016,24WBLDM01427-005794"
    },
    "019992": {
        "Stato": "IT",
        "CAP": "66043",
        "Localit\u00e0": "CASOLI",
        "Indirizzo": "CONTRADA SELVA PIANA, 62",
        "N.ri Tel.": "0872982751",
        "Insegna": "CAPUZZI",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDC01222-007108,24WBLDC03036-006950,24WBLDC03047-006047,25WBLDC03100-006047,25SBLUB01216-007111,24WBLDC02290-006646,25SBLUC01211-007101,25WBLDC03096-006047,25SBLDK01249-007111,25WBLDC03095-006047,25WBLDC02170-006648,24WBLDC02352-006977,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLDC01279-007111"
    },
    "020001": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "SAN DAMIANO D'ASTI",
        "Indirizzo": "P.ZZA XXV APRILE, 1",
        "N.ri Tel.": "081-5745499",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020008": {
        "Stato": "IT",
        "CAP": "50132",
        "Localit\u00e0": "FIRENZE",
        "Indirizzo": "VIA MASACCIO 201/D",
        "N.ri Tel.": "3351275708",
        "Insegna": "GAME 7 ATHLETICS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDC02072-006648,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLUC11215-007110,24WBLDC03036-006950,24WBLDC03047-006047,25SBLDC01358-007101,25SBLUC11541-007110,25WBLDK02069-006648,25WBLUC03233-007308,24WBLDK02042-006648,25WBLDC03100-006047,24WBLDC02290-006646,25SBLUC02231-005958,25SBLUC04206-006535,25SBLDC02232-007104,25SBLDK01249-007111,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUX02230-005958,25SBLDC03006-006950"
    },
    "020022": {
        "Stato": "IT",
        "CAP": "74024",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA XX SETTEMBRE, 45A",
        "N.ri Tel.": "0775 891183",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03040-006950,25SBLUH02276-005695"
    },
    "020037": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "VIALE GALILEO GALILEI, 29",
        "N.ri Tel.": "0558797034",
        "Insegna": "MARTELLI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC03074-006355,24WBLDC03047-006047,25WBLUC03233-007308,24WBLDK02042-006648,24WBLDC02041-006648,25WBLDC03100-006047,24WBLDC02290-006646,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC03095-006047,25WBLUC02080-005958"
    },
    "020039": {
        "Stato": "IT",
        "CAP": "94019",
        "Localit\u00e0": "VARALLO POMBIA",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02290-006646"
    },
    "020044": {
        "Stato": "IT",
        "CAP": "92017",
        "Localit\u00e0": "SAMBUCA IN SICILIA",
        "Indirizzo": "VIA DISCESA CAPPUCCINI N\u00b020",
        "N.ri Tel.": "081-8425474",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480"
    },
    "020045": {
        "Stato": "IT",
        "CAP": "96012",
        "Localit\u00e0": "VILLABATE",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020048": {
        "Stato": "IT",
        "CAP": "60019",
        "Localit\u00e0": "SENIGALLIA",
        "Indirizzo": "VIA GUGLIELMO OBERDAN,4",
        "N.ri Tel.": "686095154",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020049": {
        "Stato": "IT",
        "CAP": "91028",
        "Localit\u00e0": "PARTANNA",
        "Indirizzo": "VIA VITTORIO EMANUELE, 166",
        "Insegna": "NOTIZIE WAW",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01281-007105,25SBLUC11207-006787,25SBLUH02109-006526,25SBLUP02352-006855,25SBLUT02313-006818"
    },
    "020050": {
        "Stato": "IT",
        "CAP": "74027",
        "Localit\u00e0": "SAN GIORGIO JONICO",
        "Indirizzo": "VIA DEL CANALETTO, 27",
        "N.ri Tel.": "0994504101",
        "Insegna": "RAGNO STORE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUH02193-004547,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,25SBLDC01222-007108,25WBLUC02077-006943,25SBLUH02196-004547,24WBLDC03036-006950,24WBLDK03052-006047,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLUH02108-006864,25WBLGC02391-006648,25WBLDC03100-006047,24WBLDC02290-006646,25SBLUC01211-007101,25WBLDC03096-006047,25WBLUA05297-006127,25WBLDC03095-006047,24WBLDC03051-006047,25WBLDC02170-006648,25SBLUC03012-006719,25WBLUC03086-006047,24WBLDA05465-006127,25SBLUH02275-007100,25WBLUC06082-005480,25SBLUC03013-006719,25WBLUC02080-005958,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "020054": {
        "Stato": "RO",
        "CAP": "97015",
        "Localit\u00e0": "WALDBRONN",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "988 60 25 20",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958"
    },
    "020059": {
        "Stato": "IT",
        "CAP": "01017",
        "Localit\u00e0": "TUSCANIA",
        "Indirizzo": "VIALE TRIESTE, 20",
        "N.ri Tel.": "3932167330",
        "Insegna": "CONTI",
        "CODICE PRODOTTO KOOOMO": "25WBLDA05336-007349,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUT02346-007132,25SBLUP01189-006804,25SBLDP01079-007092,24WBLDK03052-006047,24WBLDK11337-006007,24WBLDC03047-006047,25WBLDK02069-006648,25SBLUH02194-004547,24WBLDK02042-006648,25SBLUF01184-006804,24WBLDC02041-006648,25SBLUH02108-006864,25SBLDT02125-006526,25SBLDF03076-007092,25WBLDK02073-006648,25SBLUC04176-006854,24WBLDC02290-006646,25WBLDC03096-006047,24WBLDF08400-006987,25WBLDC03095-006047,25SBLDX02290-007119,25SBLUC01209-007101,25SBLUT02306-006801,25SBLUS01342-007136,25WBLDC02170-006648,25WBLDK03103-006047,24WBLDK03086-006976,25WBLDA05337-006127,25SBLUC04082-007159,25SBLDH02375-006842,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUA05298-006127,24WBLDC03048-006047,25WBLDC03099-006047,25WBLUC02079-A05958,25SBLUC01210-007101,25SBLDC01279-007111,25SBLUF03185-006804"
    },
    "020082": {
        "Stato": "IT",
        "CAP": "50136",
        "Localit\u00e0": "FIRENZE",
        "Indirizzo": "VIA RATTAZZI 2E",
        "N.ri Tel.": "055678853",
        "Insegna": "DUE PUNTO ZERO",
        "CODICE PRODOTTO KOOOMO": "25SBLDX03008-006950,24WBLDC02044-006648,25WBLUC08078-006355,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,24WBLDC03047-006047,25WBLDK03527-006047,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25SBLUC03012-006719,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDF08248-006948,25WBLDA05337-006127"
    },
    "020115": {
        "Stato": "IT",
        "CAP": "80133",
        "Localit\u00e0": "ZNOJMO",
        "Indirizzo": "VIA P.P. RAINER, 13/A",
        "N.ri Tel.": "081-5627109",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03122-006955"
    },
    "020173": {
        "Stato": "IT",
        "CAP": "95024",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "942891027",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020181": {
        "Stato": "IT",
        "CAP": "87023",
        "Localit\u00e0": "DIAMANTE",
        "Indirizzo": "CORSO V.EMANUELE, 15",
        "Insegna": "MIRIADE DIAMANTE UOMO",
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958"
    },
    "020495": {
        "Stato": "IT",
        "CAP": "74121",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA PER SAN GIORGIO",
        "N.ri Tel.": "080 6970050",
        "Insegna": "QUALITY SPORT",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25SBLUH02193-004547,24WBLDC02049-006636,24WBLDC02044-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUT02346-007132,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLDT02125-006526,25WBLGC02391-006648,25SBLUH02191-004547,25WBLKC02427-005958,25SBLUF03186-006804,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUS01337-007137,25WBLDC02170-006648,25SBLDH02386-007144,25SBLDH02375-006842,25WBLUC02080-005958,25WBLDC03099-006047,25SBLDC04066-007109,25WBLKC02429-005958,25WBLDC11163-007110,24WBLDC02112-006631"
    },
    "020496": {
        "Stato": "IT",
        "CAP": "72023",
        "Localit\u00e0": "MESAGNE",
        "Indirizzo": "CENTRO COMMERCIALE APPIA ANTICA SS7,7",
        "N.ri Tel.": "080 6970050",
        "Insegna": "TOP SPORT SRL - DESTINAZIONE IPERSPORT MESAGNE",
        "CODICE PRODOTTO KOOOMO": "24WBLDC11209-006007,25WBLUC11083-007110,25SBLUH02193-004547,24WBLDC02049-006636,24WBLDC02044-006648,25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,24WBLDC02314-006631,25WBLUC03074-006355,25SBLDH02374-006842,25SBLUT02346-007132,25SBLUC11207-006787,24WBLDC03047-006047,25WBLUC03233-007308,25SBLDT02125-006526,25WBLGC02391-006648,25SBLUH02191-004547,25WBLKC02427-005958,25SBLUF03186-006804,25SBLUH02197-004547,24WBLDC02290-006646,25SBLUH02192-004547,25SBLDC11237-007110,25WBLDK11162-007110,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUS01337-007137,25WBLDC02170-006648,25SBLDH02386-007144,25SBLDH02375-006842,25WBLUC02080-005958,25WBLDC03099-006047,25SBLDC04066-007109,25WBLKC02429-005958,25WBLDC11163-007110,24WBLDC02112-006631"
    },
    "020545": {
        "Stato": "IT",
        "CAP": "90034",
        "Localit\u00e0": "UDINE",
        "Indirizzo": "VIALE TRICESIMO, 187",
        "N.ri Tel.": "96 159 42 50",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020973": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIA CACCIATORI, 111",
        "N.ri Tel.": "619768266",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020993": {
        "Stato": "PL",
        "CAP": "84-120",
        "Localit\u00e0": "Wladyslawowo",
        "Indirizzo": "VIA SS ANNUNZIATA, 3",
        "N.ri Tel.": "502720326",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020994": {
        "Stato": "SM",
        "CAP": "95045",
        "Localit\u00e0": "Wladyslawowo",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "96 159 42 50",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "021002": {
        "Stato": "IT",
        "CAP": "84070",
        "Localit\u00e0": "SAN GIOVANNI A PIRO",
        "Indirizzo": "VIA LUISA SPAGNOLI, 42",
        "N.ri Tel.": "0974-980236",
        "Insegna": "IANNUZZI",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02041-006648,24WBLDC02064-006100,24WBLDC02112-006631,24WBLDC02112-006631,24WBLDC02290-006646,24WBLDC02314-006631,24WBLDC02314-006631,24WBLDC03036-006950,24WBLDC03036-006950,24WBLDC03038-006950,24WBLDC03038-006950,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK02042-006648,24WBLDK03037-006950,24WBLDK03052-006047"
    },
    "021011": {
        "Stato": "IT",
        "CAP": "36025",
        "Localit\u00e0": "TIMMENDORFER STRAND",
        "Indirizzo": "STRANDALLEE 83",
        "N.ri Tel.": "04562 25 62 47",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02363-005831"
    },
    "021012": {
        "Stato": "RU",
        "CAP": "81479",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA ROMA, 55",
        "N.ri Tel.": "011 3292512",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02394-007114"
    },
    "021024": {
        "Stato": "IT",
        "CAP": "74564",
        "Localit\u00e0": "Wendlingen",
        "Indirizzo": "WILHELMSTRASSE 1-5",
        "N.ri Tel.": "0544 1847340",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02064-006100"
    },
    "021028": {
        "Stato": "IT",
        "CAP": "10154",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "S.DA COMUNALE DI ALTESSANO 141",
        "N.ri Tel.": "011212148",
        "Insegna": "ONE'S EASE",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,24WBLDC03084-006976,25WBLUC03074-006355,24WBLDC03036-006950,24WBLDC03047-006047,24WBLDC03038-006950,25WBLDK03527-006047,25WBLDC03100-006047,24WBLDK03039-006950,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,24WBLDK03086-006976,24WBLDC02016-006940,25WBLUC03086-006047,25WBLDK03495-006047,24WBLDC03048-006047,25WBLDC03099-006047"
    },
    "021037": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "347 7006858",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02309-007125"
    },
    "021042": {
        "Stato": "UA",
        "CAP": "95129",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA MONSIGNOR BAGNOLI 79",
        "N.ri Tel.": "699913377",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108"
    },
    "021048": {
        "Stato": "IT",
        "CAP": "790 01",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "0535 46696",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDH02372-005707"
    },
    "021170": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "943326126",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "021195": {
        "Stato": "PL",
        "CAP": "88046",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "059 558886",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "021236": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "943811088",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "021238": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA PRINCIPALE, 65",
        "N.ri Tel.": "049 8669830",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,24WBLDK11337-006007,25SBLUH02194-004547,24WBLDK03293-005553,25SBLGC02426-006648,24WBLDC02251-006631,25SBLUC01219-007108,25SBLUN02516-007177,25SBLUT02110-006526,25SBLGF03548-007187,25SBLUM01486-007172,24WBLDK03122-006955,25SBLGH02492-007144,25SBLUP02352-006855,25SBLUH02030-006846,25SBLUC01217-007108,25SBLUP05033-007094,24WBLDC03084-006976,24WBLDC02314-006631,25SBLUH02196-004547,24WBLDK03315-006640,25SBLUC01046-007120,24WBLDK02311-006648,24WBLDK02042-006648,24WBLDC02041-006648,24WBLDK02353-006985,25SBLDP01344-006855,25SBLUA04524-007182,25SBLUH02276-005695,25SBLGC02432-007104,25SBLUC04206-006535,25SBLUL02409-006547,25SBLUC01034-007111,25SBLGC02429-006648,24WBLDC02112-006631,24WBLDK03037-006950,25SBLDH02381-007114,24WBLDB03558-006950,25SBLUM06481-007168,25SBLDV03365-007143,25SBLUH02197-004547,25SBLKC11440-007111,25SBLKX02418-005958,24WBLDX03318-006992,25SBLDP03537-006873,24WBLDA05465-006127,25SBLDC03006-006950,24WBLDM01427-005794,24WBLDM10555-007022,25SBLDC02233-007104,25SBLDH02372-005707,25SBLKF08561-007187,24WBLDC03295-006857,25SBLDH02376-006842,25SBLKC01444-007101,25SBLDF03076-007092,24WBLUK02171-006995,BLAP049-POP,24WBLDM04428-005794,24WBLDK03212-006990,25SBLUK11239-007110,25SBLDT02138-006526,25SBLUC04082-007159,24WBLDL01420-007016,25SBLUP04353-007139,24WBLDF02101-006960,25SBLUS01339-007137,25SBLUN02510-007177,25SBLUC02151-007124,25SBLKH02555-007188,24WBLDK03039-006950,25SBLUT02312-006803,25SBLDP01326-007143,25SBLUP01183-007121,25SBLDC02232-007104,25SBLUC11083-007106,25SBLUF03187-006804,25SBLUC01209-007101,25SBLDC02330-007119,25SBLDF08078-007092,25SBLUP04354-007129,25SBLDV01146-007107,25SBLDC02289-007119,25SBLUP05190-006804,25SBLDX02235-006648,24WBLDL01417-006668,24WBLDK02556-006646,25SBLUH02195-004547,25SBLUM01478-007167,24WBLDM04562-007021,25SBLDK01249-007111,25SBLKP01554-007187,24WBLDL01416-006669,25SBLUH01149-007100,25SBLDP05080-007092,25SBLDP05301-007140,25SBLDX03008-006950,24WBLDP01448-006420,24WBLDA05467-006434,24WBLDL01421-007016,25SBLKF03551-007187,24WBLDM13260-006645,25SBLDF03201-006804,25SBLUL02412-007155,24WBLDH01432-006971,24WBLDC03298-006992,25SBLKP05564-007187,25SBLUK04174-006854,25SBLUH02108-006864,25SBLDP02143-007109,25SBLKC01435-007108,25SBLUC04176-006854,25SBLDP04142-007109,24WBLDF08400-006987,25SBLUS02336-007137,25SBLDC03007-006950,24WBLDC03051-006047,25SBLUP02038-007096,25SBLDP05141-007109,25SBLDC04333-007109,25SBLDM01473-007166,24WBLDK03086-006976,25SBLUF02188-006804,24WBLDC03252-007008,24WBLDF03399-006987,24WBLDC11209-006007,25SBLUM01476-006233,24WBLDP03446-007029,25SBLUL02582-007370,25SBLDC11335-007110,25SBLUC11207-006787,25SBLGC01441-007111,24WBLDC02342-006631,25SBLUC02254-007101,25SBLUM12488-007170,25SBLUB01216-007111,25SBLUH02192-004547,25SBLUC02228-007104,25SBLDH02370-006845,24WBLDK02363-005831,24WBLDC02016-006940,24WBLDM10259-006645,25SBLKC02417-005958,24WBLDM10408-007022,25SBLUC02227-007104,25SBLUM01480-007168,24WBLUK03216-006966,25SBLKC01445-007101,25SBLUT02310-006817,25SBLKF02553-007187,25SBLUH02241-007100,25SBLUC11214-007111,24WBLDK03120-006951,25SBLUC04168-006788,24WBLDX03280-006719,25SBLUX02230-005958,24WBLDC03048-006047,24WBLDK03040-006950,25SBLUH02103-007149,25SBLDP01079-007092,25SBLUP01350-006855,25SBLUC03011-006719,25SBLUC01047-007120,24WBLDC02018-006648,24WBLDK02043-006648,24WBLDK03297-006992,25SBLUS01338-007137,24WBLDF16106-006960,25SBLDC02236-006648,24WBLDC03119-006951,24WBLDC02044-006648,25SBLDC03003-006950,25SBLUC11215-007110,25SBLGF02547-007187,24WBLDC03038-006950,25SBLUX02255-007101,24WBLDC02290-006646,25SBLDH02389-007144,24WBLDC03211-006990,25SBLDC02128-007103,25SBLUP01324-007130,24WBLDB03294-005553,25SBLUM01482-007168,24WBLDM01437-007021,24WBLDC02049-006636,24WBLDC03114-006719,24WBLDM09261-006645,24WBLDC03036-006950,25SBLUC02280-005958,24WBLDK03052-006047,25SBLKC06443-007101,25SBLDH02387-007144,25SBLDH02377-007144,24WBLDA05469-007037,25SBLDC01159-007105,25SBLUC02231-005958,25SBLUF03031-007094,24WBLDK02362-005831,25SBLDC02251-006648,25SBLUH05028-006846,25SBLUL02407-007151,24WBLDX02113-006631,25SBLDH03371-005707,25SBLUC11541-007110,25SBLUF02101-007121,25SBLUS01341-007136,25SBLUH02348-007132,25SBLUP04062-007092,25SBLDC11237-007110,25SBLKP05558-007187,25SBLDP02345-006855,24WBLDK07405-005480,25SBLUP04353-007129,25SBBGC02453-005958,25SBLUL02411-007155,24WBLDC02250-007008,25SBLUC03012-006719,25SBLUC03013-006719,24WBLDC02352-006977,25SBLUM01479-007167,24WBLDK02124-006631,25SBLUN01521-006581,25SBLUC02229-005958,25SBLUN02514-007179,25SBLDL02396-007156,23WBLUK11014-006007,25SBLUX03226-006719,25SBLGP05549-007187,25SBLUP04322-007129,25SBLDC01279-007111,25SBLUF03185-006804,24WBLDK02045-006648,25SBLUA04527-007182,25SBLUH02109-006526,25SBLDC01358-007101,25SBLKC02430-007104,25SBLDC02264-006648,25SBLUP05355-007139,25SBLUT02309-007125,25SBLUS01337-007137,25SBLDX02290-007119,25SBLDP01140-007109,24WBLDC05357-005831,24WBLDC02064-006100,25SBLUH02394-007114,25SBLUL02402-007153,24WBLDK03346-006047,25SBLUA04525-007182,25SBLUM03490-007170,25SBLDP01300-007140,25SBLDC01221-007108,25SBLUF01568-007121,25SBLUH02191-004547,24WBLDK03315-006950,24WBLDB02092-006976,25SBLUT02313-006818,25SBLUN02513-007179,24WBLDH02433-006971,25SBLGH02495-007144,25SBLDL02399-007155,25SBLUC04163-006788"
    },
    "021587": {
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "932 84 55 84",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "021633": {
        "Stato": "IT",
        "CAP": "35100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA DELLE CONVERTITE 12/13",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950,25SBLUC11541-007110,25SBLUC02231-005958,25SBLUX03226-006719,25SBLUC03012-006719"
    },
    "021649": {
        "Stato": "RU",
        "CAP": "92016",
        "Localit\u00e0": "Wladyslawow",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01211-007101,25SBLDC11237-007110,25SBLDC04070-007109,25SBLUC11215-007110,24WBLDK02042-006648,25SBLDC01279-007111,24WBLDC03036-006950,25WBLDC03095-006047"
    },
    "021651": {
        "Stato": "IT",
        "CAP": "90049",
        "Localit\u00e0": "TERRASINI",
        "Indirizzo": "Westernstr. 14",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11207-006787"
    },
    "021657": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "WINTERBERG",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "619768266",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02041-006648,24WBLDK03040-006950,25SBLUC01210-007101,25SBLDC04066-007109"
    },
    "021793": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "VIA TISIA, 108",
        "N.ri Tel.": "943811088",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05465-006127,25WBLUK03142-005480,25SBLDH02373-005707,25SBLDC01279-007111"
    },
    "021870": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "TRAVERSETOLO",
        "Indirizzo": "VIA PUCCINI 12",
        "N.ri Tel.": "670396774",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03047-006047,25SBLDH02389-007144"
    },
    "021945": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDF01398-006987,24WBLDC03295-006857"
    },
    "021977": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03114-006719,24WBLDX03280-006719,24WBLDB02092-006976,24WBLDC02044-006648,24WBLDK02045-006648,24WBLDC03038-006950,24WBLDC03048-006047"
    },
    "022011": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02251-006648,25SBLDC02264-006648,25SBLDC04331-006788,25SBLDH02381-007114,25SBLDH02387-007144,25SBLDH02389-007144,25SBLDL02397-007156,25SBLDL02399-007155,25SBLDP01300-007140,25SBLDP02143-007109,25SBLDP03540-006873,25SBLDX02235-006648,25SBLDX02290-007119,25SBLUB04360-006788,25SBLUC01119-007105,25SBLUC01219-007108,25SBLUC02153-007124,25SBLUC02228-007104,25SBLUC02229-005958,25SBLUC02254-007101,25SBLUC03011-006719,25SBLUC04168-006788,25SBLUF03187-006804,25SBLUH01149-007100,25SBLUL02411-007155,25SBLUM06481-007168,25SBLUN01521-006581,25SBLUN02510-007177,25SBLUN02514-007179,25SBLUP01350-006855,25SBLUS01341-007136,25SBLUX01218-007108,25SBLUX02255-007101,25SBLDC01329-007131,25SBLDC04070-007109,25SBLDH02376-006842,25SBLDH02377-007147,25SBLDM08474-007166,25SBLDP01326-007143,25SBLDP03537-006873,25SBLDS01292-007141,25SBLDT02138-006526,25SBLDV01146-007107,25SBLUC02280-005958,25SBLUF03186-006804,25SBLUF08504-007173,25SBLUH02193-004547,25SBLUH02196-004547,25SBLUH02199-004547,25SBLUK11239-007110,25SBLUL02402-007153,25SBLUL02407-007151,25SBLUL02412-007155,25SBLUM01478-007167,25SBLUM12488-007170,25SBLUP01183-007121,25SBLUP02038-007096,25SBLUP02063-007092,25SBLUP04043-007130,25SBLUS01338-007137,25SBLUS01339-007137,25SBLUS01340-007138,25SBLUX03226-006719,25SBLUH02103-007149,25SBLDP04142-007109,25SBLDP05205-006804,25SBLUC01034-007111,25SBLUC01211-007101,25SBLUF03031-007094,25SBLUH02244-007100,25SBLUH02348-007132,25SBLUM01479-007167,25SBLUM03490-007170,25SBLUP05033-007094,25SBLUP05530-007173,25SBLUS02336-007137,25SBLDF03201-006804,25SBLDH02370-006845,25SBLDP01079-007092,25SBLDV04293-007143,25SBLUH02197-004547,25SBLUH02394-007114,25SBLUM01482-007168,25SBLUP02352-006855,25SBLUS01342-007136,25SBLUC01046-007120,25SBLUC11541-007110,25SBLUH02241-007100,25SBLUP05355-007139,25SBLDV03365-007143,25SBLUA04528-007183,25SBLUP04353-007129,25SBLUT02306-006801,25SBLDC01279-007111,25SBLUM01476-006233,25SBLDC01159-007105,25SBLUT02309-007125"
    },
    "022026": {
        "Stato": "IT",
        "CAP": "71018",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "WEGASTRASSE 4A",
        "N.ri Tel.": "915220722",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02313-006818,25WBLUC03086-006047,25SBLUF01568-007121,25SBLUF02101-007121,25SBLUT02310-006817"
    },
    "022042": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03298-006992,24WBLDX03318-006992"
    },
    "022053": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIALE CARDUCCI, 79",
        "N.ri Tel.": "686095154",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDA05465-006127,25WBLDK11162-007110"
    },
    "022067": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA MESTRINO 47/L",
        "N.ri Tel.": "974244948",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDF02101-006960,24WBLDK03037-006950,24WBLDC03047-006047,25SBLDC01359-007101,25SBLDX02235-006648,25SBLDH02374-006842,25SBLDH02375-006842,25SBLDC04333-007109,25SBLDP01140-007109,25SBLDP05141-007109"
    },
    "022097": {
        "Stato": "VA",
        "CAP": "89231",
        "Localit\u00e0": "VILLANOVA DI CAMPOSAMPIERO",
        "Indirizzo": "WACHMANNSTR. 49",
        "N.ri Tel.": "619768266",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03036-006950"
    },
    "022098": {
        "Stato": "IT",
        "CAP": "89231",
        "Localit\u00e0": "ZNOJMO",
        "Indirizzo": "WILHELMSTRASSE 1-5",
        "N.ri Tel.": "3472541996",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02353-006985,24WBLDC02251-006631,25SBLUC01034-007111,25SBLDC04066-007109,25SBLDB04068-007109,25SBLDC02234-006648,25SBLDC03007-006950"
    },
    "022099": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "VALLADOLID",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "983313162",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03037-006950"
    },
    "022105": {
        "Stato": "IT",
        "CAP": "96215",
        "Localit\u00e0": "Timmendorfer Strand",
        "Indirizzo": "VIA SALLUSTIO SNC",
        "N.ri Tel.": "965525432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF02188-006804,25SBLUF01184-006804,25SBLUP05190-006804,25SBLUP01189-006804"
    },
    "022111": {
        "Stato": "IT",
        "CAP": "47003",
        "Localit\u00e0": "VALLADOLID",
        "Indirizzo": "VIA DELLE ORTENSIE, 5/B",
        "N.ri Tel.": "620110821",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP03539-006873,25SBLUT02308-006801,25SBLUT02346-007132,25SBLUS02336-007138,25SBLUT02316-007116,25SBLUH02242-007100,25SBLUT02317-007116,25SBLUB01216-007111,25SBLUX01218-007108,25SBLUT02310-006817,25SBLUH02241-007100,25SBLUC01209-007101,24WBLDC03048-006047"
    },
    "022123": {
        "Stato": "IT",
        "CAP": "48011",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "944 154 925",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03052-006047,24WBLDK03086-006976,25SBLDC04066-007109,25SBLDF03076-007092,24WBLDC03051-006047,25WBLDC02196-007283"
    },
    "022125": {
        "Stato": "IT",
        "CAP": "74019",
        "Localit\u00e0": "TRICASE",
        "Indirizzo": "carrer Balmes 28, principal 2",
        "N.ri Tel.": "392 2236490",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03119-006951,24WBLDK02042-006648,24WBLDB03294-005553"
    },
    "022128": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "685737210",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03122-006955,24WBLDC03048-006047,24WBLDK03040-006950"
    },
    "022129": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "VITORIA-GASTEIZ",
        "Indirizzo": "VIA LARGO BONITO 4-6-8",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03052-006047,24WBLDC03051-006047,25WBLDC03096-006047"
    },
    "022134": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "022136": {
        "Stato": "IT",
        "CAP": "85456",
        "Localit\u00e0": "Wien",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "62977778",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02348-007132,25SBLDH02386-007144,25SBLUT02312-006803,25SBLUC01211-007101,24WBLDK02042-006648,25SBLDH02375-006842,25SBLUH02195-004547,25SBLDV02296-007143,25SBLDT02125-006526,25SBLDF03257-007113"
    },
    "022148": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "Wladyslawow",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "502720326",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "022163": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "Winnenden",
        "Indirizzo": "Wallstrasse 30",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDS01291-007141,24WBLDK03052-006047,25SBLDX03008-006950,25SBLDH02377-007144,24WBLDC02352-006977,25SBLDC03006-006950,25WBLDC03099-006047,24WBLDK02362-005831,24WBLDC03051-006047,25SBLDH03371-005707"
    },
    "022171": {
        "Stato": "IT",
        "CAP": "93012",
        "Localit\u00e0": "SQUINZANO",
        "Indirizzo": "VIA XX SETTEMBRE, 45A",
        "N.ri Tel.": "699913377",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDF03399-006987,24WBLDF08400-006987,24WBLDC03047-006047,24WBLDC03047-006047"
    },
    "022176": {
        "Stato": "IT",
        "CAP": "93012",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PLINIO, 377",
        "N.ri Tel.": "96 159 42 50",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK02045-006648,25WBLDC02506-007254,25WBLUK11140-007286"
    },
    "022189": {
        "Stato": "SM",
        "CAP": "95129",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIALE EUROPA, 7",
        "N.ri Tel.": "3938438702",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDX02113-006631,24WBLDC02290-006646"
    },
    "022191": {
        "Stato": "IT",
        "CAP": "90402",
        "Localit\u00e0": "VALLADOLID",
        "Indirizzo": "WILHELMSTR. 13",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03084-006976"
    },
    "022199": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC03051-006047"
    },
    "022204": {
        "Stato": "IT",
        "CAP": "93012",
        "Localit\u00e0": "TRAVERSETOLO",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "911 236 444",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,24WBLDK03037-006950,25SBLDH02372-005707,25SBLUA04527-007182,24WBLDC02314-006631,25SBLUH02196-004547,24WBLDC03036-006950,25SBLDH03371-005707,24WBLDK03052-006047,25SBLDF03201-006804,24WBLDC03047-006047,25SBLUC01115-007105,24WBLDC02342-006631,25SBLUC03011-006719,25SBLDL02396-007152,24WBLDC02041-006648,25SBLDP05205-006804,25SBLUA04525-007182,25WBLGC02391-006648,25SBLUT02317-007116,24WBLDK03039-006950,25SBLUH02192-004547,25SBLUC01121-007105,25SBLUL02403-006543,25SBLUN02513-007179,25SBLUC11083-007106,25SBLDF03257-007113,24WBLDC03051-006047,25SBLUF01055-007092,25WBLDK03103-006047,25SBLUC03012-006719,25SBLUH02275-007100,25SBLDF08078-007092,25SBLUH01149-007100,25SBLDC03006-006950,25SBLUH02274-007100,24WBLDC03048-006047,25SBLUF03185-006804,24WBLDK03346-006047"
    },
    "022205": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VILLANOVA DI CAMPOSAMPIERO",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDC02064-006100,24WBLDC02064-006100"
    },
    "022215": {
        "Stato": "IT",
        "CAP": "95028",
        "Localit\u00e0": "WOLLERSDORF",
        "Indirizzo": "WESTERBACHSTRASSE 5",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUL02409-006547,25SBLDC02233-007104,25SBLDC02236-006648,24WBLDC02342-006631,24WBLDK02043-006648,24WBLDK02042-006648"
    },
    "022218": {
        "Stato": "PT",
        "CAP": "L40 8LD",
        "Localit\u00e0": "ZERO BRANCO",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "911 236 444",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "022227": {
        "Stato": "VA",
        "CAP": "98125",
        "Localit\u00e0": "VILLANOVA DI CAMPOSAMPIERO",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "022228": {
        "Stato": "PL",
        "CAP": "97-306",
        "Localit\u00e0": "VILAGARCIA DE AROUSA",
        "Indirizzo": "Wola Bykowska 31",
        "N.ri Tel.": "986505893",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "24WBLDK03040-006950,24WBLDC03038-006950,24WBLDK03039-006950,24WBLDC02250-007008"
    },
    "022235": {
        "Stato": "SK",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "Zilina",
        "Indirizzo": "WILHELMSTRASSE 1-5",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648,24WBLDK03122-006955,24WBLDK03040-006950"
    },
    "003563": {
        "Stato": "DE",
        "CAP": "53332",
        "Localit\u00e0": "BORNHEIM-HERSEL",
        "Indirizzo": "SIMON-ARZT STRASSE 1",
        "N.ri Tel.": "0049222283060",
        "Insegna": "Daniels",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01221-007108,25SBLDC01221-007108,25SBLDC01222-007108,25SBLDC01328-007131,25SBLDC11335-007110,25SBLUC01034-007111,25SBLUC01217-007108,25SBLUC01217-007108,25SBLUC04163-006788,25SBLUC04163-006788"
    },
    "003568": {
        "Stato": "AT",
        "CAP": "6020",
        "Localit\u00e0": "INNSBRUCK",
        "Indirizzo": "MARIA -THERESIEN STRASSE 24",
        "N.ri Tel.": "0043512581458-1",
        "Insegna": "by FINKs",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01209-007101,25SBLUC01209-007101,25SBLUC04082-007159,25SBLUC11207-006787"
    },
    "009248": {
        "Stato": "DE",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ESCHENBRUENNLESTRASSE 11",
        "N.ri Tel.": "0049 711 2110",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF01184-006804"
    },
    "013835": {
        "Stato": "DE",
        "CAP": "8010",
        "Localit\u00e0": "GRAZ",
        "Indirizzo": "SACKSTRASSE 7-13",
        "N.ri Tel.": "0049 234 9149162-6",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01222-007108"
    },
    "014392": {
        "Stato": "CZ",
        "CAP": "73951",
        "Localit\u00e0": "Marianske lazne",
        "Indirizzo": "Lazenska kolonada",
        "N.ri Tel.": "00420605233669",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDH02381-007114"
    },
    "015077": {
        "Stato": "JP",
        "CAP": "-",
        "Localit\u00e0": "MINATO KU, TOKYO",
        "Indirizzo": "3-17-12 SHIBA, 2M BLDG, 9F",
        "N.ri Tel.": "+81-90-4307-5803",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015365": {
        "Stato": "CZ",
        "CAP": "370 01",
        "Localit\u00e0": "Ceske Budejovice CZ",
        "Indirizzo": "Namesti Otakara Premysla II 36",
        "N.ri Tel.": "00420777934924",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP05530-007173,25WBLDM01463-007330,25SBLDS01292-007141,25SBLDP05205-006804,25SBLDK01249-007111,25WBLDK03102-006047,25SBLUS01337-007137"
    },
    "016500": {
        "Stato": "DE",
        "CAP": "59065",
        "Localit\u00e0": "Hamm",
        "Indirizzo": "Weststr. 1-3",
        "N.ri Tel.": "0049 208780340",
        "Insegna": "PRUEMER'S HAUS DER DAME",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLDB04068-007109,25SBLDC02236-006648,25WBLDK02192-006648,25WBLDC02178-006646,25WBLDK03102-006047,25SBLDC03007-006950"
    },
    "017375": {
        "Stato": "CZ",
        "CAP": "779 00",
        "Localit\u00e0": "OLOMOUC",
        "Indirizzo": "TYNECKA 714/6",
        "N.ri Tel.": "+420 603865000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDH03369-006845"
    },
    "018192": {
        "Stato": "ES",
        "CAP": "20870",
        "Localit\u00e0": "ELSGUIBAR",
        "Indirizzo": "SAN FRANCISCO, 36",
        "N.ri Tel.": "943744199",
        "Insegna": "ODRIOZOLA",
        "CODICE PRODOTTO KOOOMO": "25SBLUB04167-006854,25SBLUC01211-007101,25SBLUC04163-006788,25SBLUC04163-006788,25SBLUC04168-006788,25SBLUC04176-006854,25SBLUF01184-006804,25SBLUF03186-006804,25SBLUF03186-006804,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUT02110-006526,25SBLUT02110-006526"
    },
    "018357": {
        "Stato": "DE",
        "CAP": "23683",
        "Localit\u00e0": "Scharbeutz",
        "Indirizzo": "Strandallee 138",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC02229-005958"
    },
    "019304": {
        "Stato": "PL",
        "CAP": "95028",
        "Localit\u00e0": "TARRASA - BARCELONA",
        "Indirizzo": "Strandallee 138",
        "N.ri Tel.": "937830462",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02264-006648"
    },
    "020415": {
        "Stato": "SK",
        "CAP": "54351",
        "Localit\u00e0": "Zilina",
        "Indirizzo": "Okruzni 116",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25SBLUC03011-006719,25SBLDH02375-006842,25SBLDP05080-007092,25SBLDF03076-007092,25WBLDC03097-006047,25SBLUF03185-006804,25SBLDP05141-007109"
    },
    "020446": {
        "Stato": "ES",
        "CAP": "43700",
        "Localit\u00e0": "EL VENDREILL, TARRAGONA",
        "Indirizzo": "PLAZA JAUM, I LOCAL 7",
        "N.ri Tel.": "678803980",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02194-004547,25SBLUT02346-007132"
    },
    "020861": {
        "Stato": "PL",
        "CAP": "06-500",
        "Localit\u00e0": "Nadarzyn, mazowiecki",
        "Indirizzo": "Katowicka 51/ Box 107",
        "N.ri Tel.": "0048 604 885 993",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDF03201-006804,25SBLDP05205-006804"
    },
    "021082": {
        "Stato": "ES",
        "CAP": "63741",
        "Localit\u00e0": "PRAHA 10",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25SBLUC01209-007101,25SBLDC01222-007108"
    },
    "021505": {
        "Stato": "ES",
        "CAP": "43860",
        "Localit\u00e0": "Manlleu",
        "Indirizzo": "POL IND INDUSTRIAL VINYES DEL MIG, PARC. 8",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02195-004547,25SBLUM01486-007172,25SBLUS01340-007138,25SBLUH02195-004547,25SBLUT02346-007132,25SBLUH02030-006846,25SBLUS01340-007138,25SBLUH02241-007100,25SBLUT02313-006818,25SBLUH02394-007114,25SBLUH02242-007100,25SBLUH02394-007114,25SBLUH02191-004547"
    },
    "021973": {
        "Stato": "GB",
        "CAP": "S11 8QF",
        "Localit\u00e0": "Sheffield",
        "Indirizzo": "10 Hickmott Road",
        "N.ri Tel.": "+44 7583 130736",
        "Insegna": "Partners Menswear",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25SBLUH02103-007149,25WBLUX02081-005958,25SBLUC01046-007120,25SBLUF03037-007096,25SBLUC01047-007120,25SBLUP04043-007130,25WBLUF02118-007121,25SBLUF03031-007094,25SBLUP02038-007096,25SBLUP01324-007130,25WBLUC02153-007300,25SBLUH02030-006846,25SBLUM01486-007172,25SBLUC04082-007159,25SBLUF08504-007173"
    },
    "022141": {
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "CALLE SANT AUGUSTIN 7",
        "N.ri Tel.": "0034 987 273398",
        "Insegna": "LEIKO",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03161-006719,25WBLDK03101-006047,25WBLDC02178-006646,25SBLDV02296-007143,25SBLDH02387-007144,25SBLDF03076-007092,25WBLDB03191-007294,25WBLDC03096-006047,25SBLDC03007-006950,25SBLDK01249-007111,25SBLDF03257-007113,25SBLDH02373-005707,25WBLDK03098-006047,25WBLDC03097-006047,25SBLDC01279-007111,25SBLDV01146-007107"
    },
    "022458": {
        "Stato": "PL",
        "CAP": "77933",
        "Localit\u00e0": "LAHR",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "0049 30209685174",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01358-007101"
    },
    "022459": {
        "Stato": "PL",
        "CAP": "77933",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLDX03008-006950,25WBLDC02072-006648,25SBLDC02289-007119,25WBLDK03101-006047,25SBLDC02234-006648,25SBLDC03003-006950,25SBLDC01222-007108,25SBLDC01221-007108,25SBLUC02151-007124,25SBLDC01358-007101,25SBLDL02396-007156,25SBLDL02396-007152,25SBLUC01047-007120,25WBLUK11140-007286,25SBLUK04174-006854,25WBLGC02391-006648,25SBLUH02191-004547,25SBLUB01216-007111,25WBLUC02151-007287,25SBLUC02227-007104,25SBLUL02403-006543,25SBLUC02231-005958,25SBLDC02232-007104,25WBLDC03095-006047,25WBLDK05019-007298,25WBLDC02177-007284,25SBLUC11214-007111,25SBLDH02386-007144,25SBLUC03012-006719,25SBLDC02236-006648,25SBLDL02399-007155,25SBLUC03013-006719,25SBLDC01328-007131,25SBLUX02230-005958,25SBLDH02373-005707,25SBLDC03006-006950,25SBLUL02408-007151,25WBLDK03102-006047,25SBLUC01217-007108"
    },
    "022584": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "WOLLERSDORF",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "945150305",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25WBLDC02072-006648,25WBLDK03101-006047,25SBLDC01222-007108,25SBLDC01221-007108,25WBLDK02069-006648,25SBLDC02266-007124,25WBLDC03100-006047,25SBLUC02228-007104,25SBLUC02148-007103,25SBLDC02264-006648,25SBLUC02227-007104,25SBLUC04206-006535,25SBLDC02232-007104,25SBLDC02251-006648,25SBLDC02330-007119,25SBLDC02357-007124,25SBLUC01210-007101,25SBLUC01217-007108"
    },
    "022588": {
        "Stato": "DE",
        "CAP": "89081",
        "Localit\u00e0": "Ulm",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "0049711120903",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01209-007101,25SBLUB04167-006854,25SBLUC11215-007110,25SBLUC01217-007108"
    },
    "023144": {
        "Stato": "PL",
        "CAP": "8010",
        "Localit\u00e0": "TIMMENDORFER STRAND",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "04651967700",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01221-007108,25SBLUH02030-006846,25SBLUC01217-007108,25SBLDC03007-006950,25SBLDH02372-005707,25SBLUC01281-007105,25SBLUH05028-006846,25SBLDC01260-007108,25SBLUC11215-007110,25SBLUX02230-005958,25SBLUC11207-006787,25SBLUF01184-006804,25SBLDH02373-005707,25SBLDC01328-007131,25SBLDK01249-007111"
    },
    "000124": {
        "Stato": "IT",
        "CAP": "37012",
        "Localit\u00e0": "BUSSOLENGO",
        "Indirizzo": "VIALE TRIESTE, 45",
        "N.ri Tel.": "0444 491777",
        "Insegna": "SORELLE RAMONDA",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01339-007137,25SBLUP01189-006804,25SBLUL02412-007155,25SBLUC03011-006719,25SBLUC01219-007108,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUH02276-005695,25SBLUP04062-007092,25SBLUF03031-007094,25SBLUT02310-006817,25SBLUT02306-006801,25SBLUS01342-007136,25SBLUF01055-007092,25WBLUC03086-006047,25SBLUM01486-007172,25SBLUC04082-007159,25SBLUH02394-007114,25SBLUH02030-006846"
    },
    "000250": {
        "Stato": "IT",
        "CAP": "00155",
        "Localit\u00e0": "ROMA LUNGHEZZA",
        "Indirizzo": "VIA COLLATINA, 858-860 UNITA' 213  C/o C.C. ROMA EST",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01211-007101,25SBLUC01211-007101"
    },
    "000252": {
        "Stato": "IT",
        "CAP": "20040",
        "Localit\u00e0": "ROMA LUNGHEZZA",
        "Indirizzo": "VIA COLLATINA, 858-860 UNITA' 213  C/o C.C. ROMA EST",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI",
        "CODICE PRODOTTO KOOOMO": "25SBLUX02230-005958"
    },
    "000669": {
        "Stato": "IT",
        "CAP": "37011",
        "Localit\u00e0": "BARDOLINO",
        "Indirizzo": "CORSO UMBERTO I, 18",
        "N.ri Tel.": "045 7210614",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK02192-006648"
    },
    "000779": {
        "Stato": "IT",
        "CAP": "30034",
        "Localit\u00e0": "MIRA",
        "Indirizzo": "VIA NAZIONALE, 161/162",
        "N.ri Tel.": "041 423335",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000825": {
        "Stato": "IT",
        "CAP": "84091",
        "Localit\u00e0": "BATTIPAGLIA",
        "Indirizzo": "VIALE DELLE INDUSTRIE, 8 - ZONA INDUSTRIALE",
        "N.ri Tel.": "0828 308950",
        "Insegna": "GANA SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC11237-007110,25SBLDC11237-007110,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11569-006787,25SBLUF01055-007092,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02195-004547,25SBLUP02063-007092,25SBLUP02063-007092,25SBLUP02352-006855,25SBLUP02352-006855,25SBLUP03534-006873,25SBLUP04062-007092,25SBLUS01337-007137,25SBLUS01337-007137,25SBLUT02306-006801,25SBLUT02306-006801"
    },
    "000990": {
        "Stato": "IT",
        "CAP": "41032",
        "Localit\u00e0": "CAVEZZO",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "0535 46696",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC04176-006854"
    },
    "001019": {
        "Stato": "IT",
        "CAP": "33057",
        "Localit\u00e0": "PALMANOVA DEL FRIULI",
        "Indirizzo": "PIAZZA GRANDE, 15",
        "N.ri Tel.": "0432 502098",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001051": {
        "Stato": "IT",
        "CAP": "48121",
        "Localit\u00e0": "RIVAROLO",
        "Indirizzo": "VIA CAVOUR, 26",
        "N.ri Tel.": "0544 212076",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02348-007132"
    },
    "001527": {
        "Stato": "IT",
        "CAP": "70018",
        "Localit\u00e0": "RUTIGLIANO",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "080 4769091",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF03187-006804"
    },
    "001765": {
        "Stato": "IT",
        "CAP": "00060",
        "Localit\u00e0": "FORMELLO",
        "Indirizzo": "VIA CASAL DEI PINI, 9/10/11",
        "N.ri Tel.": "06 90127774",
        "Insegna": "EXPANCE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC02079-005958,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUH02196-004547,25SBLUC11215-007110,25SBLUT02346-007132,25SBLUC11207-006787,25SBLUL02412-007155,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02108-006864,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02192-004547,25SBLUP04062-007092,25WBLDC03096-006047,25SBLUC01121-007105,25SBLUT02309-007125,25SBLUN02513-007179,25SBLUC04206-006535,25SBLUS01337-007137,25SBLUF01055-007092,25SBLUC03012-006719,25SBLUX02230-005958,25WBLUA05301-006434,25WBLUC02079-A05958,25SBLUL02583-007370,25SBLUT02315-007117,25WBLDC03097-006047,25WBLDA05337-006127"
    },
    "002055": {
        "Stato": "IT",
        "CAP": "04011",
        "Localit\u00e0": "APRILIA",
        "Indirizzo": "VIA ALDO MORO, 41E",
        "N.ri Tel.": "06 9275397",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02196-004547"
    },
    "006169": {
        "Stato": "IT",
        "CAP": "35139",
        "Localit\u00e0": "PALMANOVA DEL FRIULI",
        "Indirizzo": "PIAZZA INSURREZIONE, 12",
        "N.ri Tel.": "049 664178",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF02188-006804,25SBLUP05190-006804,25SBLUF08504-007173,25SBLUF03186-006804"
    },
    "006334": {
        "Stato": "IT",
        "CAP": "07052",
        "Localit\u00e0": "LOC. PUNTA SABBATINO - S.TEODORO",
        "Indirizzo": "CONDOMINIO LA PIAZZETTA - PN 08 PUNTALDIA",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP04353-007139,25SBLDP01344-006855"
    },
    "008101": {
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA SANTA MARIA LA NOVA, 01",
        "N.ri Tel.": "081 8694791",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP05190-006804"
    },
    "008270": {
        "Stato": "IT",
        "CAP": "31033",
        "Localit\u00e0": "LOC. PUNTA SABBATINO - S.TEODORO",
        "Indirizzo": "GALLERIA EUROPA, 25 -  C.C. \"I GIARDINI DEL SOLE\"",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "009496": {
        "Stato": "IT",
        "CAP": "10151",
        "Localit\u00e0": "AVIGLIANA",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "347 7006858",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "010136": {
        "Stato": "IT",
        "CAP": "04100",
        "Localit\u00e0": "LATINA",
        "Indirizzo": "VIA OFANTO SN",
        "N.ri Tel.": "0773-668940",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP04354-007129"
    },
    "011460": {
        "Stato": "IT",
        "CAP": "42035",
        "Localit\u00e0": "CASTELNOVO NE' MONTI",
        "Indirizzo": "PIAZZA ANTONIO GRAMSCI, 1/S",
        "N.ri Tel.": "0522/810181",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC02229-005958"
    },
    "012642": {
        "Stato": "IT",
        "CAP": "50013",
        "Localit\u00e0": "CAMPI BISENZIO",
        "Indirizzo": "VIA DELLE 3 VILLE , 5/A",
        "N.ri Tel.": "055 660383",
        "Insegna": "PIAZZA ALBERTI 17",
        "CODICE PRODOTTO KOOOMO": "25SBLDC11237-007110,25SBLDC11237-007110,25SBLDC11237-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUH02275-007100"
    },
    "013409": {
        "Stato": "IT",
        "CAP": "73030",
        "Localit\u00e0": "SURANO",
        "Indirizzo": "STRADA STATALE 275 MAGLIE-LEUCA KM 13,4 KM 13,4",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDH02375-006842"
    },
    "013410": {
        "Stato": "IT",
        "CAP": "73014",
        "Localit\u00e0": "GALLIPOLI",
        "Indirizzo": "VIA SAN LAZZARO 15",
        "N.ri Tel.": "0833/835235",
        "Insegna": "GOGGI SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLUA05297-006127,25SBLDC01329-007131,25SBLUT02310-006817"
    },
    "013991": {
        "Stato": "IT",
        "CAP": "36100",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIA A. ROLFO, 18",
        "N.ri Tel.": "049 8758706",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02197-004547"
    },
    "014217": {
        "Stato": "IT",
        "CAP": "95030",
        "Localit\u00e0": "MASCALUCIA",
        "Indirizzo": "CORSO SAN VITO 38",
        "Insegna": "LUXURY",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01209-007101"
    },
    "014435": {
        "Stato": "IT",
        "CAP": "67039",
        "Localit\u00e0": "SULMONA",
        "Indirizzo": "VIA SALLUSTRIO SNC",
        "N.ri Tel.": "340 1796989",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014436": {
        "Stato": "IT",
        "CAP": "74015",
        "Localit\u00e0": "Marianske lazne",
        "Indirizzo": "VIA SALLUSTIO  20c,22,24",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25SBLUC02227-007104"
    },
    "014488": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "LECCE",
        "Indirizzo": "VIA GINO DE SANCTIS",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUK11239-007110"
    },
    "014960": {
        "Stato": "IT",
        "CAP": "90144",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "VIA SCIUTI 25/27",
        "N.ri Tel.": "091-346644",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02313-006818"
    },
    "015312": {
        "Stato": "IT",
        "CAP": "60027",
        "Localit\u00e0": "Star\u00e9 Hradit u Pardubic",
        "Indirizzo": "Hraditna P\u00edsku 59",
        "N.ri Tel.": "328/6445076",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015416": {
        "Stato": "IT",
        "CAP": "80040",
        "Localit\u00e0": "POGGIOMARINO",
        "Indirizzo": "VIA NUOVA S. MARZANO, 200",
        "N.ri Tel.": "0818652711",
        "Insegna": "TOMMASEO SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01279-007111,25SBLDC01279-007111,25SBLDC01328-007131,25SBLDC01328-007131,25SBLDC11237-007110,25SBLDC11237-007110,25SBLDC11237-007110,25SBLDH02374-006842,25SBLDH02374-006842,25SBLDH02375-006842,25SBLDH02375-006842,25SBLUC01211-007101,25SBLUC01211-007101,25SBLUC01211-007101,25SBLUC11207-006787,25SBLUC11207-006787,25SBLUC11214-007111,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUF01184-006804,25SBLUF03186-006804,25SBLUF03186-006804,25SBLUH02108-006864,25SBLUH02108-006864,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUP02352-006855,25SBLUP02352-006855,25SBLUP02352-006855,25SBLUT02110-006526,25SBLUT02110-006526,25SBLUT02306-006801,25SBLUT02306-006801,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUT02346-007132,25SBLUT02346-007132,25SBLUX02230-005958,25SBLUX02230-005958,25SBLUX02230-005958"
    },
    "015538": {
        "Stato": "IT",
        "CAP": "00136",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "LARGO MACCAGNO, 3/4",
        "N.ri Tel.": "06 35404423",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDV02296-007143"
    },
    "015742": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "RUTIGLIANO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "095475432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015891": {
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "PORTOGRUARO",
        "Indirizzo": "VIA SANTA MARIA LA NOVA, 01",
        "N.ri Tel.": "333 4549643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02308-006801"
    },
    "016144": {
        "Stato": "IT",
        "CAP": "67048",
        "Localit\u00e0": "ROCCA DI MEZZO",
        "Indirizzo": "PIAZZA PRINCIPE DI PIEMONTE N.7",
        "N.ri Tel.": "0862917615",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDP02345-006855"
    },
    "016481": {
        "Stato": "IT",
        "CAP": "55045",
        "Localit\u00e0": "MARINA DI PIETRASANTA",
        "Indirizzo": "VIA VERSILIA, 35",
        "N.ri Tel.": "3355913041",
        "Insegna": "MARESIA",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUC11541-007110,25SBLUC02227-007104,25WBLDK02069-006648,25WBLDK11162-007110,25WBLUC08078-006355,25WBLDC02178-006646,25WBLDK03102-006047,25SBLDK01249-007111,25SBLDC02232-007104,25WBLUC03074-006355,25WBLDC03095-006047,25SBLDC01279-007111"
    },
    "016716": {
        "Stato": "IT",
        "CAP": "71065",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "VIA FRANCESCO RISMONDO, 5",
        "N.ri Tel.": "3386722069",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC02153-007124,25SBLDP02345-006855"
    },
    "016725": {
        "Stato": "IT",
        "CAP": "76125",
        "Localit\u00e0": "TRANI",
        "Indirizzo": "VIA MARIO PAGANO, 240",
        "N.ri Tel.": "3386722069",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDS01366-007141"
    },
    "016735": {
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA SANTA MARIA LA NOVA, 01",
        "N.ri Tel.": "081 8694791",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016784": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "LECCE",
        "Indirizzo": "VIA GINO DE SANCTIS",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUK11239-007110,25SBLUC01219-007108"
    },
    "017043": {
        "Stato": "IT",
        "CAP": "91022",
        "Localit\u00e0": "CASTELVETRANO",
        "Indirizzo": "VIA V. EMANUELE 92",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02109-006526,25SBLUH02108-006864"
    },
    "017301": {
        "Stato": "PL",
        "CAP": "36040",
        "Localit\u00e0": "Tarnow",
        "Indirizzo": "VIA ROMA 10",
        "N.ri Tel.": "0444 401051",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02234-006648"
    },
    "017364": {
        "Stato": "IT",
        "CAP": "37671",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "WESTERBACHSTRASSE 5",
        "N.ri Tel.": "02 63471267",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF03031-007094"
    },
    "017367": {
        "Stato": "IT",
        "CAP": "58014",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA SS ANNUNZIATA, 3",
        "N.ri Tel.": "075 800 4272",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02274-007100"
    },
    "017390": {
        "Stato": "IT",
        "CAP": "70017",
        "Localit\u00e0": "PUTIGNANO",
        "Indirizzo": "VIA CRISTOFORO COLOMBO, 23",
        "N.ri Tel.": "3939161185",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP04062-007092,25WBLUC06082-005480"
    },
    "017553": {
        "Stato": "IT",
        "CAP": "60121",
        "Localit\u00e0": "ANCONA",
        "Indirizzo": "CORSO GARIBALDI 115",
        "N.ri Tel.": "3205672142",
        "Insegna": "+39",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02233-007104,25SBLUP05033-007094,25SBLDC02289-007119,25SBLUN01521-006581,25SBLDC01222-007108,25SBLDC01221-007108,25SBLDH03371-005707,25SBLUP01189-006804,25WBLDC02196-007283,25WBLDP01291-007324,25SBLDP01079-007092,25SBLUX02255-007101,25SBLUC03011-006719,25SBLUH02191-004547,25SBLUT02313-006818,25SBLUC01211-007101,25SBLUC04206-006535,25SBLDC02128-007103,25SBLUF03187-006804,25SBLUC03012-006719,25SBLUH02275-007100,25SBLDF08078-007092,25WBLUC05125-007283,25SBLUX02230-005958,25WBLDF08236-007301,25SBLUH02394-007114,25SBLUM01476-006233"
    },
    "017615": {
        "Stato": "IT",
        "CAP": "110 00",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA CASSIA 905",
        "N.ri Tel.": "0630362716",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDS01291-007141"
    },
    "017707": {
        "Stato": "IT",
        "CAP": "36029",
        "Localit\u00e0": "ROSSANO VENETO",
        "Indirizzo": "VIA MOTTINELLO, 91",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDT02138-006526"
    },
    "017824": {
        "Stato": "IT",
        "CAP": "80144",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO SECONDIGLIANO 316",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUN02516-007177,25SBLUN02514-007179"
    },
    "017867": {
        "Stato": "IT",
        "CAP": "80034",
        "Localit\u00e0": "MARIGLIANO",
        "Indirizzo": "C.SO UMBERTO 1, N 387",
        "N.ri Tel.": "081 5704153",
        "Insegna": "MAGLIO",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01210-007101,25SBLUC01210-007101,25SBLUC01211-007101,25SBLUC01211-007101,25SBLUC01211-007101,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUT02310-006817"
    },
    "017883": {
        "Stato": "IT",
        "CAP": "00148",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA DEL PONTE PISANO 50",
        "N.ri Tel.": "06/65746565",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017921": {
        "Stato": "IT",
        "CAP": "24021",
        "Localit\u00e0": "ALBINO",
        "Indirizzo": "VIALE DELLA LIBERTA' 16",
        "N.ri Tel.": "035/755000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF03037-007096,25SBLUP02038-007096"
    },
    "018129": {
        "Stato": "IT",
        "CAP": "73039",
        "Localit\u00e0": "TRICASE",
        "Indirizzo": "VIA ROMA 10",
        "N.ri Tel.": "392 2236490",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01338-007137"
    },
    "018189": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "SURANO",
        "Indirizzo": "VIA GINO DE SANCTIS",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018266": {
        "Stato": "IT",
        "CAP": "03025",
        "Localit\u00e0": "MONTE SAN GIOVANNI CAMPANO",
        "Indirizzo": "VIA BOCCAFOLLE, 42",
        "N.ri Tel.": "0775 891183",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01119-007105,25SBLUL02411-007155,25SBLDX02290-007119,25SBLUF01055-007092,25SBLDX02290-007119"
    },
    "018405": {
        "Stato": "IT",
        "CAP": "57023",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA MAGOLFA, 12",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDP05205-006804"
    },
    "018612": {
        "Stato": "PL",
        "CAP": "85100",
        "Localit\u00e0": "ZNOJMO",
        "Indirizzo": "VIA DEL GALLITELLO, 191",
        "N.ri Tel.": "349 4314897",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUS01337-007137"
    },
    "018878": {
        "Stato": "IT",
        "CAP": "70020",
        "Localit\u00e0": "CAVEZZO",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "3890215357",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUS02336-007137"
    },
    "018970": {
        "Stato": "IT",
        "CAP": "35134",
        "Localit\u00e0": "PADOVA",
        "Indirizzo": "VIA GUIDO RENI, 59",
        "N.ri Tel.": "3408313295",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019189": {
        "Stato": "IT",
        "CAP": "75100",
        "Localit\u00e0": "SURANO",
        "Indirizzo": "VIALE MANCINI, 17/19",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01329-007131"
    },
    "019224": {
        "Stato": "IT",
        "CAP": "55049",
        "Localit\u00e0": "VIAREGGIO",
        "Indirizzo": "VIA FORO BOARIO, 79/81",
        "N.ri Tel.": "0545 282231",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019240": {
        "Stato": "IT",
        "CAP": "04100",
        "Localit\u00e0": "LATINA",
        "Indirizzo": "VIA PIAVE, KM 68,60",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUS02336-007137,25SBLUS02336-007137,25SBLUS01340-007138"
    },
    "019518": {
        "Stato": "IT",
        "CAP": "80030",
        "Localit\u00e0": "VERCELLI",
        "Indirizzo": "VIA VITTORIO VENETO, 17/18",
        "N.ri Tel.": "081 5191658",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019543": {
        "Stato": "IT",
        "CAP": "92027",
        "Localit\u00e0": "PORTO EMPEDOCLE",
        "Indirizzo": "VIA VINCENZELLA SNC",
        "N.ri Tel.": "3283771367",
        "Insegna": "PIETRO LEONE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01279-007111,25SBLDC01328-007131,25SBLDC11237-007110,25SBLDC11237-007110,25SBLDH02374-006842,25SBLDH02374-006842,25SBLDH02374-006842,25SBLDH02376-006842,25SBLDH02376-006842,25SBLUC01209-007101,25SBLUC01209-007101,25SBLUC11214-007111,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUH02108-006864,25SBLUH02108-006864,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUP01350-006855,25SBLUP02352-006855,25SBLUP02352-006855,25SBLUP02352-006855,25SBLUT02308-006801,25SBLUT02308-006801,25SBLUT02308-006801,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUX02230-005958,25SBLUX02230-005958,25SBLUX02230-005958,25SBBKC01452-007111,25SBLGC01441-007111,25SBLGC01441-007111,25SBLGC02432-007104,25SBLGC02432-007104,25SBLGC02432-007104,25SBLGH02550-007188,25SBLGH02550-007188,25SBLGH02550-007188,25SBLKC01445-007101,25SBLKC01445-007101,25SBLKC06443-007101,25SBLKC06443-007101,25SBLKC11440-007111,25SBLKC11440-007111,25SBLKF03551-007187,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKP05558-007187,25SBLKT02464-006818,25SBLKX02418-005958,25SBLKX02418-005958,25SBLKX02418-005958"
    },
    "019544": {
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA PRINCIPALE, 65",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDM01473-007166,25WBLDK01376-007378"
    },
    "019643": {
        "Stato": "PL",
        "CAP": "41-300",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA PERUGIA, 32/G",
        "N.ri Tel.": "620920155",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02312-006803"
    },
    "019729": {
        "Stato": "IT",
        "CAP": "67100",
        "Localit\u00e0": "SAN BENEDETTO DEL TRONTO",
        "Indirizzo": "VIALE SECONDO MORETTI N\u00b0 84",
        "N.ri Tel.": "393 4840377",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019739": {
        "Stato": "IT",
        "CAP": "80331",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "WESTENHELLWEG 2",
        "N.ri Tel.": "3386722069",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC02153-007124"
    },
    "019809": {
        "Stato": "IT",
        "CAP": "60019",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUB04167-006854,25WBLDC11163-007110,25SBLUT02309-007125"
    },
    "019991": {
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA GINO DE SANCTIS",
        "N.ri Tel.": "3939161185",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF03187-006804"
    },
    "020031": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "Paterna, Valencia",
        "Indirizzo": "VIA SANTA LUCIA, 3",
        "N.ri Tel.": "670675608",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC03013-006719,25WBLUC03074-006355"
    },
    "020172": {
        "Stato": "IT",
        "CAP": "88067",
        "Localit\u00e0": "SAN VITO SULLO IONIO",
        "Indirizzo": "VIA GARIBALDI, 39",
        "N.ri Tel.": "3286523501",
        "Insegna": "SINOPOLI",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLDC02072-006648,25SBLDH02372-005707,25WBLDC02178-006646,25WBLUC02079-005958,25SBLDC02234-006648,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC11541-007110,25SBLUP01350-006855,25WBLDK02069-006648,25SBLUF03037-007096,25SBLDF03076-007092,25SBLUF03186-006804,25SBLUT02313-006818,25SBLUC02228-007104,25SBLDC11237-007110,25SBLUT02309-007125,25SBLUC04206-006535,25SBLDK01249-007111,25WBLDC03095-006047,25SBLUP02038-007096,25SBLUT02306-006801,25SBLUF01055-007092,25SBLUC03012-006719,25SBLUF02188-006804,25WBLUL02318-007340,25SBLUX02230-005958,25SBLUH02199-004547,25WBLDK03102-006047,25WBLUC02079-A05958,25SBLUP02063-007092,25WBLDX03181-006985,25SBLDV01146-007107,25SBLUM01476-006233"
    },
    "020209": {
        "Stato": "IT",
        "CAP": "60044",
        "Localit\u00e0": "MODENA",
        "Indirizzo": "VIALE P. SERAFINI 22",
        "N.ri Tel.": "0732-22576",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02276-005695"
    },
    "020210": {
        "Stato": "IT",
        "CAP": "36600",
        "Localit\u00e0": "VILAGARCIA DE AROUSA",
        "Indirizzo": "VIA ARISTIDE MERLONI, 141- C.C. GranRoma",
        "N.ri Tel.": "986505893",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01121-007105,25SBLUT02306-006801,25SBLUH02193-004547,25SBLDT02125-006526"
    },
    "020344": {
        "Stato": "PL",
        "CAP": "99-300",
        "Localit\u00e0": "VENAFRO",
        "Indirizzo": "VIA VARIANTE 7BIS, 12",
        "N.ri Tel.": "3518028504",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02108-006864"
    },
    "020368": {
        "Stato": "IT",
        "CAP": "88054",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "943811088",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02194-004547,25SBLUT02308-006801"
    },
    "020379": {
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "340-5874472",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020384": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "SURANO",
        "Indirizzo": "VIALE STAZIONE, SNC",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02109-006526,25WBLDC03096-006047,25SBLUB01216-007111,25SBLUF01184-006804"
    },
    "020398": {
        "Stato": "IT",
        "CAP": "85748",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "081-1944768",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01281-007105,25SBLUH02197-004547"
    },
    "020414": {
        "Stato": "IT",
        "CAP": "37016",
        "Localit\u00e0": "PIACENZA",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "0523 609538",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020448": {
        "Stato": "IT",
        "CAP": "94015",
        "Localit\u00e0": "PIAZZA ARMERINA",
        "Indirizzo": "VIALE GENERALE CIANCIO , 25",
        "N.ri Tel.": "0935 956084",
        "Insegna": "MANBITUS",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLKC11416-007110,25WBLUC03074-006355,25SBLUH02109-006526,25SBLDH02374-006842,25SBLUH02196-004547,25SBLDC01221-007108,25SBLUC11207-006787,25SBLDH02376-006842,25SBLGC01441-007111,25SBLUC11541-007110,25WBLDK02069-006648,25SBLUH02194-004547,25SBLUH02108-006864,25SBLDH02387-007144,25WBLGC02391-006648,25WBLDB03191-007294,25WBLDC03100-006047,25SBLUT02110-006526,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02309-007125,25SBLUC04206-006535,25SBLKC01445-007101,25SBLUT02310-006817,25SBLKT02464-006818,25WBLDC03095-006047,25SBLUC01209-007101,25WBLDC02170-006648,25SBLDH02386-007144,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUA05301-006434,25WBLDK03102-006047,25WBLDA05335-007349,25WBLDC03099-006047,25SBLGC02429-006648,25SBLDC01279-007111,25WBLDA05337-006127,25WBLKC02429-005958"
    },
    "020449": {
        "Stato": "IT",
        "CAP": "63074",
        "Localit\u00e0": "VIAREGGIO",
        "Indirizzo": "VIALE SECONDO MORETTI N\u00b0 84",
        "N.ri Tel.": "3395966527",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02310-006817,25SBLUF03185-006804,25WBLDC03095-006047"
    },
    "020462": {
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "CORSO VITTORIO EMANUELE II, 32",
        "N.ri Tel.": "3289846573",
        "Insegna": "SAN LORENZO GALLERY BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11569-006787,25SBLUH02193-004547,25SBLUH02109-006526,25SBLUT02346-007132,25SBLUP01350-006855,25WBLUC03233-007308,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUC04176-006854,25SBLUC01219-007108,25SBLUT02313-006818,25SBLUT02309-007125,25SBLUC04206-006535,25SBLUP04353-007129,25SBLUT02306-006801,25SBLUF01055-007092,25WBLUC03086-006047,25SBLUH02275-007100,25WBLUC06082-005480"
    },
    "020464": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "091-8112478",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284,25SBLUH02193-004547"
    },
    "020476": {
        "Stato": "IT",
        "CAP": "00062",
        "Localit\u00e0": "CIVITAVECCHIA",
        "Indirizzo": "VIA SANDRO PERTINI, 1",
        "N.ri Tel.": "06 5898254",
        "Insegna": "CASTELLA.CASTELLESE",
        "CODICE PRODOTTO KOOOMO": "25SBLDH02377-007147,25SBLDP01344-006855,25SBLDP01344-006855,25SBLDX03008-006950,25SBLUC01121-007105,25SBLUC04206-006535,25SBLUF01055-007092,25SBLUH02030-006846,25SBLUP01350-006855,25SBLUS02336-007138,25SBLUS02336-007138,25SBLUT02306-006801,25SBLUT02315-007117"
    },
    "020478": {
        "Stato": "IT",
        "CAP": "00166",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA SANDRO PERTINI, 1",
        "N.ri Tel.": "06 5898254",
        "Insegna": "CASTELLA.CASTELLESE",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01159-007105,25SBLDC01221-007108,25SBLDC01221-007108,25SBLDC01328-007131,25SBLDH02372-005707,25SBLDH02372-005707,25SBLDH02373-005707,25SBLDH02373-005707,25SBLDH02373-005707,25SBLDH02376-006842,25SBLDH02376-006842,25SBLDH02377-007144,25SBLDH02377-007144,25SBLDH02386-007144,25SBLDH02386-007144,25SBLDH02387-007144,25SBLDH02387-007144,25SBLDH02389-007144,25SBLDH02389-007144,25SBLDH03371-005707,25SBLDH03371-005707,25SBLDP01344-006855,25SBLDP01344-006855,25SBLDX03008-006950,25SBLDX03008-006950,25SBLUB01216-007111,25SBLUB01216-007111,25SBLUC01121-007105,25SBLUC04206-006535,25SBLUH02030-006846,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUP01350-006855,25SBLUP01350-006855,25SBLUP01350-006855,25SBLUS02336-007138,25SBLUT02306-006801,25SBLUT02309-007125,25SBLUT02309-007125,25SBLUT02309-007125,25SBLUT02309-007125,25SBLUT02309-007125,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUX02230-005958,25SBLUX02230-005958,25SBLUX02230-005958"
    },
    "020488": {
        "Stato": "IT",
        "CAP": "81479",
        "Localit\u00e0": "Spindleruv mlyn",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "3938438702",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUF03187-006804,25SBLUC04176-006854"
    },
    "020510": {
        "Stato": "IT",
        "CAP": "67051",
        "Localit\u00e0": "AVEZZANO",
        "Indirizzo": "VIA SERGIO CATALDI, 144",
        "N.ri Tel.": "0863441428",
        "Insegna": "EMPORIO D'ANTONI",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25WBLDC03097-006047,25SBLUH02194-004547,25SBLUH02191-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUT02309-007125,25WBLDK03103-006047,25SBLUP02352-006855,25SBLUX02230-005958,25WBLDK03098-006047"
    },
    "020514": {
        "Stato": "IT",
        "CAP": "72015",
        "Localit\u00e0": "TORRE CANNE di FASANO",
        "Indirizzo": "VIA MESSINA, 16",
        "N.ri Tel.": "3922909483",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUS02336-007137,25SBLUT02309-007125,25SBLUT02313-006818,25SBLUT02309-007125"
    },
    "020518": {
        "Stato": "RU",
        "CAP": "80146",
        "Localit\u00e0": "TULA",
        "Indirizzo": "VIA SALLUSTIO  20c,22,24",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01210-007101,25SBLUC01211-007101"
    },
    "020523": {
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "MARSICOVETERE (FERMO DEPOSITO)",
        "Indirizzo": "(FERMO DEPOSITO ) >>>VILLA D'AGRI VIA NAZIONALE 11",
        "N.ri Tel.": "335-8112666",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01359-007101,25SBLDC01359-007101"
    },
    "020526": {
        "Stato": "IT",
        "CAP": "36030",
        "Localit\u00e0": "MONTECCHIO PRECALCINO",
        "Indirizzo": "VIA SUMMANO, 5",
        "Insegna": "BE YOU",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02193-004547,25WBLUC03090-006719,25SBLDC03003-006950,25WBLUC03074-006355,25SBLDC01222-007108,25SBLUT02346-007132,25SBLUP01189-006804,25SBLUP01350-006855,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUC03011-006719,25SBLUF01184-006804,25SBLUX03226-006719,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUT02313-006818,25SBLUM01480-007168,25SBLUT02309-007125,25SBLUC04206-006535,25WBLDC03095-006047,25SBLUF03187-006804,25WBLDC02170-006648,25SBLUC03012-006719,25WBLUC03086-006047,25SBLUM01476-006233"
    },
    "020527": {
        "Stato": "IT",
        "CAP": "30015",
        "Localit\u00e0": "SOTTOMARINA",
        "Indirizzo": "PIAZZA ITALIA, 20",
        "N.ri Tel.": "041-401911",
        "Insegna": "FERRY BOAT",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLKA05458-006127,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25SBLDC02234-006648,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02150-007100,25SBLDC01221-007108,25SBLDX02235-006648,25SBLUC11207-006787,25WBLUA05300-006434,25SBLUC01115-007105,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25WBLGC02391-006648,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUH02197-004547,25WBLKC02427-005958,25SBLUH02276-005695,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25SBLUC03012-006719,25SBLUX02230-005958,25SBLDC03006-006950,25WBLUA05298-006127,25WBLUA05301-006434,25WBLDC03099-006047,25WBLDC03097-006047,25WBLKC02429-005958"
    },
    "020530": {
        "Stato": "IT",
        "CAP": "61043",
        "Localit\u00e0": "CAGLI",
        "Indirizzo": "VIA FLAMINIA, 175 B",
        "N.ri Tel.": "0721 781795",
        "Insegna": "TOPI ROSALBA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25SBLUH02193-004547,25WBLUC03090-006719,25WBLDK03101-006047,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLDC01222-007108,25SBLUH02196-004547,25SBLUP01189-006804,25SBLUF01184-006804,25SBLUT02313-006818,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDC02232-007104,25WBLDC02170-006648,25WBLDK03103-006047,25WBLUC03086-006047,25WBLDK03102-006047,25WBLDC03099-006047"
    },
    "020534": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "VIALE TRICESIMO, 187",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01211-007101,25SBLUM01476-006233"
    },
    "020535": {
        "Stato": "IT",
        "CAP": "74014",
        "Localit\u00e0": "REUS",
        "Indirizzo": "VIA GIOVANNI BATTISTA VICO, 29",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDH02387-007144,25SBLDH02387-007144"
    },
    "020550": {
        "Stato": "IT",
        "CAP": "80029",
        "Localit\u00e0": "SANT'ANTIMO",
        "Indirizzo": "VIA TRIESTE E TRENTO, 59",
        "N.ri Tel.": "347 6675483",
        "Insegna": "ER NONNO",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUH02195-004547,25WBLDK03527-006047,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02170-006648,25WBLUA05298-006127,25WBLUC02079-A05958,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "020551": {
        "Stato": "IT",
        "CAP": "84050",
        "Localit\u00e0": "POLLA",
        "Indirizzo": "VIA LUISA SPAGNOLI, 40",
        "N.ri Tel.": "0974-980236",
        "Insegna": "IANNUZZI",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25SBLUP05190-006804,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25WBLDK02069-006648,25SBLUH02194-004547,25WBLUC03233-007308,25WBLDC03100-006047,25SBLUF03186-006804,25SBLUC01211-007101,25SBLDC11237-007110,25SBLUC02227-007104,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDC02177-007284,25WBLDC02170-006648,25WBLUC02080-005958,25WBLDC03099-006047,25SBLDC04066-007109,25WBLDK03098-006047,25WBLDC03097-006047"
    },
    "020555": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "CALVI",
        "Indirizzo": "VIA PIANO CASIELLO, 13 - CONTRADA CUBANTE",
        "Insegna": "ZEUS STORE",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11541-007110,25WBLUC08078-006355,25WBLUC02079-005958,25SBLUC04206-006535,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02191-004547,25WBLUA05297-006127,25SBLUT02306-006801,25SBLUF03186-006804"
    },
    "020558": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "CALVI",
        "Indirizzo": "VIA PIANO CASIELLO, 13 - CONTRADA CUBANTE",
        "Insegna": "ZEUS STORE DONNA",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,25SBLDH02376-006842,25SBLDC11237-007110,25WBLDC03096-006047,25WBLDK11162-007110,25WBLDC02178-006646,25SBLDC01328-007131,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDC03095-006047,25SBLDH02374-006842,25SBLDC01279-007111"
    },
    "020614": {
        "Stato": "IT",
        "CAP": "85029",
        "Localit\u00e0": "VENOSA",
        "Indirizzo": "VIALE GIOVANNI PACINI, 239",
        "N.ri Tel.": "320382706",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUP01189-006804"
    },
    "020626": {
        "Stato": "IT",
        "CAP": "10040",
        "Localit\u00e0": "LEINI'",
        "Indirizzo": "VIA CASELLE, 74",
        "N.ri Tel.": "376 0139225",
        "Insegna": "TRENDY",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC03074-006355,25SBLUS02336-007138,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUS01340-007138,25WBLDC03100-006047,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUH02192-004547,25SBLUC01211-007101,25WBLDC03096-006047,25SBLUC04206-006535,25WBLDC03095-006047,25WBLDK03103-006047,25SBLUF02188-006804,25WBLDK03495-006047,25SBLUP04354-007129,25WBLUC06082-005480,25SBLUX02230-005958,25WBLDA05335-007349,25WBLDC03099-006047,25WBLDA05337-006127,25SBLUM01476-006233"
    },
    "020634": {
        "Stato": "IT",
        "CAP": "64100",
        "Localit\u00e0": "TERAMO",
        "Indirizzo": "VIA G. GALILEI, 18",
        "N.ri Tel.": "0861252347",
        "Insegna": "SOTTOSOPRA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25SBLDC02233-007104,25WBLDC02072-006648,25SBLUP05033-007094,25SBLDC02289-007119,25WBLDK03101-006047,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUX02081-005958,25WBLDC03357-007294,25WBLUC03074-006355,25SBLDH02374-006842,25WBLDC03097-006047,25SBLDP01079-007092,25SBLDH02376-006842,25SBLUC11541-007110,25SBLUX02255-007101,25WBLDC03100-006047,25SBLDS01291-007141,25SBLUH02192-004547,25SBLUC02228-007104,25SBLUC01211-007101,25WBLDC03096-006047,25WBLDK11162-007110,25SBLUC04206-006535,25SBLDC03007-006950,25SBLDS01366-007141,25WBLDC03095-006047,25SBLUP02038-007096,25SBLUP01324-007130,25WBLDC02170-006648,25WBLDK03103-006047,25SBLUC03012-006719,25WBLUC03086-006047,25SBLDF08078-007092,25WBLUC02080-005958,25SBLDC01328-007131,25SBLUX02230-005958,25SBLDC03006-006950,25WBLDK03102-006047,25WBLDC03099-006047,25WBLDK03098-006047,25SBLUH02394-007114,25SBLUH02030-006846,25WBLDC11163-007110"
    },
    "020666": {
        "Stato": "IT",
        "CAP": "98039",
        "Localit\u00e0": "TAORMINA",
        "Indirizzo": "VIA SAMMUZZO, 13/15",
        "N.ri Tel.": "0942-23151",
        "Insegna": "PARISI",
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUH02196-004547,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUC03011-006719,25WBLDC03100-006047,25SBLUH02192-004547,25SBLDC11237-007110,25SBLUC02227-007104,25SBLDC02232-007104,25WBLDC03095-006047,25SBLUC01209-007101,25SBLUC03012-006719,25WBLUC03086-006047,25SBLUC03013-006719,25WBLUC02080-005958,25SBLUX02230-005958,25SBLDC03006-006950"
    },
    "020670": {
        "Stato": "IT",
        "CAP": "81131",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIALE DEGLI ASTRONAUTI 13,",
        "N.ri Tel.": "081 7413586",
        "Insegna": "LX MODA",
        "CODICE PRODOTTO KOOOMO": "25SBLUC04206-006535,25SBLUC04206-006535,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02244-007100,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUH02275-007100"
    },
    "020674": {
        "Stato": "IT",
        "CAP": "80036",
        "Localit\u00e0": "PALMA CAMPANIA",
        "Indirizzo": "VIA TRIESTE, 157",
        "N.ri Tel.": "081-5103836",
        "Insegna": "SORRENTINO SPORT",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01221-007108,25SBLDC01221-007108,25SBLDC01279-007111,25SBLDC01279-007111,25SBLDC01328-007131,25SBLDC11237-007110,25SBLDH02374-006842,25SBLDH02374-006842,25SBLUC01211-007101,25SBLUC01211-007101,25SBLUC11207-006787,25SBLUC11207-006787,25SBLUC11214-007111,25SBLUC11214-007111,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02193-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUT02306-006801,25SBLUT02306-006801,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUT02310-006817,25SBLUT02346-007132,25SBLUT02346-007132,25SBLUX02230-005958,25SBLUX02230-005958"
    },
    "020766": {
        "Stato": "IT",
        "CAP": "61033",
        "Localit\u00e0": "FERMIGNANO",
        "Indirizzo": "VIALE KENNEDY, 44",
        "N.ri Tel.": "0722 331403",
        "Insegna": "ZAGARI",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC02079-005958,25SBLUC04206-006535,25WBLDC03099-006047,25WBLUC03074-006355,25SBLUH02109-006526"
    },
    "020816": {
        "Stato": "IT",
        "CAP": "00155",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA G. MONTANARI, SNC - C.C. DA VINCI",
        "Insegna": "AMORE CONCEPT STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDC02072-006648,25SBLUH02193-004547,25SBLDH02372-005707,25SBLUP05190-006804,25WBLUC08078-006355,25WBLUK03142-005480,25WBLDC02178-006646,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUL01316-007012,25SBLUH02150-007100,25SBLUH02109-006526,25SBLUC11215-007110,25SBLUH02196-004547,25WBLDC03097-006047,25SBLDP01079-007092,25SBLUC11207-006787,25SBLUS02336-007138,25WBLDK02069-006648,25SBLUF01184-006804,25SBLDT02125-006526,25SBLDF03076-007092,25SBLUH02191-004547,25SBLUT02317-007116,25SBLUS01340-007138,25WBLDC03100-006047,25SBLDP01344-006855,25SBLUH02197-004547,25SBLUT02110-006526,25SBLDH02389-007144,25SBLUH02192-004547,25SBLDH02377-007144,25WBLDC03096-006047,25SBLUC01121-007105,25SBLUT02309-007125,25SBLUC04206-006535,25SBLUP04322-007129,25WBLDC03095-006047,25SBLUH02241-007100,25SBLUT02306-006801,25SBLDF08078-007092,25WBLUL02318-007340,25WBLUC05125-007283,25WBLUC02080-005958,25SBLDC01328-007131,25WBLUC02132-007284,25WBLDK03102-006047,25SBLDP05080-007092,25WBLDC03099-006047,25SBLUP02063-007092,25WBLUC02079-A05958,25SBLUP02352-006855,25SBLDC01329-007131,25WBLDC11163-007110,25SBLUM01476-006233"
    },
    "020911": {
        "Stato": "IT",
        "CAP": "73042",
        "Localit\u00e0": "CASARANO",
        "Indirizzo": "ZONA INDUSTRIALE TRONCO A 5/6",
        "N.ri Tel.": "0833-603097",
        "Insegna": "MAXIMUS",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01222-007108,25SBLDC01222-007108,25SBLDC01359-007101,25SBLDC01359-007101,25SBLDC02232-007104,25SBLDC04331-006788,25SBLDC11237-007110,25SBLDC11237-007110,25SBLDH02370-006845,25SBLDH02370-006845,25SBLDH02377-007144,25SBLDH02386-007144,25SBLDH02386-007144,25SBLDK01249-007111,25SBLDX03008-006950,25SBLUC01047-007120,25SBLUC01047-007120,25SBLUC01211-007101,25SBLUC01211-007101,25SBLUC02228-007104,25SBLUC04206-006535,25SBLUC04206-006535,25SBLUC11207-006787,25SBLUC11541-007110,25SBLUC11541-007110,25SBLUF01184-006804,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02194-004547,25SBLUH02194-004547,25SBLUH02195-004547,25SBLUH02195-004547,25SBLUH02197-004547,25SBLUH02197-004547,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUH02276-005695,25SBLUH02276-005695,25SBLUK11239-007110,25SBLUK11239-007110,25SBLUP04062-007092,25SBLUP04062-007092,25SBLUT02313-006818,25SBLUT02313-006818,25SBLUT02346-007132,25SBLUT02346-007132,25SBLUX02230-005958,25SBLUX02230-005958"
    },
    "020945": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "VIA SANTA MARIA LA NOVA, 01",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02313-006818,25SBLUC01211-007101,25SBLUP04322-007129,25SBLUC11214-007111"
    },
    "021049": {
        "Stato": "IT",
        "CAP": "10078",
        "Localit\u00e0": "VENARIA REALE",
        "Indirizzo": "VIA ANDREA MENSA,16/B",
        "N.ri Tel.": "011/4598972",
        "Insegna": "ROYAL",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLDK03161-006719,25WBLUK03142-005480,25WBLDC02178-006646,25SBLUT02308-006801,25SBLDC03003-006950,25WBLUC03074-006355,25SBLUP01189-006804,25SBLUL02412-007155,25SBLUC11541-007110,25SBLUH02194-004547,25SBLUF01184-006804,25WBLDB03191-007294,25SBLUT02313-006818,25WBLDC03095-006047,25SBLUF03187-006804,25SBLUL02409-006547,25WBLDC03092-006719,25WBLDK03495-006047,25WBLUC06082-005480,25SBLDC01328-007131,25SBLUX02230-005958,25SBLDC03006-006950,25SBLUH02199-004547,25WBLDA05335-007349,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDC11163-007110,25WBLDA05337-006127"
    },
    "021077": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA GIOVANNI GIOLITTI,  7/A",
        "N.ri Tel.": "081-7580386",
        "Insegna": "FALDEA STORE",
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC08078-006355,25WBLDC02178-006646,25WBLUX02081-005958,25WBLUC03074-006355,25SBLUH02109-006526,25SBLUC01210-007101,25SBLUC11541-007110,25WBLUC03233-007308,25SBLUH02194-004547,25SBLUC04176-006854,25SBLUH02197-004547,25SBLUT02313-006818,25SBLUC01211-007101,25SBLUC02227-007104,25WBLDC03095-006047,25SBLUT02306-006801,25WBLUF03119-007121,25WBLDK03103-006047,25SBLUB04167-006854,25WBLUC02132-007284,25SBLUH02199-004547,25SBLUL02402-007153"
    },
    "021080": {
        "Stato": "IT",
        "CAP": "97019",
        "Localit\u00e0": "VITTORIA",
        "Indirizzo": "VIA ROMA 338",
        "N.ri Tel.": "0932 802490",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02313-006818,25SBLUC11207-006787,25SBLDH02376-006842,25SBLUS01339-007137,25SBLUN02514-007179,25SBLUN01521-006581,25WBLUC02080-005958,25SBLUH02109-006526"
    },
    "021084": {
        "Stato": "IT",
        "CAP": "92027",
        "Localit\u00e0": "LICATA",
        "Indirizzo": "VIA PALMA 31",
        "N.ri Tel.": "0922771590",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUM06481-007168,25SBLUM01479-007167,25SBLUN01521-006581,25SBLUT02309-007125,25SBLUH02109-006526,25SBLUH02193-004547"
    },
    "021087": {
        "Stato": "IT",
        "CAP": "73951",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "WESTERBACHSTRASSE 5",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01260-007108,25SBLUS01339-007137,25SBLUC02151-007124,25SBLUC11541-007110,25SBLUF03037-007096,25SBLUS01340-007138,25WBLDC03100-006047,25SBLUT02110-006526,25SBLDC11237-007110,25SBLUC02227-007104,25SBLUM01480-007168,25SBLUP01183-007121,25SBLDC02232-007104,25SBLUT02310-006817,25SBLUP04353-007129,25SBLUC11214-007111,25SBLUC03012-006719,25SBLDF08078-007092,25SBLUL02583-007370,25SBLUP02352-006855,25SBLDV01146-007107,25SBLDC01222-007108,25SBLDP01079-007092,25SBLUP01350-006855,25SBLUC03011-006719,25SBLUX03226-006719,25SBLUM01478-007167,25SBLUF03186-006804,25SBLUH02276-005695,25SBLUP04322-007129,25SBLUS01338-007137,25SBLUF01055-007092,25SBLDC04070-007109,25WBLDC03099-006047,25SBLUP02063-007092,25SBLUF08504-007173,25SBLUF03185-006804,25SBLUC11215-007110,25SBLUL02412-007155,25SBLUF01184-006804,25SBLUM06481-007168,25SBLUP04043-007130,25SBLDS01291-007141,25SBLUT02309-007125,25SBLDP01140-007109,25SBLDP05141-007109,25SBLUM01482-007168,25SBLDM01473-007166,25SBLUH02394-007114,25SBLUM01476-006233,25SBLDC02233-007104,25SBLDS01292-007141,25SBLDV02296-007143,25SBLUT02346-007132,25SBLDC11335-007110,25SBLUC11207-006787,25SBLUT02316-007116,25SBLDF03076-007092,25WBLDM01463-007330,25SBLUH02192-004547,25SBLUC02228-007104,25SBLUX01218-007108,25SBLDH02377-007144,25SBLDV05299-007138,25SBLUK11239-007110,25SBLDH02370-006845,25SBLDT02138-006526,25SBLUT02306-006801,25SBLUC04082-007159"
    },
    "021095": {
        "Stato": "IT",
        "CAP": "89034",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIA SS ANNUNZIATA, 3",
        "N.ri Tel.": "351-3556323",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02192-004547,25SBLUL02412-007155,25WBLDC02072-006648,25WBLUC06082-005480,25SBLUT02310-006817,25SBLUT02306-006801"
    },
    "021109": {
        "Stato": "NL",
        "CAP": "55100",
        "Localit\u00e0": "SAN LORENZO DI SEBATO",
        "Indirizzo": "VIALE GIOVANNI PACINI, 239",
        "N.ri Tel.": "320382706",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC11215-007110"
    },
    "021150": {
        "Stato": "SM",
        "CAP": "98125",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02191-004547"
    },
    "021159": {
        "Stato": "IT",
        "CAP": "96012",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "3938438702",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02309-007125,25SBLUT02309-007125,25SBLDC01279-007111"
    },
    "021171": {
        "Stato": "IT",
        "CAP": "93013",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02194-004547,25SBLUH02150-007100,25SBLUC01121-007105"
    },
    "021286": {
        "Stato": "PL",
        "CAP": "85586",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "049 8669830",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03173-007307,25WBLUX02081-005958,25SBLDC02234-006648,25WBLUC03074-006355,25WBLDC02506-007254,25SBLDC02251-006648,25WBLUC03086-006047,25WBLUC02080-005958,25SBLDC03006-006950,25WBLDK03182-006985,25WBLUK11140-007286"
    },
    "021586": {
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIALE TRICESIMO, 187",
        "N.ri Tel.": "660988497",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047,25SBLUF03186-006804"
    },
    "021655": {
        "Stato": "IT",
        "CAP": "73431",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA DELLE CONVERTITE   12/13",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC04082-007159,25SBLDH02374-006842"
    },
    "021723": {
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "TRANI",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "0971 21645",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC02128-007103"
    },
    "022609": {
        "Stato": "IT",
        "CAP": "73951",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "WACHMANNSTR. 49",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC04066-007109,25SBLDC02234-006648,25SBLDC02236-006648"
    },
    "022612": {
        "Stato": "IT",
        "CAP": "85586",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "VIA PIETRO GIARDINI 264",
        "N.ri Tel.": "328/6445076",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUX02147-007103,25SBLUC01217-007108,25SBLDC02264-006648,25SBLUC03013-006719,25SBLDX03008-006950,25SBLDC03003-006950"
    },
    "022613": {
        "Stato": "IT",
        "CAP": "82467",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "977345643",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01328-007131,25SBLDK01249-007111,25SBLUX02147-007103,25SBLDC01222-007108,25SBLDC11335-007110,25SBLUC04082-007159,25SBLUC01047-007120,25SBLUF01184-006804,25SBLUC02229-005958,25SBLDX03008-006950,25SBLDC01221-007108"
    },
    "022627": {
        "Stato": "PL",
        "CAP": "N4 3HQ",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "c/tenero Vinas n. 1",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDK01249-007111,25SBLUP04353-007139"
    },
    "022636": {
        "Stato": "IT",
        "CAP": "58022",
        "Localit\u00e0": "VILAGARCIA DE AROUSA",
        "Indirizzo": "VIALE CARDUCCI, 31/33",
        "N.ri Tel.": "986505893",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUH02150-007100,25SBLUC01281-007105,25SBLUH02192-004547,25SBLUT02312-006803,25SBLUH02276-005695,25SBLUT02316-007116,25SBLUA04524-007182,25SBLUH02192-004547,25SBLUA04524-007182,25SBLUH02150-007100,25SBLUT02315-007117"
    },
    "022637": {
        "Stato": "IT",
        "CAP": "60019",
        "Localit\u00e0": "Sitges",
        "Indirizzo": "VIA GUGLIELMO OBERDAN,4",
        "N.ri Tel.": "9655525432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUM01486-007172,25SBLUH02348-007132,25SBLUH02195-004547,25SBLUM01486-007172,25SBLUH02109-006526,25SBLUT02308-006801,25SBLUC11569-006787,25SBLUH02195-004547,25SBLUT02312-006803,25SBLUH02348-007132,25SBLUT02346-007132,25SBLUT02346-007132"
    },
    "022648": {
        "Stato": "PL",
        "CAP": "95045",
        "Localit\u00e0": "ZAKOPANE",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "095475432",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUC01034-007111,25SBLDC03003-006950,25SBLUC04206-006535,25SBLDC03003-006950,25SBLDC03003-006950,25SBLUC03011-006719,25SBLUC04206-006535,25SBLUC04206-006535"
    },
    "022656": {
        "Stato": "IT",
        "CAP": "96012",
        "Localit\u00e0": "TERMINI IMERESE",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "973243471",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02110-006526,25WBLDK03103-006047,25SBLDX03008-006950,25SBLUT02312-006803,25SBLDC11237-007110,25SBLUC11541-007110,25SBLUH02275-007100,25SBLUH02194-004547,25SBLUX02230-005958,25WBLUC02077-006943,25SBLDC03007-006950,25SBLUT02308-006801,25SBLUX03226-006719,25WBLDC03099-006047,25SBLUH02030-006846,25SBLDC01221-007108,25SBLUC01209-007101"
    },
    "022662": {
        "Stato": "IT",
        "CAP": "87561",
        "Localit\u00e0": "SORIA",
        "Indirizzo": "VIA DEL GALLITELLO, 191",
        "N.ri Tel.": "0971 21645",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLDC01358-007101,25SBLDC01358-007101,25SBLDC01260-007108,25SBLUC02227-007104,25SBLUC03012-006719,25SBLDP05301-007140,25SBLDP05301-007140"
    },
    "022849": {
        "Stato": "IT",
        "CAP": "80146",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIALE TRICESIMO, 187",
        "N.ri Tel.": "943 74 41 99",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLUT02110-006526,25SBLUC01211-007101,25SBLUB04167-006854,25SBLUC04168-006788,25SBLUC04176-006854,25SBLUH02191-004547,25SBLUC04163-006788,25SBLUF03186-006804"
    },
    "004831": {
        "Stato": "ES",
        "CAP": "24042",
        "Localit\u00e0": " LEON",
        "Indirizzo": "GRAN VIA SAN MARCOS 21",
        "N.ri Tel.": "+34 987234862",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016386": {
        "Stato": "ES",
        "CAP": "17600",
        "Localit\u00e0": "FIGUERAS, GIRONA",
        "Indirizzo": "C/ PERELADA N. 8",
        "N.ri Tel.": "0034 605099690",
        "Insegna": "BOUTIQUE CATIMINI",
        "CODICE PRODOTTO KOOOMO": "25SBLGF02547-007187,25SBLGF03548-007187,25SBLGP05549-007187,25SBLGH02550-007188"
    },
    "016588": {
        "Stato": "ES",
        "CAP": "17800",
        "Localit\u00e0": "OLOT (GIRONA)",
        "Indirizzo": "C / FERRARONS N. 3-5",
        "N.ri Tel.": "034 972260831",
        "Insegna": "DOMENECHC",
        "CODICE PRODOTTO KOOOMO": "25SBLKH02555-007188,25WBLKC03400-007308,25SBLKT02464-006818,25SBLKC01435-007108,25WBLGC02391-006648,25WBLKC02427-005958"
    },
    "016589": {
        "Stato": "ES",
        "CAP": "17520",
        "Localit\u00e0": "PUIGCERDA ( GIRONA)",
        "Indirizzo": "C/ MAYOR N. 7",
        "N.ri Tel.": "0034 667367575",
        "Insegna": "BOUTIQUE ASPEN",
        "CODICE PRODOTTO KOOOMO": "25SBLKF03551-007187,25SBLGC01441-007111,25SBLKC06443-007101,25SBLKC02430-007104,25WBLKC02427-005958,25SBLGC02432-007104,25WBLKC02429-005958"
    },
    "017422": {
        "Stato": "ES",
        "CAP": "08500",
        "Localit\u00e0": "VIC",
        "Indirizzo": "PORTLA DE LA RAMBLA LOCAL 8",
        "N.ri Tel.": "0034  938881548",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "017979": {
        "Stato": "ES",
        "CAP": "20600",
        "Localit\u00e0": "EIBAR-GIPUZCOA",
        "Indirizzo": "C/JULIAN ETXEBERRIA, LOCAL 6",
        "N.ri Tel.": "0034 943121007",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC01435-007108,25SBLGC02429-006648"
    },
    "021114": {
        "Stato": "ES",
        "CAP": "08700",
        "Localit\u00e0": "IGUALADA, CATALUNA",
        "Indirizzo": "CARRER ODENA 15",
        "N.ri Tel.": "0034 667726068",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648"
    },
    "000071": {
        "Stato": "IT",
        "CAP": "50053",
        "Localit\u00e0": "EMPOLI",
        "Indirizzo": "PIAZZA DELLA VITTORIA, 60",
        "N.ri Tel.": "0571 73009",
        "Insegna": "CASA DEL BAMBINO",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBLKP05558-007187,25SBLKH02555-007188,25SBLKC02430-007104,25SBLKF02553-007187,25WBLGC02391-006648,25SBLKP01554-007187"
    },
    "000142": {
        "Stato": "IT",
        "CAP": "89900",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIA FORGIARI, 11",
        "N.ri Tel.": "0963 44950",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000194": {
        "Stato": "IT",
        "CAP": "89063",
        "Localit\u00e0": "MELITO PORTO SALVO",
        "Indirizzo": "VIA NAZIONALE, 81",
        "N.ri Tel.": "0965 732111",
        "Insegna": "CAREZZE",
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110,25SBLKC06443-007101,25SBLKH02555-007188,25WBLGC02391-006648,25SBLKP05558-007187,25SBLGC02432-007104,25SBLKT02464-006818,25SBLGC02429-006648,25WBLKC02429-005958"
    },
    "000278": {
        "Stato": "IT",
        "CAP": "59100",
        "Localit\u00e0": "GALCIANA",
        "Indirizzo": "VIA M. DEGLI ORGANI, 202",
        "N.ri Tel.": "0574 814798",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "000860": {
        "Stato": "IT",
        "CAP": "64100",
        "Localit\u00e0": "TERAMO",
        "Indirizzo": "VIALE ORSINI ANG. VIA BAFILE",
        "N.ri Tel.": "339 1087123 Aless.",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKT02464-006818"
    },
    "001092": {
        "Stato": "IT",
        "CAP": "89020",
        "Localit\u00e0": "MELICUCCO",
        "Indirizzo": "VIA A. GRAMSCI, 180",
        "N.ri Tel.": "0966 937207",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001140": {
        "Stato": "IT",
        "CAP": "52100",
        "Localit\u00e0": "AREZZO",
        "Indirizzo": "VIA V. VENETO, 19/21",
        "N.ri Tel.": "0575 902650",
        "Insegna": "ADA E ZUCCHERO",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBBKC01452-007111"
    },
    "001304": {
        "Stato": "IT",
        "CAP": "27100",
        "Localit\u00e0": "STRADELLA",
        "Indirizzo": "VIA MARTIRI PARTIGIANI, 28",
        "N.ri Tel.": "0385 49603",
        "Insegna": "PAPERINO",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958"
    },
    "001633": {
        "Stato": "IT",
        "CAP": "52025",
        "Localit\u00e0": "MONTEVARCHI",
        "Indirizzo": "VIA ROMA, 58",
        "N.ri Tel.": "055 980040",
        "Insegna": "DIMENSIONE  KID",
        "CODICE PRODOTTO KOOOMO": "25SBBKC01452-007111,25SBLKX02418-005958"
    },
    "001755": {
        "Stato": "IT",
        "CAP": "10067",
        "Localit\u00e0": "VIGONE",
        "Indirizzo": "VIA UMBERTO I, 28",
        "N.ri Tel.": "011 9809891",
        "Insegna": "IL BRUCO MODA JR",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBLKP05558-007187,25SBLKH02555-007188,25SBLKF02553-007187,25WBLGC02391-006648,25SBLKP01554-007187,25WBLKC02429-005958"
    },
    "001819": {
        "Stato": "IT",
        "CAP": "89900",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIA MOLISE, 4",
        "N.ri Tel.": "0983 885757",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "001923": {
        "Stato": "IT",
        "CAP": "14100",
        "Localit\u00e0": "ASTI",
        "Indirizzo": "CORSO VITTORIO ALFIERI, 233",
        "N.ri Tel.": "0141 451205",
        "Insegna": "TUTTI FRUTTI",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBBGC02453-005958,25WBLGC02391-006648,25WBBXC02454-007110,25WBBXC02456-005958,25WBLKC02427-005958"
    },
    "002042": {
        "Stato": "IT",
        "CAP": "80137",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA ARENA SANITA', 14D",
        "N.ri Tel.": "081 456111",
        "Insegna": "ANITA",
        "CODICE PRODOTTO KOOOMO": "25SBLKC11440-007111,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKP05558-007187,25SBLKP05558-007187,25SBLKP05564-007187"
    },
    "002850": {
        "Stato": "IT",
        "CAP": "89900",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIA VITTORIO VENETO, 2",
        "N.ri Tel.": "0963 44950",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "007744": {
        "Stato": "IT",
        "CAP": "20100",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "VIALE ABRUZZI, 51",
        "N.ri Tel.": "02 29409287",
        "Insegna": "SALINA",
        "CODICE PRODOTTO KOOOMO": "25SBBKC01452-007111,25WBLKC11416-007110,25WBBXC02454-007110,25WBBXC02456-005958,25WBLKC02429-005958"
    },
    "008035": {
        "Stato": "IT",
        "CAP": "24047",
        "Localit\u00e0": "TREVIGLIO",
        "Indirizzo": "VIA ROMA, 16/A",
        "N.ri Tel.": "0363 301446",
        "Insegna": "ALLEGRI BIMBI",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBLGC02432-007104,25SBLKC02430-007104,25WBLGC02391-006648,25WBLKC02427-005958"
    },
    "008375": {
        "Stato": "IT",
        "CAP": "03014",
        "Localit\u00e0": "FIUGGI",
        "Indirizzo": "VIA DEI VILLINI, 5",
        "N.ri Tel.": "0775.549000",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "008505": {
        "Stato": "IT",
        "CAP": "90100",
        "Localit\u00e0": "PALERMO",
        "Indirizzo": "CORSO CALATAFIMI, 244",
        "N.ri Tel.": "091 485682",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGC02429-006648"
    },
    "009132": {
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIA A. GRAMSCI, 180",
        "N.ri Tel.": "0966 937207",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBBGC02453-005958"
    },
    "009471": {
        "Stato": "IT",
        "CAP": "70051",
        "Localit\u00e0": "BARLETTA",
        "Indirizzo": "VIA MADONNA DELLA CROCE, 38",
        "N.ri Tel.": "0883 881017",
        "Insegna": "I MONELLI",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187,25SBLKH02555-007188,25SBLKC02430-007104,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKP05558-007187,25SBLGC02432-007104,25SBLGH02495-007144,25SBLKF02553-007187,25SBLKP01554-007187,25WBLKC02429-005958"
    },
    "009763": {
        "Stato": "IT",
        "CAP": "59016",
        "Localit\u00e0": "POGGIO A CAIANO",
        "Indirizzo": "VIA CANCELLIERI DI SASSETE 17",
        "N.ri Tel.": "055 8798793",
        "Insegna": "TIPITOSTI",
        "CODICE PRODOTTO KOOOMO": "25SBLKP05558-007187,25SBLKH02555-007188,25SBLKF08561-007187,25SBLKF02553-007187,25WBLGC02391-006648,25WBLKC02429-005958,25SBLKF03551-007187"
    },
    "010005": {
        "Stato": "IT",
        "CAP": "87027",
        "Localit\u00e0": "PAOLA",
        "Indirizzo": "VIA S. AGATA, 81",
        "N.ri Tel.": "0982 585546",
        "Insegna": "MODA KIDS",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25SBLKH02555-007188,25WBLGC02391-006648,25SBLKC01435-007108,25SBLKP05558-007187,25SBLGC02432-007104,25SBLKT02464-006818,25SBLKP01554-007187,25SBLGC02429-006648"
    },
    "011385": {
        "Stato": "IT",
        "CAP": "75020",
        "Localit\u00e0": "POLICORO",
        "Indirizzo": "VIA LARGO SAN UBERTO 24/26",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC11440-007111"
    },
    "012507": {
        "Stato": "IT",
        "CAP": "80070",
        "Localit\u00e0": "MONTE DI PROCIDA",
        "Indirizzo": "CORSO GARIBALDI 11",
        "N.ri Tel.": "0818683601",
        "Insegna": "CAPRICCIO",
        "CODICE PRODOTTO KOOOMO": "25SBLGC01441-007111,25SBLKC06443-007101,25SBLKT02464-006818,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958"
    },
    "013304": {
        "Stato": "IT",
        "CAP": "80144",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO SECONDIGLIANO, 254",
        "N.ri Tel.": "081 7540628",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "013950": {
        "Stato": "IT",
        "CAP": "89020",
        "Localit\u00e0": "RUVO DI PUGLIA",
        "Indirizzo": "VIA MAZZINI, 13/1",
        "N.ri Tel.": "0966 937207",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGC02426-006648"
    },
    "014180": {
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "0818062859",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC11440-007111"
    },
    "014213": {
        "Stato": "IT",
        "CAP": "71011",
        "Localit\u00e0": "APRICENA",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "3294278844",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGF03548-007187,25SBLKC01445-007101,25SBLGC01441-007111"
    },
    "014214": {
        "Stato": "IT",
        "CAP": "80027",
        "Localit\u00e0": "FRATTAMAGGIORE",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "3804364649",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKT02464-006818,25SBBKC01452-007111"
    },
    "014326": {
        "Stato": "IT",
        "CAP": "84010",
        "Localit\u00e0": "SANT'EGIDIO DEL MONTE ALBINO",
        "Indirizzo": "VIA NAZIONALE, 89/95",
        "N.ri Tel.": "081 5159098",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "014422": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "CASORIA",
        "Indirizzo": "VIA NAZIONALE DELLE PUGLIE 21",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308"
    },
    "015013": {
        "Stato": "IT",
        "CAP": "80034",
        "Localit\u00e0": "MARIGLIANO",
        "Indirizzo": "CORSO UMBERTO I 387 389",
        "N.ri Tel.": "081",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015169": {
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "ESTE",
        "Indirizzo": "VIA UMBERTINO DA CARRARA, 6",
        "N.ri Tel.": "328-2197256",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015579": {
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "FAVARA",
        "Indirizzo": "CORSO VITTORIO VENETO, 226",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25WBLKC11416-007110,25WBLKC02429-005958"
    },
    "015582": {
        "Stato": "IT",
        "CAP": "51016",
        "Localit\u00e0": "MONTECATINI TERME",
        "Indirizzo": "PIAZZA XX SETTEMBRE, 30",
        "N.ri Tel.": "0572 71615",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015625": {
        "Stato": "IT",
        "CAP": "63074",
        "Localit\u00e0": "SAN BENEDETTO DEL TRONTO",
        "Indirizzo": "CORSO MAZZINI , 180",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "015914": {
        "Stato": "IT",
        "CAP": "80055",
        "Localit\u00e0": "PORTICI",
        "Indirizzo": "VIA ARLOTTA 24",
        "N.ri Tel.": "335 568 5635",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101,25SBLKC06443-007101"
    },
    "016113": {
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "CORSO GARIBALDI, 32",
        "N.ri Tel.": "0882 223625",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBBKC01452-007111"
    },
    "016365": {
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "MISTERBIANCO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "371 4455473",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016385": {
        "Stato": "IT",
        "CAP": "71011",
        "Localit\u00e0": "APRICENA",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "3294278844",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016480": {
        "Stato": "IT",
        "CAP": "57023",
        "Localit\u00e0": "CECINA",
        "Indirizzo": "PIAZZA GUERRAZZI, 24",
        "N.ri Tel.": "0586684543",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "016571": {
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIA LARGO SAN UBERTO 24/26",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958"
    },
    "016746": {
        "Stato": "IT",
        "CAP": "89013",
        "Localit\u00e0": "GIOIA TAURO",
        "Indirizzo": "VIA ROMA, 48",
        "N.ri Tel.": "331 4938824",
        "Insegna": "IL MONDO DELLE COCCINELLE",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02430-007104,25WBLGC02391-006648,25SBLKC01435-007108,25SBLKX02418-005958,25SBLKT02464-006818,25WBLKC02429-005958"
    },
    "016805": {
        "Stato": "IT",
        "CAP": "96100",
        "Localit\u00e0": "THIENE",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "3294278844",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC01445-007101"
    },
    "017155": {
        "Stato": "IT",
        "CAP": "81030",
        "Localit\u00e0": "CASTEL VOLTURNO",
        "Indirizzo": "VIA DOMIZIANA, 2225",
        "N.ri Tel.": "333 4462334",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBBKC01452-007111"
    },
    "017352": {
        "Stato": "IT",
        "CAP": "87100",
        "Localit\u00e0": "COSENZA",
        "Indirizzo": "VIA MONTESANTO, 83-85",
        "N.ri Tel.": "0984 86233",
        "Insegna": "PRIMAMODA",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02430-007104,25SBLGC02432-007104,25SBLGC02429-006648"
    },
    "017610": {
        "Stato": "IT",
        "CAP": "87032",
        "Localit\u00e0": "AMANTEA",
        "Indirizzo": "VIA MARGHERITA 134",
        "N.ri Tel.": "0982 424074",
        "Insegna": "CURCIO FASHION",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25SBLKF03551-007187,25SBLKH02555-007188,25SBLKC02430-007104,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKX02418-005958,25SBLKP05558-007187,25SBLGC02432-007104,25SBLKF02553-007187,25SBLKP01554-007187,25SBLGH02550-007188,25WBLKC03400-007308,25WBLKC02429-005958"
    },
    "017862": {
        "Stato": "IT",
        "CAP": "96014",
        "Localit\u00e0": "FLORIDIA",
        "Indirizzo": "VIA ARCHIMEDE 106",
        "N.ri Tel.": "3891121405",
        "Insegna": "BON TON",
        "CODICE PRODOTTO KOOOMO": "25SBLGC01441-007111,25SBLGC01441-007111,25SBLKC06443-007101,25SBLKC11440-007111,25SBLKC11440-007111,25SBLKC11440-007111"
    },
    "017931": {
        "Stato": "IT",
        "CAP": "92016",
        "Localit\u00e0": "RIBERA",
        "Indirizzo": "VIA PARLAPIANO 45",
        "N.ri Tel.": "092567939",
        "Insegna": "URSO MODA",
        "CODICE PRODOTTO KOOOMO": "25SBLKC01444-007101,25SBLKC01445-007101,25WBLGC02391-006648,25SBLGH02550-007188,25SBLGC02429-006648,25WBLKC02429-005958"
    },
    "017961": {
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "BENEVENTO",
        "Indirizzo": "VIA DEI LONGOBARDI 24",
        "N.ri Tel.": "3355364258",
        "Insegna": "PENELOPE",
        "CODICE PRODOTTO KOOOMO": "25SBLKC01444-007101,25SBLKC06443-007101"
    },
    "018084": {
        "Stato": "IT",
        "CAP": "97015",
        "Localit\u00e0": "MODICA",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "340- 2713603 tit",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "018099": {
        "Stato": "IT",
        "CAP": "81028",
        "Localit\u00e0": "SANTA MARIA A VICO",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGC01441-007111,25SBLGC01441-007111,25SBLKF03551-007187"
    },
    "018211": {
        "Stato": "IT",
        "CAP": "00173",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA TUSCOLANA, 1402",
        "N.ri Tel.": "06 7481852",
        "Insegna": "BABALUS",
        "CODICE PRODOTTO KOOOMO": "25SBLKP05558-007187,25SBLKH02555-007188,25SBLGP05549-007187,25SBLKF02553-007187,25SBLGH02550-007188,25WBBXC02456-005958,25SBLKF03551-007187"
    },
    "018273": {
        "Stato": "IT",
        "CAP": "00019",
        "Localit\u00e0": "TIVOLI",
        "Indirizzo": "VIA PALATINA, 20",
        "N.ri Tel.": "0774 312737",
        "Insegna": "INN OUTLET BIMBI DI SCIARRONE CARLOTTA",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25SBLKF03551-007187,25SBLGC01441-007111,25SBLKC06443-007101,25SBLKH02555-007188,25SBLGP05549-007187,25WBBXC02454-007110,25SBLKP01554-007187,25SBLGF03548-007187,25SBLGH02550-007188"
    },
    "018278": {
        "Stato": "IT",
        "CAP": "63082",
        "Localit\u00e0": "CASTEL DI LAMA",
        "Indirizzo": "VIA SALARIA, 178",
        "N.ri Tel.": "0736 813814",
        "Insegna": "SNOOPY",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKH02555-007188,25SBLKP05564-007187,25SBLGC02426-006648,25SBLKC01435-007108,25WBLKC02427-005958,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKC01445-007101,25SBBGC02453-005958,25SBLKF02553-007187,25SBLKP01554-007187"
    },
    "018302": {
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "SAN GIOVANNI ROTONDO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "335 568 5635",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101,25WBLKC11416-007110,25SBLKC02430-007104"
    },
    "018383": {
        "Stato": "IT",
        "CAP": "71037",
        "Localit\u00e0": "MONTE SANT'ANGELO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 181",
        "N.ri Tel.": "3402362744",
        "Insegna": "FASHION BABY",
        "CODICE PRODOTTO KOOOMO": "25SBLKF03551-007187,25SBLKH02555-007188,25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958,25SBLGF03548-007187,25SBLGH02550-007188"
    },
    "018413": {
        "Stato": "IT",
        "CAP": "10141",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "CORSO PESCHIERA, 283/A",
        "N.ri Tel.": "011721220",
        "Insegna": "PRIMA ELEGANZA",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25SBLKH02555-007188,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKC11440-007111,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKF02553-007187,25SBLKP01554-007187"
    },
    "018415": {
        "Stato": "IT",
        "CAP": "25037",
        "Localit\u00e0": "TIRANO",
        "Indirizzo": "VIALE ITALIA, 163C",
        "N.ri Tel.": "3931552251",
        "Insegna": "MODARTE",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKC06443-007101,25SBLKX02418-005958,25SBLGC02432-007104,25SBLKT02464-006818,25WBLKC02429-005958"
    },
    "018448": {
        "Stato": "IT",
        "CAP": "98071",
        "Localit\u00e0": "CAPO D'ORLANDO",
        "Indirizzo": "VIA ROMA, 49",
        "Insegna": "MANGANO JUNIOR",
        "CODICE PRODOTTO KOOOMO": "25SBLKF03551-007187,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKT02464-006818,25SBLKT02464-006818"
    },
    "018465": {
        "Stato": "IT",
        "CAP": "15033",
        "Localit\u00e0": "CASALE MONFERRATO",
        "Indirizzo": "VIA ROMA, 176",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187"
    },
    "018467": {
        "Stato": "IT",
        "CAP": "10024",
        "Localit\u00e0": "MONCALIERI",
        "Indirizzo": "VIA SAN MARTINO, 19",
        "N.ri Tel.": "011 6485308",
        "Insegna": "BAMBI",
        "CODICE PRODOTTO KOOOMO": "25SBLGC02432-007104,25SBLKC02417-005958,25SBLKC02417-005958,25SBLKF02553-007187,25SBLKF03551-007187,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKP05564-007187,25SBLKX02418-005958,25SBLKX02418-005958"
    },
    "018521": {
        "Stato": "IT",
        "CAP": "01073",
        "Localit\u00e0": "CIRIE'",
        "Indirizzo": "VIA VITTORIO EMANUELE 110/112",
        "N.ri Tel.": "3336863952",
        "Insegna": "NATALINA BIMBI",
        "CODICE PRODOTTO KOOOMO": "25SBLKF02553-007187,25SBLKF08561-007187,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKP05558-007187,25SBLKP05558-007187"
    },
    "018526": {
        "Stato": "IT",
        "CAP": "28921",
        "Localit\u00e0": "VERBANIA",
        "Indirizzo": "VIA BAIETTINI, 75",
        "N.ri Tel.": "0323/405482",
        "Insegna": "BULLI E PUPE",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBLKP05558-007187,25SBLKH02555-007188,25SBLKF02553-007187,25WBLGC02391-006648,25SBLKP01554-007187,25WBLKC02427-005958,25WBLKC02429-005958,25SBLKF03551-007187"
    },
    "018531": {
        "Stato": "IT",
        "CAP": "12100",
        "Localit\u00e0": "CUNEO",
        "Indirizzo": "VIA CARLO EMANUELE III, 25",
        "N.ri Tel.": "01711890112",
        "Insegna": "MINIME'",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKH02555-007188,25SBLGC02426-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958"
    },
    "018553": {
        "Stato": "IT",
        "CAP": "10121",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA XX SETTEMBRE, 54",
        "N.ri Tel.": "011 3826111",
        "Insegna": "PRIME VANITA'",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKX02418-005958,25SBLKP05558-007187,25SBLGC02432-007104,25SBLKF02553-007187,25SBLKP01554-007187,25WBLKC02429-005958"
    },
    "018556": {
        "Stato": "IT",
        "CAP": "09040",
        "Localit\u00e0": "SENORBI",
        "Indirizzo": "VIA CARLO SANNA, 148",
        "N.ri Tel.": "3202723015",
        "Insegna": "TENEREZZE",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25SBLKC06443-007101,25WBLGC02391-006648,25SBLKP05558-007187,25SBLGH02492-007144"
    },
    "018574": {
        "Stato": "IT",
        "CAP": "20855",
        "Localit\u00e0": "LESMO",
        "Indirizzo": "VIA XXV APRILE, 11",
        "Insegna": "SIMEONI JUNIOR",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958,25SBBKC01452-007111,25WBLGC02391-006648,25WBBXC02456-005958,25WBLKC02429-005958"
    },
    "018691": {
        "Stato": "IT",
        "CAP": "80048",
        "Localit\u00e0": "SANT'ANASTASIA",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "081 5301974",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKF02553-007187"
    },
    "018795": {
        "Stato": "IT",
        "CAP": "20013",
        "Localit\u00e0": "MAGENTA",
        "Indirizzo": "VIA ROMA,  5",
        "N.ri Tel.": "0297002225",
        "Insegna": "fedenosotti@gmail.com",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187,25WBBXC02456-005958,25SBLGF02547-007187,25SBLGP05549-007187,25WBLKC02427-005958,25SBLKP05558-007187,25SBLKP01554-007187,25SBLGH02550-007188,25WBLKC02429-005958"
    },
    "018813": {
        "Stato": "IT",
        "CAP": "90036",
        "Localit\u00e0": "MISILMERI",
        "Indirizzo": "CORSO IV APRILE, 272",
        "N.ri Tel.": "3394212008",
        "Insegna": "LITTLES",
        "CODICE PRODOTTO KOOOMO": "25SBLGF02547-007187,25SBLKC06443-007101,25SBLKH02555-007188,25SBLGP05549-007187,25WBLGC02391-006648,25SBLKX02418-005958,25SBLKP05558-007187,25SBLGC02432-007104,25SBBGC02453-005958,25SBLKF02553-007187,25SBLKP01554-007187,25SBLGH02550-007188"
    },
    "018854": {
        "Stato": "IT",
        "CAP": "97019",
        "Localit\u00e0": "VITTORIA",
        "Indirizzo": "VIA NINO BIXIO 119",
        "Insegna": "TARGET BOY & TEEN",
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110,25SBLGC01441-007111,25SBLKC06443-007101,25WBLGC02391-006648,25SBLGC02432-007104,25SBLKC01445-007101,25WBLKC02429-005958"
    },
    "018897": {
        "Stato": "IT",
        "CAP": "92015",
        "Localit\u00e0": "RAFFADALI",
        "Indirizzo": "VIA PORTA AGRIGENTO, 203",
        "N.ri Tel.": "0922/471607",
        "Insegna": "BIMBO IN",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25SBLGC01441-007111,25SBLKC01444-007101,25SBLKC02430-007104,25WBLGC02391-006648,25SBLGC02432-007104,25SBLGH02495-007144,25SBLKT02464-006818,25SBLGH02492-007144,25WBLKC02429-005958"
    },
    "018911": {
        "Stato": "IT",
        "CAP": "80063",
        "Localit\u00e0": "PIANO DI SORRENTO",
        "Indirizzo": "CORSO ITALIA 170",
        "N.ri Tel.": "0810201952",
        "Insegna": "METRO STYLE",
        "CODICE PRODOTTO KOOOMO": "25SBLKP05558-007187,25SBLKH02555-007188,25SBLKP05564-007187,25SBLKF02553-007187,25WBLGC02391-006648,25SBLKP01554-007187,25WBLKC02427-005958,25WBLKC03400-007308,25SBLKF03551-007187"
    },
    "018920": {
        "Stato": "IT",
        "CAP": "85022",
        "Localit\u00e0": "BARILE",
        "Indirizzo": "Strada Statale 93, snc NOI DUE",
        "N.ri Tel.": "0972 724350",
        "Insegna": "ROLEMA ABBIGLIAMENTO",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKF03551-007187,25SBLKH02555-007188,25SBLGP05549-007187,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKX02418-005958,25SBLKP05558-007187,25SBLGH02495-007144,25SBLKF02553-007187,25SBLKP01554-007187,25SBLGH02550-007188"
    },
    "018987": {
        "Stato": "IT",
        "CAP": "95046",
        "Localit\u00e0": "PALAGONIA",
        "Indirizzo": "VIA VITTORIO EMANUELE 134",
        "Insegna": "LE GRANDI FIRME",
        "CODICE PRODOTTO KOOOMO": "25SBLGC01441-007111,25SBLGC01441-007111,25SBLGC02432-007104,25SBLGC02432-007104,25SBLGH02495-007144,25SBLGH02495-007144,25SBLGH02495-007144,25SBLKC02430-007104,25SBLKC02430-007104,25SBLKC11440-007111,25SBLKC11440-007111,25SBLKT02464-006818"
    },
    "018988": {
        "Stato": "IT",
        "CAP": "64026",
        "Localit\u00e0": "ROSETO DEGLI ABRUZZI",
        "Indirizzo": "VIA G.BOCCACCIO, 15",
        "Insegna": "ANGELS",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBBXC02456-005958,25SBLKF03551-007187,25SBLKC06443-007101,25SBLKH02555-007188,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKP05558-007187"
    },
    "018999": {
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "S.G.GEMINI",
        "Indirizzo": "CORSO F. CRISPI, 200",
        "N.ri Tel.": "0922 900997",
        "Insegna": "REINOLDS",
        "CODICE PRODOTTO KOOOMO": "25SBLKF03551-007187,25SBLKH02555-007188,25SBLGC02426-006648,25SBLKC02430-007104,25WBLGC02391-006648,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKF02553-007187,25SBBGC02453-005958,25SBLKP01554-007187,25SBLGH02550-007188,25WBLKC02429-005958"
    },
    "019000": {
        "Stato": "IT",
        "CAP": "92019",
        "Localit\u00e0": "SCIACCA",
        "Indirizzo": "VIA G. LICATA 98",
        "N.ri Tel.": "3474128207",
        "Insegna": "17een",
        "CODICE PRODOTTO KOOOMO": "25SBBGC02453-005958,25SBBGC02453-005958,25SBBKC01452-007111,25SBBKC01452-007111,25SBLGC01441-007111,25SBLGC01441-007111,25SBLGC02432-007104,25SBLGC02432-007104,25SBLGF03548-007187,25SBLGF03548-007187,25SBLGH02495-007144,25SBLGH02495-007144,25SBLGH02550-007188,25SBLGH02550-007188,25SBLGH02550-007188,25SBLKC01445-007101,25SBLKC01445-007101,25SBLKC01445-007101,25SBLKC06443-007101,25SBLKC06443-007101,25SBLKC11440-007111,25SBLKC11440-007111,25SBLKF02553-007187,25SBLKF02553-007187,25SBLKF02553-007187,25SBLKF03551-007187,25SBLKF03551-007187,25SBLKF03551-007187,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187,25SBLKP05558-007187,25SBLKP05558-007187,25SBLKP05558-007187,25SBLKT02464-006818,25SBLKT02464-006818"
    },
    "019168": {
        "Stato": "IT",
        "CAP": "80146",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "3294278844",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101"
    },
    "019225": {
        "Stato": "IT",
        "CAP": "20035",
        "Localit\u00e0": "LISSONE",
        "Indirizzo": "VIA LORETO 26",
        "N.ri Tel.": "039 2182610",
        "Insegna": "PUCCININNI",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKX02418-005958"
    },
    "019231": {
        "Stato": "IT",
        "CAP": "25034",
        "Localit\u00e0": "ORZI NUOVI",
        "Indirizzo": "PIAZZA VITTORIO EMANUELE II , 2",
        "N.ri Tel.": "030 9941872",
        "Insegna": "JOLIE BOUTIQUE",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187,25SBLGP05549-007187,25WBLKC02427-005958,25SBLKX02418-005958,25SBLKP05558-007187,25SBLGH02550-007188,25SBLKC01445-007101,25SBLKT02464-006818,25SBLGF03548-007187,25SBLGH02492-007144,25SBLGC02429-006648,25WBLKC02429-005958"
    },
    "019234": {
        "Stato": "IT",
        "CAP": "20093",
        "Localit\u00e0": "COLOGNO MONZESE",
        "Indirizzo": "PIAZZA 11 FEBBRAIO, 12",
        "N.ri Tel.": "02 36574173",
        "Insegna": "ZUCCHERO",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKX02418-005958,25SBLKC01445-007101,25WBBXC02456-005958"
    },
    "019239": {
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "SAN MARZANO SUL SARNO",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "3760254370",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC01444-007101"
    },
    "019460": {
        "Stato": "IT",
        "CAP": "58022",
        "Localit\u00e0": "FOLLONICA",
        "Indirizzo": "VIA ROMA, 65",
        "N.ri Tel.": "056654092",
        "Insegna": "MARINE SPORT",
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25SBLKX02418-005958,25SBBKC01452-007111,25WBLKC02429-005958"
    },
    "019465": {
        "Stato": "IT",
        "CAP": "16011",
        "Localit\u00e0": "ARENZANO",
        "Indirizzo": "PIAZZA DAVID CHIOSSONE, 3",
        "N.ri Tel.": "0109126791",
        "Insegna": "FANTASIE DEL BORGO",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187,25SBLGF02547-007187,25SBLGC01441-007111,25SBLKH02555-007188,25SBLGP05549-007187,25WBLGC02391-006648,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKF02553-007187,25SBLKP01554-007187,25SBLGH02550-007188,25WBLKC02429-005958"
    },
    "019479": {
        "Stato": "IT",
        "CAP": "17025",
        "Localit\u00e0": "LOANO",
        "Indirizzo": "VIA CESAREA 27",
        "N.ri Tel.": "019673798",
        "Insegna": "TRE MONELLI",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187,25WBBXC02456-005958,25SBLKH02555-007188,25WBLGC02391-006648,25SBLKX02418-005958,25SBLKP05558-007187,25SBLKF02553-007187,25WBLKC02429-005958"
    },
    "019483": {
        "Stato": "IT",
        "CAP": "88900",
        "Localit\u00e0": "CROTONE",
        "Indirizzo": "VIA ROMA,  74",
        "N.ri Tel.": "0962 26910",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101"
    },
    "019490": {
        "Stato": "IT",
        "CAP": "74123",
        "Localit\u00e0": "TARANTO",
        "Indirizzo": "VIA ROMA, 176",
        "N.ri Tel.": "3204690304",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019507": {
        "Stato": "IT",
        "CAP": "48121",
        "Localit\u00e0": "RAVENNA",
        "Indirizzo": "VIA PODGORA 51B SECONDA",
        "N.ri Tel.": "+39 334 893 9332.",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "019515": {
        "Stato": "IT",
        "CAP": "55100",
        "Localit\u00e0": "LUCCA",
        "Indirizzo": "PIAZZA DELL'ARANCIO 29",
        "N.ri Tel.": "0583494107",
        "Insegna": "GIROTONDO",
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25SBLKX02418-005958,25WBLKC02429-005958"
    },
    "019759": {
        "Stato": "IT",
        "CAP": "25136",
        "Localit\u00e0": "BRESCIA",
        "Indirizzo": "VIA TRIUMPLINA, 235",
        "N.ri Tel.": "030 - 2000859",
        "Insegna": "E-MODA",
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110,25WBLUC03090-006719,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25SBLKC06443-007101,25WBLGA05461-007349,25WBLDC03100-006047,25WBLKC02427-005958,25SBLKX02418-005958,25WBLDC03096-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLDK03102-006047,25WBLDC03099-006047,25WBLKC02429-005958"
    },
    "019900": {
        "Stato": "IT",
        "CAP": "00177",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE DELLA SERENISSIMA, 26/A",
        "N.ri Tel.": "0621800745",
        "Insegna": "INFANZIA ELEGANTE",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25SBLGC01441-007111,25SBLKP05558-007187,25SBLKC01445-007101,25SBBKC01452-007111,25WBLKC02429-005958"
    },
    "020009": {
        "Stato": "IT",
        "CAP": "86100",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "VIA ROMA, 176",
        "N.ri Tel.": "3200413255",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLKC02430-007104,25SBLKC01444-007101,25SBLKC11440-007111,25SBLGC02432-007104"
    },
    "020060": {
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA SOLFATARA, 12/A",
        "Insegna": "PAFUNDI",
        "CODICE PRODOTTO KOOOMO": "25SBLKC11440-007111,25SBLKF02553-007187,25SBLKF02553-007187,25SBLKF03551-007187,25SBLKF03551-007187,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKH02555-007188,25SBLKP01554-007187,25SBLKP05558-007187"
    },
    "020123": {
        "Stato": "IT",
        "CAP": "07026",
        "Localit\u00e0": "OLBIA",
        "Indirizzo": "VIA SANTA LUCIA SS 125 LOC. BASA SNC C.C TERRANOVA",
        "Insegna": "KERLY KIDS",
        "CODICE PRODOTTO KOOOMO": "25SBLGC02432-007104,25SBLKC01445-007101,25WBLGC02391-006648,25SBLKF03551-007187"
    },
    "020139": {
        "Stato": "IT",
        "CAP": "95122",
        "Localit\u00e0": "TORRE DEL GRECO",
        "Indirizzo": "VIALE MARIO RAPISARDI, 287",
        "N.ri Tel.": "095 7514195",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020376": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "TERRACINA",
        "Indirizzo": "VIALE MARIO RAPISARDI, 287",
        "N.ri Tel.": "3760254370",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020387": {
        "Stato": "IT",
        "CAP": "95037",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "VIA UMBERTINO DA CARRARA, 6",
        "N.ri Tel.": "3804364649",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKF03551-007187"
    },
    "020395": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "TORRE DEL GRECO",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "371 4455473",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "020413": {
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIALE DEL COMMERCIO , 4",
        "N.ri Tel.": "3475860510",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBBKC01452-007111"
    },
    "020484": {
        "Stato": "IT",
        "CAP": "92100",
        "Localit\u00e0": "VIC",
        "Indirizzo": "VIALE DELLA VITTORIA, 197",
        "N.ri Tel.": "0922-21796",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101,25SBLGH02495-007144"
    },
    "020507": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "TREZZANO SUL NAVIGLIO",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "340- 2713603 tit",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKX02418-005958"
    },
    "020570": {
        "Stato": "IT",
        "CAP": "70026",
        "Localit\u00e0": "MODUGNO",
        "Indirizzo": "CORSO VITTORIO EMANUELE, 49",
        "N.ri Tel.": "3394380618",
        "Insegna": "RIZZA KIDS",
        "CODICE PRODOTTO KOOOMO": "25SBLGF02547-007187,25SBLGC01441-007111,25SBLKH02555-007188,25SBLKP05564-007187,25SBLGC02426-006648,25SBLGP05549-007187,25WBLKC02427-005958,25SBLKX02418-005958,25SBLKF02553-007187,25SBBKC01452-007111,25SBLGH02550-007188"
    },
    "020664": {
        "Stato": "IT",
        "CAP": "80016",
        "Localit\u00e0": "MARANO DI NAPOLI",
        "Indirizzo": "CORSO EUROPA, 158",
        "N.ri Tel.": "3772037225",
        "Insegna": "SCUGNIZZI",
        "CODICE PRODOTTO KOOOMO": "25SBLKF03551-007187,25SBLGF02547-007187,25SBLKH02555-007188,25SBLGP05549-007187,25WBLGC02391-006648,25WBLKC02427-005958,25SBLKP05558-007187,25SBLKF02553-007187,25SBLKP01554-007187,25SBLGH02550-007188,25WBLKC02429-005958"
    },
    "020921": {
        "Stato": "IT",
        "CAP": "96100",
        "Localit\u00e0": "VALENZANO",
        "Indirizzo": "VIA VITTORIO VENETO 99",
        "N.ri Tel.": "3475860510",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110"
    },
    "020951": {
        "Stato": "IT",
        "CAP": "90129",
        "Localit\u00e0": "SANT'ANASTASIA",
        "Indirizzo": "VIA FRANCESCO SPECIALE, 15",
        "N.ri Tel.": "333 4462334",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGC02432-007104,25SBLKH02555-007188,25SBLKP01554-007187"
    },
    "021021": {
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC02417-005958,25SBLGC02426-006648,25SBLKC01445-007101,25SBBGC02453-005958,25SBLGH02492-007144,25SBLKC02430-007104,25SBLKC01435-007108,25SBLKX02418-005958,25SBLKC01444-007101"
    },
    "021088": {
        "Stato": "IT",
        "CAP": "84128",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA SCOPARI, 5",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101,25WBLKC11416-007110,25SBLKF02553-007187"
    },
    "021092": {
        "Stato": "IT",
        "CAP": "00054",
        "Localit\u00e0": "FREGENE  -  FIUMICINO",
        "Indirizzo": "VIALE CASTELLAMARE, 68/A",
        "N.ri Tel.": "06-6680980",
        "Insegna": "MALIBU'",
        "CODICE PRODOTTO KOOOMO": "25SBBGC02453-005958,25SBBGC02453-005958,25SBBKC01452-007111,25SBLGC02432-007104,25SBLKC06443-007101,25SBLKC06443-007101"
    },
    "021281": {
        "Stato": "IT",
        "CAP": "90143",
        "Localit\u00e0": "SANT'ANTONIO ABATE",
        "Indirizzo": "VIA STABIA, 355/357",
        "N.ri Tel.": "3334732594",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKT02464-006818"
    },
    "021766": {
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VILLARICCA",
        "Indirizzo": "VIALE DEL COMMERCIO , 4",
        "N.ri Tel.": "972 21 21 10",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": ""
    },
    "022107": {
        "Stato": "IT",
        "CAP": "86039",
        "Localit\u00e0": "TERMOLI",
        "Indirizzo": "VIA XX SETTEMBRE 9",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGC02426-006648"
    },
    "022172": {
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VINAZOR ES CASTELLON",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKH02555-007188,25SBLKF03551-007187"
    },
    "022392": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "393-5299693",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKT02464-006818,25SBLGC01441-007111,25SBLGH02495-007144,25SBLKT02464-006818,25SBLKF02553-007187,25SBLKP05558-007187,25SBLKX02418-005958,25SBLKC02430-007104,25SBLKC11440-007111,25SBLKP01554-007187"
    },
    "022436": {
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIALE STRASBURGO, 170-174",
        "N.ri Tel.": "3204690304",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKC06443-007101,25SBLKC01445-007101"
    },
    "022602": {
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VINAZOR ES CASTELLON",
        "Indirizzo": "VIALE AMENDOLA 104",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLKF08561-007187,25SBLKH02555-007188,25SBLKP05564-007187,25SBLKH02555-007188"
    },
    "022625": {
        "Stato": "IT",
        "CAP": "84010",
        "Localit\u00e0": "VIC",
        "Indirizzo": "VIALE ROMA 81 - 85",
        "N.ri Tel.": "MAURO",
        "Insegna": "- ",
        "CODICE PRODOTTO KOOOMO": "25SBLGF02547-007187,25SBLGH02550-007188,25SBLGP05549-007187,25SBLGP05549-007187,25SBLGF02547-007187,25SBLGH02550-007188,25SBLGH02550-007188,25SBLGP05549-007187,25SBLKP05558-007187,25SBLKH02555-007188,25SBLKP05558-007187"
    },
    "004199": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUK11140-007286,25WBLUK11140-007286",
        "Stato": "DE",
        "CAP": "96047",
        "Localit\u00e0": "BAMBERG",
        "Indirizzo": "OBERE BR\u00dcCKE  7",
        "N.ri Tel.": "004995121808",
        "Insegna": "ali er&sie"
    },
    "011899": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "UA",
        "CAP": "2081",
        "Localit\u00e0": "KIEV",
        "Indirizzo": "UL. SAKSAGANSKOGO, 85",
        "Insegna": "- "
    },
    "012431": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK05019-007298",
        "Stato": "GB",
        "CAP": "LL53 7AS",
        "Localit\u00e0": "GWYNEDD",
        "Indirizzo": "THE HARBOUR, ABERSOCH, PWLLHELI",
        "N.ri Tel.": "01758 712293",
        "Insegna": "- "
    },
    "012821": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "CZ",
        "CAP": "66902",
        "Localit\u00e0": "ZNOJMO",
        "Indirizzo": "HORNI CESKA 233/10",
        "N.ri Tel.": "+420 602744959",
        "Insegna": "- "
    },
    "013482": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "CZ",
        "CAP": "73951",
        "Localit\u00e0": "DOBRA",
        "Indirizzo": "DOBRATICE 260",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- "
    },
    "014277": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUK03142-005480",
        "Stato": "ES",
        "CAP": "08201",
        "Localit\u00e0": "SABADELL (BARCELONA)",
        "Indirizzo": "GRACIA 38",
        "N.ri Tel.": "93 727 96 12",
        "Insegna": "JULIAN ADRADOS"
    },
    "014838": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "PL",
        "CAP": "02-486",
        "Localit\u00e0": "Warsaw",
        "Indirizzo": "Al. Jerozolimskie 200, lok. 410",
        "Insegna": "- "
    },
    "015655": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDF08248-006948,25WBLDK02192-006648,25WBLDX03181-006985,25WBLUA05297-006127,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUA05301-006434,25WBLUA05301-006434,25WBLUC02151-007287,25WBLUC06082-005480,25WBLUK03142-005480",
        "Stato": "RU",
        "CAP": "630112",
        "Localit\u00e0": "NOVOSIBIRSK OBLAST",
        "Indirizzo": "\"AYPA\", VOYENNAYA UL., 5",
        "N.ri Tel.": "028321103",
        "Insegna": "ZEPPELIN"
    },
    "015694": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUK03142-005480",
        "Stato": "ES",
        "CAP": "17100",
        "Localit\u00e0": "LA BISBAL D'EMPORDA",
        "Indirizzo": "CALLE PLAZA JACINTO, 4",
        "N.ri Tel.": "972640384",
        "Insegna": "HOMO"
    },
    "015725": {
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLUK03142-005480",
        "Stato": "FR",
        "CAP": "51100",
        "Localit\u00e0": "REIMS",
        "Indirizzo": "16 RUE DU CADRAN SAINT PIERRE",
        "N.ri Tel.": "0661961717",
        "Insegna": "CAVIAR"
    },
    "016410": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02151-007287,25WBLUC03090-006719",
        "Stato": "DE",
        "CAP": "71634",
        "Localit\u00e0": "LUDWIGSBURG",
        "Indirizzo": "KOERNERSTRASSE 17",
        "N.ri Tel.": "07141 911291",
        "Insegna": "HOMERUN"
    },
    "016595": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC08078-006355",
        "Stato": "DE",
        "CAP": "72147",
        "Localit\u00e0": "Nehren",
        "Indirizzo": "Reutlinger Strasse 23",
        "N.ri Tel.": "07473-94280",
        "Insegna": "SKI NILL"
    },
    "017037": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDK03101-006047,25WBLDK03101-006047",
        "Stato": "DE",
        "CAP": "83022",
        "Localit\u00e0": "Rosenheim (Innenstadt), Bayern",
        "Indirizzo": "Ludwigplatz 4",
        "N.ri Tel.": "08031-9411200",
        "Insegna": "Block 6 - Knierer-Hartinger GbR, Block"
    },
    "018570": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "PT",
        "CAP": "63741",
        "Localit\u00e0": "PORTO",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "00493041706555",
        "Insegna": "- "
    },
    "019444": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02151-007287",
        "Stato": "DE",
        "CAP": "96264",
        "Localit\u00e0": "ALTENKUNSTADT",
        "Indirizzo": "GEWERBEGEBIET 1",
        "Insegna": "- "
    },
    "019951": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047",
        "Stato": "ES",
        "CAP": "24001",
        "Localit\u00e0": "LEON",
        "Indirizzo": "Calle ordono II, 12",
        "N.ri Tel.": "0034 987232486",
        "Insegna": "- "
    },
    "020011": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDF08248-006948,25WBLDK02192-006648,25WBLDX03181-006985,25WBLUA05297-006127,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUA05301-006434,25WBLUA05301-006434,25WBLUC02151-007287,25WBLUC06082-005480,25WBLUK03142-005480",
        "Stato": "RU",
        "CAP": "105122",
        "Localit\u00e0": "MOSCOW",
        "Indirizzo": "Int.Ter. Municipal District, Golyanovo, Shchelkovskoe highway, 9, office 1P",
        "Insegna": "OSCAR (ULAN UDE)"
    },
    "022548": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK03101-006047",
        "Stato": "AT",
        "CAP": "1010",
        "Localit\u00e0": "WIEN",
        "Indirizzo": "C/O BLAUMAX STORE, Goldschmiedgasse 9",
        "N.ri Tel.": "0043 2243 228990",
        "Insegna": "NEUMANN"
    },
    "022757": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "ES",
        "CAP": "08018",
        "Localit\u00e0": "BARCELLONA",
        "Indirizzo": "CALLE PALLARS 141-143 PRIMERO",
        "N.ri Tel.": "+34 934 869158",
        "Insegna": "- "
    },
    "023045": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03101-006047,25WBLDK02192-006648,25WBLDC02072-006648,25WBLDK02069-006648",
        "Stato": "ES",
        "CAP": "89081",
        "Localit\u00e0": "Ulm",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "945150305",
        "Insegna": "- "
    },
    "023064": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "DE",
        "CAP": "89081",
        "Localit\u00e0": "Ulm",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "0731-140810",
        "Insegna": "- "
    },
    "023206": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC02080-005958",
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "Magnice, Wroclaw",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- "
    },
    "023222": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK02073-006648,25WBLDC02177-007284,25WBLDC02177-007284",
        "Stato": "SK",
        "CAP": "96264",
        "Localit\u00e0": "WEITERSTADT",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- "
    },
    "023260": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "RU",
        "CAP": "85748",
        "Localit\u00e0": "TRAVEMUENDE",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "941593051",
        "Insegna": "- "
    },
    "023276": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK02192-006648",
        "Stato": "ES",
        "CAP": "73951",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "973243471",
        "Insegna": "- "
    },
    "023336": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "PL",
        "CAP": "77-300",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "WEBERGASSE 3",
        "N.ri Tel.": "0049 7031 616 2016",
        "Insegna": "- "
    },
    "023413": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03090-006719,25WBLUC02132-007284",
        "Stato": "PL",
        "CAP": "85310",
        "Localit\u00e0": "ZIELONA GORA",
        "Indirizzo": "WALLSTRASSE 1A",
        "N.ri Tel.": "619108808",
        "Insegna": "- "
    },
    "023414": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC02170-006648,25WBLDC03092-006719,25WBLDC03092-006719,25WBLUC02079-005958,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDC03100-006047,25WBLDK03098-006047,25WBLUC03090-006719",
        "Stato": "XK",
        "CAP": "85748",
        "Localit\u00e0": "SINDELFINGEN",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "0049899077469109",
        "Insegna": "- "
    },
    "023430": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05338-006127,25WBLDC03100-006047",
        "Stato": "UA",
        "CAP": "82031",
        "Localit\u00e0": "Swadzim",
        "Indirizzo": "ZABOLOTNOGO 67/1",
        "N.ri Tel.": "974244948",
        "Insegna": "- "
    },
    "023435": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284,25WBLUC11083-007110",
        "Stato": "UA",
        "CAP": "34396",
        "Localit\u00e0": "MASLAK",
        "Indirizzo": "UL. SAKSAGANSKOGO, 85",
        "N.ri Tel.": "+90 212 335 75 75",
        "Insegna": "- "
    },
    "023512": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355,25WBLUC06082-005480,25WBLDC02178-006646",
        "Stato": "ES",
        "CAP": "73951",
        "Localit\u00e0": "Sitges",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "977345643",
        "Insegna": "- "
    },
    "023513": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "DE",
        "CAP": "89081",
        "Localit\u00e0": "Ulm",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "0731-140810",
        "Insegna": "- "
    },
    "023810": {
        "CODICE PRODOTTO KOOOMO": "25WBLUA05300-006434,25WBLUA05300-006434,25WBLUA05300-006434,25WBLDK02192-006648,25WBLUC03233-007308,25WBLUC02151-007287,25WBLDK02192-006648,25WBLUC02151-007287,25WBLDK03161-006719,25WBLUA05299-006127,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUX02081-005958",
        "Stato": "RU",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "RYTIRSKA 13",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- "
    },
    "000072": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "40121",
        "Localit\u00e0": "BOLOGNA",
        "Indirizzo": "VIA INDIPENDENZA, 52",
        "N.ri Tel.": "051 246317",
        "Insegna": "- "
    },
    "000251": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-A05958,25WBLDC02178-006646",
        "Stato": "IT",
        "CAP": "24050",
        "Localit\u00e0": "ORIO AL SERIO",
        "Indirizzo": "VIA PORTICO, 71",
        "N.ri Tel.": "0423 400145",
        "Insegna": "PELLIZZARI"
    },
    "000349": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "25030",
        "Localit\u00e0": "TORBIATO DI ADRO",
        "Indirizzo": "VIA PRINCIPE UMBERTO SNC",
        "N.ri Tel.": "0331 771463",
        "Insegna": "SORELLE RAMONDA"
    },
    "000350": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "25015",
        "Localit\u00e0": "DESENZANO",
        "Indirizzo": "VIA MANTOVA, 1",
        "N.ri Tel.": "030 9141101",
        "Insegna": "SORELLE RAMONDA"
    },
    "000356": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "42020",
        "Localit\u00e0": "QUATTRO CASTELLA Loc. MONTECAVOLO",
        "Indirizzo": "VIA P. TOGLIATTI, 26/B",
        "N.ri Tel.": "052 2886171",
        "Insegna": "SORELLE RAMONDA"
    },
    "000359": {
        "CODICE PRODOTTO KOOOMO": "25WBLUL01314-007012",
        "Stato": "IT",
        "CAP": "20035",
        "Localit\u00e0": "LISSONE",
        "Indirizzo": "VIA NUOVA VALASSINA, 346",
        "N.ri Tel.": "039 9908685",
        "Insegna": "- "
    },
    "000410": {
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "36071",
        "Localit\u00e0": "ARZIGNANO",
        "Indirizzo": "PIAZZA DELLE LIBERTA', 4",
        "N.ri Tel.": "0444 670047",
        "Insegna": "- "
    },
    "000600": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284",
        "Stato": "IT",
        "CAP": "47822",
        "Localit\u00e0": "SANTARCANGELO DI ROMAGNA",
        "Indirizzo": "VIA A. COSTA, 14",
        "N.ri Tel.": "0541 624013",
        "Insegna": "- "
    },
    "000689": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "32032",
        "Localit\u00e0": "FELTRE",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "0439 2346",
        "Insegna": "- "
    },
    "001193": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK03101-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLDK03527-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC06082-005480",
        "Stato": "IT",
        "CAP": "80121",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA DEI MILLE, 83",
        "N.ri Tel.": "081 5567392",
        "Insegna": "PASKAL"
    },
    "001480": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK02069-006648,25WBLDK03495-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "16129",
        "Localit\u00e0": "GENOVA",
        "Indirizzo": "VIA SAN VINCENZO, 7R",
        "N.ri Tel.": "010 561026",
        "Insegna": "TESSILMODA"
    },
    "002869": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "23030",
        "Localit\u00e0": "LIVIGNO",
        "Indirizzo": "VIA BONDI, 120",
        "N.ri Tel.": "0342 970210",
        "Insegna": "- "
    },
    "005999": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLDK03495-006047,25WBLUA05297-006127,25WBLUA05297-006127,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "10067",
        "Localit\u00e0": "VIGONE",
        "Indirizzo": "VIA OGGERO BESSONE, 2/A",
        "N.ri Tel.": "011 9809646",
        "Insegna": "BIASIBETTI"
    },
    "006038": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLUC03086-006047,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "08027",
        "Localit\u00e0": "ORGOSOLO",
        "Indirizzo": "CORSO REPUBBLICA, 288",
        "N.ri Tel.": "0784 403126",
        "Insegna": "GARDENIA BLU"
    },
    "006188": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "32043",
        "Localit\u00e0": "CORTINA D'AMPEZZO",
        "Indirizzo": "CORSO ITALIA, 190",
        "N.ri Tel.": "0436 860905",
        "Insegna": "- "
    },
    "008901": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "73055",
        "Localit\u00e0": "RACALE",
        "Indirizzo": "VIA GIUSEPPE MAZZINI, 160",
        "N.ri Tel.": "0833 552702",
        "Insegna": "- "
    },
    "008934": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "30900",
        "Localit\u00e0": "BOLZANO",
        "Indirizzo": "VIA GALILEO GALILEI, 20",
        "N.ri Tel.": "0444 491777",
        "Insegna": "- "
    },
    "009683": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03086-006047,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "33081",
        "Localit\u00e0": "AVIANO",
        "Indirizzo": "VIALE SAN GIORGIO, 9",
        "N.ri Tel.": "0434 651728",
        "Insegna": "INTROINI"
    },
    "009831": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDK03101-006047,25WBLDK03101-006047,25WBLDK11162-007110,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "38054",
        "Localit\u00e0": "SIROR Loc. S. MARTINO DI CASTROZZA",
        "Indirizzo": "VIA LAGHETTO, 4",
        "N.ri Tel.": "0439 769109",
        "Insegna": "BANCHER"
    },
    "011200": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC03233-007308",
        "Stato": "IT",
        "CAP": "23900",
        "Localit\u00e0": "LECCO",
        "Indirizzo": "Piazza XX Settembre, 5",
        "N.ri Tel.": "0341 1716240",
        "Insegna": "BUTTI"
    },
    "011622": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "56020",
        "Localit\u00e0": "SANTA MARIA A MONTE",
        "Indirizzo": "VIA COLOMBAIE 11,",
        "N.ri Tel.": "0587749036",
        "Insegna": "- "
    },
    "012594": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO PONTICELLI 33/35",
        "N.ri Tel.": "081/5965377",
        "Insegna": "PRELUDIO"
    },
    "012880": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02177-007284,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLDK01375-007378,25WBLDK02069-006648,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLDK03527-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUX02081-005958,25WBLGC02391-006648,25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "81020",
        "Localit\u00e0": "SAN MARCO EVANGELISTA",
        "Indirizzo": "STRADA STATALE 265 KM 26.200",
        "Insegna": "MASSARO"
    },
    "013695": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02153-007300",
        "Stato": "IT",
        "CAP": "10138",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA PALMIERI 47/P",
        "N.ri Tel.": "340 2728804",
        "Insegna": "- "
    },
    "014051": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "16030",
        "Localit\u00e0": "GATTORNA DI MOCONESI",
        "Indirizzo": "VIA DEL COMMERCIO, 75",
        "N.ri Tel.": "0185 935014",
        "Insegna": "LA FRANCHEZZA"
    },
    "014106": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05337-006127,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "83031",
        "Localit\u00e0": "ARIANO IRPINO",
        "Indirizzo": "VIA CARDITO , 112",
        "N.ri Tel.": "349-1492635",
        "Insegna": "PUOPOLO"
    },
    "014261": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "80056",
        "Localit\u00e0": "ERCOLANO",
        "Indirizzo": "VIA IV NOVEMBRE 181",
        "N.ri Tel.": "331-1518643",
        "Insegna": "- "
    },
    "014366": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "34074",
        "Localit\u00e0": "MONFALCONE",
        "Indirizzo": "VIA GUGLIELMO OBERDAN 10",
        "N.ri Tel.": "0481/410996",
        "Insegna": "- "
    },
    "014421": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLUC06082-005480",
        "Stato": "IT",
        "CAP": "73049",
        "Localit\u00e0": "RUFFANO",
        "Indirizzo": "VIA POMPONIO D'URSO 85",
        "N.ri Tel.": "0833/693501",
        "Insegna": "TERZO MILLENIO FASHION JEANS"
    },
    "015026": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "26866",
        "Localit\u00e0": "SANT'ANGELO LODIGIANO",
        "Indirizzo": "VIA GIUSEPPE MAZZINI,  21",
        "N.ri Tel.": "0371933926",
        "Insegna": "FRATTI"
    },
    "015423": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "RU",
        "CAP": "690091",
        "Localit\u00e0": "VLADIVOSTOK",
        "Indirizzo": "VIA CACCIATORI, 111",
        "N.ri Tel.": "011 4172174",
        "Insegna": "- "
    },
    "015441": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "10126",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GENOVA 30",
        "N.ri Tel.": "011-6634427",
        "Insegna": "- "
    },
    "015449": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK02069-006648,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA DEI MILLE II TRAVERSA",
        "N.ri Tel.": "0968/750121",
        "Insegna": "AMERICAN JEANS"
    },
    "015465": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "80147",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA FILUMENA MARTURANO, 28",
        "N.ri Tel.": "081 5593427",
        "Insegna": "BLACK JACK"
    },
    "015587": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "31046",
        "Localit\u00e0": "ODERZO",
        "Indirizzo": "PIAZZA GRANDE, 5",
        "N.ri Tel.": "0422-814510",
        "Insegna": "START ODERZO"
    },
    "015612": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03096-006047",
        "Stato": "IT",
        "CAP": "00186",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA TIBURTINA VALERIA KM 20 - UNITA' 67",
        "N.ri Tel.": "06 41734236",
        "Insegna": "NUVOLARI"
    },
    "016051": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "80038",
        "Localit\u00e0": "POMIGLIANO D'ARCO",
        "Indirizzo": "VIA ERCOLE CANTONE, 36",
        "N.ri Tel.": "3939686845",
        "Insegna": "- "
    },
    "016468": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03090-006719",
        "Stato": "IT",
        "CAP": "54011",
        "Localit\u00e0": "AULLA",
        "Indirizzo": "VIA NAZIONALE, 44",
        "N.ri Tel.": "0187420786",
        "Insegna": "MILLENNIUM"
    },
    "016586": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "15050",
        "Localit\u00e0": "ALZANO SCRIVIA",
        "Indirizzo": "STRADA PROVINCIALE 90 NR 16",
        "N.ri Tel.": "0131-826767",
        "Insegna": "- "
    },
    "016860": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDK03495-006047",
        "Stato": "IT",
        "CAP": "80138",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA A. SCIALOIA, 9",
        "N.ri Tel.": "081 204741",
        "Insegna": "- "
    },
    "017041": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "10126",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA GENOVA 32",
        "N.ri Tel.": "011-6634427",
        "Insegna": "- "
    },
    "017086": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03090-006719,25WBLUC03090-006719,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK11140-007286",
        "Stato": "IT",
        "CAP": "20833",
        "Localit\u00e0": "GIUSSANO",
        "Indirizzo": "VIA PREALPI 28",
        "N.ri Tel.": "0362 850179",
        "Insegna": "MASCHERONI"
    },
    "017087": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "67051",
        "Localit\u00e0": "GIUSSANO",
        "Indirizzo": "VIA MONSIGNOR BAGNOLI 79",
        "N.ri Tel.": "3938438702",
        "Insegna": "- "
    },
    "017887": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03086-006047",
        "Stato": "PL",
        "CAP": "62-080",
        "Localit\u00e0": "Swadzim",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "501090403",
        "Insegna": "- "
    },
    "018047": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "89134",
        "Localit\u00e0": "SPEYER",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "393 4840377",
        "Insegna": "- "
    },
    "018283": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03100-006047,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "43010",
        "Localit\u00e0": "MONCHIO DELLE CORTI",
        "Indirizzo": "VIA PER PRATOSPILLA, 10",
        "N.ri Tel.": "335 711 6528",
        "Insegna": "WINNER"
    },
    "018311": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLDK11162-007110",
        "Stato": "IT",
        "CAP": "81059",
        "Localit\u00e0": "VAIRANO SCALO",
        "Indirizzo": "VIA NAPOLI, 52",
        "N.ri Tel.": "0823 988924",
        "Insegna": "CLOTHES LIFE"
    },
    "018377": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA TRENCIA, 40",
        "N.ri Tel.": "3662045058",
        "Insegna": "- "
    },
    "018723": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "41058",
        "Localit\u00e0": "VIGNOLA",
        "Indirizzo": "VIA A. ROLFO, 18",
        "N.ri Tel.": "059775297",
        "Insegna": "- "
    },
    "018831": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03527-006047,25WBLDK05019-007298,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "60121",
        "Localit\u00e0": "ANCONA",
        "Indirizzo": "CORSO GARIBALDI 115",
        "N.ri Tel.": "3205672142",
        "Insegna": "+39"
    },
    "018833": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLUB05126-007283,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC05125-007283,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "00162",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA NOMENTANA, 459",
        "N.ri Tel.": "06 86215948",
        "Insegna": "GIBOT"
    },
    "018880": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03100-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUC08078-006355,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "70014",
        "Localit\u00e0": "CONVERSANO",
        "Indirizzo": "VIA MANTOVA, 35",
        "N.ri Tel.": "080 4951275",
        "Insegna": "MAX 1980"
    },
    "019538": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK03142-005480,25WBLGA05461-007349,25WBLGC02391-006648,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKA05458-006127,25WBLKA05458-006127,25WBLKC02429-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "92014",
        "Localit\u00e0": "PORTO EMPEDOCLE",
        "Indirizzo": "VIA VINCENZELLA SNC",
        "N.ri Tel.": "3283771367",
        "Insegna": "PIETRO LEONE"
    },
    "020219": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "56020",
        "Localit\u00e0": "TRENTO",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "3381870499",
        "Insegna": "- "
    },
    "020439": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "35139",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA DELLE CONVERTITE   12/13",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- "
    },
    "020609": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC03090-006719,25WBLUC03090-006719,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUX02081-005958,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "09127",
        "Localit\u00e0": "CAGLIARI",
        "Indirizzo": "VIA SIDNEY SONNINO, 35",
        "N.ri Tel.": "070 666106",
        "Insegna": "SURF SPOT"
    },
    "020648": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02177-007284,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "90011",
        "Localit\u00e0": "BAGHERIA",
        "Indirizzo": "CORSO BUTERA, 490",
        "N.ri Tel.": "091/903627",
        "Insegna": "BERTINI"
    },
    "020682": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC02132-007284,25WBLUC08078-006355,25WBLUC08078-006355",
        "Stato": "IT",
        "CAP": "95024",
        "Localit\u00e0": "ACIREALE",
        "Indirizzo": "CORSO SAVOIA, 72/74",
        "N.ri Tel.": "3717602413",
        "Insegna": "MAP"
    },
    "020787": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "74014",
        "Localit\u00e0": "PRAHA 1",
        "Indirizzo": "VIA ROMA, 79",
        "N.ri Tel.": "3208062934",
        "Insegna": "- "
    },
    "020871": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDK02069-006648,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "58015",
        "Localit\u00e0": "ORBETELLO",
        "Indirizzo": "CORSO ITALIA, 44",
        "N.ri Tel.": "0564 9167692",
        "Insegna": "VOO MOOD"
    },
    "020885": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDB03191-007294,25WBLDB03191-007294,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDK03098-006047,25WBLDK03098-006047,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC06082-005480,25WBLUK03142-005480,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "76121",
        "Localit\u00e0": "TRIGGIANO",
        "Indirizzo": "VIA TRANI, 19 c/o C.C.MONGOLFIERA",
        "N.ri Tel.": "080/3210405",
        "Insegna": "REV 73"
    },
    "020893": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648",
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "TERRASINI",
        "Indirizzo": "VIALE INDIPENDENZA, 2",
        "N.ri Tel.": "3890215357",
        "Insegna": "- "
    },
    "020897": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05335-007349,25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDA05337-006127,25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK03103-006047,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUA05299-006127,25WBLUA05299-006127,25WBLUA05299-006127,25WBLUA05299-006127,25WBLUA05300-006434,25WBLUA05300-006434,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "35042",
        "Localit\u00e0": "ESTE",
        "Indirizzo": "VIA PRINCIPE UMBERTO, 10/A",
        "N.ri Tel.": "0444 887860",
        "Insegna": "GIO' ABBIGLIAMENTO"
    },
    "020906": {
        "CODICE PRODOTTO KOOOMO": "25WBLUX02081-005958,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK11162-007110,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUC11083-007110,25WBLUK03142-005480,25WBLDC03092-006719,25WBLDC03095-006047,25WBLUC03233-007308,25WBLUK03142-005480,25WBLUX02081-005958,25WBLDC02170-006648,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC08078-006355,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "33073",
        "Localit\u00e0": "FONTANAFREDDA",
        "Indirizzo": "VIALE VENEZIA, 86 INT.1",
        "N.ri Tel.": "0434 565499",
        "Insegna": "SORELLE RAMONDA"
    },
    "020939": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK02069-006648",
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "3383015250",
        "Insegna": "- "
    },
    "020941": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "76011",
        "Localit\u00e0": "SOGLIANO CAVOUR",
        "Indirizzo": "ZONA INDUSTRIALE P.I.P. LOTTO, 30",
        "N.ri Tel.": "336381752",
        "Insegna": "- "
    },
    "020956": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "33053",
        "Localit\u00e0": "MILANO",
        "Indirizzo": "PIAZZA INDIPENDENZA , 39",
        "N.ri Tel.": "02 63471267",
        "Insegna": "- "
    },
    "020959": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC02072-006648,25WBLDK02069-006648,25WBLDK03495-006047",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA VIRGILLO SNC",
        "Insegna": "CONTAINER UOMO"
    },
    "020965": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC08078-006355,25WBLUC08078-006355,25WBLGC02391-006648,25WBLGC02391-006648,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "89057",
        "Localit\u00e0": "GAMBARIE D'ASPROMONTE",
        "Indirizzo": "PIAZZA MANGERUCA, 7",
        "N.ri Tel.": "0965 743010",
        "Insegna": "SPORTIME"
    },
    "020971": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "71016",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "VIA INDIPENDENZA, 52",
        "N.ri Tel.": "051 246317",
        "Insegna": "- "
    },
    "021129": {
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480",
        "Stato": "IT",
        "CAP": "97015",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA SACRO CUORE, 127",
        "N.ri Tel.": "0932 1972529",
        "Insegna": "- "
    },
    "021162": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDF08248-006948,25WBLDF08248-006948,25WBLDK02069-006648,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02153-007300,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUC11083-007110,25WBLUK11140-007286,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "58100",
        "Localit\u00e0": "GROSSETO",
        "Indirizzo": "VIALE SONNINO, 5",
        "N.ri Tel.": "0564 29525",
        "Insegna": "PARRONCHI"
    },
    "021168": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02178-006646,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC11163-007110,25WBLUA05297-006127,25WBLUA05297-006127,25WBLUA05297-006127,25WBLUA05299-006127,25WBLUA05299-006127,25WBLUC03074-006355,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC02178-006646,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUK03142-005480,25WBLUX02081-005958,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "66100",
        "Localit\u00e0": "CHIETI SCALO",
        "Indirizzo": "VIA PADRE UGOLINO FRASCA SNC",
        "N.ri Tel.": "085 9431373",
        "Insegna": "CLINIKA"
    },
    "021180": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC02177-007284,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02132-007284,25WBLUC02132-007284,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "CATANZARO",
        "Indirizzo": "LOCALITA' BARONE FRASSO",
        "N.ri Tel.": "0968/750121",
        "Insegna": "MILANO FASHION"
    },
    "021190": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047",
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "TREMP (LLEIDA)",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "0771674366",
        "Insegna": "- "
    },
    "021249": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDC02178-006646,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDK03103-006047,25WBLDK03103-006047,25WBLDK11162-007110,25WBLDK11162-007110,25WBLUC02079-005958,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02079-A05958,25WBLUC03074-006355,25WBLUK03142-005480,25WBLUK03142-005480,25WBLUL01316-007012,25WBLGC02391-006648,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "09025",
        "Localit\u00e0": "SANLURI",
        "Indirizzo": "VIALE RINASCITA S.N.",
        "N.ri Tel.": "070 9370879",
        "Insegna": "TUVERI"
    },
    "021256": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110",
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "VENEZIA",
        "Indirizzo": "VIA MAZZINI 72",
        "N.ri Tel.": "335-8112666",
        "Insegna": "- "
    },
    "021280": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "98123",
        "Localit\u00e0": "RIBERA",
        "Indirizzo": "VIA PARLAPIANO 39,",
        "N.ri Tel.": "0925 67939",
        "Insegna": "- "
    },
    "021297": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "47921",
        "Localit\u00e0": "RIMINI",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "0541-1416436",
        "Insegna": "- "
    },
    "021356": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA ROMA, 18",
        "N.ri Tel.": "0921/423492",
        "Insegna": "- "
    },
    "021364": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "SCIACCA",
        "Indirizzo": "VIA TOMMASO FIORE, 58",
        "N.ri Tel.": "3890215357",
        "Insegna": "- "
    },
    "021375": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC11083-007110",
        "Stato": "PL",
        "CAP": "85100",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "3939161185",
        "Insegna": "- "
    },
    "021425": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "PL",
        "CAP": "91100",
        "Localit\u00e0": "TRENTO",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- "
    },
    "021428": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02077-006943,25WBLUC02077-006943,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC06082-005480,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUL01316-007012,25WBLUX02081-005958,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA XX SETTEMBRE, 62",
        "Insegna": "CONTAINER UOMO"
    },
    "021429": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC08078-006355,25WBLUK03142-005480,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA VIRGILLO SNC",
        "Insegna": "CONTAINER UOMO"
    },
    "021433": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC02080-005958,25WBLUC02080-005958",
        "Stato": "IT",
        "CAP": "88046",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "VIA XX SETTEMBRE, 27",
        "Insegna": "CONTAINER UOMO"
    },
    "021454": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "98071",
        "Localit\u00e0": "CAPO D'ORLANDO",
        "Indirizzo": "VIA CRISPI, 41/43",
        "Insegna": "MANGANO JUNIOR"
    },
    "021460": {
        "CODICE PRODOTTO KOOOMO": "25WBLDB03191-007294,25WBLDB03191-007294,25WBLDB03191-007294,25WBLDC03095-006047,25WBLDC03097-006047,25WBLDK03098-006047,25WBLDK03103-006047,25WBLDL01340-007355,25WBLDP01291-007324,25WBLUB05126-007283,25WBLUC03090-006719,25WBLDK03102-006047,25WBLDK11162-007110,25WBLUC05125-007283,25WBLDC02170-006648",
        "Stato": "IT",
        "CAP": "70121",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "0775 246015",
        "Insegna": "- "
    },
    "021478": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02177-007284,25WBLUC02079-A05958",
        "Stato": "IT",
        "CAP": "62014",
        "Localit\u00e0": "TORREANO DI MARTIGNACCO",
        "Indirizzo": "VIALE DELL'INDUSTRIA, 303/C",
        "N.ri Tel.": "620885870",
        "Insegna": "- "
    },
    "021500": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC11163-007110",
        "Stato": "IT",
        "CAP": "85050",
        "Localit\u00e0": "VIAREGGIO",
        "Indirizzo": "ZONA INDUSTRIALE P.I.P. LOTTO, 30",
        "N.ri Tel.": "MAURO",
        "Insegna": "- "
    },
    "021524": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03098-006047",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "619768266",
        "Insegna": "- "
    },
    "021530": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC11083-007110",
        "Stato": "IT",
        "CAP": "64010",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIALE ERITREA 70/D/E/F - AFRICANO",
        "N.ri Tel.": "O6 41734336",
        "Insegna": "NUVOLARI"
    },
    "021564": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "VOLPIANO",
        "Indirizzo": "VITTORIO EMANUELE, 267",
        "N.ri Tel.": "MAURO",
        "Insegna": "- "
    },
    "022931": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC02170-006648,25WBLDC02170-006648",
        "Stato": "IT",
        "CAP": "80026",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA LARGO BONITO 4-6-8",
        "N.ri Tel.": "+420 221181000",
        "Insegna": "- "
    },
    "022960": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "RU",
        "CAP": "66-100",
        "Localit\u00e0": "TVER",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "045 7256884",
        "Insegna": "- "
    },
    "023012": {
        "CODICE PRODOTTO KOOOMO": "25WBLUL01316-007012",
        "Stato": "PL",
        "CAP": "M1 2EG",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- "
    },
    "023149": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "RU",
        "CAP": "644123",
        "Localit\u00e0": "Scharbeutz",
        "Indirizzo": "VIA MAMURRANO, Loclita\u00e0' S.CROCE  - C.C. ITACA",
        "N.ri Tel.": "943811088",
        "Insegna": "- "
    },
    "023154": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "98123",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "937960308",
        "Insegna": "- "
    },
    "023188": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "76001",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIA BONDI, 120",
        "N.ri Tel.": "977345643",
        "Insegna": "- "
    },
    "023189": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03099-006047",
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIALE VENEZIA , 52",
        "N.ri Tel.": "943811088",
        "Insegna": "- "
    },
    "023191": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90049",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA SPARANO DA BARI , 54/A",
        "N.ri Tel.": "972673323",
        "Insegna": "- "
    },
    "023200": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "97421",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "943326126",
        "Insegna": "- "
    },
    "023202": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "PL",
        "CAP": "M1 2EG",
        "Localit\u00e0": "Warsaw",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "629 576 721",
        "Insegna": "- "
    },
    "023227": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "RO",
        "CAP": "89081",
        "Localit\u00e0": "WIEN",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "699913377",
        "Insegna": "- "
    },
    "023231": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "UA",
        "CAP": "70121",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "0784 865502",
        "Insegna": "- "
    },
    "023266": {
        "CODICE PRODOTTO KOOOMO": "25WBLDF08236-007301,25WBLDK02069-006648,25WBLDA05337-006127,25WBLDK03103-006047,25WBLUC03074-006355",
        "Stato": "ME",
        "CAP": "85310",
        "Localit\u00e0": "TRICASE",
        "Indirizzo": "PIAZZA CAPPUCCINI, 63",
        "N.ri Tel.": "392 2236490",
        "Insegna": "- "
    },
    "023282": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "97421",
        "Localit\u00e0": "TRENTO",
        "Indirizzo": "VIA VOLTURNO, 8",
        "N.ri Tel.": "068131545",
        "Insegna": "- "
    },
    "023290": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VILLESSE",
        "Indirizzo": "VIALE INDIPENDENZA, 2",
        "N.ri Tel.": "3939686845",
        "Insegna": "- "
    },
    "023308": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "96103",
        "Localit\u00e0": "TRIESTE",
        "Indirizzo": "WILHELMSTR. 13",
        "N.ri Tel.": "07621 91966 0",
        "Insegna": "- "
    },
    "023309": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLDL01340-007355,25WBLDK03161-006719",
        "Stato": "IT",
        "CAP": "500 02",
        "Localit\u00e0": "PALMA DE MALLORCA",
        "Indirizzo": "Roudnicska 50/3",
        "N.ri Tel.": "620920155",
        "Insegna": "- "
    },
    "023311": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIALE GANDHI, 5",
        "N.ri Tel.": "937960308",
        "Insegna": "- "
    },
    "023333": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "UA",
        "CAP": "96264",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "977345643",
        "Insegna": "- "
    },
    "023335": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03100-006047,25WBLDK11162-007110,25WBLUC02132-007284",
        "Stato": "IT",
        "CAP": "95463",
        "Localit\u00e0": "ZEVIO",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "973249885",
        "Insegna": "- "
    },
    "023339": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDK03103-006047,25WBLDK03495-006047,25WBLUC03074-006355,25WBLUC03074-006355,25WBLUC03086-006047,25WBLUC06082-005480,25WBLUC06082-005480,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUX02081-005958,25WBLUX02081-005958",
        "Stato": "IT",
        "CAP": "28883",
        "Localit\u00e0": "GRAVELLONA TOCE",
        "Indirizzo": "STRADA PRIVATA EDISON/CORSO MILANO 141",
        "N.ri Tel.": "0323 840351",
        "Insegna": "SPORTWAY KIDS"
    },
    "023343": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02080-005958",
        "Stato": "PL",
        "CAP": "97015",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIALE CARDUCCI, 79",
        "N.ri Tel.": "988 60 25 20",
        "Insegna": "- "
    },
    "023345": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK03102-006047,25WBLUC03086-006047,25WBLDC03095-006047,25WBLDC03100-006047",
        "Stato": "IT",
        "CAP": "92024",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "MAURO",
        "Insegna": "- "
    },
    "023385": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "ME",
        "CAP": "860-0847",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA SPARANO DA BARI , 54/A",
        "N.ri Tel.": "670675608",
        "Insegna": "- "
    },
    "023392": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03357-007294",
        "Stato": "PL",
        "CAP": "71-515",
        "Localit\u00e0": "VERONA",
        "Indirizzo": "VIA VITTORIO VENETO 67",
        "N.ri Tel.": "0771674366",
        "Insegna": "- "
    },
    "023422": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC08078-006355",
        "Stato": "RU",
        "CAP": "98123",
        "Localit\u00e0": "ZARAGOZA",
        "Indirizzo": "c/o CEVA Logistics, Ul. Stefana Banacha 2",
        "N.ri Tel.": "984 393 382",
        "Insegna": "- "
    },
    "023428": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "UA",
        "CAP": "85100",
        "Localit\u00e0": "Zilina",
        "Indirizzo": "ul. Orzechowa 8",
        "N.ri Tel.": "973243471",
        "Insegna": "- "
    },
    "023438": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03096-006047,25WBLUC06082-005480,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "98125",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "VIALE INDIPENDENZA, 2",
        "N.ri Tel.": "986438299",
        "Insegna": "- "
    },
    "023443": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC03233-007308,25WBLUK03142-005480,25WBLUC03090-006719,25WBLUC03074-006355",
        "Stato": "IT",
        "CAP": "73018",
        "Localit\u00e0": "VILAGARCIA DE AROUSA, PONTEVEDRA",
        "Indirizzo": "WEICHERTSTRASSE 5 c/o Logwin Solutions Network GmbH",
        "N.ri Tel.": "986505893",
        "Insegna": "- "
    },
    "023455": {
        "CODICE PRODOTTO KOOOMO": "25WBLUK03142-005480,25WBLUX02081-005958,25WBLUC02151-007287",
        "Stato": "IT",
        "CAP": "92017",
        "Localit\u00e0": "TRIESTE",
        "Indirizzo": "VIALE P. SERAFINI 22",
        "N.ri Tel.": "328/6445076",
        "Insegna": "- "
    },
    "023514": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02079-005958",
        "Stato": "VA",
        "CAP": "96103",
        "Localit\u00e0": "Wien",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "943 74 41 99",
        "Insegna": "- "
    },
    "023528": {
        "CODICE PRODOTTO KOOOMO": "25WBLUC02132-007284",
        "Stato": "TR",
        "CAP": "98123",
        "Localit\u00e0": "ZIELONA GORA",
        "Indirizzo": "ul. Innowacyjna 8",
        "N.ri Tel.": "391/3463151",
        "Insegna": "- "
    },
    "023530": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC03096-006047,25WBLDK11162-007110",
        "Stato": "IT",
        "CAP": "80138",
        "Localit\u00e0": "TRENTO",
        "Indirizzo": "VIA XXXI OTTOBRE, 1",
        "N.ri Tel.": "973249885",
        "Insegna": "- "
    },
    "023579": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03099-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDC03100-006047,25WBLDK03102-006047,25WBLDK03102-006047,25WBLDK03103-006047",
        "Stato": "IT",
        "CAP": "88100",
        "Localit\u00e0": "LAMEZIA TERME",
        "Indirizzo": "CORSO MAZZINI, 199/201",
        "Insegna": "CONTAINER UOMO"
    },
    "023644": {
        "CODICE PRODOTTO KOOOMO": "24WBLDB03294-005553,24WBLDC02018-006648,24WBLDC02018-006648,24WBLDC02064-006100,24WBLDC02314-006631,24WBLDC03047-006047,24WBLDC03047-006047,24WBLDC03048-006047,24WBLDC03048-006047,24WBLDC03051-006047,24WBLDC03114-006719,24WBLDC03119-006951,24WBLDC03252-007008,24WBLDC03295-006857,24WBLDC03298-006992,24WBLDF01398-006987,24WBLDF08400-006987,24WBLDH01432-006971,24WBLDH02433-006971,24WBLDH02433-006971,24WBLDK02042-006648,24WBLDK02043-006648,24WBLDK02045-006648,24WBLDK02311-006648,24WBLDK03052-006047,24WBLDK03052-006047,24WBLDK03212-006990,24WBLDK03315-006950,24WBLDK03346-006047,24WBLDL01417-006668,24WBLDL01421-007016,24WBLDP03447-007025,24WBLDP03447-007029,24WBLDX03280-006719,25SBLDB04068-007109,25SBLDC01222-007108,25SBLDC01260-007108,25SBLDC01328-007131,25SBLDC01329-007131,25SBLDC02128-007103,25SBLDC02233-007104,25SBLDC02234-006648,25SBLDC02234-006648,25SBLDC02234-006648,25SBLDC02236-006648,25SBLDC02264-006648,25SBLDC02266-007124,25SBLDC02330-007119,25SBLDC03003-006950,25SBLDC03003-006950,25SBLDC03006-006950,25SBLDC03006-006950,25SBLDC03007-006950,25SBLDC03007-006950,25SBLDC04066-007109,25SBLDC04070-007109,25SBLDC11237-007110,25SBLDC11237-007110,25SBLDC11237-007110,25SBLDC11335-007110,25SBLDF03076-007092,25SBLDH02372-005707,25SBLDH02372-005707,25SBLDH02373-005707,25SBLDH02375-006842,25SBLDH02377-007147,25SBLDH02386-007144,25SBLDH02389-007144,25SBLDP01079-007092,25SBLDP01344-006855,25SBLDP02345-006855,25SBLDP02345-006855,25SBLDP02345-006855,25SBLDP05141-007109,25SBLDP05205-006804,25SBLDS01366-007141,25SBLDT02125-006526,25SBLDV05299-007138,25SBLDV05299-007138,25SBLDX02235-006648,25SBLDX02290-007119,25SBLUA04524-007182,25SBLUA04528-007183,25SBLUB01216-007111,25SBLUB04167-006854,25SBLUB04167-006854,25SBLUB04360-006788,25SBLUC01034-007111,25SBLUC01047-007120,25SBLUC01115-007105,25SBLUC01119-007105,25SBLUC01121-007105,25SBLUC01209-007101,25SBLUC01210-007101,25SBLUC01211-007101,25SBLUC01217-007108,25SBLUC01281-007105,25SBLUC02148-007103,25SBLUC02153-007124,25SBLUC02227-007104,25SBLUC02228-007104,25SBLUC02229-005958,25SBLUC02231-005958,25SBLUC03011-006719,25SBLUC03012-006719,25SBLUC04168-006788,25SBLUC04176-006854,25SBLUC04206-006535,25SBLUC11207-006787,25SBLUC11207-006787,25SBLUC11214-007111,25SBLUC11215-007110,25SBLUC11541-007110,25SBLUC11569-006787,25SBLUF01055-007092,25SBLUF01184-006804,25SBLUF02188-006804,25SBLUF03037-007096,25SBLUF03185-006804,25SBLUF03185-006804,25SBLUF03186-006804,25SBLUH02030-006846,25SBLUH02030-006846,25SBLUH02108-006864,25SBLUH02108-006864,25SBLUH02109-006526,25SBLUH02109-006526,25SBLUH02150-007100,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02191-004547,25SBLUH02192-004547,25SBLUH02192-004547,25SBLUH02193-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02196-004547,25SBLUH02199-004547,25SBLUH02242-007100,25SBLUH02244-007100,25SBLUH02274-007100,25SBLUH02275-007100,25SBLUH02275-007100,25SBLUH02394-007114,25SBLUH02394-007114,25SBLUL02403-006543,25SBLUL02408-007151,25SBLUL02582-007370,25SBLUL02583-007370,25SBLUM01476-006233,25SBLUM01486-007172,25SBLUN02513-007179,25SBLUP01183-007121,25SBLUP01189-006804,25SBLUP01189-006804,25SBLUP01324-007130,25SBLUP01324-007130,25SBLUP01324-007130,25SBLUP02063-007092,25SBLUP03535-006873,25SBLUP04322-007129,25SBLUP04353-007129,25SBLUP04353-007139,25SBLUP04354-007129,25SBLUP05190-006804,25SBLUP05355-007139,25SBLUP05355-007139,25SBLUP05530-007173,25SBLUS01338-007137,25SBLUS01341-007136,25SBLUS01342-007136,25SBLUS02336-007137,25SBLUT02306-006801,25SBLUT02308-006801,25SBLUT02309-007125,25SBLUT02309-007125,25SBLUT02310-006817,25SBLUT02312-006803,25SBLUT02312-006803,25SBLUT02313-006818,25SBLUT02315-007117,25SBLUT02316-007116,25SBLUT02317-007116,25SBLUT02346-007132,25SBLUX02147-007103,25SBLUX02147-007103,25SBLUX02230-005958,25SBLUX02230-005958,25SBLUX02230-005958,25SBLUX02230-005958,25SBLUX02255-007101,25SBLUX03226-006719,25SBLUX03226-006719,25SBLUX03226-006719,25SBLUX03226-006719,25WBLDA05336-007349,25WBLDC02506-007254,25WBLDC03092-006719,25WBLDC03092-006719,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03173-007307,25WBLDC03173-007307,25WBLDC11163-007110,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03098-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLDK03182-006985,25WBLDK03182-006985,25WBLDK03495-006047,25WBLDK03495-006047,25WBLDK03495-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDK03527-006047,25WBLDL01340-007355,25WBLDX03181-006985,25WBLDX03181-006985,25WBLUA05299-006127,25WBLUA05300-006434,25WBLUC02077-006943,25WBLUC02151-007287,25WBLUC03074-006355,25WBLUC11083-007110,25WBLUX02081-005958,25WBLUC11083-007110,25WBLDK02069-006648,25WBLUA05299-006127,25WBLUA05300-006434,25WBLUA05300-006434,25WBLDC03173-007307,25WBLDK03102-006047,25WBLUC03090-006719,25WBLDC11163-007110,25WBLDK03495-006047,25WBLDK03527-006047,25WBLDK03527-006047,25WBLUC03086-006047,25WBLUC08078-006355,25WBLDC03100-006047,25WBLDC03357-007294,25WBLUC02079-A05958,25WBLDC03100-006047,25WBLDA05336-007349,25WBLDK03098-006047,25WBLDK03495-006047,25WBLDK03527-006047,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUA05299-006127,25WBLDA05335-007349,25WBLDA05336-007349,25WBLDA05337-006127,25WBLDA05338-006127,25WBLDA05338-006127,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLDC03097-006047,25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03357-007294,25WBLDK03098-006047,25WBLDM01463-007330,25WBLDP01295-007323,25WBLUC02079-A05958,25WBLUC06082-005480,25WBLUC11083-007110,25WBLUL02318-007340,25WBLDX03181-006985,25WBLDA05335-007349,25WBLDA05335-007349,25WBLDK03098-006047,25WBLDC03092-006719,25WBLDC03099-006047,25WBLDC11163-007110,25WBLUC02080-005958,25WBLUA05297-006127,25WBLDC03096-006047,25WBLDK01376-007378,25WBLUC02077-006943,25WBLUC03233-007308,25WBLDC02177-007284,25WBLDK03101-006047,25WBLUC02132-007284,25WBLDC02072-006648,25WBLDC02072-006648,25WBLDC02177-007284,25WBLDC03092-006719,25WBLDC03095-006047,25WBLDC03173-007307,25WBLDC11163-007110,25WBLDK03102-006047,25WBLDK03182-006985,25WBLDK03495-006047,25WBLDK03495-006047,25WBLDK05019-007298,25WBLUA05299-006127,25WBLUA05299-006127,25WBLUA05299-006127,25WBLUC02077-006943,25WBLUC02079-005958,25WBLUC02079-A05958,25WBLUC02080-005958,25WBLUC03233-007308,25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02196-007283,25WBLDC03095-006047,25WBLDC03100-006047,25WBLDC03357-007294,25WBLDF08236-007301,25WBLDK03102-006047,25WBLDK03103-006047,25WBLDK03161-006719,25WBLDL01340-007355,25WBLDM01463-007330,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC03086-006047,25WBLUC03233-007308,25WBLUC05125-007283,25WBLUC08078-006355,25WBLUC08078-006355,25WBLUC11083-007110,25WBLUK11140-007286,25WBLUX02081-005958,25WBLDB03191-007294,25WBLDB03191-007294,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUC03086-006047,25WBLUC03074-006355,25WBLUC02080-005958,25WBLDC02177-007284,25WBLDF08248-006948,25WBLUF02118-007121,25WBLUF03119-007121,25WBLUK11140-007286,25WBLUA05297-006127,25WBLUA05297-006127,25WBLUA05301-006434,25WBLUC02080-005958,25WBLDC02177-007284,25WBLDK03161-006719,25WBLUA05301-006434,25WBLUA05301-006434,25WBLDC02072-006648,25WBLDK01375-007378,25WBLDK03102-006047,25WBLUC03090-006719,25WBLDC02072-006648,25WBLDC02170-006648,25WBLDC03095-006047,25WBLDK03101-006047,25WBLDK03102-006047,25WBLUA05301-006434,25WBLUA05301-006434,25WBLUC03233-007308,25WBLUC08078-006355,25WBLUL01314-007012,25WBLUL01314-007012,25WBLUC02132-007284,25WBLDC02170-006648,25WBLDC02170-006648,25WBLDC03096-006047,25WBLUC02080-005958,25WBLDC03095-006047,25WBLDC03096-006047,25WBLDC03096-006047,25WBLUC08078-006355,25WBLUC03086-006047,25WBLUC02079-005958,25WBLUC03086-006047,25WBLDA05338-006127,25WBLUC03086-006047,25WBLDA05337-006127,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUA05297-006127,25WBLUA05297-006127,25WBLDK03101-006047,25WBLDC02178-006646,25WBLUC11083-007110,25WBLUK03142-005480,25WBLUK03142-005480,25WBLUL02318-007340,25WBLDC02072-006648,25WBLDC03095-006047,25WBLDC03095-006047,25WBLDK03103-006047,25WBLUB05126-007283,25WBLUC03074-006355,25WBLDK02073-006648,25WBLDX03181-006985,25WBLUA05297-006127,25WBLDC03092-006719,25WBLUL01316-007012,25WBLUX02081-005958,25WBLDK02069-006648,25WBLDL01346-007354,25WBLDX03181-006985,25WBLUA05297-006127,25WBLUC03090-006719,25WBLUL01316-007012,25WBLUX02081-005958,25WBLDA05335-007349,25WBLDA05337-006127,25WBLDC02170-006648,25WBLDC03092-006719,25WBLDC03097-006047,25WBLDC03100-006047,25WBLDK02073-006648,25WBLDK03098-006047,25WBLDK03161-006719,25WBLDK11162-007110,25WBLDK11162-007110,25WBLDP01295-007323,25WBLDP01295-007323,25WBLUA05298-006127,25WBLUA05298-006127,25WBLUC02079-005958,25WBLUC02153-007300,25WBLUC06082-005480,25WBLDA05337-006127,25WBLDC02178-006646,25WBLDK02069-006648,25WBLUC02079-005958,25WBLUC03074-006355,25SBBKC01452-007111,25SBLGC01441-007111,25SBLGC02426-006648,25SBLGF02547-007187,25SBLGH02495-007144,25SBLGH02550-007188,25SBLKC01444-007101,25SBLKF03551-007187,25SBLKH02555-007188,25WBLKA05458-006127,25WBBXC02454-007110,25WBLGA05461-007349,25WBLKC11416-007110,25WBLKC11416-007110,25WBLKC02429-005958,25WBLGA05461-007349,25WBBXC02454-007110,25WBBXC02456-005958,25WBLGA05461-007349,25WBLKA05458-006127,25WBLKC02429-005958,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKA05458-006127,25WBLKA05458-006127,25WBLKA05458-006127,25WBBXC02456-005958,25WBLKC02427-005958,25WBLKC02427-005958,25WBLKC03400-007308,25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "65100",
        "Localit\u00e0": "VILLAFRANCA PADOVANA (fr Ronchi)",
        "Indirizzo": "VIA MESTRINO 47/L",
        "N.ri Tel.": "041 5731819",
        "Insegna": "- "
    },
    "023680": {
        "CODICE PRODOTTO KOOOMO": "25WBLDK01376-007378,25WBLDK03101-006047,25WBLUC03086-006047",
        "Stato": "IT",
        "CAP": "96103",
        "Localit\u00e0": "WOLLERSDORF",
        "Indirizzo": "WILHELMSTR. 13",
        "N.ri Tel.": "973243471",
        "Insegna": "- "
    },
    "023910": {
        "CODICE PRODOTTO KOOOMO": "25WBLDC03097-006047,25WBLDC03099-006047,25WBLDC03100-006047",
        "Stato": "PL",
        "CAP": "M1 2EG",
        "Localit\u00e0": "ZLIN",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "941593051",
        "Insegna": "- "
    },
    "023914": {
        "CODICE PRODOTTO KOOOMO": "25WBLDA05338-006127,25WBLDA05336-007349,25WBLDP01291-007324,25WBLDF08248-006948,25WBLUA05301-006434,25WBLDA05338-006127,25WBLDA05336-007349,25WBLDP04294-007324",
        "Stato": "PL",
        "CAP": "84-120",
        "Localit\u00e0": "Wladyslawowo",
        "Indirizzo": "VIA TEMPIO MALATESTIANO, 43",
        "N.ri Tel.": "06-77209843",
        "Insegna": "- "
    },
    "023938": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "PL",
        "CAP": "71065",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA PALMIERI 47/P",
        "N.ri Tel.": "501090403",
        "Insegna": "- "
    },
    "000068": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "22063",
        "Localit\u00e0": "CANTU'",
        "Indirizzo": "VIA ORESTE GRASSI, 10",
        "N.ri Tel.": "031 715171",
        "Insegna": "MINI MONDO"
    },
    "000098": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "70032",
        "Localit\u00e0": "BITONTO",
        "Indirizzo": "VIA PERRESE, 81/G",
        "N.ri Tel.": "080 3741914",
        "Insegna": "- "
    },
    "000141": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "53036",
        "Localit\u00e0": "POGGIBONSI",
        "Indirizzo": "VIA VITTORIO VENETO, 26",
        "N.ri Tel.": "0577 936346",
        "Insegna": "- "
    },
    "000180": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBBXC02456-005958",
        "Stato": "IT",
        "CAP": "00162",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA NOMENTANA, 459",
        "N.ri Tel.": "06 86215948",
        "Insegna": "GIBOT"
    },
    "000217": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "20048",
        "Localit\u00e0": "CARATE BRIANZA",
        "Indirizzo": "VIA DANTE CESANA, 28",
        "N.ri Tel.": "0362 904173",
        "Insegna": "- "
    },
    "000269": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "10123",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA CARLO ALBERTO, 32",
        "N.ri Tel.": "011 546191",
        "Insegna": "- "
    },
    "000706": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "05029",
        "Localit\u00e0": "SAN GEMINI",
        "Indirizzo": "VIA E. FERMI s.n.c.",
        "N.ri Tel.": "0744 242531 AMM",
        "Insegna": "- "
    },
    "001088": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02454-007110",
        "Stato": "IT",
        "CAP": "80132",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "VIA TOLEDO, 9",
        "N.ri Tel.": "081 4201190",
        "Insegna": "- "
    },
    "001496": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "40121",
        "Localit\u00e0": "BOLOGNA",
        "Indirizzo": "GALLERIA DEL TORO, 3",
        "N.ri Tel.": "051 269905",
        "Insegna": "- "
    },
    "001610": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "10036",
        "Localit\u00e0": "SETTIMO TORINESE",
        "Indirizzo": "VIA ITALIA, 49",
        "N.ri Tel.": "011 8968670",
        "Insegna": "- "
    },
    "001726": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "13051",
        "Localit\u00e0": "BIELLA",
        "Indirizzo": "VIA BERTODANO, 7",
        "N.ri Tel.": "015 2522304",
        "Insegna": "LEONE BIMBI"
    },
    "002050": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "80014",
        "Localit\u00e0": "GIUGLIANO IN CAMPANIA",
        "Indirizzo": "VIA S. M. A CUBITO - C.C. AUCHAN",
        "N.ri Tel.": "081 8187905",
        "Insegna": "YES PELLECCHIA"
    },
    "002316": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "50051",
        "Localit\u00e0": "CASTEL FIORENTINO",
        "Indirizzo": "VIA GARIBALDI, 40/42",
        "N.ri Tel.": "0571 61611",
        "Insegna": "PUCCI"
    },
    "002441": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958",
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "0818062859",
        "Insegna": "- "
    },
    "007269": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "10022",
        "Localit\u00e0": "CARMAGNOLA",
        "Indirizzo": "PIAZZA IV MARTIRI, 30",
        "N.ri Tel.": "011 9711763",
        "Insegna": "PUNTO BIMBI"
    },
    "007443": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "00165",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA GRAZIANO, 48",
        "Insegna": "- "
    },
    "007740": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBLKC02427-005958,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "22017",
        "Localit\u00e0": "MENAGGIO",
        "Indirizzo": "VIA CAMOZZI, 26",
        "N.ri Tel.": "0344 31382",
        "Insegna": "BOLLICINE"
    },
    "007948": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "63018",
        "Localit\u00e0": "PORTO SANT'ELPIDIO",
        "Indirizzo": "CSO UMBERTO I, 598/B",
        "N.ri Tel.": "0734 994914",
        "Insegna": "- "
    },
    "009079": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "80142",
        "Localit\u00e0": "NAPOLI",
        "Indirizzo": "CORSO ARNALDO LUCCI, 115-117",
        "N.ri Tel.": "081 201274",
        "Insegna": "- "
    },
    "009687": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "36030",
        "Localit\u00e0": "COSTABISSARA",
        "Indirizzo": "SS PASUBIO, 12/C",
        "N.ri Tel.": "0444 970487",
        "Insegna": "TATO E TATA"
    },
    "010047": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "22032",
        "Localit\u00e0": "ALBESE CON CASSANO",
        "Indirizzo": "VIA BELLINI, 3",
        "N.ri Tel.": "031.422.0507",
        "Insegna": "CERES"
    },
    "010361": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "10078",
        "Localit\u00e0": "VENARIA",
        "Indirizzo": "VIA B.BUOZZI , 13",
        "N.ri Tel.": "069844841",
        "Insegna": "- "
    },
    "012739": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "04019",
        "Localit\u00e0": "TERRACINA",
        "Indirizzo": "VIA ROMA, 68",
        "N.ri Tel.": "0773 705057",
        "Insegna": "- "
    },
    "013731": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "81042",
        "Localit\u00e0": "CALVI RISORTA",
        "Indirizzo": "VIA O.MANCINI 48",
        "Insegna": "POLIZZI"
    },
    "013954": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "86039",
        "Localit\u00e0": "TERMOLI",
        "Indirizzo": "VIA XX SETTEMBRE 9",
        "N.ri Tel.": "0875-81003",
        "Insegna": "- "
    },
    "014303": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "10078",
        "Localit\u00e0": "VENARIA",
        "Indirizzo": "VIA NINO OXILIA 9",
        "N.ri Tel.": "011 5213046",
        "Insegna": "- "
    },
    "014353": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "91011",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIA LUIGI EINAUDI, 96",
        "N.ri Tel.": "0924-23645",
        "Insegna": "- "
    },
    "014540": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "28100",
        "Localit\u00e0": "NOVARA",
        "Indirizzo": "CORSO ITALIA, 22/B",
        "Insegna": "PAPALLA"
    },
    "014541": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "TUSCANIA",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "338-9759191",
        "Insegna": "- "
    },
    "015032": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "80078",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "0818062859",
        "Insegna": "- "
    },
    "015041": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- "
    },
    "015153": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "07100",
        "Localit\u00e0": "SASSARI",
        "Indirizzo": "STRADA 2 - Predda Niedda",
        "Insegna": "DESOLE"
    },
    "015176": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90034",
        "Localit\u00e0": "CORLEONE",
        "Indirizzo": "VIA SANTA LUCIA, 3",
        "N.ri Tel.": "091/8464362",
        "Insegna": "- "
    },
    "015217": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBBXC02456-005958,25WBLGC02391-006648,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "70033",
        "Localit\u00e0": "CORATO",
        "Indirizzo": "VIA RUVO, 29",
        "N.ri Tel.": "0831-5640725",
        "Insegna": "GRAFFITI"
    },
    "015617": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "15121",
        "Localit\u00e0": "ALESSANDRIA",
        "Indirizzo": "CORSO ROMA 115",
        "Insegna": "- "
    },
    "016057": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "81100",
        "Localit\u00e0": "CASERTA",
        "Indirizzo": "VIA SAN GIOVANNI, 51",
        "N.ri Tel.": "0823-442067",
        "Insegna": "- "
    },
    "016242": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "31044",
        "Localit\u00e0": "MONTEBELLUNA",
        "Indirizzo": "VIA PERLASCA, 18/A",
        "N.ri Tel.": "0423 300830",
        "Insegna": "- "
    },
    "016378": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "PIAZZA RISORGIMENTO SN",
        "N.ri Tel.": "0964 380240",
        "Insegna": "- "
    },
    "017739": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "37011",
        "Localit\u00e0": "BARDOLINO",
        "Indirizzo": "VICOLO VIRGILIO, 3/5",
        "N.ri Tel.": "340 3368660",
        "Insegna": "POP CORN"
    },
    "017951": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02427-005958,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "45014",
        "Localit\u00e0": "PORTO VIRO LOC. DONADA",
        "Indirizzo": "VIA ROMA 35",
        "N.ri Tel.": "0426 320373",
        "Insegna": "STIL BIMBI"
    },
    "018067": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "70033",
        "Localit\u00e0": "CORATO",
        "Indirizzo": "CORSO GARIBALDI, 156",
        "N.ri Tel.": "080 8984728",
        "Insegna": "HICMOS"
    },
    "018210": {
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "24064",
        "Localit\u00e0": "GRUMELLO DEL MONTE",
        "Indirizzo": "VIA NEMBRINI, 63",
        "N.ri Tel.": "035 0782745",
        "Insegna": "DIDI STORE"
    },
    "018348": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "80100",
        "Localit\u00e0": "SAVONA",
        "Indirizzo": "VIA ROMA, 2",
        "N.ri Tel.": "3804364649",
        "Insegna": "- "
    },
    "018631": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "30014",
        "Localit\u00e0": "CAVARZERE",
        "Indirizzo": "CORSO ITALIA, 12/bis",
        "N.ri Tel.": "3493697289",
        "Insegna": "L'ARCOBALENO"
    },
    "018665": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "SM",
        "CAP": "47899",
        "Localit\u00e0": "TUSCANIA",
        "Indirizzo": "VIA MANTOVA SNC",
        "N.ri Tel.": "338-9759191",
        "Insegna": "- "
    },
    "018886": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "00012",
        "Localit\u00e0": "GUIDONIA",
        "Indirizzo": "VIA PALOMBARESE, 203",
        "Insegna": "- "
    },
    "019251": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "80146",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIA MONTE SAN MICHELE, 23",
        "N.ri Tel.": "3804364649",
        "Insegna": "- "
    },
    "019299": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "89020",
        "Localit\u00e0": "PLATJA D'ARO, GIRONA",
        "Indirizzo": "VIA A. GRAMSCI, 180",
        "N.ri Tel.": "0966 937207",
        "Insegna": "- "
    },
    "019375": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "TERAMO",
        "Indirizzo": "VIALE DEL COMMERCIO",
        "N.ri Tel.": "328-2197256",
        "Insegna": "- "
    },
    "019379": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "86021",
        "Localit\u00e0": "BOJANO",
        "Indirizzo": "VIA MOLISE, 32",
        "N.ri Tel.": "328-0245956",
        "Insegna": "- "
    },
    "019414": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "50019",
        "Localit\u00e0": "SESTO FIORENTINO",
        "Indirizzo": "VIA GIUSEPPE VERDI, 32",
        "N.ri Tel.": "3298535073",
        "Insegna": "BOOM"
    },
    "019438": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92024",
        "Localit\u00e0": "CANICATTI'",
        "Indirizzo": "VIA SANDRO PERTINI,4",
        "N.ri Tel.": "331 5969604",
        "Insegna": "- "
    },
    "019568": {
        "CODICE PRODOTTO KOOOMO": "25WBLKA05458-006127,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "36012",
        "Localit\u00e0": "ASIAGO",
        "Indirizzo": "CORSO IV NOVEMBRE, 5",
        "N.ri Tel.": "0424 1761774",
        "Insegna": "ORSO DINO"
    },
    "019748": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958,25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "83040",
        "Localit\u00e0": "CASTEL SAN GIORGIO",
        "Indirizzo": "VIA TENENTE BRUNO LOMBARDI 122",
        "N.ri Tel.": "3343349234",
        "Insegna": "INSIEME CRESCEREMO"
    },
    "019755": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLKC02429-005958,25WBLGC02391-006648,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "52011",
        "Localit\u00e0": "SOCI BIBBIENA",
        "Indirizzo": "VIA DEL LANIFICIO, 18",
        "N.ri Tel.": "0575561530",
        "Insegna": "CASA DEL BAMBINO"
    },
    "019849": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "25047",
        "Localit\u00e0": "DARFO BOARIO TERME",
        "Indirizzo": "VIA ZANARDELLI 1",
        "N.ri Tel.": "0364-533640",
        "Insegna": "PEPERINO"
    },
    "020061": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "SALERNO",
        "Indirizzo": "VIA SANDRO PERTINI,4",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- "
    },
    "020091": {
        "CODICE PRODOTTO KOOOMO": "25WBLGA05461-007349,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "28021",
        "Localit\u00e0": "BORGOMANERO",
        "Indirizzo": "CORSO ROMA, 100",
        "Insegna": "FATE E FOLLETTI"
    },
    "020179": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "89020",
        "Localit\u00e0": "POZZUOLI",
        "Indirizzo": "VIA PROVINCIALE PIANURA , 17",
        "N.ri Tel.": "0966 937207",
        "Insegna": "- "
    },
    "020385": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "03043",
        "Localit\u00e0": "GUIDONIA",
        "Indirizzo": "VIA PALOMBARESE, 203",
        "N.ri Tel.": "0776 272500",
        "Insegna": "- "
    },
    "020421": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "VILLARICCA",
        "Indirizzo": "CORSO VITTORIO VENETO, 226",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- "
    },
    "020432": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92024",
        "Localit\u00e0": "SAN SEVERO",
        "Indirizzo": "VIA VITRUVIO, 57",
        "N.ri Tel.": "389 8584354",
        "Insegna": "- "
    },
    "020768": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "84010",
        "Localit\u00e0": "SANT'EGIDIO DEL MONTE ALBINO",
        "Indirizzo": "VIA VITRUVIO, 57",
        "N.ri Tel.": "389 8584354",
        "Insegna": "- "
    },
    "020801": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "88068",
        "Localit\u00e0": "SOVERATO",
        "Indirizzo": "CORSO UMBERTO I, 80/82",
        "N.ri Tel.": "347 6620964",
        "Insegna": "MAGIA JUNIOR"
    },
    "020877": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "82100",
        "Localit\u00e0": "POTENZA",
        "Indirizzo": "VIA ISCA DEGLI ANTICHI, 12",
        "N.ri Tel.": "3290395811",
        "Insegna": "- "
    },
    "020879": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC03400-007308,25WBBXC02454-007110,25WBLKC03400-007308",
        "Stato": "IT",
        "CAP": "80047",
        "Localit\u00e0": "SAN GIUSEPPE VESUVIANO",
        "Indirizzo": "VIA ASTALONGA, 98",
        "N.ri Tel.": "081-8501783",
        "Insegna": "- "
    },
    "020888": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "36013",
        "Localit\u00e0": "PIOVENE ROCCHETTE",
        "Indirizzo": "VIA GRUMELLO, 2",
        "N.ri Tel.": "0445-650721",
        "Insegna": "- "
    },
    "020896": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "12045",
        "Localit\u00e0": "FOSSANO",
        "Indirizzo": "VIA GUGLIELMO MARCONI , 15",
        "Insegna": "- "
    },
    "020903": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "04016",
        "Localit\u00e0": "SABAUDIA",
        "Indirizzo": "PIAZZA OBERDAN , 14/24",
        "N.ri Tel.": "329/8403788",
        "Insegna": "- "
    },
    "020912": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "SM",
        "CAP": "98100",
        "Localit\u00e0": "TORINO",
        "Indirizzo": "VIA SANTA LUCIA, 3",
        "N.ri Tel.": "320/9306958",
        "Insegna": "- "
    },
    "020919": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "81028",
        "Localit\u00e0": "SANTA MARIA A VICO",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "334-8035058",
        "Insegna": "- "
    },
    "020934": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "89900",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIA FRANCESCO TRABATTONI, 49",
        "N.ri Tel.": "3494105031",
        "Insegna": "- "
    },
    "020936": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "16039",
        "Localit\u00e0": "SESTRI LEVANTE",
        "Indirizzo": "VIA SAN FRANCESCO D'ASSISI, 27",
        "N.ri Tel.": "0185486001",
        "Insegna": "- "
    },
    "020940": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "41125",
        "Localit\u00e0": "MODENA",
        "Indirizzo": "VIA GIOVANNI AMENDOLA 150",
        "N.ri Tel.": "3485798775",
        "Insegna": "- "
    },
    "020967": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "97100",
        "Localit\u00e0": "SIRACUSA",
        "Indirizzo": "VIALE MARCO POLO 31",
        "N.ri Tel.": "340- 2713603 tit",
        "Insegna": "- "
    },
    "020980": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "47001",
        "Localit\u00e0": "VALLADOLID, CASTILLA",
        "Indirizzo": "VIA GUGLIELMO MARCONI , 15",
        "N.ri Tel.": "0121-393916",
        "Insegna": "- "
    },
    "021053": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "TERRASINI",
        "Indirizzo": "VIALE STRASBURGO, 170-174",
        "N.ri Tel.": "3760254370",
        "Insegna": "- "
    },
    "021100": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "73100",
        "Localit\u00e0": "VIC",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "3334732594",
        "Insegna": "- "
    },
    "021104": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "RUBIERA",
        "Indirizzo": "VIALE DELLA VITTORIA 22",
        "N.ri Tel.": "3760254370",
        "Insegna": "- "
    },
    "021121": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "SM",
        "CAP": "89048",
        "Localit\u00e0": "SIDERNO",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "3294278844",
        "Insegna": "- "
    },
    "021123": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "86100",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "333-5906519",
        "Insegna": "- "
    },
    "021124": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "VILLARICCA",
        "Indirizzo": "VIALE DEL COMMERCIO , 4",
        "N.ri Tel.": "347-1475729",
        "Insegna": "- "
    },
    "021184": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02429-005958,25WBLKC02429-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "85059",
        "Localit\u00e0": "VILLA D'AGRI DI MARSICOVETERE",
        "Indirizzo": "VIA VITTORIO EMANUELE II SN",
        "N.ri Tel.": "0975 354447",
        "Insegna": "COIRO FASHION TIME"
    },
    "021216": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90041",
        "Localit\u00e0": "VIC",
        "Indirizzo": "VIA SAN GIOVANNI, 51",
        "N.ri Tel.": ": 3495468862",
        "Insegna": "- "
    },
    "021218": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "97015",
        "Localit\u00e0": "TUDELA, NAVARRA",
        "Indirizzo": "VIALE STRASBURGO, 170-174",
        "N.ri Tel.": "351 0956170",
        "Insegna": "- "
    },
    "021220": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90047",
        "Localit\u00e0": "VIC",
        "Indirizzo": "VIA TEODORO II 12,",
        "N.ri Tel.": ": 3495468862",
        "Insegna": "- "
    },
    "021221": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBBXC02456-005958,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKA05458-006127,25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "00123",
        "Localit\u00e0": "ROMA",
        "Indirizzo": "VIA ANTON GIULIO BRAGAGLIA, 19/E",
        "N.ri Tel.": "06 30889840",
        "Insegna": "PAROLIN"
    },
    "021235": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "42020",
        "Localit\u00e0": "MONTECAVOLO",
        "Indirizzo": "VIA PALMIRO TOGLIATTI, 26/B",
        "N.ri Tel.": "0522666171",
        "Insegna": "SORELLE RAMONDA"
    },
    "021242": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "80050",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA MONTE SAN MICHELE, 23",
        "N.ri Tel.": "336381752",
        "Insegna": "- "
    },
    "021243": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "91011",
        "Localit\u00e0": "Vielha, Lerida",
        "Indirizzo": "carretera de gausac 30",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "021244": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "97100",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIA PROVINCIALE 51",
        "N.ri Tel.": "0932 255194",
        "Insegna": "- "
    },
    "021270": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "98100",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "Via E:Mattei, 1/c -C.C. VALECENTER",
        "N.ri Tel.": "351 8686783",
        "Insegna": "- "
    },
    "021272": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "91025",
        "Localit\u00e0": "VIBO VALENTIA",
        "Indirizzo": "VIA ROMA, 101/103",
        "N.ri Tel.": "338-9759191",
        "Insegna": "- "
    },
    "021288": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "980015",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIALE UNITA' D'ITALIA, 10",
        "N.ri Tel.": "3804364649",
        "Insegna": "- "
    },
    "021328": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC11416-007110",
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "021329": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "TERMOLI",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- "
    },
    "021330": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958",
        "Stato": "IT",
        "CAP": "86039",
        "Localit\u00e0": "VEDELAGO",
        "Indirizzo": "VIA XX SETTEMBRE 9",
        "N.ri Tel.": "348 5215883",
        "Insegna": "- "
    },
    "021336": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92020",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "3804364649",
        "Insegna": "- "
    },
    "021337": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "SM",
        "CAP": "91011",
        "Localit\u00e0": "BORGO MAGGIORE",
        "Indirizzo": "VIA L. CIBRARIO, 25",
        "N.ri Tel.": "0924-23645",
        "Insegna": "- "
    },
    "021355": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90143",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIA ZUCCOLA, 24/C",
        "N.ri Tel.": ": 3495468862",
        "Insegna": "- "
    },
    "021396": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLGC02391-006648,25WBLKC02427-005958,25WBLKC02427-005958,25WBLKC02429-005958",
        "Stato": "IT",
        "CAP": "80055",
        "Localit\u00e0": "PORTICI",
        "Indirizzo": "VIA LIBERTA', 55",
        "N.ri Tel.": "081-7763815",
        "Insegna": "SNEAKERS PORTICI"
    },
    "021403": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648,25WBLGC02391-006648,25WBLKA05458-006127,25WBLKC02427-005958,25WBLKC02427-005958",
        "Stato": "IT",
        "CAP": "33100",
        "Localit\u00e0": "UDINE",
        "Indirizzo": "VIA RIALTO, 15",
        "N.ri Tel.": "0422 546108",
        "Insegna": "MIOZZI"
    },
    "021414": {
        "CODICE PRODOTTO KOOOMO": "25WBLKC02427-005958,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VICENZA",
        "Indirizzo": "VIA ZAMENHOF, 98",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "021706": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VILLAFRANCA DEL BIERZO - LEON",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "022195": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "92026",
        "Localit\u00e0": "ZUMARRAGA ES GUPUZCOA",
        "Indirizzo": "VIALE PIAVE 20B",
        "N.ri Tel.": "380-6860054",
        "Insegna": "- "
    },
    "022981": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "97013",
        "Localit\u00e0": "TORRE ANNUNZIATA",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "972 21 21 10",
        "Insegna": "- "
    },
    "023027": {
        "CODICE PRODOTTO KOOOMO": "25WBBXC02456-005958,25WBBXC02456-005958,25WBLGC02391-006648,25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "95045",
        "Localit\u00e0": "MISTERBIANCO",
        "Indirizzo": "VIA GARIBALDI, 605  P.T.",
        "N.ri Tel.": "095-445648",
        "Insegna": "- "
    },
    "023184": {
        "CODICE PRODOTTO KOOOMO": "25WBLGC02391-006648",
        "Stato": "IT",
        "CAP": "95129",
        "Localit\u00e0": "VINAZOR ES CASTELLON",
        "Indirizzo": "VIALE SANT'ANTONIO, 32",
        "N.ri Tel.": "972 21 21 10",
        "Insegna": "- "
    },
    "023269": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "91025",
        "Localit\u00e0": "VOLLA",
        "Indirizzo": "VIALE VENEZIA, 106",
        "N.ri Tel.": ": 3495468862",
        "Insegna": "- "
    },
    "023272": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "90141",
        "Localit\u00e0": "VIRY",
        "Indirizzo": "VIA ZOCCO 99",
        "N.ri Tel.": "393-9707309 dom",
        "Insegna": "- "
    },
    "023357": {
        "CODICE PRODOTTO KOOOMO": "",
        "Stato": "IT",
        "CAP": "89048",
        "Localit\u00e0": "TRIGGIANO",
        "Indirizzo": "VIA VITTORIO VENETO, 26",
        "N.ri Tel.": "0964 380240",
        "Insegna": "- "
    }
};

(function() {
    var errorProd = document.querySelector('.error-prod-code');
    /*ERROR MESSAGE*/
    const error_message = document.getElementById("error_store");
    /*CONTAINER*/
	const containerStores = document.getElementById("container-stores");
	/* SELECTS*/
	const selectStato = document.getElementById("country_store");
	const selectLocalita = document.getElementById("city_store");
	/*INPUT*/
	const input_code = document.getElementById("prod_code");
	/* Selezioniamo il pulsante*/
	const cercaButton = document.getElementById('search-store');
    function checkAvailableSelection(){
        let str_code=input_code.value;
        let statoSelected = selectStato.options[selectStato.selectedIndex].value;
        if(str_code == ""){
            return false;  
        }
        if(str_code != "" || statoSelected != "0"){
            let _stato='';
            let _localita='';
            for (let key in stores_json) {
                if(  ( str_code == "" || stores_json[key]["CODICE PRODOTTO KOOOMO"].includes(str_code) ) && ( statoSelected == "0" || stores_json[key]["Stato"] == statoSelected ) ){
                    if(!_localita.includes(stores_json[key]['Localit\u00e0']))
                        _localita +=stores_json[key]['Localit\u00e0']+',';
                    if(!_stato.includes(stores_json[key]['Stato']))
                        _stato +=stores_json[key]['Stato']+',';
                }
            }
            if(str_code != "" ){
                for(var i = 0; i < selectStato.options.length; i++){
                    if(!_stato.includes(selectStato.options[i].value) && selectStato.options[i].value != "0" ){
                        selectStato.options[i].className="hidden";
                    }else{				
                        selectStato.options[i].className="";
                    }
                }
            }
            for(var i = 0; i < selectLocalita.options.length; i++){
                if(!_localita.includes(selectLocalita.options[i].textContent) && selectLocalita.options[i].value != "0"){
					selectLocalita.options[i].className="hidden";
				}else{				
					selectLocalita.options[i].className="";
				}
            }
        }else{
            selectStato.options[0].selected = true;
            selectLocalita.options[0].selected = true;
            /*active all COUNTRY*/
            for(var i = 0; i < selectStato.options.length; i++){
				selectStato.options[i].selected = false;
				selectStato.options[i].className="";
			}
			
            /*active all CITY*/
            for(var i = 0; i < selectLocalita.options.length; i++){
				selectLocalita.options[i].selected = false;
				selectLocalita.options[i].className="";
			}

			selectLocalita.options[0].selected = true;
            selectStato.options[0].selected = true;
        }
    }
    /*HIDE CONTRY AND CITY WHERE CODE IS NOT PLACED*/
    input_code.addEventListener('input', (event) => {
        checkAvailableSelection();       
    });
	/*SELECT COUNTRY*/
	selectStato.onchange = function() {
        for(var i = 0; i < selectLocalita.options.length; i++){
            selectLocalita.options[i].selected = false;
        }
        selectLocalita.options[0].selected = true;
        checkAvailableSelection();
	};
	/* CERCA*/
    let countStore=0;
	cercaButton.onclick = function() {
        countStore=0;
		let str_code=input_code.value;
        if(str_code == ""){
            errorProd.classList.add('error');
            return false;  
        }else{
            errorProd.classList.remove('error');
        }
		let statoSelected = selectStato.options[selectStato.selectedIndex].value;
		let localitaSelected = selectLocalita.options[selectLocalita.selectedIndex].value;
		if(localitaSelected != 0)
			localitaSelected = selectLocalita.options[selectLocalita.selectedIndex].textContent;

		containerStores.innerHTML="";
		/* cerco nel JSON quali store corrispondono*/
        
		for (let key in stores_json) {
			let is_it=true;
			if (stores_json.hasOwnProperty(key)) {
				if( ( str_code == '' || stores_json[key]["CODICE PRODOTTO KOOOMO"].includes(str_code) )){
					is_it = true;
				}else{
					is_it = false;

				}
				if( is_it && ( localitaSelected == '0' || stores_json[key]["Localit\u00e0"]==localitaSelected )){
					is_it = true;
				}else{
					is_it = false;
				}		
				if( is_it && ( statoSelected == '0' || stores_json[key]["Stato"]==statoSelected )){
					is_it = true;
				}else{
					is_it = false;
				}
				if(is_it){
                    let insegna =stores_json[key]['Insegna'];
                    if(insegna == "- "){
                        insegna="";
                    }
					let newElement = document.createElement('div');
                    let stringHTML="<div class='innerCard'>";
                    stringHTML+="<b class='store_insegna'>"+insegna.toLowerCase() +"</b>";                    
                    stringHTML+='<label class="store_indirizzo"><i class="fa fa-map"></i> '+stores_json[key]['Indirizzo'].toLowerCase()+', ' ;
                    stringHTML+=stores_json[key]['CAP'].toLowerCase()+'</label>' ;
                    stringHTML+='<label class="store_localita">'+stores_json[key]['Localit\u00e0'].toLowerCase() ;
                    stringHTML+=', ' + stores_json[key]['Stato']+'</label>' ;                    
                    stringHTML+='<label class="store_telefono"><i class="fa fa-phone"></i> '+stores_json[key]['N.ri Tel.']+'</label>';
                    stringHTML+='</div>';

					newElement.className="card";
					newElement.innerHTML = stringHTML;
					containerStores.appendChild(newElement);
                    countStore++;
				}
			}
		}
        if(countStore==0){
            error_message.className="";
        }else{
            error_message.className="hidden";
        }

	};

	/*CREO LE OPTION DELLE SELECT DAL JSON*/
	for (let key in stores_json) {
		if (stores_json.hasOwnProperty(key)) {
			let stato = stores_json[key].Stato;
			let localita = stores_json[key]['Localit\u00e0'];
			if(!selectHasValue('country_store',stato)){
				let optionStato = document.createElement('option');
				optionStato.value = stato.toUpperCase();
				optionStato.textContent = countries[stato].toUpperCase();
				selectStato.appendChild(optionStato);
			}
			if(!selectHasValueLocalita('city_store',localita)){
				let optionLocalita = document.createElement('option');
				optionLocalita.value = stato.toUpperCase();
				optionLocalita.textContent = localita.toUpperCase();
				selectLocalita.appendChild(optionLocalita);
			}
		}
	}

	function selectHasValue(selectId, value) {
		const select = document.getElementById(selectId);
		if (select !== null) {
			return select.innerHTML.indexOf('value="' + value.toUpperCase() + '"') > -1;
		} else {
			return false;
		}
	}
	function selectHasValueLocalita(selectId, value) {
		const select = document.getElementById(selectId);
		if (select !== null) {
			return select.innerHTML.indexOf('>' + value.toUpperCase() + '<') > -1;
		} else {
			return false;
		}
	}

	function sortSelect(selElem) {
		let tmpAry = [];
		for (let i = 0; i < selElem.options.length; i++) {
			tmpAry[i] = [selElem.options[i].text, selElem.options[i].value];
		}
		tmpAry.sort();

		while (selElem.options.length > 0) {
			selElem.options[0] = null;
		}
		for (let i = 0; i < tmpAry.length; i++) {
			if(tmpAry[i][1] == 0){				
				let op = new Option(tmpAry[i][0], tmpAry[i][1]);
				selElem.options[0] = op;
			}
		}
		let count=1;
		for (let i = 0; i < tmpAry.length; i++) {
			if(tmpAry[i][1] != 0){
				let op = new Option(tmpAry[i][0], tmpAry[i][1]);
				selElem.options[count] = op;
				count++;
			}
			
		}
		
	}
	sortSelect(selectStato);
	sortSelect(selectLocalita);
    if(input_code.value.length != 0){
        cercaButton.click();
    }
})();